export var productStructureDe = `{
  "language": "GERMAN",
  "indexHeadline": "BS2000 Dokumentation",
  "indexDescription": "Auf dieser Seite finden Sie alle Produktbereiche der Dokumentation zum BS2000. Wählen Sie den Produktlink, um zur angegebenen Produktdokumentation zu gelangen, oder nutzen Sie das Feld 'Suche nach Produkt', um ein bestimmtes Produkt zu finden.",
  "productAreas": [
    {
      "id": "area-fujitsusoftwarebs2000",
      "name": "Fujitsu Software BS2000",
      "productGroups": [
        {
          "id": "group-operatingsystem",
          "name": "Betriebssystem",
          "productIds": [
            "product-bs2000operatingsystem",
            "product-posix",
            "product-osdbcpackage",
            "product-osdxcpackage",
            "product-conceptdescriptions"
          ]
        },
        {
          "id": "group-utilityroutines",
          "name": "Dienstprogramme",
          "productIds": [
            "product-edt",
            "product-fhs",
            "product-fms",
            "product-ifg",
            "product-lms",
            "product-percon",
            "product-rfa",
            "product-sort",
            "product-taskdate",
            "product-tomproducts"
          ]
        },
        {
          "id": "group-jobcontrol",
          "name": "Jobsteuerung",
          "productIds": [
            "product-avas",
            "product-jv",
            "product-sdf",
            "product-sdfa",
            "product-sdfp"
          ]
        },
        {
          "id": "group-communicationandinternet",
          "name": "Kommunikation und Internet",
          "productIds": [
            "product-apache",
            "product-internetservices",
            "product-mt9750",
            "product-nfs",
            "product-opennetserver",
            "product-osisessionservice",
            "product-tiam",
            "product-xhcs"
          ]
        },
        {
          "id": "group-performancemanagement",
          "name": "Performance-Management",
          "productIds": [
            "product-cosmos",
            "product-dab",
            "product-opensm2",
            "product-pcs",
            "product-rav",
            "product-sca",
            "product-sm2pa"
          ]
        },
        {
          "id": "group-printmanagement",
          "name": "Print-Management",
          "productIds": [
            "product-bs2zip",
            "product-conv2pdf",
            "product-dprint",
            "product-rso",
            "product-spool"
          ]
        },
        {
          "id": "group-programmingsystems",
          "name": "Programmier-Systeme",
          "productIds": [
            "product-aid",
            "product-assembh",
            "product-bs2ide",
            "product-cobol85",
            "product-cobol2000",
            "product-columbus85",
            "product-cc++",
            "product-crte",
            "product-for1fortran",
            "product-jenvjava",
            "product-pascal",
            "product-perl",
            "product-pl1"
          ]
        },
        {
          "id": "group-security",
          "name": "Sicherheit",
          "productIds": [
            "product-crypt",
            "product-ipsec",
            "product-secos"
          ]
        },
        {
          "id": "group-storageandbackupmanagement",
          "name": "Storage- und Backup-Management",
          "productIds": [
            "product-archive",
            "product-drv",
            "product-fddrl",
            "product-hsms",
            "product-maren",
            "product-robar",
            "product-shcosd",
            "product-spaceopt"
          ]
        },
        {
          "id": "group-systemmanagement",
          "name": "System-Management",
          "productIds": [
            "product-hiplexmscf",
            "product-omnis",
            "product-omnismenu",
            "product-propxt",
            "product-sbabs2",
            "product-snmpagents",
            "product-ssasm2bs2",
            "product-ssaoutmbs2",
            "product-sscbs2"
          ]
        },
        {
          "id": "group-virtualization",
          "name": "Virtualisierung",
          "productIds": ["product-vm2000"]
        }
      ]
    },
    {
      "id": "area-fujitsusoftwaremiddleware",
      "name": "Fujitsu Software Middleware",
      "productGroups": [
        {
          "id": "group-databasesystems",
          "name": "Datenbank-Systeme",
          "productIds": [
            "product-cis",
            "product-drivecomp",
            "product-drivewindows",
            "product-leasy",
            "product-oracle",
            "product-sesamsql",
            "product-udsiqs",
            "product-udssql"
          ]
        },
        {
          "id": "group-openseas",
          "name": "openSEAS",
          "productIds": [
            "product-beanconnect",
            "product-openft",
            "product-openutm",
            "product-pcmxunixbasedos",
            "product-webtransactions"
          ]
        }
      ]
    },
    {
      "id": "area-fujitsuserverbs2000",
      "name": "Fujitsu Server BS2000",
      "productGroups": [
        {
          "id": "group-seseriesinfrastructure",
          "name": "SE Server",
          "productIds": ["product-seseriesinfrastructure"]
        },
        {
          "id": "group-sserver",
          "name": "S-Server",
          "productIds": ["product-sserver"]
        },
        {
          "id": "group-sqserver",
          "name": "SQ-Server",
          "productIds": ["product-sqserver"]
        },
        {
          "id": "group-serverconnectivity",
          "name": "Server Connectivity",
          "productIds": [
            "product-onlinestoragefujitsueternus",
            "product-onlinestorageemcvmax",
            "product-fcswitch"
          ]
        }
      ]
    }
  ],
  "alphabeticalProducts": {
    "A": [
      "product-avas",
      "product-apache",
      "product-aid",
      "product-assembh",
      "product-archive"
    ],
    "B": [
      "product-bs2000operatingsystem",
      "product-bs2zip",
      "product-bs2ide",
      "product-beanconnect"
    ],
    "C": [
      "product-cosmos",
      "product-conv2pdf",
      "product-cobol85",
      "product-cobol2000",
      "product-columbus85",
      "product-cc++",
      "product-crte",
      "product-crypt",
      "product-cis"
    ],
    "D": [
      "product-dab",
      "product-dprint",
      "product-drv",
      "product-drivecomp",
      "product-drivewindows"
    ],
    "E": ["product-edt"],
    "F": [
      "product-fhs",
      "product-fms",
      "product-for1fortran",
      "product-fddrl",
      "product-fcswitch"
    ],
    "H": [
      "product-hsms",
      "product-hiplexmscf"
    ],
    "I": [
      "product-ifg",
      "product-internetservices",
      "product-ipsec"
    ],
    "J": [
      "product-jv",
      "product-jenvjava"
    ],
    "K": ["product-conceptdescriptions"],
    "L": [
      "product-lms",
      "product-leasy"
    ],
    "M": [
      "product-mt9750",
      "product-maren"
    ],
    "N": ["product-nfs"],
    "O": [
      "product-osdbcpackage",
      "product-osdxcpackage",
      "product-opennetserver",
      "product-osisessionservice",
      "product-opensm2",
      "product-omnis",
      "product-omnismenu",
      "product-oracle",
      "product-openft",
      "product-openutm",
      "product-onlinestoragefujitsueternus",
      "product-onlinestorageemcvmax"
    ],
    "P": [
      "product-posix",
      "product-percon",
      "product-pcs",
      "product-pascal",
      "product-perl",
      "product-pl1",
      "product-propxt",
      "product-pcmxunixbasedos"
    ],
    "R": [
      "product-rfa",
      "product-rso",
      "product-robar"
    ],
    "S": [
      "product-sort",
      "product-sdf",
      "product-sdfa",
      "product-sdfp",
      "product-sca",
      "product-sm2pa",
      "product-spool",
      "product-secos",
      "product-shcosd",
      "product-spaceopt",
      "product-sbabs2",
      "product-snmpagents",
      "product-ssasm2bs2",
      "product-ssaoutmbs2",
      "product-sscbs2",
      "product-sesamsql",
      "product-seseriesinfrastructure"
    ],
    "T": [
      "product-taskdate",
      "product-tomproducts",
      "product-tiam"
    ],
    "U": [
      "product-udsiqs",
      "product-udssql"
    ],
    "V": ["product-vm2000"],
    "W": ["product-webtransactions"],
    "X": ["product-xhcs"]
  },
  "servicePacks": [{
    "id": "sp-servicepack201",
    "name": "Service Pack 20.1",
    "spaceKey": "spSERVICEPACK201de",
    "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/display/spSERVICEPACK201de",
    "updatedProducts": [
      {
        "id": "product-internetservices",
        "name": "interNet Services",
        "description": "Eine Sammlung von Internet-Diensten für die Interoperabilität von Kommunikationspartnern in TCP/IP basierten Netzen.",
        "version": "V3.4B",
        "spaceKey": "psINTERNETSERVICESV34Bde",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psINTERNETSERVICESV34Bde",
        "releaseNotices": [{
          "title": "interNet Services",
          "subtitle": "",
          "version": "V3.4B",
          "type": "Freigabemitteilung",
          "edition": "2020-06",
          "filelink": "20259/sysfgm.inetserv.034.d.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "interNet Services - Freigabemitteilung - de (V3.4B, 2020-06)"
        }]
      },
      {
        "id": "product-lms",
        "name": "LMS",
        "description": "LMS erstellt und verwaltet BS2000 Programmbibliotheken und bearbeitet die darin enthaltenen Elemente.",
        "version": "V3.5",
        "spaceKey": "psLMSV35de",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psLMSV35de",
        "releaseNotices": [{
          "title": "LMS",
          "subtitle": "",
          "version": "V3.5B",
          "type": "Freigabemitteilung",
          "edition": "2020-06",
          "filelink": "20250/sysfgm.lms.035.d.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "LMS - Freigabemitteilung - de (V3.5B, 2020-06)"
        }]
      },
      {
        "id": "product-opensm2",
        "name": "openSM2",
        "description": "Liefert umfassende Messdaten über die Serversysteme BS2000, Linux, Microsoft Windows und die Speichersysteme ETERNUS DX und VMAX sowie alle SNMP-fähigen Systeme, um das Leistungsverhalten der Systeme gezielt zu verbessern.",
        "version": "V11.0B",
        "spaceKey": "psOPENSM2V110Bde",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psOPENSM2V110Bde",
        "releaseNotices": [
          {
            "title": "SM2-WEB",
            "subtitle": "",
            "version": "V11.0B",
            "type": "Freigabemitteilung",
            "edition": "2020-07",
            "filelink": "20269/sysfgm.sm2-web.110.d.pdf",
            "mediatype": "fj-mediatype-pdf",
            "descriptiveName": "SM2-WEB - Freigabemitteilung - de (V11.0B, 2020-07)"
          },
          {
            "title": "SM2-TOOLS",
            "subtitle": "",
            "version": "V11.0B",
            "type": "Freigabemitteilung",
            "edition": "2020-07",
            "filelink": "20268/sysfgm.sm2-tools.110.d.pdf",
            "mediatype": "fj-mediatype-pdf",
            "descriptiveName": "SM2-TOOLS - Freigabemitteilung - de (V11.0B, 2020-07)"
          }
        ]
      },
      {
        "id": "product-osdxcpackage",
        "name": "OSD/XC Paket",
        "description": "",
        "version": "V11.0B",
        "spaceKey": "psOSDXCPACKAGEV110Bde",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psOSDXCPACKAGEV110Bde",
        "releaseNotices": [{
          "title": "OSD/XC",
          "subtitle": "",
          "version": "V11.0B",
          "type": "Freigabemitteilung",
          "edition": "2020-06",
          "filelink": "20275/sysfgm.osdxc.110.d.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "OSD/XC - Freigabemitteilung - de (V11.0B, 2020-06)"
        }]
      },
      {
        "id": "product-shcosd",
        "name": "SHC-OSD",
        "description": "Informationsdienste und Kommandos zur Überwachung und Steuerung von Storage Systemen im BS2000.",
        "version": "V14.0",
        "spaceKey": "psSHCOSDV140de",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psSHCOSDV140de",
        "releaseNotices": [{
          "title": "SHC-OSD",
          "subtitle": "",
          "version": "V14.0A",
          "type": "Freigabemitteilung",
          "edition": "2020-04",
          "filelink": "20226/SYSFGM.SHC-OSD.140.D.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "SHC-OSD - Freigabemitteilung - de (V14.0A, 2020-04)"
        }]
      },
      {
        "id": "product-snmpagents",
        "name": "SNMP-AGENTS",
        "description": "Zentrale Überwachung von BS2000-Systemen und ihren Anwendungen via SNMP.",
        "version": "V1.1",
        "spaceKey": "psSNMPAGENTSV11de",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psSNMPAGENTSV11de",
        "releaseNotices": [{
          "title": "SNMP Agents",
          "subtitle": "",
          "version": "V1.1",
          "type": "Freigabemitteilung",
          "edition": "2020-07",
          "filelink": "20244/sysfgm.snmp-agents.011.d.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "SNMP Agents - Freigabemitteilung - de (V1.1, 2020-07)"
        }]
      },
      {
        "id": "product-webtransactions",
        "name": "WebTransactions",
        "description": "Portal Integration and Web enabling: Ein Business Processing Tool - Flexible Integration vorhandener Hostanwendungen.",
        "version": "V7.5",
        "spaceKey": "psWEBTRANSACTIONSV75de",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psWEBTRANSACTIONSV75de",
        "releaseNotices": [
          {
            "title": "WebTA openUTM (BS2000)",
            "subtitle": "",
            "version": "V7.5C",
            "type": "Freigabemitteilung",
            "edition": "2020-05",
            "filelink": "20320/sysfgm.webta-utm-bs2000.075.d.pdf",
            "mediatype": "fj-mediatype-pdf",
            "descriptiveName": "WebTA openUTM (BS2000) - Freigabemitteilung - de (V7.5C, 2020-05)"
          },
          {
            "title": "WebTA OSD (BS2000)",
            "subtitle": "",
            "version": "V7.5C",
            "type": "Freigabemitteilung",
            "edition": "2020-05",
            "filelink": "20318/sysfgm.webta-osd-bs2000.075.d.pdf",
            "mediatype": "fj-mediatype-pdf",
            "descriptiveName": "WebTA OSD (BS2000) - Freigabemitteilung - de (V7.5C, 2020-05)"
          }
        ]
      }
    ],
    "updatedReleaseNotices": [
      {
        "id": "product-crte",
        "name": "CRTE",
        "description": "Die erforderliche gemeinsame Laufzeitumgebung für die übersetzten Quellprogramme der Compiler C/C++, COBOL2000 und COBOL85.",
        "version": "V10.1",
        "spaceKey": "psCRTEV101de",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psCRTEV101de",
        "releaseNotices": [
          {
            "title": "CRTE-BAS",
            "subtitle": "",
            "version": "V10.1",
            "type": "Freigabemitteilung",
            "edition": "2020-07",
            "filelink": "20267/sysfgm.crte-bas.101.d.pdf",
            "mediatype": "fj-mediatype-pdf",
            "descriptiveName": "CRTE-BAS - Freigabemitteilung - de (V10.1, 2020-07)"
          },
          {
            "title": "CRTE",
            "subtitle": "",
            "version": "V10.1",
            "type": "Freigabemitteilung",
            "edition": "2020-07",
            "filelink": "20266/sysfgm.crte.101.d.pdf",
            "mediatype": "fj-mediatype-pdf",
            "descriptiveName": "CRTE - Freigabemitteilung - de (V10.1, 2020-07)"
          }
        ]
      },
      {
        "id": "product-crte",
        "name": "CRTE",
        "description": "Die erforderliche gemeinsame Laufzeitumgebung für die übersetzten Quellprogramme der Compiler C/C++, COBOL2000 und COBOL85.",
        "version": "V11.1",
        "spaceKey": "psCRTEV111de",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psCRTEV111de",
        "releaseNotices": [
          {
            "title": "CRTE-BAS",
            "subtitle": "",
            "version": "V11.1",
            "type": "Freigabemitteilung",
            "edition": "2020-07",
            "filelink": "20261/sysfgm.crte-bas.111.d.pdf",
            "mediatype": "fj-mediatype-pdf",
            "descriptiveName": "CRTE-BAS - Freigabemitteilung - de (V11.1, 2020-07)"
          },
          {
            "title": "CRTE",
            "subtitle": "",
            "version": "V11.1",
            "type": "Freigabemitteilung",
            "edition": "2020-07",
            "filelink": "20260/sysfgm.crte.111.d.pdf",
            "mediatype": "fj-mediatype-pdf",
            "descriptiveName": "CRTE - Freigabemitteilung - de (V11.1, 2020-07)"
          }
        ]
      },
      {
        "id": "product-hsms",
        "name": "HSMS",
        "description": "Hierarchisches Speicher-Management-System.",
        "version": "V12.0",
        "spaceKey": "psHSMSV120de",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psHSMSV120de",
        "releaseNotices": [{
          "title": "HSMS",
          "subtitle": "",
          "version": "V12.0A",
          "type": "Freigabemitteilung",
          "edition": "2020-06",
          "filelink": "20255/SYSFGM.HSMS.120.D.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "HSMS - Freigabemitteilung - de (V12.0A, 2020-06)"
        }]
      },
      {
        "id": "product-osdbcpackage",
        "name": "OSD/BC Paket",
        "description": "",
        "version": "V10.0",
        "spaceKey": "psOSDBCPACKAGEV100de",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psOSDBCPACKAGEV100de",
        "releaseNotices": [{
          "title": "OSD/BC",
          "subtitle": "",
          "version": "V10.0A",
          "type": "Freigabemitteilung",
          "edition": "2020-06",
          "filelink": "20272/sysfgm.bs2osd.100.d.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "OSD/BC - Freigabemitteilung - de (V10.0A, 2020-06)"
        }]
      },
      {
        "id": "product-osdbcpackage",
        "name": "OSD/BC Paket",
        "description": "",
        "version": "V11.0B",
        "spaceKey": "psOSDBCPACKAGEV110Bde",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psOSDBCPACKAGEV110Bde",
        "releaseNotices": [{
          "title": "OSD/BC",
          "subtitle": "",
          "version": "V11.0B",
          "type": "Freigabemitteilung",
          "edition": "2020-06",
          "filelink": "20273/sysfgm.bs2osd.110.d.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "OSD/BC - Freigabemitteilung - de (V11.0B, 2020-06)"
        }]
      },
      {
        "id": "product-osdxcpackage",
        "name": "OSD/XC Paket",
        "description": "",
        "version": "V10.0",
        "spaceKey": "psOSDXCPACKAGEV100de",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psOSDXCPACKAGEV100de",
        "releaseNotices": [{
          "title": "OSD/XC",
          "subtitle": "",
          "version": "V10.0",
          "type": "Freigabemitteilung",
          "edition": "2020-06",
          "filelink": "20274/sysfgm.osdxc.100.d.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "OSD/XC - Freigabemitteilung - de (V10.0, 2020-06)"
        }]
      },
      {
        "id": "product-secos",
        "name": "SECOS",
        "description": "Das Produkt SECOS realisiert für BS2000-Systeme einfache bis anspruchsvolle, kundenindividuelle Sicherheitskonzepte.",
        "version": "V5.5",
        "spaceKey": "psSECOSV55de",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psSECOSV55de",
        "releaseNotices": [{
          "title": "SECOS",
          "subtitle": "",
          "version": "V5.5",
          "type": "Freigabemitteilung",
          "edition": "2020-06",
          "filelink": "20256/sysfgm.secos.055.d.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "SECOS - Freigabemitteilung - de (V5.5, 2020-06)"
        }]
      },
      {
        "id": "product-vm2000",
        "name": "VM2000",
        "description": "Das Virtuelle Maschinensystem VM2000 ermöglicht das gleichzeitige Betreiben unterschiedlicher BS2000-Systeme auf einem Server.",
        "version": "V11.5",
        "spaceKey": "psVM2000V115de",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psVM2000V115de",
        "releaseNotices": [{
          "title": "VM2000-MON",
          "subtitle": "",
          "version": "V11.5",
          "type": "Freigabemitteilung",
          "edition": "2020-06",
          "filelink": "20249/SYSFGM.VM2000-MON.115.D.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "VM2000-MON - Freigabemitteilung - de (V11.5, 2020-06)"
        }]
      }
    ]
  }],
  "products": {
    "product-bs2000operatingsystem": {
      "id": "product-bs2000operatingsystem",
      "productPackage": false,
      "name": "BS2000 Betriebssystem",
      "latestVersion": {
        "version": "V11.0B",
        "latest": true,
        "spaceKey": "psBS2000OPERATINGSYSTEMV110Bde"
      },
      "versions": [
        {
          "version": "V11.0B",
          "latest": true,
          "spaceKey": "psBS2000OPERATINGSYSTEMV110Bde"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psBS2000OPERATINGSYSTEMV100de"
        },
        {
          "version": "Frühere Manuale",
          "latest": false,
          "spaceKey": "psBS2000OPERATINGSYSTEMV01de"
        }
      ]
    },
    "product-posix": {
      "id": "product-posix",
      "productPackage": false,
      "name": "POSIX",
      "latestVersion": {
        "version": "V11.0",
        "latest": true,
        "spaceKey": "psPOSIXV110de"
      },
      "versions": [
        {
          "version": "V11.0",
          "latest": true,
          "spaceKey": "psPOSIXV110de"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psPOSIXV100de"
        },
        {
          "version": "V9.0",
          "latest": false,
          "spaceKey": "psPOSIXV90de"
        }
      ]
    },
    "product-osdbcpackage": {
      "id": "product-osdbcpackage",
      "productPackage": true,
      "name": "OSD/BC Paket",
      "latestVersion": {
        "version": "V11.0B",
        "latest": true,
        "spaceKey": "psOSDBCPACKAGEV110Bde"
      },
      "versions": [
        {
          "version": "V11.0B",
          "latest": true,
          "spaceKey": "psOSDBCPACKAGEV110Bde"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psOSDBCPACKAGEV100de"
        }
      ]
    },
    "product-osdxcpackage": {
      "id": "product-osdxcpackage",
      "productPackage": true,
      "name": "OSD/XC Paket",
      "latestVersion": {
        "version": "V11.0B",
        "latest": true,
        "spaceKey": "psOSDXCPACKAGEV110Bde"
      },
      "versions": [
        {
          "version": "V11.0B",
          "latest": true,
          "spaceKey": "psOSDXCPACKAGEV110Bde"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psOSDXCPACKAGEV100de"
        }
      ]
    },
    "product-conceptdescriptions": {
      "id": "product-conceptdescriptions",
      "productPackage": false,
      "name": "Konzeptbeschreibungen",
      "latestVersion": {
        "version": "V11.0B",
        "latest": true,
        "spaceKey": "psCONCEPTDESCRIPTIONSV110Bde"
      },
      "versions": [
        {
          "version": "V11.0B",
          "latest": true,
          "spaceKey": "psCONCEPTDESCRIPTIONSV110Bde"
        },
        {
          "version": "V11.0",
          "latest": false,
          "spaceKey": "psCONCEPTDESCRIPTIONSV110de"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psCONCEPTDESCRIPTIONSV100de"
        },
        {
          "version": "V9.0",
          "latest": false,
          "spaceKey": "psCONCEPTDESCRIPTIONSV90de"
        }
      ]
    },
    "product-edt": {
      "id": "product-edt",
      "productPackage": false,
      "name": "EDT",
      "latestVersion": {
        "version": "V17.0",
        "latest": true,
        "spaceKey": "psEDTV170de"
      },
      "versions": [{
        "version": "V17.0",
        "latest": true,
        "spaceKey": "psEDTV170de"
      }]
    },
    "product-fhs": {
      "id": "product-fhs",
      "productPackage": false,
      "name": "FHS",
      "latestVersion": {
        "version": "V8.3",
        "latest": true,
        "spaceKey": "psFHSV83de"
      },
      "versions": [{
        "version": "V8.3",
        "latest": true,
        "spaceKey": "psFHSV83de"
      }]
    },
    "product-fms": {
      "id": "product-fms",
      "productPackage": false,
      "name": "FMS",
      "latestVersion": {
        "version": "V2.4",
        "latest": true,
        "spaceKey": "psFMSV24de"
      },
      "versions": [{
        "version": "V2.4",
        "latest": true,
        "spaceKey": "psFMSV24de"
      }]
    },
    "product-ifg": {
      "id": "product-ifg",
      "productPackage": false,
      "name": "IFG",
      "latestVersion": {
        "version": "V8.3",
        "latest": true,
        "spaceKey": "psIFGV83de"
      },
      "versions": [{
        "version": "V8.3",
        "latest": true,
        "spaceKey": "psIFGV83de"
      }]
    },
    "product-lms": {
      "id": "product-lms",
      "productPackage": false,
      "name": "LMS",
      "latestVersion": {
        "version": "V3.5",
        "latest": true,
        "spaceKey": "psLMSV35de"
      },
      "versions": [{
        "version": "V3.5",
        "latest": true,
        "spaceKey": "psLMSV35de"
      }]
    },
    "product-percon": {
      "id": "product-percon",
      "productPackage": false,
      "name": "PERCON",
      "latestVersion": {
        "version": "V2.9",
        "latest": true,
        "spaceKey": "psPERCONV29de"
      },
      "versions": [{
        "version": "V2.9",
        "latest": true,
        "spaceKey": "psPERCONV29de"
      }]
    },
    "product-rfa": {
      "id": "product-rfa",
      "productPackage": false,
      "name": "RFA",
      "latestVersion": {
        "version": "V20.0",
        "latest": true,
        "spaceKey": "psRFAV200de"
      },
      "versions": [
        {
          "version": "V20.0",
          "latest": true,
          "spaceKey": "psRFAV200de"
        },
        {
          "version": "V19.0",
          "latest": false,
          "spaceKey": "psRFAV190de"
        }
      ]
    },
    "product-sort": {
      "id": "product-sort",
      "productPackage": false,
      "name": "SORT",
      "latestVersion": {
        "version": "V8.0",
        "latest": true,
        "spaceKey": "psSORTV80de"
      },
      "versions": [{
        "version": "V8.0",
        "latest": true,
        "spaceKey": "psSORTV80de"
      }]
    },
    "product-taskdate": {
      "id": "product-taskdate",
      "productPackage": false,
      "name": "TASKDATE",
      "latestVersion": {
        "version": "V20.0B",
        "latest": true,
        "spaceKey": "psTASKDATEV200Bde"
      },
      "versions": [
        {
          "version": "V20.0B",
          "latest": true,
          "spaceKey": "psTASKDATEV200Bde"
        },
        {
          "version": "V19.0",
          "latest": false,
          "spaceKey": "psTASKDATEV190de"
        }
      ]
    },
    "product-tomproducts": {
      "id": "product-tomproducts",
      "productPackage": false,
      "name": "TOM-Produkte",
      "latestVersion": {
        "version": "V5.1",
        "latest": true,
        "spaceKey": "psTOMPRODUCTSV51de"
      },
      "versions": [
        {
          "version": "V5.1",
          "latest": true,
          "spaceKey": "psTOMPRODUCTSV51de"
        },
        {
          "version": "V5.0",
          "latest": false,
          "spaceKey": "psTOMPRODUCTSV50de"
        },
        {
          "version": "V3.2",
          "latest": false,
          "spaceKey": "psTOMPRODUCTSV32de"
        },
        {
          "version": "V3.0",
          "latest": false,
          "spaceKey": "psTOMPRODUCTSV30de"
        }
      ]
    },
    "product-avas": {
      "id": "product-avas",
      "productPackage": false,
      "name": "AVAS",
      "latestVersion": {
        "version": "V8.5",
        "latest": true,
        "spaceKey": "psAVASV85de"
      },
      "versions": [{
        "version": "V8.5",
        "latest": true,
        "spaceKey": "psAVASV85de"
      }]
    },
    "product-jv": {
      "id": "product-jv",
      "productPackage": false,
      "name": "JV",
      "latestVersion": {
        "version": "V15.1",
        "latest": true,
        "spaceKey": "psJVV151de"
      },
      "versions": [{
        "version": "V15.1",
        "latest": true,
        "spaceKey": "psJVV151de"
      }]
    },
    "product-sdf": {
      "id": "product-sdf",
      "productPackage": false,
      "name": "SDF",
      "latestVersion": {
        "version": "V4.8",
        "latest": true,
        "spaceKey": "psSDFV48de"
      },
      "versions": [
        {
          "version": "V4.8",
          "latest": true,
          "spaceKey": "psSDFV48de"
        },
        {
          "version": "V4.7",
          "latest": false,
          "spaceKey": "psSDFV47de"
        },
        {
          "version": "V4.6",
          "latest": false,
          "spaceKey": "psSDFV46de"
        }
      ]
    },
    "product-sdfa": {
      "id": "product-sdfa",
      "productPackage": false,
      "name": "SDF-A",
      "latestVersion": {
        "version": "V4.1",
        "latest": true,
        "spaceKey": "psSDFAV41de"
      },
      "versions": [{
        "version": "V4.1",
        "latest": true,
        "spaceKey": "psSDFAV41de"
      }]
    },
    "product-sdfp": {
      "id": "product-sdfp",
      "productPackage": false,
      "name": "SDF-P",
      "latestVersion": {
        "version": "V2.5",
        "latest": true,
        "spaceKey": "psSDFPV25de"
      },
      "versions": [{
        "version": "V2.5",
        "latest": true,
        "spaceKey": "psSDFPV25de"
      }]
    },
    "product-apache": {
      "id": "product-apache",
      "productPackage": false,
      "name": "Apache",
      "latestVersion": {
        "version": "V2.4",
        "latest": true,
        "spaceKey": "psAPACHEV24de"
      },
      "versions": [
        {
          "version": "V2.4",
          "latest": true,
          "spaceKey": "psAPACHEV24de"
        },
        {
          "version": "V2.2",
          "latest": false,
          "spaceKey": "psAPACHEV22de"
        }
      ]
    },
    "product-internetservices": {
      "id": "product-internetservices",
      "productPackage": false,
      "name": "interNet Services",
      "latestVersion": {
        "version": "V3.4B",
        "latest": true,
        "spaceKey": "psINTERNETSERVICESV34Bde"
      },
      "versions": [
        {
          "version": "V3.4B",
          "latest": true,
          "spaceKey": "psINTERNETSERVICESV34Bde"
        },
        {
          "version": "V3.4",
          "latest": false,
          "spaceKey": "psINTERNETSERVICESV34de"
        }
      ]
    },
    "product-mt9750": {
      "id": "product-mt9750",
      "productPackage": false,
      "name": "MT9750",
      "latestVersion": {
        "version": "V9.0",
        "latest": true,
        "spaceKey": "psMT9750V90de"
      },
      "versions": [
        {
          "version": "V9.0",
          "latest": true,
          "spaceKey": "psMT9750V90de"
        },
        {
          "version": "V8.0",
          "latest": false,
          "spaceKey": "psMT9750V80de"
        }
      ]
    },
    "product-nfs": {
      "id": "product-nfs",
      "productPackage": false,
      "name": "NFS",
      "latestVersion": {
        "version": "V3.0",
        "latest": true,
        "spaceKey": "psNFSV30de"
      },
      "versions": [{
        "version": "V3.0",
        "latest": true,
        "spaceKey": "psNFSV30de"
      }]
    },
    "product-opennetserver": {
      "id": "product-opennetserver",
      "productPackage": false,
      "name": "openNet Server",
      "latestVersion": {
        "version": "V4.0",
        "latest": true,
        "spaceKey": "psOPENNETSERVERV40de"
      },
      "versions": [
        {
          "version": "V4.0",
          "latest": true,
          "spaceKey": "psOPENNETSERVERV40de"
        },
        {
          "version": "V3.6",
          "latest": false,
          "spaceKey": "psOPENNETSERVERV36de"
        }
      ]
    },
    "product-osisessionservice": {
      "id": "product-osisessionservice",
      "productPackage": false,
      "name": "OSI Session Service",
      "latestVersion": {
        "version": "V4.1",
        "latest": true,
        "spaceKey": "psOSISESSIONSERVICEV41de"
      },
      "versions": [{
        "version": "V4.1",
        "latest": true,
        "spaceKey": "psOSISESSIONSERVICEV41de"
      }]
    },
    "product-tiam": {
      "id": "product-tiam",
      "productPackage": false,
      "name": "TIAM",
      "latestVersion": {
        "version": "V13.2",
        "latest": true,
        "spaceKey": "psTIAMV132de"
      },
      "versions": [{
        "version": "V13.2",
        "latest": true,
        "spaceKey": "psTIAMV132de"
      }]
    },
    "product-xhcs": {
      "id": "product-xhcs",
      "productPackage": false,
      "name": "XHCS",
      "latestVersion": {
        "version": "V4.0",
        "latest": true,
        "spaceKey": "psXHCSV40de"
      },
      "versions": [
        {
          "version": "V4.0",
          "latest": true,
          "spaceKey": "psXHCSV40de"
        },
        {
          "version": "V3.6",
          "latest": false,
          "spaceKey": "psXHCSV36de"
        },
        {
          "version": "V3.5",
          "latest": false,
          "spaceKey": "psXHCSV35de"
        }
      ]
    },
    "product-cosmos": {
      "id": "product-cosmos",
      "productPackage": false,
      "name": "COSMOS",
      "latestVersion": {
        "version": "V20.0B",
        "latest": true,
        "spaceKey": "psCOSMOSV200Bde"
      },
      "versions": [
        {
          "version": "V20.0B",
          "latest": true,
          "spaceKey": "psCOSMOSV200Bde"
        },
        {
          "version": "V20.0",
          "latest": false,
          "spaceKey": "psCOSMOSV200de"
        },
        {
          "version": "V19.0",
          "latest": false,
          "spaceKey": "psCOSMOSV190de"
        },
        {
          "version": "V18.0",
          "latest": false,
          "spaceKey": "psCOSMOSV180de"
        }
      ]
    },
    "product-dab": {
      "id": "product-dab",
      "productPackage": false,
      "name": "DAB",
      "latestVersion": {
        "version": "V9.5",
        "latest": true,
        "spaceKey": "psDABV95de"
      },
      "versions": [
        {
          "version": "V9.5",
          "latest": true,
          "spaceKey": "psDABV95de"
        },
        {
          "version": "V9.4",
          "latest": false,
          "spaceKey": "psDABV94de"
        }
      ]
    },
    "product-opensm2": {
      "id": "product-opensm2",
      "productPackage": false,
      "name": "openSM2",
      "latestVersion": {
        "version": "V11.0B",
        "latest": true,
        "spaceKey": "psOPENSM2V110Bde"
      },
      "versions": [
        {
          "version": "V11.0B",
          "latest": true,
          "spaceKey": "psOPENSM2V110Bde"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psOPENSM2V100de"
        },
        {
          "version": "V9.2",
          "latest": false,
          "spaceKey": "psOPENSM2V92de"
        }
      ]
    },
    "product-pcs": {
      "id": "product-pcs",
      "productPackage": false,
      "name": "PCS",
      "latestVersion": {
        "version": "V3.2",
        "latest": true,
        "spaceKey": "psPCSV32de"
      },
      "versions": [
        {
          "version": "V3.2",
          "latest": true,
          "spaceKey": "psPCSV32de"
        },
        {
          "version": "V3.1",
          "latest": false,
          "spaceKey": "psPCSV31de"
        }
      ]
    },
    "product-rav": {
      "id": "product-rav",
      "productPackage": false,
      "name": "RAV",
      "latestVersion": {
        "version": "",
        "latest": true,
        "spaceKey": "psRAVde"
      },
      "versions": [{
        "version": "",
        "latest": true,
        "spaceKey": "psRAVde"
      }]
    },
    "product-sca": {
      "id": "product-sca",
      "productPackage": false,
      "name": "SCA",
      "latestVersion": {
        "version": "V20.0",
        "latest": true,
        "spaceKey": "psSCAV200de"
      },
      "versions": [
        {
          "version": "V20.0",
          "latest": true,
          "spaceKey": "psSCAV200de"
        },
        {
          "version": "V19.0",
          "latest": false,
          "spaceKey": "psSCAV190de"
        }
      ]
    },
    "product-sm2pa": {
      "id": "product-sm2pa",
      "productPackage": false,
      "name": "SM2-PA",
      "latestVersion": {
        "version": "V2.0",
        "latest": true,
        "spaceKey": "psSM2PAV20de"
      },
      "versions": [{
        "version": "V2.0",
        "latest": true,
        "spaceKey": "psSM2PAV20de"
      }]
    },
    "product-bs2zip": {
      "id": "product-bs2zip",
      "productPackage": false,
      "name": "BS2ZIP",
      "latestVersion": {
        "version": "V1.2",
        "latest": true,
        "spaceKey": "psBS2ZIPV12de"
      },
      "versions": [{
        "version": "V1.2",
        "latest": true,
        "spaceKey": "psBS2ZIPV12de"
      }]
    },
    "product-conv2pdf": {
      "id": "product-conv2pdf",
      "productPackage": false,
      "name": "CONV2PDF",
      "latestVersion": {
        "version": "V4.9",
        "latest": true,
        "spaceKey": "psCONV2PDFV49de"
      },
      "versions": [{
        "version": "V4.9",
        "latest": true,
        "spaceKey": "psCONV2PDFV49de"
      }]
    },
    "product-dprint": {
      "id": "product-dprint",
      "productPackage": false,
      "name": "DPRINT",
      "latestVersion": {
        "version": "V1.2",
        "latest": true,
        "spaceKey": "psDPRINTV12de"
      },
      "versions": [{
        "version": "V1.2",
        "latest": true,
        "spaceKey": "psDPRINTV12de"
      }]
    },
    "product-rso": {
      "id": "product-rso",
      "productPackage": false,
      "name": "RSO",
      "latestVersion": {
        "version": "V3.6",
        "latest": true,
        "spaceKey": "psRSOV36de"
      },
      "versions": [{
        "version": "V3.6",
        "latest": true,
        "spaceKey": "psRSOV36de"
      }]
    },
    "product-spool": {
      "id": "product-spool",
      "productPackage": false,
      "name": "SPOOL",
      "latestVersion": {
        "version": "V4.9",
        "latest": true,
        "spaceKey": "psSPOOLV49de"
      },
      "versions": [{
        "version": "V4.9",
        "latest": true,
        "spaceKey": "psSPOOLV49de"
      }]
    },
    "product-aid": {
      "id": "product-aid",
      "productPackage": false,
      "name": "AID",
      "latestVersion": {
        "version": "V3.4",
        "latest": true,
        "spaceKey": "psAIDV34de"
      },
      "versions": [{
        "version": "V3.4",
        "latest": true,
        "spaceKey": "psAIDV34de"
      }]
    },
    "product-assembh": {
      "id": "product-assembh",
      "productPackage": false,
      "name": "ASSEMBH",
      "latestVersion": {
        "version": "V1.3",
        "latest": true,
        "spaceKey": "psASSEMBHV13de"
      },
      "versions": [{
        "version": "V1.3",
        "latest": true,
        "spaceKey": "psASSEMBHV13de"
      }]
    },
    "product-bs2ide": {
      "id": "product-bs2ide",
      "productPackage": false,
      "name": "BS2IDE",
      "latestVersion": {
        "version": "",
        "latest": true,
        "spaceKey": "psBS2IDEde"
      },
      "versions": [{
        "version": "",
        "latest": true,
        "spaceKey": "psBS2IDEde"
      }]
    },
    "product-cobol85": {
      "id": "product-cobol85",
      "productPackage": false,
      "name": "COBOL85",
      "latestVersion": {
        "version": "V2.3",
        "latest": true,
        "spaceKey": "psCOBOL85V23de"
      },
      "versions": [{
        "version": "V2.3",
        "latest": true,
        "spaceKey": "psCOBOL85V23de"
      }]
    },
    "product-cobol2000": {
      "id": "product-cobol2000",
      "productPackage": false,
      "name": "COBOL2000",
      "latestVersion": {
        "version": "V1.6",
        "latest": true,
        "spaceKey": "psCOBOL2000V16de"
      },
      "versions": [
        {
          "version": "V1.6",
          "latest": true,
          "spaceKey": "psCOBOL2000V16de"
        },
        {
          "version": "V1.5",
          "latest": false,
          "spaceKey": "psCOBOL2000V15de"
        }
      ]
    },
    "product-columbus85": {
      "id": "product-columbus85",
      "productPackage": false,
      "name": "COLUMBUS85",
      "latestVersion": {
        "version": "V1.1",
        "latest": true,
        "spaceKey": "psCOLUMBUS85V11de"
      },
      "versions": [{
        "version": "V1.1",
        "latest": true,
        "spaceKey": "psCOLUMBUS85V11de"
      }]
    },
    "product-cc++": {
      "id": "product-cc++",
      "productPackage": false,
      "name": "C/C++",
      "latestVersion": {
        "version": "V4.0",
        "latest": true,
        "spaceKey": "psCCV40de"
      },
      "versions": [
        {
          "version": "V4.0",
          "latest": true,
          "spaceKey": "psCCV40de"
        },
        {
          "version": "V3.2",
          "latest": false,
          "spaceKey": "psCCV32de"
        }
      ]
    },
    "product-crte": {
      "id": "product-crte",
      "productPackage": false,
      "name": "CRTE",
      "latestVersion": {
        "version": "V11.1",
        "latest": true,
        "spaceKey": "psCRTEV111de"
      },
      "versions": [
        {
          "version": "V11.1",
          "latest": true,
          "spaceKey": "psCRTEV111de"
        },
        {
          "version": "V11.0",
          "latest": false,
          "spaceKey": "psCRTEV110de"
        },
        {
          "version": "V10.1",
          "latest": false,
          "spaceKey": "psCRTEV101de"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psCRTEV100de"
        },
        {
          "version": "V1.9",
          "latest": false,
          "spaceKey": "psCRTEV19de"
        }
      ]
    },
    "product-for1fortran": {
      "id": "product-for1fortran",
      "productPackage": false,
      "name": "FOR1 (Fortran)",
      "latestVersion": {
        "version": "V2.2",
        "latest": true,
        "spaceKey": "psFOR1FORTRANV22de"
      },
      "versions": [{
        "version": "V2.2",
        "latest": true,
        "spaceKey": "psFOR1FORTRANV22de"
      }]
    },
    "product-jenvjava": {
      "id": "product-jenvjava",
      "productPackage": false,
      "name": "JENV (Java)",
      "latestVersion": {
        "version": "V9.0",
        "latest": true,
        "spaceKey": "psJENVJAVAV90de"
      },
      "versions": [
        {
          "version": "V9.0",
          "latest": true,
          "spaceKey": "psJENVJAVAV90de"
        },
        {
          "version": "V8.1",
          "latest": false,
          "spaceKey": "psJENVJAVAV81de"
        }
      ]
    },
    "product-pascal": {
      "id": "product-pascal",
      "productPackage": false,
      "name": "Pascal",
      "latestVersion": {
        "version": "V2.2",
        "latest": true,
        "spaceKey": "psPASCALV22de"
      },
      "versions": [{
        "version": "V2.2",
        "latest": true,
        "spaceKey": "psPASCALV22de"
      }]
    },
    "product-perl": {
      "id": "product-perl",
      "productPackage": false,
      "name": "PERL",
      "latestVersion": {
        "version": "V52.4",
        "latest": true,
        "spaceKey": "psPERLV524de"
      },
      "versions": [
        {
          "version": "V52.4",
          "latest": true,
          "spaceKey": "psPERLV524de"
        },
        {
          "version": "V5.8",
          "latest": false,
          "spaceKey": "psPERLV58de"
        },
        {
          "version": "V1.3",
          "latest": false,
          "spaceKey": "psPERLV13de"
        },
        {
          "version": "V1.0",
          "latest": false,
          "spaceKey": "psPERLV10de"
        }
      ]
    },
    "product-pl1": {
      "id": "product-pl1",
      "productPackage": false,
      "name": "PL/1",
      "latestVersion": {
        "version": "V4.2",
        "latest": true,
        "spaceKey": "psPL1V42de"
      },
      "versions": [{
        "version": "V4.2",
        "latest": true,
        "spaceKey": "psPL1V42de"
      }]
    },
    "product-crypt": {
      "id": "product-crypt",
      "productPackage": false,
      "name": "CRYPT",
      "latestVersion": {
        "version": "V2.0",
        "latest": true,
        "spaceKey": "psCRYPTV20de"
      },
      "versions": [{
        "version": "V2.0",
        "latest": true,
        "spaceKey": "psCRYPTV20de"
      }]
    },
    "product-ipsec": {
      "id": "product-ipsec",
      "productPackage": false,
      "name": "IPSec",
      "latestVersion": {
        "version": "V1.4",
        "latest": true,
        "spaceKey": "psIPSECV14de"
      },
      "versions": [{
        "version": "V1.4",
        "latest": true,
        "spaceKey": "psIPSECV14de"
      }]
    },
    "product-secos": {
      "id": "product-secos",
      "productPackage": false,
      "name": "SECOS",
      "latestVersion": {
        "version": "V5.5",
        "latest": true,
        "spaceKey": "psSECOSV55de"
      },
      "versions": [
        {
          "version": "V5.5",
          "latest": true,
          "spaceKey": "psSECOSV55de"
        },
        {
          "version": "V5.4",
          "latest": false,
          "spaceKey": "psSECOSV54de"
        }
      ]
    },
    "product-archive": {
      "id": "product-archive",
      "productPackage": false,
      "name": "ARCHIVE",
      "latestVersion": {
        "version": "V12.0",
        "latest": true,
        "spaceKey": "psARCHIVEV120de"
      },
      "versions": [
        {
          "version": "V12.0",
          "latest": true,
          "spaceKey": "psARCHIVEV120de"
        },
        {
          "version": "V11.0",
          "latest": false,
          "spaceKey": "psARCHIVEV110de"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psARCHIVEV100de"
        }
      ]
    },
    "product-drv": {
      "id": "product-drv",
      "productPackage": false,
      "name": "DRV",
      "latestVersion": {
        "version": "V3.2",
        "latest": true,
        "spaceKey": "psDRVV32de"
      },
      "versions": [{
        "version": "V3.2",
        "latest": true,
        "spaceKey": "psDRVV32de"
      }]
    },
    "product-fddrl": {
      "id": "product-fddrl",
      "productPackage": false,
      "name": "FDDRL",
      "latestVersion": {
        "version": "V20.0",
        "latest": true,
        "spaceKey": "psFDDRLV200de"
      },
      "versions": [
        {
          "version": "V20.0",
          "latest": true,
          "spaceKey": "psFDDRLV200de"
        },
        {
          "version": "V19.0",
          "latest": false,
          "spaceKey": "psFDDRLV190de"
        }
      ]
    },
    "product-hsms": {
      "id": "product-hsms",
      "productPackage": false,
      "name": "HSMS",
      "latestVersion": {
        "version": "V12.0",
        "latest": true,
        "spaceKey": "psHSMSV120de"
      },
      "versions": [
        {
          "version": "V12.0",
          "latest": true,
          "spaceKey": "psHSMSV120de"
        },
        {
          "version": "V11.0",
          "latest": false,
          "spaceKey": "psHSMSV110de"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psHSMSV100de"
        }
      ]
    },
    "product-maren": {
      "id": "product-maren",
      "productPackage": false,
      "name": "MAREN",
      "latestVersion": {
        "version": "V12.5",
        "latest": true,
        "spaceKey": "psMARENV125de"
      },
      "versions": [
        {
          "version": "V12.5",
          "latest": true,
          "spaceKey": "psMARENV125de"
        },
        {
          "version": "V12.0",
          "latest": false,
          "spaceKey": "psMARENV120de"
        }
      ]
    },
    "product-robar": {
      "id": "product-robar",
      "productPackage": false,
      "name": "ROBAR",
      "latestVersion": {
        "version": "V7.6",
        "latest": true,
        "spaceKey": "psROBARV76de"
      },
      "versions": [
        {
          "version": "V7.6",
          "latest": true,
          "spaceKey": "psROBARV76de"
        },
        {
          "version": "V7.5",
          "latest": false,
          "spaceKey": "psROBARV75de"
        },
        {
          "version": "V7.0",
          "latest": false,
          "spaceKey": "psROBARV70de"
        }
      ]
    },
    "product-shcosd": {
      "id": "product-shcosd",
      "productPackage": false,
      "name": "SHC-OSD",
      "latestVersion": {
        "version": "V14.0",
        "latest": true,
        "spaceKey": "psSHCOSDV140de"
      },
      "versions": [
        {
          "version": "V14.0",
          "latest": true,
          "spaceKey": "psSHCOSDV140de"
        },
        {
          "version": "V13.0",
          "latest": false,
          "spaceKey": "psSHCOSDV130de"
        },
        {
          "version": "V12.0",
          "latest": false,
          "spaceKey": "psSHCOSDV120de"
        }
      ]
    },
    "product-spaceopt": {
      "id": "product-spaceopt",
      "productPackage": false,
      "name": "SPACEOPT",
      "latestVersion": {
        "version": "V8.0",
        "latest": true,
        "spaceKey": "psSPACEOPTV80de"
      },
      "versions": [
        {
          "version": "V8.0",
          "latest": true,
          "spaceKey": "psSPACEOPTV80de"
        },
        {
          "version": "V7.0",
          "latest": false,
          "spaceKey": "psSPACEOPTV70de"
        }
      ]
    },
    "product-hiplexmscf": {
      "id": "product-hiplexmscf",
      "productPackage": false,
      "name": "HIPLEX-MSCF",
      "latestVersion": {
        "version": "V11.0",
        "latest": true,
        "spaceKey": "psHIPLEXMSCFV110de"
      },
      "versions": [
        {
          "version": "V11.0",
          "latest": true,
          "spaceKey": "psHIPLEXMSCFV110de"
        },
        {
          "version": "V8.0",
          "latest": false,
          "spaceKey": "psHIPLEXMSCFV80de"
        }
      ]
    },
    "product-omnis": {
      "id": "product-omnis",
      "productPackage": false,
      "name": "OMNIS",
      "latestVersion": {
        "version": "V8.5",
        "latest": true,
        "spaceKey": "psOMNISV85de"
      },
      "versions": [{
        "version": "V8.5",
        "latest": true,
        "spaceKey": "psOMNISV85de"
      }]
    },
    "product-omnismenu": {
      "id": "product-omnismenu",
      "productPackage": false,
      "name": "OMNIS-MENU",
      "latestVersion": {
        "version": "V3.5",
        "latest": true,
        "spaceKey": "psOMNISMENUV35de"
      },
      "versions": [{
        "version": "V3.5",
        "latest": true,
        "spaceKey": "psOMNISMENUV35de"
      }]
    },
    "product-propxt": {
      "id": "product-propxt",
      "productPackage": false,
      "name": "PROP-XT",
      "latestVersion": {
        "version": "V1.3",
        "latest": true,
        "spaceKey": "psPROPXTV13de"
      },
      "versions": [{
        "version": "V1.3",
        "latest": true,
        "spaceKey": "psPROPXTV13de"
      }]
    },
    "product-sbabs2": {
      "id": "product-sbabs2",
      "productPackage": false,
      "name": "SBA-BS2",
      "latestVersion": {
        "version": "V6.2",
        "latest": true,
        "spaceKey": "psSBABS2V62de"
      },
      "versions": [{
        "version": "V6.2",
        "latest": true,
        "spaceKey": "psSBABS2V62de"
      }]
    },
    "product-snmpagents": {
      "id": "product-snmpagents",
      "productPackage": false,
      "name": "SNMP-AGENTS",
      "latestVersion": {
        "version": "V1.1",
        "latest": true,
        "spaceKey": "psSNMPAGENTSV11de"
      },
      "versions": [
        {
          "version": "V1.1",
          "latest": true,
          "spaceKey": "psSNMPAGENTSV11de"
        },
        {
          "version": "V1.0",
          "latest": false,
          "spaceKey": "psSNMPAGENTSV10de"
        }
      ]
    },
    "product-ssasm2bs2": {
      "id": "product-ssasm2bs2",
      "productPackage": false,
      "name": "SSA-SM2-BS2",
      "latestVersion": {
        "version": "V5.0",
        "latest": true,
        "spaceKey": "psSSASM2BS2V50de"
      },
      "versions": [{
        "version": "V5.0",
        "latest": true,
        "spaceKey": "psSSASM2BS2V50de"
      }]
    },
    "product-ssaoutmbs2": {
      "id": "product-ssaoutmbs2",
      "productPackage": false,
      "name": "SSA-OUTM-BS2",
      "latestVersion": {
        "version": "V5.0",
        "latest": true,
        "spaceKey": "psSSAOUTMBS2V50de"
      },
      "versions": [{
        "version": "V5.0",
        "latest": true,
        "spaceKey": "psSSAOUTMBS2V50de"
      }]
    },
    "product-sscbs2": {
      "id": "product-sscbs2",
      "productPackage": false,
      "name": "SSC-BS2",
      "latestVersion": {
        "version": "V6.0",
        "latest": true,
        "spaceKey": "psSSCBS2V60de"
      },
      "versions": [{
        "version": "V6.0",
        "latest": true,
        "spaceKey": "psSSCBS2V60de"
      }]
    },
    "product-vm2000": {
      "id": "product-vm2000",
      "productPackage": false,
      "name": "VM2000",
      "latestVersion": {
        "version": "V11.5",
        "latest": true,
        "spaceKey": "psVM2000V115de"
      },
      "versions": [
        {
          "version": "V11.5",
          "latest": true,
          "spaceKey": "psVM2000V115de"
        },
        {
          "version": "V11.0",
          "latest": false,
          "spaceKey": "psVM2000V110de"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psVM2000V100de"
        }
      ]
    },
    "product-cis": {
      "id": "product-cis",
      "productPackage": false,
      "name": "CIS",
      "latestVersion": {
        "version": "V12.0",
        "latest": true,
        "spaceKey": "psCISV120de"
      },
      "versions": [{
        "version": "V12.0",
        "latest": true,
        "spaceKey": "psCISV120de"
      }]
    },
    "product-drivecomp": {
      "id": "product-drivecomp",
      "productPackage": false,
      "name": "DRIVE-COMP",
      "latestVersion": {
        "version": "V3.1",
        "latest": true,
        "spaceKey": "psDRIVECOMPV31de"
      },
      "versions": [
        {
          "version": "V3.1",
          "latest": true,
          "spaceKey": "psDRIVECOMPV31de"
        },
        {
          "version": "V2.1",
          "latest": false,
          "spaceKey": "psDRIVECOMPV21de"
        }
      ]
    },
    "product-drivewindows": {
      "id": "product-drivewindows",
      "productPackage": false,
      "name": "DRIVE/Windows",
      "latestVersion": {
        "version": "V3.1",
        "latest": true,
        "spaceKey": "psDRIVEWINDOWSV31de"
      },
      "versions": [
        {
          "version": "V3.1",
          "latest": true,
          "spaceKey": "psDRIVEWINDOWSV31de"
        },
        {
          "version": "V2.2",
          "latest": false,
          "spaceKey": "psDRIVEWINDOWSV22de"
        },
        {
          "version": "V2.1",
          "latest": false,
          "spaceKey": "psDRIVEWINDOWSV21de"
        }
      ]
    },
    "product-leasy": {
      "id": "product-leasy",
      "productPackage": false,
      "name": "LEASY",
      "latestVersion": {
        "version": "V6.2",
        "latest": true,
        "spaceKey": "psLEASYV62de"
      },
      "versions": [{
        "version": "V6.2",
        "latest": true,
        "spaceKey": "psLEASYV62de"
      }]
    },
    "product-oracle": {
      "id": "product-oracle",
      "productPackage": false,
      "name": "Oracle",
      "latestVersion": {
        "version": "12.2",
        "latest": true,
        "spaceKey": "psORACLEV122de"
      },
      "versions": [
        {
          "version": "12.2",
          "latest": true,
          "spaceKey": "psORACLEV122de"
        },
        {
          "version": "12.1",
          "latest": false,
          "spaceKey": "psORACLEV121de"
        },
        {
          "version": "11.2",
          "latest": false,
          "spaceKey": "psORACLEV112de"
        }
      ]
    },
    "product-sesamsql": {
      "id": "product-sesamsql",
      "productPackage": false,
      "name": "SESAM/SQL",
      "latestVersion": {
        "version": "V9.1",
        "latest": true,
        "spaceKey": "psSESAMSQLV91de"
      },
      "versions": [
        {
          "version": "V9.1",
          "latest": true,
          "spaceKey": "psSESAMSQLV91de"
        },
        {
          "version": "V9.0",
          "latest": false,
          "spaceKey": "psSESAMSQLV90de"
        }
      ]
    },
    "product-udsiqs": {
      "id": "product-udsiqs",
      "productPackage": false,
      "name": "UDS-IQS",
      "latestVersion": {
        "version": "V4.0",
        "latest": true,
        "spaceKey": "psUDSIQSV40de"
      },
      "versions": [{
        "version": "V4.0",
        "latest": true,
        "spaceKey": "psUDSIQSV40de"
      }]
    },
    "product-udssql": {
      "id": "product-udssql",
      "productPackage": false,
      "name": "UDS/SQL",
      "latestVersion": {
        "version": "V2.9",
        "latest": true,
        "spaceKey": "psUDSSQLV29de"
      },
      "versions": [
        {
          "version": "V2.9",
          "latest": true,
          "spaceKey": "psUDSSQLV29de"
        },
        {
          "version": "V2.8",
          "latest": false,
          "spaceKey": "psUDSSQLV28de"
        }
      ]
    },
    "product-beanconnect": {
      "id": "product-beanconnect",
      "productPackage": false,
      "name": "BeanConnect",
      "latestVersion": {
        "version": "V6.5",
        "latest": true,
        "spaceKey": "psBEANCONNECTV65de"
      },
      "versions": [
        {
          "version": "V6.5",
          "latest": true,
          "spaceKey": "psBEANCONNECTV65de"
        },
        {
          "version": "V3.0",
          "latest": false,
          "spaceKey": "psBEANCONNECTV30de"
        }
      ]
    },
    "product-openft": {
      "id": "product-openft",
      "productPackage": false,
      "name": "openFT",
      "latestVersion": {
        "version": "V12.1",
        "latest": true,
        "spaceKey": "psOPENFTV121de"
      },
      "versions": [
        {
          "version": "V12.1",
          "latest": true,
          "spaceKey": "psOPENFTV121de"
        },
        {
          "version": "V12.0",
          "latest": false,
          "spaceKey": "psOPENFTV120de"
        }
      ]
    },
    "product-openutm": {
      "id": "product-openutm",
      "productPackage": false,
      "name": "openUTM",
      "latestVersion": {
        "version": "V7.0",
        "latest": true,
        "spaceKey": "psOPENUTMV70de"
      },
      "versions": [
        {
          "version": "V7.0",
          "latest": true,
          "spaceKey": "psOPENUTMV70de"
        },
        {
          "version": "V6.5",
          "latest": false,
          "spaceKey": "psOPENUTMV65de"
        },
        {
          "version": "V6.4",
          "latest": false,
          "spaceKey": "psOPENUTMV64de"
        },
        {
          "version": "V6.3",
          "latest": false,
          "spaceKey": "psOPENUTMV63de"
        }
      ]
    },
    "product-pcmxunixbasedos": {
      "id": "product-pcmxunixbasedos",
      "productPackage": false,
      "name": "PCMX (Unix basiertes OS)",
      "latestVersion": {
        "version": "V6.0",
        "latest": true,
        "spaceKey": "psPCMXUNIXBASEDOSV60de"
      },
      "versions": [{
        "version": "V6.0",
        "latest": true,
        "spaceKey": "psPCMXUNIXBASEDOSV60de"
      }]
    },
    "product-webtransactions": {
      "id": "product-webtransactions",
      "productPackage": false,
      "name": "WebTransactions",
      "latestVersion": {
        "version": "V7.5",
        "latest": true,
        "spaceKey": "psWEBTRANSACTIONSV75de"
      },
      "versions": [{
        "version": "V7.5",
        "latest": true,
        "spaceKey": "psWEBTRANSACTIONSV75de"
      }]
    },
    "product-seseriesinfrastructure": {
      "id": "product-seseriesinfrastructure",
      "productPackage": false,
      "name": "SE-Infrastruktur",
      "latestVersion": {
        "version": "V6.3",
        "latest": true,
        "spaceKey": "psSESERIESINFRASTRUCTUREV63de"
      },
      "versions": [
        {
          "version": "V6.3",
          "latest": true,
          "spaceKey": "psSESERIESINFRASTRUCTUREV63de"
        },
        {
          "version": "V6.2",
          "latest": false,
          "spaceKey": "psSESERIESINFRASTRUCTUREV62de"
        },
        {
          "version": "V6.1",
          "latest": false,
          "spaceKey": "psSESERIESINFRASTRUCTUREV61de"
        },
        {
          "version": "V6.0",
          "latest": false,
          "spaceKey": "psSESERIESINFRASTRUCTUREV60de"
        }
      ]
    },
    "product-sserver": {
      "id": "product-sserver",
      "productPackage": false,
      "name": "S-Server",
      "latestVersion": {
        "version": "",
        "latest": true,
        "spaceKey": "psSSERVERde"
      },
      "versions": [{
        "version": "",
        "latest": true,
        "spaceKey": "psSSERVERde"
      }]
    },
    "product-sqserver": {
      "id": "product-sqserver",
      "productPackage": false,
      "name": "SQ-Server",
      "latestVersion": {
        "version": "",
        "latest": true,
        "spaceKey": "psSQSERVERde"
      },
      "versions": [{
        "version": "",
        "latest": true,
        "spaceKey": "psSQSERVERde"
      }]
    },
    "product-onlinestoragefujitsueternus": {
      "id": "product-onlinestoragefujitsueternus",
      "productPackage": false,
      "name": "Online Storage FUJITSU ETERNUS",
      "latestVersion": {
        "version": "",
        "latest": true,
        "spaceKey": "psONLINESTORAGEFUJITSUETERNUSde"
      },
      "versions": [{
        "version": "",
        "latest": true,
        "spaceKey": "psONLINESTORAGEFUJITSUETERNUSde"
      }]
    },
    "product-onlinestorageemcvmax": {
      "id": "product-onlinestorageemcvmax",
      "productPackage": false,
      "name": "Online Storage EMC VMAX",
      "latestVersion": {
        "version": "",
        "latest": true,
        "spaceKey": "psONLINESTORAGEEMCVMAXde"
      },
      "versions": [{
        "version": "",
        "latest": true,
        "spaceKey": "psONLINESTORAGEEMCVMAXde"
      }]
    },
    "product-fcswitch": {
      "id": "product-fcswitch",
      "productPackage": false,
      "name": "FC-Switch",
      "latestVersion": {
        "version": "",
        "latest": true,
        "spaceKey": "psFCSWITCHde"
      },
      "versions": [{
        "version": "",
        "latest": true,
        "spaceKey": "psFCSWITCHde"
      }]
    }
  }
}`;

export var productStructureEn = `{
  "language": "ENGLISH",
  "indexHeadline": "BS2000 Documentation",
  "indexDescription": "On this site you will find all product areas of documentation concerning BS2000. Choose the product link to get to the specified product documentation or use the 'search for product' field to find a specific product.",
  "productAreas": [
    {
      "id": "area-fujitsusoftwarebs2000",
      "name": "Fujitsu Software BS2000",
      "productGroups": [
        {
          "id": "group-operatingsystem",
          "name": "Operating System",
          "productIds": [
            "product-bs2000operatingsystem",
            "product-posix",
            "product-osdbcpackage",
            "product-osdxcpackage",
            "product-conceptdescriptions"
          ]
        },
        {
          "id": "group-utilityroutines",
          "name": "Utility Routines",
          "productIds": [
            "product-edt",
            "product-fhs",
            "product-fms",
            "product-ifg",
            "product-lms",
            "product-percon",
            "product-rfa",
            "product-sort",
            "product-taskdate",
            "product-tomproducts"
          ]
        },
        {
          "id": "group-jobcontrol",
          "name": "Job Control",
          "productIds": [
            "product-avas",
            "product-jv",
            "product-sdf",
            "product-sdfa",
            "product-sdfp"
          ]
        },
        {
          "id": "group-communicationandinternet",
          "name": "Communication and Internet",
          "productIds": [
            "product-apache",
            "product-internetservices",
            "product-mt9750",
            "product-nfs",
            "product-opennetserver",
            "product-osisessionservice",
            "product-tiam",
            "product-xhcs"
          ]
        },
        {
          "id": "group-performancemanagement",
          "name": "Performance Management",
          "productIds": [
            "product-cosmos",
            "product-dab",
            "product-opensm2",
            "product-pcs",
            "product-rav",
            "product-sca",
            "product-sm2pa"
          ]
        },
        {
          "id": "group-printmanagement",
          "name": "Print Management",
          "productIds": [
            "product-bs2zip",
            "product-conv2pdf",
            "product-dprint",
            "product-rso",
            "product-spool"
          ]
        },
        {
          "id": "group-programmingsystems",
          "name": "Programming Systems",
          "productIds": [
            "product-aid",
            "product-assembh",
            "product-bs2ide",
            "product-cobol85",
            "product-cobol2000",
            "product-columbus85",
            "product-cc++",
            "product-crte",
            "product-for1fortran",
            "product-jenvjava",
            "product-pascal",
            "product-perl",
            "product-pl1"
          ]
        },
        {
          "id": "group-security",
          "name": "Security",
          "productIds": [
            "product-crypt",
            "product-ipsec",
            "product-secos"
          ]
        },
        {
          "id": "group-storageandbackupmanagement",
          "name": "Storage and Backup Management",
          "productIds": [
            "product-archive",
            "product-drv",
            "product-fddrl",
            "product-hsms",
            "product-maren",
            "product-robar",
            "product-shcosd",
            "product-spaceopt"
          ]
        },
        {
          "id": "group-systemmanagement",
          "name": "System Management",
          "productIds": [
            "product-hiplexmscf",
            "product-omnis",
            "product-omnismenu",
            "product-propxt",
            "product-sbabs2",
            "product-snmpagents",
            "product-ssasm2bs2",
            "product-ssaoutmbs2",
            "product-sscbs2"
          ]
        },
        {
          "id": "group-virtualization",
          "name": "Virtualization",
          "productIds": ["product-vm2000"]
        }
      ]
    },
    {
      "id": "area-fujitsusoftwaremiddleware",
      "name": "Fujitsu Software Middleware",
      "productGroups": [
        {
          "id": "group-databasesystems",
          "name": "Database Systems",
          "productIds": [
            "product-cis",
            "product-drivecomp",
            "product-drivewindows",
            "product-leasy",
            "product-oracle",
            "product-sesamsql",
            "product-udsiqs",
            "product-udssql"
          ]
        },
        {
          "id": "group-openseas",
          "name": "openSEAS",
          "productIds": [
            "product-beanconnect",
            "product-openft",
            "product-openutm",
            "product-pcmxunixbasedos",
            "product-webtransactions"
          ]
        }
      ]
    },
    {
      "id": "area-fujitsuserverbs2000",
      "name": "Fujitsu Server BS2000",
      "productGroups": [
        {
          "id": "group-seseriesinfrastructure",
          "name": "SE Server",
          "productIds": ["product-seseriesinfrastructure"]
        },
        {
          "id": "group-sserver",
          "name": "S-Server",
          "productIds": ["product-sserver"]
        },
        {
          "id": "group-sqserver",
          "name": "SQ-Server",
          "productIds": ["product-sqserver"]
        },
        {
          "id": "group-serverconnectivity",
          "name": "Server Connectivity",
          "productIds": [
            "product-onlinestoragefujitsueternus",
            "product-onlinestorageemcvmax",
            "product-fcswitch"
          ]
        }
      ]
    }
  ],
  "alphabeticalProducts": {
    "A": [
      "product-avas",
      "product-apache",
      "product-aid",
      "product-assembh",
      "product-archive"
    ],
    "B": [
      "product-bs2000operatingsystem",
      "product-bs2zip",
      "product-bs2ide",
      "product-beanconnect"
    ],
    "C": [
      "product-conceptdescriptions",
      "product-cosmos",
      "product-conv2pdf",
      "product-cobol85",
      "product-cobol2000",
      "product-columbus85",
      "product-cc++",
      "product-crte",
      "product-crypt",
      "product-cis"
    ],
    "D": [
      "product-dab",
      "product-dprint",
      "product-drv",
      "product-drivecomp",
      "product-drivewindows"
    ],
    "E": ["product-edt"],
    "F": [
      "product-fhs",
      "product-fms",
      "product-for1fortran",
      "product-fddrl",
      "product-fcswitch"
    ],
    "H": [
      "product-hsms",
      "product-hiplexmscf"
    ],
    "I": [
      "product-ifg",
      "product-internetservices",
      "product-ipsec"
    ],
    "J": [
      "product-jv",
      "product-jenvjava"
    ],
    "L": [
      "product-lms",
      "product-leasy"
    ],
    "M": [
      "product-mt9750",
      "product-maren"
    ],
    "N": ["product-nfs"],
    "O": [
      "product-osdbcpackage",
      "product-osdxcpackage",
      "product-opennetserver",
      "product-osisessionservice",
      "product-opensm2",
      "product-omnis",
      "product-omnismenu",
      "product-oracle",
      "product-openft",
      "product-openutm",
      "product-onlinestoragefujitsueternus",
      "product-onlinestorageemcvmax"
    ],
    "P": [
      "product-posix",
      "product-percon",
      "product-pcs",
      "product-pascal",
      "product-perl",
      "product-pl1",
      "product-propxt",
      "product-pcmxunixbasedos"
    ],
    "R": [
      "product-rfa",
      "product-rso",
      "product-robar"
    ],
    "S": [
      "product-sort",
      "product-sdf",
      "product-sdfa",
      "product-sdfp",
      "product-sca",
      "product-sm2pa",
      "product-spool",
      "product-secos",
      "product-shcosd",
      "product-spaceopt",
      "product-sbabs2",
      "product-snmpagents",
      "product-ssasm2bs2",
      "product-ssaoutmbs2",
      "product-sscbs2",
      "product-sesamsql",
      "product-seseriesinfrastructure"
    ],
    "T": [
      "product-taskdate",
      "product-tomproducts",
      "product-tiam"
    ],
    "U": [
      "product-udsiqs",
      "product-udssql"
    ],
    "V": ["product-vm2000"],
    "W": ["product-webtransactions"],
    "X": ["product-xhcs"]
  },
  "servicePacks": [{
    "id": "sp-servicepack201",
    "name": "Service Pack 20.1",
    "spaceKey": "spSERVICEPACK201en",
    "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/display/spSERVICEPACK201en",
    "updatedProducts": [
      {
        "id": "product-internetservices",
        "name": "interNet Services",
        "description": "A collection of internet services supporting the interoperability of communication partners in TCP/IP-based networks.",
        "version": "V3.4B",
        "spaceKey": "psINTERNETSERVICESV34Ben",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psINTERNETSERVICESV34Ben",
        "releaseNotices": [{
          "title": "interNet Services",
          "subtitle": "",
          "version": "V3.4B",
          "type": "Release Notice",
          "edition": "2020-06",
          "filelink": "20258/sysfgm.inetserv.034.e.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "interNet Services - Release Notice - en (V3.4B, 2020-06)"
        }]
      },
      {
        "id": "product-lms",
        "name": "LMS",
        "description": "LMS creates and manages BS2000 program libraries and processes the program members they contain.",
        "version": "V3.5",
        "spaceKey": "psLMSV35en",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psLMSV35en",
        "releaseNotices": [{
          "title": "LMS",
          "subtitle": "",
          "version": "V3.5B",
          "type": "Release Notice",
          "edition": "2020-06",
          "filelink": "20252/sysfgm.lms.035.e.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "LMS - Release Notice - en (V3.5B, 2020-06)"
        }]
      },
      {
        "id": "product-opensm2",
        "name": "openSM2",
        "description": "Supplies extensive monitoring data to improve performance for the server systems BS2000, Linux, Windows-based systems and the storage systems ETERNUS DX, VMAX and additional all systems which aids the SNMP standard.",
        "version": "V11.0B",
        "spaceKey": "psOPENSM2V110Ben",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psOPENSM2V110Ben",
        "releaseNotices": [
          {
            "title": "SM2-WEB",
            "subtitle": "",
            "version": "V11.0B",
            "type": "Release Notice",
            "edition": "2020-07",
            "filelink": "20271/sysfgm.sm2-web.110.e.pdf",
            "mediatype": "fj-mediatype-pdf",
            "descriptiveName": "SM2-WEB - Release Notice - en (V11.0B, 2020-07)"
          },
          {
            "title": "SM2-TOOLS",
            "subtitle": "",
            "version": "V11.0B",
            "type": "Release Notice",
            "edition": "2020-07",
            "filelink": "20270/sysfgm.sm2-tools.110.e.pdf",
            "mediatype": "fj-mediatype-pdf",
            "descriptiveName": "SM2-TOOLS - Release Notice - en (V11.0B, 2020-07)"
          }
        ]
      },
      {
        "id": "product-osdxcpackage",
        "name": "OSD/XC Package",
        "description": "",
        "version": "V11.0B",
        "spaceKey": "psOSDXCPACKAGEV110Ben",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psOSDXCPACKAGEV110Ben",
        "releaseNotices": [{
          "title": "OSD/XC",
          "subtitle": "",
          "version": "V11.0B",
          "type": "Release Notice",
          "edition": "2020-06",
          "filelink": "20278/sysfgm.osdxc.110.e.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "OSD/XC - Release Notice - en (V11.0B, 2020-06)"
        }]
      },
      {
        "id": "product-shcosd",
        "name": "SHC-OSD",
        "description": "SHC-OSD provides commands and information services for monitoring and controlling of disk storage systems from BS2000.",
        "version": "V14.0",
        "spaceKey": "psSHCOSDV140en",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psSHCOSDV140en",
        "releaseNotices": [{
          "title": "SHC-OSD",
          "subtitle": "",
          "version": "V14.0A",
          "type": "Release Notice",
          "edition": "2020-04",
          "filelink": "20229/SYSFGM.SHC-OSD.140.E.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "SHC-OSD - Release Notice - en (V14.0A, 2020-04)"
        }]
      },
      {
        "id": "product-snmpagents",
        "name": "SNMP-AGENTS",
        "description": "Central monitoring of BS2000 systems and their applications via SNMP.",
        "version": "V1.1",
        "spaceKey": "psSNMPAGENTSV11en",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psSNMPAGENTSV11en",
        "releaseNotices": [{
          "title": "SNMP Agents",
          "subtitle": "",
          "version": "V1.1",
          "type": "Release Notice",
          "edition": "2020-07",
          "filelink": "20245/sysfgm.snmp-agents.011.e.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "SNMP Agents - Release Notice - en (V1.1, 2020-07)"
        }]
      },
      {
        "id": "product-webtransactions",
        "name": "WebTransactions",
        "description": "Portal Integration and Web enabling: A business processing tool - flexible integration of existing host applications.",
        "version": "V7.5",
        "spaceKey": "psWEBTRANSACTIONSV75en",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psWEBTRANSACTIONSV75en",
        "releaseNotices": [
          {
            "title": "WebTA openUTM (BS2000)",
            "subtitle": "",
            "version": "V7.5C",
            "type": "Release Notice",
            "edition": "2020-05",
            "filelink": "20321/sysfgm.webta-utm-bs2000.075.e.pdf",
            "mediatype": "fj-mediatype-pdf",
            "descriptiveName": "WebTA openUTM (BS2000) - Release Notice - en (V7.5C, 2020-05)"
          },
          {
            "title": "WebTA OSD (BS2000)",
            "subtitle": "",
            "version": "V7.5C",
            "type": "Release Notice",
            "edition": "2020-05",
            "filelink": "20319/sysfgm.webta-osd-bs2000.075.e.pdf",
            "mediatype": "fj-mediatype-pdf",
            "descriptiveName": "WebTA OSD (BS2000) - Release Notice - en (V7.5C, 2020-05)"
          }
        ]
      }
    ],
    "updatedReleaseNotices": [
      {
        "id": "product-crte",
        "name": "CRTE",
        "description": "Common run-time environment required for running source programs compiled with the C/C++, COBOL2000 and COBOL85 compilers.",
        "version": "V10.1",
        "spaceKey": "psCRTEV101en",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psCRTEV101en",
        "releaseNotices": [
          {
            "title": "CRTE-BAS",
            "subtitle": "",
            "version": "V10.1",
            "type": "Release Notice",
            "edition": "2020-07",
            "filelink": "20265/sysfgm.crte-bas.101.e.pdf",
            "mediatype": "fj-mediatype-pdf",
            "descriptiveName": "CRTE-BAS - Release Notice - en (V10.1, 2020-07)"
          },
          {
            "title": "CRTE",
            "subtitle": "",
            "version": "V10.1",
            "type": "Release Notice",
            "edition": "2020-07",
            "filelink": "20264/sysfgm.crte.101.e.pdf",
            "mediatype": "fj-mediatype-pdf",
            "descriptiveName": "CRTE - Release Notice - en (V10.1, 2020-07)"
          }
        ]
      },
      {
        "id": "product-crte",
        "name": "CRTE",
        "description": "Common run-time environment required for running source programs compiled with the C/C++, COBOL2000 and COBOL85 compilers.",
        "version": "V11.1",
        "spaceKey": "psCRTEV111en",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psCRTEV111en",
        "releaseNotices": [
          {
            "title": "CRTE-BAS",
            "subtitle": "",
            "version": "V11.1",
            "type": "Release Notice",
            "edition": "2020-07",
            "filelink": "20263/sysfgm.crte-bas.111.e.pdf",
            "mediatype": "fj-mediatype-pdf",
            "descriptiveName": "CRTE-BAS - Release Notice - en (V11.1, 2020-07)"
          },
          {
            "title": "CRTE",
            "subtitle": "",
            "version": "V11.1",
            "type": "Release Notice",
            "edition": "2020-07",
            "filelink": "20262/sysfgm.crte.111.e.pdf",
            "mediatype": "fj-mediatype-pdf",
            "descriptiveName": "CRTE - Release Notice - en (V11.1, 2020-07)"
          }
        ]
      },
      {
        "id": "product-hsms",
        "name": "HSMS",
        "description": "Hierarchic storage management system.",
        "version": "V12.0",
        "spaceKey": "psHSMSV120en",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psHSMSV120en",
        "releaseNotices": [{
          "title": "HSMS",
          "subtitle": "",
          "version": "V12.0A",
          "type": "Release Notice",
          "edition": "2020-06",
          "filelink": "20254/SYSFGM.HSMS.120.E.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "HSMS - Release Notice - en (V12.0A, 2020-06)"
        }]
      },
      {
        "id": "product-osdbcpackage",
        "name": "OSD/BC Package",
        "description": "",
        "version": "V10.0",
        "spaceKey": "psOSDBCPACKAGEV100en",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psOSDBCPACKAGEV100en",
        "releaseNotices": [{
          "title": "OSD/BC",
          "subtitle": "",
          "version": "V10.0A",
          "type": "Release Notice",
          "edition": "2020-06",
          "filelink": "20277/sysfgm.bs2osd.100.e.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "OSD/BC - Release Notice - en (V10.0A, 2020-06)"
        }]
      },
      {
        "id": "product-osdbcpackage",
        "name": "OSD/BC Package",
        "description": "",
        "version": "V11.0B",
        "spaceKey": "psOSDBCPACKAGEV110Ben",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psOSDBCPACKAGEV110Ben",
        "releaseNotices": [{
          "title": "OSD/BC",
          "subtitle": "",
          "version": "V11.0B",
          "type": "Release Notice",
          "edition": "2020-06",
          "filelink": "20276/sysfgm.bs2osd.110.e.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "OSD/BC - Release Notice - en (V11.0B, 2020-06)"
        }]
      },
      {
        "id": "product-osdxcpackage",
        "name": "OSD/XC Package",
        "description": "",
        "version": "V10.0",
        "spaceKey": "psOSDXCPACKAGEV100en",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psOSDXCPACKAGEV100en",
        "releaseNotices": [{
          "title": "OSD/XC",
          "subtitle": "",
          "version": "V10.0",
          "type": "Release Notice",
          "edition": "2020-06",
          "filelink": "20279/sysfgm.osdxc.100.e.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "OSD/XC - Release Notice - en (V10.0, 2020-06)"
        }]
      },
      {
        "id": "product-secos",
        "name": "SECOS",
        "description": "SECOS is a software product that is designed to implement security solutions for BS2000 systems to meet all requirements, from simple concepts to complex, according to customer-specific security policies.",
        "version": "V5.5",
        "spaceKey": "psSECOSV55en",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psSECOSV55en",
        "releaseNotices": [{
          "title": "SECOS",
          "subtitle": "",
          "version": "V5.5",
          "type": "Release Notice",
          "edition": "2020-06",
          "filelink": "20257/sysfgm.secos.055.e.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "SECOS - Release Notice - en (V5.5, 2020-06)"
        }]
      },
      {
        "id": "product-vm2000",
        "name": "VM2000",
        "description": "The virtual machine system VM2000 enables simultaneous operation of multiple virtual BS2000 systems on one server.",
        "version": "V11.5",
        "spaceKey": "psVM2000V115en",
        "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psVM2000V115en",
        "releaseNotices": [{
          "title": "VM2000-MON",
          "subtitle": "",
          "version": "V11.5",
          "type": "Release Notice",
          "edition": "2020-06",
          "filelink": "20248/SYSFGM.VM2000-MON.115.E.pdf",
          "mediatype": "fj-mediatype-pdf",
          "descriptiveName": "VM2000-MON - Release Notice - en (V11.5, 2020-06)"
        }]
      }
    ]
  }],
  "products": {
    "product-bs2000operatingsystem": {
      "id": "product-bs2000operatingsystem",
      "productPackage": false,
      "name": "BS2000 Operating System",
      "latestVersion": {
        "version": "V11.0B",
        "latest": true,
        "spaceKey": "psBS2000OPERATINGSYSTEMV110Ben"
      },
      "versions": [
        {
          "version": "V11.0B",
          "latest": true,
          "spaceKey": "psBS2000OPERATINGSYSTEMV110Ben"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psBS2000OPERATINGSYSTEMV100en"
        },
        {
          "version": "Previous Manuals",
          "latest": false,
          "spaceKey": "psBS2000OPERATINGSYSTEMV01en"
        }
      ]
    },
    "product-posix": {
      "id": "product-posix",
      "productPackage": false,
      "name": "POSIX",
      "latestVersion": {
        "version": "V11.0",
        "latest": true,
        "spaceKey": "psPOSIXV110en"
      },
      "versions": [
        {
          "version": "V11.0",
          "latest": true,
          "spaceKey": "psPOSIXV110en"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psPOSIXV100en"
        },
        {
          "version": "V9.0",
          "latest": false,
          "spaceKey": "psPOSIXV90en"
        }
      ]
    },
    "product-osdbcpackage": {
      "id": "product-osdbcpackage",
      "productPackage": true,
      "name": "OSD/BC Package",
      "latestVersion": {
        "version": "V11.0B",
        "latest": true,
        "spaceKey": "psOSDBCPACKAGEV110Ben"
      },
      "versions": [
        {
          "version": "V11.0B",
          "latest": true,
          "spaceKey": "psOSDBCPACKAGEV110Ben"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psOSDBCPACKAGEV100en"
        }
      ]
    },
    "product-osdxcpackage": {
      "id": "product-osdxcpackage",
      "productPackage": true,
      "name": "OSD/XC Package",
      "latestVersion": {
        "version": "V11.0B",
        "latest": true,
        "spaceKey": "psOSDXCPACKAGEV110Ben"
      },
      "versions": [
        {
          "version": "V11.0B",
          "latest": true,
          "spaceKey": "psOSDXCPACKAGEV110Ben"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psOSDXCPACKAGEV100en"
        }
      ]
    },
    "product-conceptdescriptions": {
      "id": "product-conceptdescriptions",
      "productPackage": false,
      "name": "Concept Descriptions",
      "latestVersion": {
        "version": "V11.0B",
        "latest": true,
        "spaceKey": "psCONCEPTDESCRIPTIONSV110Ben"
      },
      "versions": [
        {
          "version": "V11.0B",
          "latest": true,
          "spaceKey": "psCONCEPTDESCRIPTIONSV110Ben"
        },
        {
          "version": "V11.0",
          "latest": false,
          "spaceKey": "psCONCEPTDESCRIPTIONSV110en"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psCONCEPTDESCRIPTIONSV100en"
        },
        {
          "version": "V9.0",
          "latest": false,
          "spaceKey": "psCONCEPTDESCRIPTIONSV90en"
        }
      ]
    },
    "product-edt": {
      "id": "product-edt",
      "productPackage": false,
      "name": "EDT",
      "latestVersion": {
        "version": "V17.0",
        "latest": true,
        "spaceKey": "psEDTV170en"
      },
      "versions": [{
        "version": "V17.0",
        "latest": true,
        "spaceKey": "psEDTV170en"
      }]
    },
    "product-fhs": {
      "id": "product-fhs",
      "productPackage": false,
      "name": "FHS",
      "latestVersion": {
        "version": "V8.3",
        "latest": true,
        "spaceKey": "psFHSV83en"
      },
      "versions": [{
        "version": "V8.3",
        "latest": true,
        "spaceKey": "psFHSV83en"
      }]
    },
    "product-fms": {
      "id": "product-fms",
      "productPackage": false,
      "name": "FMS",
      "latestVersion": {
        "version": "V2.4",
        "latest": true,
        "spaceKey": "psFMSV24en"
      },
      "versions": [{
        "version": "V2.4",
        "latest": true,
        "spaceKey": "psFMSV24en"
      }]
    },
    "product-ifg": {
      "id": "product-ifg",
      "productPackage": false,
      "name": "IFG",
      "latestVersion": {
        "version": "V8.3",
        "latest": true,
        "spaceKey": "psIFGV83en"
      },
      "versions": [{
        "version": "V8.3",
        "latest": true,
        "spaceKey": "psIFGV83en"
      }]
    },
    "product-lms": {
      "id": "product-lms",
      "productPackage": false,
      "name": "LMS",
      "latestVersion": {
        "version": "V3.5",
        "latest": true,
        "spaceKey": "psLMSV35en"
      },
      "versions": [{
        "version": "V3.5",
        "latest": true,
        "spaceKey": "psLMSV35en"
      }]
    },
    "product-percon": {
      "id": "product-percon",
      "productPackage": false,
      "name": "PERCON",
      "latestVersion": {
        "version": "V2.9",
        "latest": true,
        "spaceKey": "psPERCONV29en"
      },
      "versions": [{
        "version": "V2.9",
        "latest": true,
        "spaceKey": "psPERCONV29en"
      }]
    },
    "product-rfa": {
      "id": "product-rfa",
      "productPackage": false,
      "name": "RFA",
      "latestVersion": {
        "version": "V20.0",
        "latest": true,
        "spaceKey": "psRFAV200en"
      },
      "versions": [
        {
          "version": "V20.0",
          "latest": true,
          "spaceKey": "psRFAV200en"
        },
        {
          "version": "V19.0",
          "latest": false,
          "spaceKey": "psRFAV190en"
        }
      ]
    },
    "product-sort": {
      "id": "product-sort",
      "productPackage": false,
      "name": "SORT",
      "latestVersion": {
        "version": "V8.0",
        "latest": true,
        "spaceKey": "psSORTV80en"
      },
      "versions": [{
        "version": "V8.0",
        "latest": true,
        "spaceKey": "psSORTV80en"
      }]
    },
    "product-taskdate": {
      "id": "product-taskdate",
      "productPackage": false,
      "name": "TASKDATE",
      "latestVersion": {
        "version": "V20.0B",
        "latest": true,
        "spaceKey": "psTASKDATEV200Ben"
      },
      "versions": [
        {
          "version": "V20.0B",
          "latest": true,
          "spaceKey": "psTASKDATEV200Ben"
        },
        {
          "version": "V19.0",
          "latest": false,
          "spaceKey": "psTASKDATEV190en"
        }
      ]
    },
    "product-tomproducts": {
      "id": "product-tomproducts",
      "productPackage": false,
      "name": "TOM Products",
      "latestVersion": {
        "version": "V5.1",
        "latest": true,
        "spaceKey": "psTOMPRODUCTSV51en"
      },
      "versions": [
        {
          "version": "V5.1",
          "latest": true,
          "spaceKey": "psTOMPRODUCTSV51en"
        },
        {
          "version": "V5.0",
          "latest": false,
          "spaceKey": "psTOMPRODUCTSV50en"
        },
        {
          "version": "V3.2",
          "latest": false,
          "spaceKey": "psTOMPRODUCTSV32en"
        },
        {
          "version": "V3.0",
          "latest": false,
          "spaceKey": "psTOMPRODUCTSV30en"
        }
      ]
    },
    "product-avas": {
      "id": "product-avas",
      "productPackage": false,
      "name": "AVAS",
      "latestVersion": {
        "version": "V8.5",
        "latest": true,
        "spaceKey": "psAVASV85en"
      },
      "versions": [{
        "version": "V8.5",
        "latest": true,
        "spaceKey": "psAVASV85en"
      }]
    },
    "product-jv": {
      "id": "product-jv",
      "productPackage": false,
      "name": "JV",
      "latestVersion": {
        "version": "V15.1",
        "latest": true,
        "spaceKey": "psJVV151en"
      },
      "versions": [{
        "version": "V15.1",
        "latest": true,
        "spaceKey": "psJVV151en"
      }]
    },
    "product-sdf": {
      "id": "product-sdf",
      "productPackage": false,
      "name": "SDF",
      "latestVersion": {
        "version": "V4.8",
        "latest": true,
        "spaceKey": "psSDFV48en"
      },
      "versions": [
        {
          "version": "V4.8",
          "latest": true,
          "spaceKey": "psSDFV48en"
        },
        {
          "version": "V4.7",
          "latest": false,
          "spaceKey": "psSDFV47en"
        },
        {
          "version": "V4.6",
          "latest": false,
          "spaceKey": "psSDFV46en"
        }
      ]
    },
    "product-sdfa": {
      "id": "product-sdfa",
      "productPackage": false,
      "name": "SDF-A",
      "latestVersion": {
        "version": "V4.1",
        "latest": true,
        "spaceKey": "psSDFAV41en"
      },
      "versions": [{
        "version": "V4.1",
        "latest": true,
        "spaceKey": "psSDFAV41en"
      }]
    },
    "product-sdfp": {
      "id": "product-sdfp",
      "productPackage": false,
      "name": "SDF-P",
      "latestVersion": {
        "version": "V2.5",
        "latest": true,
        "spaceKey": "psSDFPV25en"
      },
      "versions": [{
        "version": "V2.5",
        "latest": true,
        "spaceKey": "psSDFPV25en"
      }]
    },
    "product-apache": {
      "id": "product-apache",
      "productPackage": false,
      "name": "Apache",
      "latestVersion": {
        "version": "V2.4",
        "latest": true,
        "spaceKey": "psAPACHEV24en"
      },
      "versions": [
        {
          "version": "V2.4",
          "latest": true,
          "spaceKey": "psAPACHEV24en"
        },
        {
          "version": "V2.2",
          "latest": false,
          "spaceKey": "psAPACHEV22en"
        }
      ]
    },
    "product-internetservices": {
      "id": "product-internetservices",
      "productPackage": false,
      "name": "interNet Services",
      "latestVersion": {
        "version": "V3.4B",
        "latest": true,
        "spaceKey": "psINTERNETSERVICESV34Ben"
      },
      "versions": [
        {
          "version": "V3.4B",
          "latest": true,
          "spaceKey": "psINTERNETSERVICESV34Ben"
        },
        {
          "version": "V3.4",
          "latest": false,
          "spaceKey": "psINTERNETSERVICESV34en"
        }
      ]
    },
    "product-mt9750": {
      "id": "product-mt9750",
      "productPackage": false,
      "name": "MT9750",
      "latestVersion": {
        "version": "V9.0",
        "latest": true,
        "spaceKey": "psMT9750V90en"
      },
      "versions": [
        {
          "version": "V9.0",
          "latest": true,
          "spaceKey": "psMT9750V90en"
        },
        {
          "version": "V8.0",
          "latest": false,
          "spaceKey": "psMT9750V80en"
        }
      ]
    },
    "product-nfs": {
      "id": "product-nfs",
      "productPackage": false,
      "name": "NFS",
      "latestVersion": {
        "version": "V3.0",
        "latest": true,
        "spaceKey": "psNFSV30en"
      },
      "versions": [{
        "version": "V3.0",
        "latest": true,
        "spaceKey": "psNFSV30en"
      }]
    },
    "product-opennetserver": {
      "id": "product-opennetserver",
      "productPackage": false,
      "name": "openNet Server",
      "latestVersion": {
        "version": "V4.0",
        "latest": true,
        "spaceKey": "psOPENNETSERVERV40en"
      },
      "versions": [
        {
          "version": "V4.0",
          "latest": true,
          "spaceKey": "psOPENNETSERVERV40en"
        },
        {
          "version": "V3.6",
          "latest": false,
          "spaceKey": "psOPENNETSERVERV36en"
        }
      ]
    },
    "product-osisessionservice": {
      "id": "product-osisessionservice",
      "productPackage": false,
      "name": "OSI Session Service",
      "latestVersion": {
        "version": "V4.1",
        "latest": true,
        "spaceKey": "psOSISESSIONSERVICEV41en"
      },
      "versions": [{
        "version": "V4.1",
        "latest": true,
        "spaceKey": "psOSISESSIONSERVICEV41en"
      }]
    },
    "product-tiam": {
      "id": "product-tiam",
      "productPackage": false,
      "name": "TIAM",
      "latestVersion": {
        "version": "V13.2",
        "latest": true,
        "spaceKey": "psTIAMV132en"
      },
      "versions": [{
        "version": "V13.2",
        "latest": true,
        "spaceKey": "psTIAMV132en"
      }]
    },
    "product-xhcs": {
      "id": "product-xhcs",
      "productPackage": false,
      "name": "XHCS",
      "latestVersion": {
        "version": "V4.0",
        "latest": true,
        "spaceKey": "psXHCSV40en"
      },
      "versions": [
        {
          "version": "V4.0",
          "latest": true,
          "spaceKey": "psXHCSV40en"
        },
        {
          "version": "V3.6",
          "latest": false,
          "spaceKey": "psXHCSV36en"
        },
        {
          "version": "V3.5",
          "latest": false,
          "spaceKey": "psXHCSV35en"
        }
      ]
    },
    "product-cosmos": {
      "id": "product-cosmos",
      "productPackage": false,
      "name": "COSMOS",
      "latestVersion": {
        "version": "V20.0B",
        "latest": true,
        "spaceKey": "psCOSMOSV200Ben"
      },
      "versions": [
        {
          "version": "V20.0B",
          "latest": true,
          "spaceKey": "psCOSMOSV200Ben"
        },
        {
          "version": "V20.0",
          "latest": false,
          "spaceKey": "psCOSMOSV200en"
        },
        {
          "version": "V19.0",
          "latest": false,
          "spaceKey": "psCOSMOSV190en"
        },
        {
          "version": "V18.0",
          "latest": false,
          "spaceKey": "psCOSMOSV180en"
        }
      ]
    },
    "product-dab": {
      "id": "product-dab",
      "productPackage": false,
      "name": "DAB",
      "latestVersion": {
        "version": "V9.5",
        "latest": true,
        "spaceKey": "psDABV95en"
      },
      "versions": [
        {
          "version": "V9.5",
          "latest": true,
          "spaceKey": "psDABV95en"
        },
        {
          "version": "V9.4",
          "latest": false,
          "spaceKey": "psDABV94en"
        }
      ]
    },
    "product-opensm2": {
      "id": "product-opensm2",
      "productPackage": false,
      "name": "openSM2",
      "latestVersion": {
        "version": "V11.0B",
        "latest": true,
        "spaceKey": "psOPENSM2V110Ben"
      },
      "versions": [
        {
          "version": "V11.0B",
          "latest": true,
          "spaceKey": "psOPENSM2V110Ben"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psOPENSM2V100en"
        },
        {
          "version": "V9.2",
          "latest": false,
          "spaceKey": "psOPENSM2V92en"
        }
      ]
    },
    "product-pcs": {
      "id": "product-pcs",
      "productPackage": false,
      "name": "PCS",
      "latestVersion": {
        "version": "V3.2",
        "latest": true,
        "spaceKey": "psPCSV32en"
      },
      "versions": [
        {
          "version": "V3.2",
          "latest": true,
          "spaceKey": "psPCSV32en"
        },
        {
          "version": "V3.1",
          "latest": false,
          "spaceKey": "psPCSV31en"
        }
      ]
    },
    "product-rav": {
      "id": "product-rav",
      "productPackage": false,
      "name": "RAV",
      "latestVersion": {
        "version": "",
        "latest": true,
        "spaceKey": "psRAVen"
      },
      "versions": [{
        "version": "",
        "latest": true,
        "spaceKey": "psRAVen"
      }]
    },
    "product-sca": {
      "id": "product-sca",
      "productPackage": false,
      "name": "SCA",
      "latestVersion": {
        "version": "V20.0",
        "latest": true,
        "spaceKey": "psSCAV200en"
      },
      "versions": [
        {
          "version": "V20.0",
          "latest": true,
          "spaceKey": "psSCAV200en"
        },
        {
          "version": "V19.0",
          "latest": false,
          "spaceKey": "psSCAV190en"
        }
      ]
    },
    "product-sm2pa": {
      "id": "product-sm2pa",
      "productPackage": false,
      "name": "SM2-PA",
      "latestVersion": {
        "version": "V2.0",
        "latest": true,
        "spaceKey": "psSM2PAV20en"
      },
      "versions": [{
        "version": "V2.0",
        "latest": true,
        "spaceKey": "psSM2PAV20en"
      }]
    },
    "product-bs2zip": {
      "id": "product-bs2zip",
      "productPackage": false,
      "name": "BS2ZIP",
      "latestVersion": {
        "version": "V1.2",
        "latest": true,
        "spaceKey": "psBS2ZIPV12en"
      },
      "versions": [{
        "version": "V1.2",
        "latest": true,
        "spaceKey": "psBS2ZIPV12en"
      }]
    },
    "product-conv2pdf": {
      "id": "product-conv2pdf",
      "productPackage": false,
      "name": "CONV2PDF",
      "latestVersion": {
        "version": "V4.9",
        "latest": true,
        "spaceKey": "psCONV2PDFV49en"
      },
      "versions": [{
        "version": "V4.9",
        "latest": true,
        "spaceKey": "psCONV2PDFV49en"
      }]
    },
    "product-dprint": {
      "id": "product-dprint",
      "productPackage": false,
      "name": "DPRINT",
      "latestVersion": {
        "version": "V1.2",
        "latest": true,
        "spaceKey": "psDPRINTV12en"
      },
      "versions": [{
        "version": "V1.2",
        "latest": true,
        "spaceKey": "psDPRINTV12en"
      }]
    },
    "product-rso": {
      "id": "product-rso",
      "productPackage": false,
      "name": "RSO",
      "latestVersion": {
        "version": "V3.6",
        "latest": true,
        "spaceKey": "psRSOV36en"
      },
      "versions": [{
        "version": "V3.6",
        "latest": true,
        "spaceKey": "psRSOV36en"
      }]
    },
    "product-spool": {
      "id": "product-spool",
      "productPackage": false,
      "name": "SPOOL",
      "latestVersion": {
        "version": "V4.9",
        "latest": true,
        "spaceKey": "psSPOOLV49en"
      },
      "versions": [{
        "version": "V4.9",
        "latest": true,
        "spaceKey": "psSPOOLV49en"
      }]
    },
    "product-aid": {
      "id": "product-aid",
      "productPackage": false,
      "name": "AID",
      "latestVersion": {
        "version": "V3.4",
        "latest": true,
        "spaceKey": "psAIDV34en"
      },
      "versions": [{
        "version": "V3.4",
        "latest": true,
        "spaceKey": "psAIDV34en"
      }]
    },
    "product-assembh": {
      "id": "product-assembh",
      "productPackage": false,
      "name": "ASSEMBH",
      "latestVersion": {
        "version": "V1.3",
        "latest": true,
        "spaceKey": "psASSEMBHV13en"
      },
      "versions": [{
        "version": "V1.3",
        "latest": true,
        "spaceKey": "psASSEMBHV13en"
      }]
    },
    "product-bs2ide": {
      "id": "product-bs2ide",
      "productPackage": false,
      "name": "BS2IDE",
      "latestVersion": {
        "version": "",
        "latest": true,
        "spaceKey": "psBS2IDEen"
      },
      "versions": [{
        "version": "",
        "latest": true,
        "spaceKey": "psBS2IDEen"
      }]
    },
    "product-cobol85": {
      "id": "product-cobol85",
      "productPackage": false,
      "name": "COBOL85",
      "latestVersion": {
        "version": "V2.3",
        "latest": true,
        "spaceKey": "psCOBOL85V23en"
      },
      "versions": [{
        "version": "V2.3",
        "latest": true,
        "spaceKey": "psCOBOL85V23en"
      }]
    },
    "product-cobol2000": {
      "id": "product-cobol2000",
      "productPackage": false,
      "name": "COBOL2000",
      "latestVersion": {
        "version": "V1.6",
        "latest": true,
        "spaceKey": "psCOBOL2000V16en"
      },
      "versions": [
        {
          "version": "V1.6",
          "latest": true,
          "spaceKey": "psCOBOL2000V16en"
        },
        {
          "version": "V1.5",
          "latest": false,
          "spaceKey": "psCOBOL2000V15en"
        }
      ]
    },
    "product-columbus85": {
      "id": "product-columbus85",
      "productPackage": false,
      "name": "COLUMBUS85",
      "latestVersion": {
        "version": "V1.1",
        "latest": true,
        "spaceKey": "psCOLUMBUS85V11en"
      },
      "versions": [{
        "version": "V1.1",
        "latest": true,
        "spaceKey": "psCOLUMBUS85V11en"
      }]
    },
    "product-cc++": {
      "id": "product-cc++",
      "productPackage": false,
      "name": "C/C++",
      "latestVersion": {
        "version": "V4.0",
        "latest": true,
        "spaceKey": "psCCV40en"
      },
      "versions": [
        {
          "version": "V4.0",
          "latest": true,
          "spaceKey": "psCCV40en"
        },
        {
          "version": "V3.2",
          "latest": false,
          "spaceKey": "psCCV32en"
        }
      ]
    },
    "product-crte": {
      "id": "product-crte",
      "productPackage": false,
      "name": "CRTE",
      "latestVersion": {
        "version": "V11.1",
        "latest": true,
        "spaceKey": "psCRTEV111en"
      },
      "versions": [
        {
          "version": "V11.1",
          "latest": true,
          "spaceKey": "psCRTEV111en"
        },
        {
          "version": "V11.0",
          "latest": false,
          "spaceKey": "psCRTEV110en"
        },
        {
          "version": "V10.1",
          "latest": false,
          "spaceKey": "psCRTEV101en"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psCRTEV100en"
        },
        {
          "version": "V1.9",
          "latest": false,
          "spaceKey": "psCRTEV19en"
        }
      ]
    },
    "product-for1fortran": {
      "id": "product-for1fortran",
      "productPackage": false,
      "name": "FOR1 (Fortran)",
      "latestVersion": {
        "version": "V2.2",
        "latest": true,
        "spaceKey": "psFOR1FORTRANV22en"
      },
      "versions": [{
        "version": "V2.2",
        "latest": true,
        "spaceKey": "psFOR1FORTRANV22en"
      }]
    },
    "product-jenvjava": {
      "id": "product-jenvjava",
      "productPackage": false,
      "name": "JENV (Java)",
      "latestVersion": {
        "version": "V9.0",
        "latest": true,
        "spaceKey": "psJENVJAVAV90en"
      },
      "versions": [
        {
          "version": "V9.0",
          "latest": true,
          "spaceKey": "psJENVJAVAV90en"
        },
        {
          "version": "V8.1",
          "latest": false,
          "spaceKey": "psJENVJAVAV81en"
        }
      ]
    },
    "product-pascal": {
      "id": "product-pascal",
      "productPackage": false,
      "name": "Pascal",
      "latestVersion": {
        "version": "V2.2",
        "latest": true,
        "spaceKey": "psPASCALV22en"
      },
      "versions": [{
        "version": "V2.2",
        "latest": true,
        "spaceKey": "psPASCALV22en"
      }]
    },
    "product-perl": {
      "id": "product-perl",
      "productPackage": false,
      "name": "PERL",
      "latestVersion": {
        "version": "V52.4",
        "latest": true,
        "spaceKey": "psPERLV524en"
      },
      "versions": [
        {
          "version": "V52.4",
          "latest": true,
          "spaceKey": "psPERLV524en"
        },
        {
          "version": "V5.8",
          "latest": false,
          "spaceKey": "psPERLV58en"
        },
        {
          "version": "V1.3",
          "latest": false,
          "spaceKey": "psPERLV13en"
        },
        {
          "version": "V1.0",
          "latest": false,
          "spaceKey": "psPERLV10en"
        }
      ]
    },
    "product-pl1": {
      "id": "product-pl1",
      "productPackage": false,
      "name": "PL/1",
      "latestVersion": {
        "version": "V4.2",
        "latest": true,
        "spaceKey": "psPL1V42en"
      },
      "versions": [{
        "version": "V4.2",
        "latest": true,
        "spaceKey": "psPL1V42en"
      }]
    },
    "product-crypt": {
      "id": "product-crypt",
      "productPackage": false,
      "name": "CRYPT",
      "latestVersion": {
        "version": "V2.0",
        "latest": true,
        "spaceKey": "psCRYPTV20en"
      },
      "versions": [{
        "version": "V2.0",
        "latest": true,
        "spaceKey": "psCRYPTV20en"
      }]
    },
    "product-ipsec": {
      "id": "product-ipsec",
      "productPackage": false,
      "name": "IPSec",
      "latestVersion": {
        "version": "V1.4",
        "latest": true,
        "spaceKey": "psIPSECV14en"
      },
      "versions": [{
        "version": "V1.4",
        "latest": true,
        "spaceKey": "psIPSECV14en"
      }]
    },
    "product-secos": {
      "id": "product-secos",
      "productPackage": false,
      "name": "SECOS",
      "latestVersion": {
        "version": "V5.5",
        "latest": true,
        "spaceKey": "psSECOSV55en"
      },
      "versions": [
        {
          "version": "V5.5",
          "latest": true,
          "spaceKey": "psSECOSV55en"
        },
        {
          "version": "V5.4",
          "latest": false,
          "spaceKey": "psSECOSV54en"
        }
      ]
    },
    "product-archive": {
      "id": "product-archive",
      "productPackage": false,
      "name": "ARCHIVE",
      "latestVersion": {
        "version": "V12.0",
        "latest": true,
        "spaceKey": "psARCHIVEV120en"
      },
      "versions": [
        {
          "version": "V12.0",
          "latest": true,
          "spaceKey": "psARCHIVEV120en"
        },
        {
          "version": "V11.0",
          "latest": false,
          "spaceKey": "psARCHIVEV110en"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psARCHIVEV100en"
        }
      ]
    },
    "product-drv": {
      "id": "product-drv",
      "productPackage": false,
      "name": "DRV",
      "latestVersion": {
        "version": "V3.2",
        "latest": true,
        "spaceKey": "psDRVV32en"
      },
      "versions": [{
        "version": "V3.2",
        "latest": true,
        "spaceKey": "psDRVV32en"
      }]
    },
    "product-fddrl": {
      "id": "product-fddrl",
      "productPackage": false,
      "name": "FDDRL",
      "latestVersion": {
        "version": "V20.0",
        "latest": true,
        "spaceKey": "psFDDRLV200en"
      },
      "versions": [
        {
          "version": "V20.0",
          "latest": true,
          "spaceKey": "psFDDRLV200en"
        },
        {
          "version": "V19.0",
          "latest": false,
          "spaceKey": "psFDDRLV190en"
        }
      ]
    },
    "product-hsms": {
      "id": "product-hsms",
      "productPackage": false,
      "name": "HSMS",
      "latestVersion": {
        "version": "V12.0",
        "latest": true,
        "spaceKey": "psHSMSV120en"
      },
      "versions": [
        {
          "version": "V12.0",
          "latest": true,
          "spaceKey": "psHSMSV120en"
        },
        {
          "version": "V11.0",
          "latest": false,
          "spaceKey": "psHSMSV110en"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psHSMSV100en"
        }
      ]
    },
    "product-maren": {
      "id": "product-maren",
      "productPackage": false,
      "name": "MAREN",
      "latestVersion": {
        "version": "V12.5",
        "latest": true,
        "spaceKey": "psMARENV125en"
      },
      "versions": [
        {
          "version": "V12.5",
          "latest": true,
          "spaceKey": "psMARENV125en"
        },
        {
          "version": "V12.0",
          "latest": false,
          "spaceKey": "psMARENV120en"
        }
      ]
    },
    "product-robar": {
      "id": "product-robar",
      "productPackage": false,
      "name": "ROBAR",
      "latestVersion": {
        "version": "V7.6",
        "latest": true,
        "spaceKey": "psROBARV76en"
      },
      "versions": [
        {
          "version": "V7.6",
          "latest": true,
          "spaceKey": "psROBARV76en"
        },
        {
          "version": "V7.5",
          "latest": false,
          "spaceKey": "psROBARV75en"
        },
        {
          "version": "V7.0",
          "latest": false,
          "spaceKey": "psROBARV70en"
        }
      ]
    },
    "product-shcosd": {
      "id": "product-shcosd",
      "productPackage": false,
      "name": "SHC-OSD",
      "latestVersion": {
        "version": "V14.0",
        "latest": true,
        "spaceKey": "psSHCOSDV140en"
      },
      "versions": [
        {
          "version": "V14.0",
          "latest": true,
          "spaceKey": "psSHCOSDV140en"
        },
        {
          "version": "V13.0",
          "latest": false,
          "spaceKey": "psSHCOSDV130en"
        },
        {
          "version": "V12.0",
          "latest": false,
          "spaceKey": "psSHCOSDV120en"
        }
      ]
    },
    "product-spaceopt": {
      "id": "product-spaceopt",
      "productPackage": false,
      "name": "SPACEOPT",
      "latestVersion": {
        "version": "V8.0",
        "latest": true,
        "spaceKey": "psSPACEOPTV80en"
      },
      "versions": [
        {
          "version": "V8.0",
          "latest": true,
          "spaceKey": "psSPACEOPTV80en"
        },
        {
          "version": "V7.0",
          "latest": false,
          "spaceKey": "psSPACEOPTV70en"
        }
      ]
    },
    "product-hiplexmscf": {
      "id": "product-hiplexmscf",
      "productPackage": false,
      "name": "HIPLEX-MSCF",
      "latestVersion": {
        "version": "V11.0",
        "latest": true,
        "spaceKey": "psHIPLEXMSCFV110en"
      },
      "versions": [
        {
          "version": "V11.0",
          "latest": true,
          "spaceKey": "psHIPLEXMSCFV110en"
        },
        {
          "version": "V8.0",
          "latest": false,
          "spaceKey": "psHIPLEXMSCFV80en"
        }
      ]
    },
    "product-omnis": {
      "id": "product-omnis",
      "productPackage": false,
      "name": "OMNIS",
      "latestVersion": {
        "version": "V8.5",
        "latest": true,
        "spaceKey": "psOMNISV85en"
      },
      "versions": [{
        "version": "V8.5",
        "latest": true,
        "spaceKey": "psOMNISV85en"
      }]
    },
    "product-omnismenu": {
      "id": "product-omnismenu",
      "productPackage": false,
      "name": "OMNIS-MENU",
      "latestVersion": {
        "version": "V3.5",
        "latest": true,
        "spaceKey": "psOMNISMENUV35en"
      },
      "versions": [{
        "version": "V3.5",
        "latest": true,
        "spaceKey": "psOMNISMENUV35en"
      }]
    },
    "product-propxt": {
      "id": "product-propxt",
      "productPackage": false,
      "name": "PROP-XT",
      "latestVersion": {
        "version": "V1.3",
        "latest": true,
        "spaceKey": "psPROPXTV13en"
      },
      "versions": [{
        "version": "V1.3",
        "latest": true,
        "spaceKey": "psPROPXTV13en"
      }]
    },
    "product-sbabs2": {
      "id": "product-sbabs2",
      "productPackage": false,
      "name": "SBA-BS2",
      "latestVersion": {
        "version": "V6.2",
        "latest": true,
        "spaceKey": "psSBABS2V62en"
      },
      "versions": [{
        "version": "V6.2",
        "latest": true,
        "spaceKey": "psSBABS2V62en"
      }]
    },
    "product-snmpagents": {
      "id": "product-snmpagents",
      "productPackage": false,
      "name": "SNMP-AGENTS",
      "latestVersion": {
        "version": "V1.1",
        "latest": true,
        "spaceKey": "psSNMPAGENTSV11en"
      },
      "versions": [
        {
          "version": "V1.1",
          "latest": true,
          "spaceKey": "psSNMPAGENTSV11en"
        },
        {
          "version": "V1.0",
          "latest": false,
          "spaceKey": "psSNMPAGENTSV10en"
        }
      ]
    },
    "product-ssasm2bs2": {
      "id": "product-ssasm2bs2",
      "productPackage": false,
      "name": "SSA-SM2-BS2",
      "latestVersion": {
        "version": "V5.0",
        "latest": true,
        "spaceKey": "psSSASM2BS2V50en"
      },
      "versions": [{
        "version": "V5.0",
        "latest": true,
        "spaceKey": "psSSASM2BS2V50en"
      }]
    },
    "product-ssaoutmbs2": {
      "id": "product-ssaoutmbs2",
      "productPackage": false,
      "name": "SSA-OUTM-BS2",
      "latestVersion": {
        "version": "V5.0",
        "latest": true,
        "spaceKey": "psSSAOUTMBS2V50en"
      },
      "versions": [{
        "version": "V5.0",
        "latest": true,
        "spaceKey": "psSSAOUTMBS2V50en"
      }]
    },
    "product-sscbs2": {
      "id": "product-sscbs2",
      "productPackage": false,
      "name": "SSC-BS2",
      "latestVersion": {
        "version": "V6.0",
        "latest": true,
        "spaceKey": "psSSCBS2V60en"
      },
      "versions": [{
        "version": "V6.0",
        "latest": true,
        "spaceKey": "psSSCBS2V60en"
      }]
    },
    "product-vm2000": {
      "id": "product-vm2000",
      "productPackage": false,
      "name": "VM2000",
      "latestVersion": {
        "version": "V11.5",
        "latest": true,
        "spaceKey": "psVM2000V115en"
      },
      "versions": [
        {
          "version": "V11.5",
          "latest": true,
          "spaceKey": "psVM2000V115en"
        },
        {
          "version": "V11.0",
          "latest": false,
          "spaceKey": "psVM2000V110en"
        },
        {
          "version": "V10.0",
          "latest": false,
          "spaceKey": "psVM2000V100en"
        }
      ]
    },
    "product-cis": {
      "id": "product-cis",
      "productPackage": false,
      "name": "CIS",
      "latestVersion": {
        "version": "V12.0",
        "latest": true,
        "spaceKey": "psCISV120en"
      },
      "versions": [{
        "version": "V12.0",
        "latest": true,
        "spaceKey": "psCISV120en"
      }]
    },
    "product-drivecomp": {
      "id": "product-drivecomp",
      "productPackage": false,
      "name": "DRIVE-COMP",
      "latestVersion": {
        "version": "V3.1",
        "latest": true,
        "spaceKey": "psDRIVECOMPV31en"
      },
      "versions": [
        {
          "version": "V3.1",
          "latest": true,
          "spaceKey": "psDRIVECOMPV31en"
        },
        {
          "version": "V2.1",
          "latest": false,
          "spaceKey": "psDRIVECOMPV21en"
        }
      ]
    },
    "product-drivewindows": {
      "id": "product-drivewindows",
      "productPackage": false,
      "name": "DRIVE/Windows",
      "latestVersion": {
        "version": "V3.1",
        "latest": true,
        "spaceKey": "psDRIVEWINDOWSV31en"
      },
      "versions": [
        {
          "version": "V3.1",
          "latest": true,
          "spaceKey": "psDRIVEWINDOWSV31en"
        },
        {
          "version": "V2.2",
          "latest": false,
          "spaceKey": "psDRIVEWINDOWSV22en"
        },
        {
          "version": "V2.1",
          "latest": false,
          "spaceKey": "psDRIVEWINDOWSV21en"
        }
      ]
    },
    "product-leasy": {
      "id": "product-leasy",
      "productPackage": false,
      "name": "LEASY",
      "latestVersion": {
        "version": "V6.2",
        "latest": true,
        "spaceKey": "psLEASYV62en"
      },
      "versions": [{
        "version": "V6.2",
        "latest": true,
        "spaceKey": "psLEASYV62en"
      }]
    },
    "product-oracle": {
      "id": "product-oracle",
      "productPackage": false,
      "name": "Oracle",
      "latestVersion": {
        "version": "12.2",
        "latest": true,
        "spaceKey": "psORACLEV122en"
      },
      "versions": [
        {
          "version": "12.2",
          "latest": true,
          "spaceKey": "psORACLEV122en"
        },
        {
          "version": "12.1",
          "latest": false,
          "spaceKey": "psORACLEV121en"
        },
        {
          "version": "11.2",
          "latest": false,
          "spaceKey": "psORACLEV112en"
        }
      ]
    },
    "product-sesamsql": {
      "id": "product-sesamsql",
      "productPackage": false,
      "name": "SESAM/SQL",
      "latestVersion": {
        "version": "V9.1",
        "latest": true,
        "spaceKey": "psSESAMSQLV91en"
      },
      "versions": [
        {
          "version": "V9.1",
          "latest": true,
          "spaceKey": "psSESAMSQLV91en"
        },
        {
          "version": "V9.0",
          "latest": false,
          "spaceKey": "psSESAMSQLV90en"
        }
      ]
    },
    "product-udsiqs": {
      "id": "product-udsiqs",
      "productPackage": false,
      "name": "UDS-IQS",
      "latestVersion": {
        "version": "V4.0",
        "latest": true,
        "spaceKey": "psUDSIQSV40en"
      },
      "versions": [{
        "version": "V4.0",
        "latest": true,
        "spaceKey": "psUDSIQSV40en"
      }]
    },
    "product-udssql": {
      "id": "product-udssql",
      "productPackage": false,
      "name": "UDS/SQL",
      "latestVersion": {
        "version": "V2.9",
        "latest": true,
        "spaceKey": "psUDSSQLV29en"
      },
      "versions": [
        {
          "version": "V2.9",
          "latest": true,
          "spaceKey": "psUDSSQLV29en"
        },
        {
          "version": "V2.8",
          "latest": false,
          "spaceKey": "psUDSSQLV28en"
        }
      ]
    },
    "product-beanconnect": {
      "id": "product-beanconnect",
      "productPackage": false,
      "name": "BeanConnect",
      "latestVersion": {
        "version": "V6.5",
        "latest": true,
        "spaceKey": "psBEANCONNECTV65en"
      },
      "versions": [
        {
          "version": "V6.5",
          "latest": true,
          "spaceKey": "psBEANCONNECTV65en"
        },
        {
          "version": "V3.0",
          "latest": false,
          "spaceKey": "psBEANCONNECTV30en"
        }
      ]
    },
    "product-openft": {
      "id": "product-openft",
      "productPackage": false,
      "name": "openFT",
      "latestVersion": {
        "version": "V12.1",
        "latest": true,
        "spaceKey": "psOPENFTV121en"
      },
      "versions": [
        {
          "version": "V12.1",
          "latest": true,
          "spaceKey": "psOPENFTV121en"
        },
        {
          "version": "V12.0",
          "latest": false,
          "spaceKey": "psOPENFTV120en"
        }
      ]
    },
    "product-openutm": {
      "id": "product-openutm",
      "productPackage": false,
      "name": "openUTM",
      "latestVersion": {
        "version": "V7.0",
        "latest": true,
        "spaceKey": "psOPENUTMV70en"
      },
      "versions": [
        {
          "version": "V7.0",
          "latest": true,
          "spaceKey": "psOPENUTMV70en"
        },
        {
          "version": "V6.5",
          "latest": false,
          "spaceKey": "psOPENUTMV65en"
        },
        {
          "version": "V6.4",
          "latest": false,
          "spaceKey": "psOPENUTMV64en"
        },
        {
          "version": "V6.3",
          "latest": false,
          "spaceKey": "psOPENUTMV63en"
        }
      ]
    },
    "product-pcmxunixbasedos": {
      "id": "product-pcmxunixbasedos",
      "productPackage": false,
      "name": "PCMX (Unix based OS)",
      "latestVersion": {
        "version": "V6.0",
        "latest": true,
        "spaceKey": "psPCMXUNIXBASEDOSV60en"
      },
      "versions": [{
        "version": "V6.0",
        "latest": true,
        "spaceKey": "psPCMXUNIXBASEDOSV60en"
      }]
    },
    "product-webtransactions": {
      "id": "product-webtransactions",
      "productPackage": false,
      "name": "WebTransactions",
      "latestVersion": {
        "version": "V7.5",
        "latest": true,
        "spaceKey": "psWEBTRANSACTIONSV75en"
      },
      "versions": [{
        "version": "V7.5",
        "latest": true,
        "spaceKey": "psWEBTRANSACTIONSV75en"
      }]
    },
    "product-seseriesinfrastructure": {
      "id": "product-seseriesinfrastructure",
      "productPackage": false,
      "name": "SE Infrastructure",
      "latestVersion": {
        "version": "V6.3",
        "latest": true,
        "spaceKey": "psSESERIESINFRASTRUCTUREV63en"
      },
      "versions": [
        {
          "version": "V6.3",
          "latest": true,
          "spaceKey": "psSESERIESINFRASTRUCTUREV63en"
        },
        {
          "version": "V6.2",
          "latest": false,
          "spaceKey": "psSESERIESINFRASTRUCTUREV62en"
        },
        {
          "version": "V6.1",
          "latest": false,
          "spaceKey": "psSESERIESINFRASTRUCTUREV61en"
        },
        {
          "version": "V6.0",
          "latest": false,
          "spaceKey": "psSESERIESINFRASTRUCTUREV60en"
        }
      ]
    },
    "product-sserver": {
      "id": "product-sserver",
      "productPackage": false,
      "name": "S-Server",
      "latestVersion": {
        "version": "",
        "latest": true,
        "spaceKey": "psSSERVERen"
      },
      "versions": [{
        "version": "",
        "latest": true,
        "spaceKey": "psSSERVERen"
      }]
    },
    "product-sqserver": {
      "id": "product-sqserver",
      "productPackage": false,
      "name": "SQ-Server",
      "latestVersion": {
        "version": "",
        "latest": true,
        "spaceKey": "psSQSERVERen"
      },
      "versions": [{
        "version": "",
        "latest": true,
        "spaceKey": "psSQSERVERen"
      }]
    },
    "product-onlinestoragefujitsueternus": {
      "id": "product-onlinestoragefujitsueternus",
      "productPackage": false,
      "name": "Online Storage FUJITSU ETERNUS",
      "latestVersion": {
        "version": "",
        "latest": true,
        "spaceKey": "psONLINESTORAGEFUJITSUETERNUSen"
      },
      "versions": [{
        "version": "",
        "latest": true,
        "spaceKey": "psONLINESTORAGEFUJITSUETERNUSen"
      }]
    },
    "product-onlinestorageemcvmax": {
      "id": "product-onlinestorageemcvmax",
      "productPackage": false,
      "name": "Online Storage EMC VMAX",
      "latestVersion": {
        "version": "",
        "latest": true,
        "spaceKey": "psONLINESTORAGEEMCVMAXen"
      },
      "versions": [{
        "version": "",
        "latest": true,
        "spaceKey": "psONLINESTORAGEEMCVMAXen"
      }]
    },
    "product-fcswitch": {
      "id": "product-fcswitch",
      "productPackage": false,
      "name": "FC-Switch",
      "latestVersion": {
        "version": "",
        "latest": true,
        "spaceKey": "psFCSWITCHen"
      },
      "versions": [{
        "version": "",
        "latest": true,
        "spaceKey": "psFCSWITCHen"
      }]
    }
  }
}`;

export var spaceKeys = `{
  "psBS2000OPERATINGSYSTEMV110Ben": {
    "spaceProperties": {
      "prodId": "product-bs2000operatingsystem",
      "prod": "BS2000 Operating System",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Accounting Records",
        "subtitle": "",
        "version": "V11.0",
        "type": "User Guide",
        "edition": "2009-05",
        "filelink": "8531/abrech.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ASTI",
        "subtitle": "",
        "version": "V2.0F",
        "type": "Readme File",
        "edition": "2016-06",
        "filelink": "3051/sysrme.asti.020.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "BINDER",
        "subtitle": "",
        "version": "V2.8",
        "type": "Release Notice",
        "edition": "2018-06",
        "filelink": "13767/sysfgm.binder.028.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "BINDER",
        "subtitle": "",
        "version": "V2.7A",
        "type": "User Guide",
        "edition": "2016-03",
        "filelink": "12690/binder.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "BLSSERV",
        "subtitle": "",
        "version": "V2.8",
        "type": "Readme File",
        "edition": "2009-10",
        "filelink": "9136/SYSRME.BLSSERV.028a.E.TXT",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "BLSSERV",
        "subtitle": "Dynamic Binder Loader/Starter in BS2000/OSD",
        "version": "V2.7",
        "type": "User Guide",
        "edition": "2009-05",
        "filelink": "8832/blsserv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CALENDAR",
        "subtitle": "",
        "version": "V20.0",
        "type": "Readme File",
        "edition": "2017-07",
        "filelink": "13427/sysrme.calendar.200.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CALENDAR",
        "subtitle": "",
        "version": "V17",
        "type": "User Guide",
        "edition": "2010-06",
        "filelink": "8621/calendar.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CAPRI",
        "subtitle": "",
        "version": "V2.0",
        "type": "Readme File",
        "edition": "2003-09",
        "filelink": "8623/sysrme.capri.020a.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "Commands, Volume 1-7",
        "subtitle": "",
        "version": "V11.0B",
        "type": "User Guide",
        "edition": "2020-06",
        "filelink": "20289/BS2V110B-Commands-en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRYPT",
        "subtitle": "",
        "version": "V2.0",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13262/cryptobox.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Diagnostics Handbook",
        "subtitle": "",
        "version": "V11.0",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13192/diagnose.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DMS Introduction",
        "subtitle": "",
        "version": "V11.0B",
        "type": "User Guide",
        "edition": "2020-06",
        "filelink": "20290/BS2V110B-DmsIntro-en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DMS Macros",
        "subtitle": "",
        "version": "V11.0B",
        "type": "User Guide",
        "edition": "2020-06",
        "filelink": "20291/BS2V110B-DmsMacros-en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DSSM",
        "subtitle": "",
        "version": "V4.3",
        "type": "Readme File",
        "edition": "2016-06",
        "filelink": "8625/sysrme.dssm.043.c05.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DSSM V4.0/SSCM V2.3",
        "subtitle": "",
        "version": "V2.3",
        "type": "User Guide",
        "edition": "2002-03",
        "filelink": "2635/dssm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ELSA",
        "subtitle": "",
        "version": "V1.7A",
        "type": "Readme File",
        "edition": "2000-10",
        "filelink": "4654/sysrme.elsa.017a.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "ELSA",
        "subtitle": "Error Logging System Analysis",
        "version": "V1.6A",
        "type": "User Guide",
        "edition": "1999-12",
        "filelink": "1305/elsa.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Executive Macros",
        "subtitle": "",
        "version": "V11.0",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13193/makros.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IMON",
        "subtitle": "",
        "version": "V3.3B",
        "type": "Release Notice",
        "edition": "2018-10",
        "filelink": "11448/sysfgm.imon.033.b00.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IMON",
        "subtitle": "",
        "version": "V3.3B",
        "type": "Readme File",
        "edition": "2018-10",
        "filelink": "11446/sysrme.imon.033.b00.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IMON",
        "subtitle": "",
        "version": "V3.2",
        "type": "User Guide",
        "edition": "2010-12",
        "filelink": "9924/imon.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "System Administration (SE Server)",
        "subtitle": "",
        "version": "V11.0B",
        "type": "User Guide",
        "edition": "2019-06",
        "filelink": "20022/Systemadministration-en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "System Exits",
        "subtitle": "",
        "version": "V11.0",
        "type": "User Guide",
        "edition": "2002-03",
        "filelink": "2655/sysexit.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "System Installation (SE Server)",
        "subtitle": "",
        "version": "V11.0B",
        "type": "User Guide",
        "edition": "2019-06",
        "filelink": "20023/SYSinstpub-290519-0821-1125en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "System Managed Storage",
        "subtitle": "",
        "version": "V11.0",
        "type": "User Guide",
        "edition": "2004-12",
        "filelink": "4621/sms.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "System Messages (download)",
        "subtitle": "(Zip archive)",
        "version": "V11.0B",
        "type": "Help System",
        "edition": "2020-06",
        "filelink": "20293/WebHelp_en.zip",
        "mediatype": "fj-mediatype-zip"
      },
      {
        "title": "TSOSLNK (German)",
        "subtitle": "",
        "version": "V21.0D",
        "type": "User Guide",
        "edition": "1991-05",
        "filelink": "20087/tsoslnk.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Utility Routines",
        "subtitle": "",
        "version": "V11.0B",
        "type": "User Guide",
        "edition": "2019-06",
        "filelink": "20024/UtilityRoutinesV11.0B.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psBS2000OPERATINGSYSTEMV110Bde": {
    "spaceProperties": {
      "prodId": "product-bs2000operatingsystem",
      "prod": "BS2000 Betriebssystem",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Abrechnungssätze",
        "subtitle": "",
        "version": "V11.0",
        "type": "Benutzerhandbuch",
        "edition": "2009-05",
        "filelink": "8530/abrech.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ASTI",
        "subtitle": "",
        "version": "V2.0F",
        "type": "Readme Datei",
        "edition": "2016-06",
        "filelink": "2345/sysrme.asti.020.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "BINDER",
        "subtitle": "",
        "version": "V2.8",
        "type": "Freigabemitteilung",
        "edition": "2018-06",
        "filelink": "13766/sysfgm.binder.028.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "BINDER",
        "subtitle": "",
        "version": "V2.7A",
        "type": "Benutzerhandbuch",
        "edition": "2016-03",
        "filelink": "12689/binder.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "BLSSERV",
        "subtitle": "",
        "version": "V2.8",
        "type": "Readme Datei",
        "edition": "2009-10",
        "filelink": "9162/SYSRME.BLSSERV.028a.D.TXT",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "BLSSERV",
        "subtitle": "Bindelader-Starter in BS2000/OSD",
        "version": "V2.7",
        "type": "Benutzerhandbuch",
        "edition": "2009-05",
        "filelink": "8562/blsserv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CALENDAR",
        "subtitle": "",
        "version": "V20.0",
        "type": "Readme Datei",
        "edition": "2017-07",
        "filelink": "13426/sysrme.calendar.200.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CALENDAR",
        "subtitle": "",
        "version": "V17",
        "type": "Benutzerhandbuch",
        "edition": "2010-06",
        "filelink": "8620/calendar.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CAPRI",
        "subtitle": "",
        "version": "V2.0",
        "type": "Readme Datei",
        "edition": "2003-09",
        "filelink": "8622/sysrme.capri.020a.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "CRYPT",
        "subtitle": "",
        "version": "V2.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13261/cryptobox.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Diagnosehandbuch",
        "subtitle": "",
        "version": "V11.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13187/diagnose.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Dienstprogramme",
        "subtitle": "",
        "version": "V11.0B",
        "type": "Benutzerhandbuch",
        "edition": "2019-06",
        "filelink": "20008/DIENSTPROGRAMME-de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DSSM",
        "subtitle": "",
        "version": "V4.3",
        "type": "Readme Datei",
        "edition": "2016-06",
        "filelink": "8624/sysrme.dssm.043.c05.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DSSM V4.0/SSCM V2.3",
        "subtitle": "",
        "version": "V2.3",
        "type": "Benutzerhandbuch",
        "edition": "2002-03",
        "filelink": "1900/dssm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DVS Einführung",
        "subtitle": "",
        "version": "V11.0B",
        "type": "Benutzerhandbuch",
        "edition": "2020-06",
        "filelink": "20286/BS2V110B-DvsEinf-de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DVS Makros",
        "subtitle": "",
        "version": "V11.0B",
        "type": "Benutzerhandbuch",
        "edition": "2020-06",
        "filelink": "20287/BS2V110B-DvsMakros-de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ELSA",
        "subtitle": "",
        "version": "V1.7A",
        "type": "Readme Datei",
        "edition": "2000-10",
        "filelink": "4653/sysrme.elsa.017a.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "ELSA",
        "subtitle": "Error Logging System Analysis",
        "version": "V1.6A",
        "type": "Benutzerhandbuch",
        "edition": "1999-12",
        "filelink": "375/elsa.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IMON",
        "subtitle": "",
        "version": "V3.3B",
        "type": "Freigabemitteilung",
        "edition": "2018-10",
        "filelink": "11447/sysfgm.imon.033.b00.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IMON",
        "subtitle": "",
        "version": "V3.3B",
        "type": "Readme Datei",
        "edition": "2018-10",
        "filelink": "11445/sysrme.imon.033.b00.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IMON",
        "subtitle": "",
        "version": "V3.2",
        "type": "Benutzerhandbuch",
        "edition": "2010-12",
        "filelink": "9923/imon.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Kommandos Band 1-7",
        "subtitle": "",
        "version": "V11.0B",
        "type": "Benutzerhandbuch",
        "edition": "2020-06",
        "filelink": "20288/BS2V110B-Kommandos-de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Makroaufrufe an den Ablaufteil",
        "subtitle": "",
        "version": "V11.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13189/makros.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "System Exits",
        "subtitle": "",
        "version": "V11.0",
        "type": "Benutzerhandbuch",
        "edition": "2002-03",
        "filelink": "1929/sysexit.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "System Managed Storage BHB",
        "subtitle": "",
        "version": "V11.0",
        "type": "Benutzerhandbuch",
        "edition": "2004-12",
        "filelink": "4598/sms.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Systembetreuung (SE Server)",
        "subtitle": "",
        "version": "V11.0B",
        "type": "Benutzerhandbuch",
        "edition": "2019-06",
        "filelink": "20016/Systembetreuung-de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Systeminstallation (SE Server)",
        "subtitle": "",
        "version": "V11.0B",
        "type": "Benutzerhandbuch",
        "edition": "2019-06",
        "filelink": "20017/SYSinstpub-290519-0807-1119de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Systemmeldungen (download)",
        "subtitle": "(Zip-Archiv)",
        "version": "V11.0B",
        "type": "Hilfesystem",
        "edition": "2020-06",
        "filelink": "20292/WebHelp_de.zip",
        "mediatype": "fj-mediatype-zip"
      },
      {
        "title": "TSOSLNK",
        "subtitle": "",
        "version": "V21.0D",
        "type": "Benutzerhandbuch",
        "edition": "1991-05",
        "filelink": "20087/tsoslnk.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psBS2000OPERATINGSYSTEMV100en": {
    "spaceProperties": {
      "prodId": "product-bs2000operatingsystem",
      "prod": "BS2000 Operating System",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Accounting Records",
        "subtitle": "",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2009-05",
        "filelink": "8531/abrech.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ADAM",
        "subtitle": "",
        "version": "V17",
        "type": "User Guide",
        "edition": "2010-06",
        "filelink": "1012/adam.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ASTI",
        "subtitle": "",
        "version": "V2.0F",
        "type": "Readme File",
        "edition": "2016-06",
        "filelink": "3051/sysrme.asti.020.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "BINDER",
        "subtitle": "",
        "version": "V2.8",
        "type": "Release Notice",
        "edition": "2018-06",
        "filelink": "13767/sysfgm.binder.028.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "BINDER",
        "subtitle": "",
        "version": "V2.7A",
        "type": "User Guide",
        "edition": "2016-03",
        "filelink": "12690/binder.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "BLSSERV",
        "subtitle": "",
        "version": "V2.8",
        "type": "Readme File",
        "edition": "2009-10",
        "filelink": "9136/SYSRME.BLSSERV.028a.E.TXT",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "BLSSERV",
        "subtitle": "Dynamic Binder Loader/Starter in BS2000/OSD",
        "version": "V2.7",
        "type": "User Guide",
        "edition": "2009-05",
        "filelink": "8832/blsserv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CALENDAR",
        "subtitle": "",
        "version": "V19.0A",
        "type": "Readme File",
        "edition": "2012-12",
        "filelink": "12165/sysrme.calendar.190.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CALENDAR",
        "subtitle": "",
        "version": "V17",
        "type": "User Guide",
        "edition": "2010-06",
        "filelink": "8621/calendar.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CAPRI",
        "subtitle": "",
        "version": "V2.0",
        "type": "Readme File",
        "edition": "2003-09",
        "filelink": "8623/sysrme.capri.020a.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "Commands, Volume 1",
        "subtitle": "General Part",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2017-06",
        "filelink": "12036/cmd_1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Commands, Volume 2",
        "subtitle": "ACTIVATE-SNAPSHOT - DECRYPT-FILE",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2017-06",
        "filelink": "12037/cmd_2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Commands, Volume 3",
        "subtitle": "DELETE-ALTERNATE-INDEX - LOGOFF",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2017-06",
        "filelink": "12038/cmd_3.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Commands, Volume 4",
        "subtitle": "MAIL-FILE \u2013 MOVE-TASK-TO-CATEGORY",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2017-06",
        "filelink": "12039/cmd_4.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Commands, Volume 5",
        "subtitle": "OPEN-VARIABLE-CONTAINER \u2013 SHOW-DSSM-INFORMATION",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2017-06",
        "filelink": "12040/cmd_5.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Commands, Volume 6",
        "subtitle": "SHOW-FILE \u2013 SHOW-PUBSET-SPACEPRO-OPTIONS",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2017-06",
        "filelink": "12041/cmd_6.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Commands, Volume 7",
        "subtitle": "SHOW-RESOURCE-ALLOCATION \u2013 WRITE-TEXT",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2017-06",
        "filelink": "12042/cmd_7.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Diagnostics Handbook",
        "subtitle": "",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12030/diagnose.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DMS Macros",
        "subtitle": "",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2016-06",
        "filelink": "12035/dvsmakros.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DSSM",
        "subtitle": "",
        "version": "V4.3",
        "type": "Readme File",
        "edition": "2016-06",
        "filelink": "8625/sysrme.dssm.043.c05.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DSSM V4.0/SSCM V2.3",
        "subtitle": "",
        "version": "V2.3",
        "type": "User Guide",
        "edition": "2002-03",
        "filelink": "2635/dssm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ELSA",
        "subtitle": "",
        "version": "V1.7A",
        "type": "Readme File",
        "edition": "2000-10",
        "filelink": "4654/sysrme.elsa.017a.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "ELSA",
        "subtitle": "Error Logging System Analysis",
        "version": "V1.6A",
        "type": "User Guide",
        "edition": "1999-12",
        "filelink": "1305/elsa.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Executive Macros",
        "subtitle": "",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2015-11",
        "filelink": "12043/makros.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IMON",
        "subtitle": "",
        "version": "V3.3B",
        "type": "Release Notice",
        "edition": "2018-10",
        "filelink": "11448/sysfgm.imon.033.b00.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IMON",
        "subtitle": "",
        "version": "V3.3B",
        "type": "Readme File",
        "edition": "2018-10",
        "filelink": "11446/sysrme.imon.033.b00.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IMON",
        "subtitle": "",
        "version": "V3.2",
        "type": "User Guide",
        "edition": "2010-12",
        "filelink": "9924/imon.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Introductory Guide to DMS",
        "subtitle": "",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12034/dvs_ein.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IORM",
        "subtitle": "",
        "version": "V10.0A01",
        "type": "Readme File",
        "edition": "2017-06",
        "filelink": "13277/sysrme.iorm.100.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Migration Guide",
        "subtitle": "",
        "version": "V10.0",
        "type": "Readme File",
        "edition": "2015-04",
        "filelink": "12044/migr_gde.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SANCHECK",
        "subtitle": "",
        "version": "V3.0A",
        "type": "Readme File",
        "edition": "2015-04",
        "filelink": "12167/sysrme.sancheck.030.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "System Administration (SE Server)",
        "subtitle": "",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12033/sysbtr_se.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "System Exits",
        "subtitle": "",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2002-03",
        "filelink": "2655/sysexit.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "System Installation",
        "subtitle": "",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12046/sysinst_se.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "System Managed Storage",
        "subtitle": "",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2004-12",
        "filelink": "4621/sms.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "System Messages (download)",
        "subtitle": "(self-extracting archive)",
        "version": "V10.0",
        "type": "Help system",
        "edition": "",
        "filelink": "12234/messages_v10.exe",
        "mediatype": "fj-mediatype-zip"
      },
      {
        "title": "TSOSLNK (German)",
        "subtitle": "",
        "version": "V21.0D",
        "type": "User Guide",
        "edition": "1991-05",
        "filelink": "20087/tsoslnk.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Utility Routines",
        "subtitle": "",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12031/dienstp.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psBS2000OPERATINGSYSTEMV100de": {
    "spaceProperties": {
      "prodId": "product-bs2000operatingsystem",
      "prod": "BS2000 Betriebssystem",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Abrechnungssätze",
        "subtitle": "",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2009-05",
        "filelink": "8530/abrech.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ADAM",
        "subtitle": "",
        "version": "V17",
        "type": "Benutzerhandbuch",
        "edition": "2010-06",
        "filelink": "76/adam.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ASTI",
        "subtitle": "",
        "version": "V2.0F",
        "type": "Readme Datei",
        "edition": "2016-06",
        "filelink": "2345/sysrme.asti.020.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "BINDER",
        "subtitle": "",
        "version": "V2.8",
        "type": "Freigabemitteilung",
        "edition": "2018-06",
        "filelink": "13766/sysfgm.binder.028.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "BINDER",
        "subtitle": "",
        "version": "V2.7A",
        "type": "Benutzerhandbuch",
        "edition": "2016-03",
        "filelink": "12689/binder.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "BLSSERV",
        "subtitle": "",
        "version": "V2.8",
        "type": "Readme Datei",
        "edition": "2009-10",
        "filelink": "9162/SYSRME.BLSSERV.028a.D.TXT",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "BLSSERV",
        "subtitle": "Bindelader-Starter in BS2000/OSD",
        "version": "V2.7",
        "type": "Benutzerhandbuch",
        "edition": "2009-05",
        "filelink": "8562/blsserv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CALENDAR",
        "subtitle": "",
        "version": "V19.0A",
        "type": "Readme Datei",
        "edition": "2012-12",
        "filelink": "12164/sysrme.calendar.190.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CALENDAR",
        "subtitle": "",
        "version": "V17",
        "type": "Benutzerhandbuch",
        "edition": "2010-06",
        "filelink": "8620/calendar.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CAPRI",
        "subtitle": "",
        "version": "V2.0",
        "type": "Readme Datei",
        "edition": "2003-09",
        "filelink": "8622/sysrme.capri.020a.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "Diagnosehandbuch",
        "subtitle": "",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12011/diagnose.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Dienstprogramme",
        "subtitle": "",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12012/dienstp.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DSSM",
        "subtitle": "",
        "version": "V4.3",
        "type": "Readme Datei",
        "edition": "2016-06",
        "filelink": "8624/sysrme.dssm.043.c05.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DSSM V4.0/SSCM V2.3",
        "subtitle": "",
        "version": "V2.3",
        "type": "Benutzerhandbuch",
        "edition": "2002-03",
        "filelink": "1900/dssm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DVS Einführung",
        "subtitle": "",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12013/dvs_ein.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DVS Makros",
        "subtitle": "",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-06",
        "filelink": "12014/dvsmakros.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ELSA",
        "subtitle": "",
        "version": "V1.7A",
        "type": "Readme Datei",
        "edition": "2000-10",
        "filelink": "4653/sysrme.elsa.017a.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "ELSA",
        "subtitle": "Error Logging System Analysis",
        "version": "V1.6A",
        "type": "Benutzerhandbuch",
        "edition": "1999-12",
        "filelink": "375/elsa.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IMON",
        "subtitle": "",
        "version": "V3.3B",
        "type": "Freigabemitteilung",
        "edition": "2018-10",
        "filelink": "11447/sysfgm.imon.033.b00.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IMON",
        "subtitle": "",
        "version": "V3.3B",
        "type": "Readme Datei",
        "edition": "2018-10",
        "filelink": "11445/sysrme.imon.033.b00.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IMON",
        "subtitle": "",
        "version": "V3.2",
        "type": "Benutzerhandbuch",
        "edition": "2010-12",
        "filelink": "9923/imon.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IORM",
        "subtitle": "",
        "version": "V10.0A01",
        "type": "Readme Datei",
        "edition": "2017-07",
        "filelink": "13276/sysrme.iorm.100.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Kommandos Band 1",
        "subtitle": "Allgemeiner Teil",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-06",
        "filelink": "12015/cmd_1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Kommandos Band 2",
        "subtitle": "ACTIVATE-SNAPSHOT - DECRYPT-FILE",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-06",
        "filelink": "12016/cmd_2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Kommandos Band 3",
        "subtitle": "DELETE-ALTERNATE-INDEX - LOGOFF",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-06",
        "filelink": "12017/cmd_3.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Kommandos Band 4",
        "subtitle": "MAIL-FILE \u2013 MOVE-TASK-TO-CATEGORY",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-06",
        "filelink": "12018/cmd_4.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Kommandos Band 5",
        "subtitle": "OPEN-VARIABLE-CONTAINER \u2013 SHOW-DSSM-INFORMATION",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-06",
        "filelink": "12019/cmd_5.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Kommandos Band 6",
        "subtitle": "SHOW-FILE \u2013 SHOW-PUBSET-SPACEPRO-OPTIONS",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-06",
        "filelink": "12020/cmd_6.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Kommandos Band 7",
        "subtitle": "SHOW-RESOURCE-ALLOCATION \u2013 WRITE-TEXT",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-06",
        "filelink": "12021/cmd_7.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Makroaufrufe an den Ablaufteil",
        "subtitle": "",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2015-11",
        "filelink": "12022/makros.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Migration Guide",
        "subtitle": "",
        "version": "V10.0",
        "type": "Readme Datei",
        "edition": "2015-04",
        "filelink": "12023/migr_gde.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SANCHECK",
        "subtitle": "",
        "version": "V3.0A",
        "type": "Readme Datei",
        "edition": "2015-04",
        "filelink": "12166/sysrme.sancheck.030.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "System Exits",
        "subtitle": "",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2002-03",
        "filelink": "1929/sysexit.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "System Managed Storage BHB",
        "subtitle": "",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2004-12",
        "filelink": "4598/sms.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Systembetreuung",
        "subtitle": "",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-06",
        "filelink": "12032/sysbetr_se.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Systeminstallation",
        "subtitle": "",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12027/sysinst_se.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Systemmeldungen (download)",
        "subtitle": "(selbstextrahierendes ZIP-Archiv)",
        "version": "V10.0",
        "type": "Hilfesystem",
        "edition": "",
        "filelink": "12233/meldungen_v10.exe",
        "mediatype": "fj-mediatype-zip"
      },
      {
        "title": "TSOSLNK",
        "subtitle": "",
        "version": "V21.0D",
        "type": "Benutzerhandbuch",
        "edition": "1991-05",
        "filelink": "20087/tsoslnk.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psBS2000OPERATINGSYSTEMV01en": {
    "spaceProperties": {
      "prodId": "product-bs2000operatingsystem",
      "prod": "BS2000 Operating System",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "BINDER",
        "subtitle": "",
        "version": "V2.3A",
        "type": "User Guide",
        "edition": "2004-06",
        "filelink": "2622/binder.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LMS (ISP)",
        "subtitle": "",
        "version": "V2.0",
        "type": "User Guide",
        "edition": "2009-06",
        "filelink": "20088/lms_isp20_e.PDF",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Operator Commands (ISP)",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "1993-04",
        "filelink": "10572/opr_komm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PERCON (ISP) (German)",
        "subtitle": "",
        "version": "V2.3A",
        "type": "User Guide",
        "edition": "1988-12",
        "filelink": "20089/PERCON_ISP.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SORT (ISP) (German)",
        "subtitle": "",
        "version": "V7.3A",
        "type": "User Guide",
        "edition": "1990-08",
        "filelink": "20090/SORT-BS2000-V7.3A_Beschreibung_1990-08_scanned.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "System Administrator Commands (ISP)",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "1993-04",
        "filelink": "10573/sys_kdo.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "User Commands (ISP)",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "1993-04",
        "filelink": "10571/ben_kdo.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Utility Routines",
        "subtitle": "",
        "version": "V2.0A",
        "type": "User Guide",
        "edition": "1995-07",
        "filelink": "20091/Utilities OSD V2.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psBS2000OPERATINGSYSTEMV01de": {
    "spaceProperties": {
      "prodId": "product-bs2000operatingsystem",
      "prod": "BS2000 Betriebssystem",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Benutzerkommandos (ISP)",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "1991-05",
        "filelink": "4574/ben_kdo.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "BINDER",
        "subtitle": "",
        "version": "V2.3A",
        "type": "Benutzerhandbuch",
        "edition": "2004-06",
        "filelink": "1898/binder.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Dienstprogramme (Englisch)",
        "subtitle": "",
        "version": "V2.0A",
        "type": "Benutzerhandbuch",
        "edition": "1995-07",
        "filelink": "20091/Utilities OSD V2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LMS (ISP)",
        "subtitle": "",
        "version": "V2.0A",
        "type": "Benutzerhandbuch",
        "edition": "1992-01",
        "filelink": "20150/LMS_ISP.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Operator Kommandos (ISP)",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "1993-04",
        "filelink": "4575/opr_komm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PERCON (ISP)",
        "subtitle": "",
        "version": "V2.3A",
        "type": "Benutzerhandbuch",
        "edition": "1988-12",
        "filelink": "20089/PERCON_ISP.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SORT (ISP)",
        "subtitle": "",
        "version": "V7.3A",
        "type": "Benutzerhandbuch",
        "edition": "1990-08",
        "filelink": "20090/SORT-BS2000-V7.3A_Beschreibung_1990-08_scanned.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Systemverwalter Kommandos (ISP)",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "1991-04",
        "filelink": "4573/sys_kdo.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psPOSIXV110en": {
    "spaceProperties": {
      "prodId": "product-posix",
      "prod": "POSIX",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Loading shared objects in POSIX",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2012-11",
        "filelink": "11131/dynlnk.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX",
        "subtitle": "",
        "version": "V11.0",
        "type": "Readme File",
        "edition": "2017-07",
        "filelink": "13435/sysrme.posix-bc.110.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX Basics",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2012-11",
        "filelink": "11125/posix_g.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX BS2000 file system bs2fs",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2012-11",
        "filelink": "11129/posix_bs2fs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX Commands",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13248/posix_k.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX SOCKETS/XTI",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2005-03",
        "filelink": "4686/posix_s.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX-BC",
        "subtitle": "",
        "version": "V11.0",
        "type": "Release Notice",
        "edition": "2017-07",
        "filelink": "13411/sysfgm.posix-bc.110.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX-NSL",
        "subtitle": "",
        "version": "V10.0A",
        "type": "Readme File",
        "edition": "2016-10",
        "filelink": "13437/sysrme.posix-nsl.100.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psPOSIXV110de": {
    "spaceProperties": {
      "prodId": "product-posix",
      "prod": "POSIX",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Laden von Shared Objects in POSIX",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2012-11",
        "filelink": "11130/dynlnk.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX",
        "subtitle": "",
        "version": "V11.0",
        "type": "Readme Datei",
        "edition": "2017-07",
        "filelink": "13434/sysrme.posix-bc.110.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX BS2000-Dateisystem bs2fs",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2012-11",
        "filelink": "11128/posix_bs2fs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX Grundlagen",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2012-11",
        "filelink": "11124/posix_g.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX Kommandos",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13247/posix_k.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX SOCKETS/XTI",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2005-03",
        "filelink": "4685/posix_s.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX-BC",
        "subtitle": "",
        "version": "V11.0",
        "type": "Freigabemitteilung",
        "edition": "2017-07",
        "filelink": "13410/sysfgm.posix-bc.110.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX-NSL",
        "subtitle": "",
        "version": "V10.0A",
        "type": "Readme Datei",
        "edition": "2016-10",
        "filelink": "13436/sysrme.posix-nsl.100.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psPOSIXV100en": {
    "spaceProperties": {
      "prodId": "product-posix",
      "prod": "POSIX",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Loading shared objects in POSIX",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2012-11",
        "filelink": "11131/dynlnk.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX",
        "subtitle": "",
        "version": "V10.0A",
        "type": "Readme File",
        "edition": "2017-07",
        "filelink": "12169/sysrme.posix-bc.100.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX Basics",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2012-11",
        "filelink": "11125/posix_g.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX BS2000 file system bs2fs",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2012-11",
        "filelink": "11129/posix_bs2fs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX Commands",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13248/posix_k.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX SOCKETS/XTI",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2005-03",
        "filelink": "4686/posix_s.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX-BC",
        "subtitle": "",
        "version": "V10.0",
        "type": "Release Notice",
        "edition": "2017-07",
        "filelink": "12155/sysfgm.posix-bc.100.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX-NSL",
        "subtitle": "",
        "version": "V10.0A",
        "type": "Readme File",
        "edition": "2016-10",
        "filelink": "13437/sysrme.posix-nsl.100.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX-SOCKETS",
        "subtitle": "",
        "version": "V10.0A",
        "type": "Readme File",
        "edition": "2016-10",
        "filelink": "13439/sysrme.posix-sockets.100.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psPOSIXV100de": {
    "spaceProperties": {
      "prodId": "product-posix",
      "prod": "POSIX",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Laden von Shared Objects in POSIX",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2012-11",
        "filelink": "11130/dynlnk.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX",
        "subtitle": "",
        "version": "V10.0A",
        "type": "Readme Datei",
        "edition": "2017-07",
        "filelink": "12168/sysrme.posix-bc.100.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX BS2000-Dateisystem bs2fs",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2012-11",
        "filelink": "11128/posix_bs2fs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX Grundlagen",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2012-11",
        "filelink": "11124/posix_g.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX Kommandos",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13247/posix_k.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX SOCKETS/XTI",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2005-03",
        "filelink": "4685/posix_s.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX-BC",
        "subtitle": "",
        "version": "V10.0",
        "type": "Freigabemitteilung",
        "edition": "2017-07",
        "filelink": "12154/sysfgm.posix-bc.100.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX-NSL",
        "subtitle": "",
        "version": "V10.0A",
        "type": "Readme Datei",
        "edition": "2016-10",
        "filelink": "13436/sysrme.posix-nsl.100.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX-SOCKETS",
        "subtitle": "",
        "version": "V10.0A",
        "type": "Readme Datei",
        "edition": "2016-10",
        "filelink": "13438/sysrme.posix-sockets.100.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psPOSIXV90en": {
    "spaceProperties": {
      "prodId": "product-posix",
      "prod": "POSIX",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Loading shared objects in POSIX",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2012-11",
        "filelink": "11131/dynlnk.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX",
        "subtitle": "",
        "version": "V9.0A",
        "type": "Readme File",
        "edition": "2014-09",
        "filelink": "11873/sysrme.posix-bc.090.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX Basics",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2012-11",
        "filelink": "11125/posix_g.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX BS2000 file system bs2fs",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2012-11",
        "filelink": "11129/posix_bs2fs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX Commands",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2012-12",
        "filelink": "11127/posix_k.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX-BC",
        "subtitle": "",
        "version": "V9.0",
        "type": "Release Notice",
        "edition": "2015-10",
        "filelink": "10878/sysfgm.posix-bc.090.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX-BC",
        "subtitle": "",
        "version": "V9.0A",
        "type": "Readme File",
        "edition": "2011-02",
        "filelink": "10837/sysrme.posix-bc.090a.e.txt",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psPOSIXV90de": {
    "spaceProperties": {
      "prodId": "product-posix",
      "prod": "POSIX",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Laden von Shared Objects in POSIX",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2012-11",
        "filelink": "11130/dynlnk.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX",
        "subtitle": "",
        "version": "V9.0A",
        "type": "Readme Datei",
        "edition": "2014-09",
        "filelink": "11872/sysrme.posix-bc.090.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX BS2000-Dateisystem bs2fs",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2012-11",
        "filelink": "11128/posix_bs2fs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX Grundlagen",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2012-11",
        "filelink": "11124/posix_g.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX Kommandos",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2012-11",
        "filelink": "11126/posix_k.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX-BC",
        "subtitle": "",
        "version": "V9.0",
        "type": "Freigabemitteilung",
        "edition": "2015-10",
        "filelink": "10877/sysfgm.posix-bc.090.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "POSIX-BC",
        "subtitle": "",
        "version": "V9.0A",
        "type": "Readme Datei",
        "edition": "2011-02",
        "filelink": "10836/sysrme.posix-bc.090a.d.txt",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psOSDBCPACKAGEV110Ben": {
    "spaceProperties": {
      "prodId": "product-osdbcpackage",
      "prod": "OSD/BC Package",
      "lang": 1,
      "productPackage": true,
      "servicePack": false,
      "spaceType": "PRODUCT_PACKAGE"
    },
    "manuals": [{
      "title": "OSD/BC",
      "subtitle": "",
      "version": "V11.0B",
      "type": "Release Notice",
      "edition": "2020-06",
      "filelink": "20276/sysfgm.bs2osd.110.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psOSDBCPACKAGEV110Bde": {
    "spaceProperties": {
      "prodId": "product-osdbcpackage",
      "prod": "OSD/BC Paket",
      "lang": 0,
      "productPackage": true,
      "servicePack": false,
      "spaceType": "PRODUCT_PACKAGE"
    },
    "manuals": [{
      "title": "OSD/BC",
      "subtitle": "",
      "version": "V11.0B",
      "type": "Freigabemitteilung",
      "edition": "2020-06",
      "filelink": "20273/sysfgm.bs2osd.110.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psOSDBCPACKAGEV100en": {
    "spaceProperties": {
      "prodId": "product-osdbcpackage",
      "prod": "OSD/BC Package",
      "lang": 1,
      "productPackage": true,
      "servicePack": false,
      "spaceType": "PRODUCT_PACKAGE"
    },
    "manuals": [{
      "title": "OSD/BC",
      "subtitle": "",
      "version": "V10.0A",
      "type": "Release Notice",
      "edition": "2020-06",
      "filelink": "20277/sysfgm.bs2osd.100.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psOSDBCPACKAGEV100de": {
    "spaceProperties": {
      "prodId": "product-osdbcpackage",
      "prod": "OSD/BC Paket",
      "lang": 0,
      "productPackage": true,
      "servicePack": false,
      "spaceType": "PRODUCT_PACKAGE"
    },
    "manuals": [{
      "title": "OSD/BC",
      "subtitle": "",
      "version": "V10.0A",
      "type": "Freigabemitteilung",
      "edition": "2020-06",
      "filelink": "20272/sysfgm.bs2osd.100.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psOSDXCPACKAGEV110Ben": {
    "spaceProperties": {
      "prodId": "product-osdxcpackage",
      "prod": "OSD/XC Package",
      "lang": 1,
      "productPackage": true,
      "servicePack": false,
      "spaceType": "PRODUCT_PACKAGE"
    },
    "manuals": [{
      "title": "OSD/XC",
      "subtitle": "",
      "version": "V11.0B",
      "type": "Release Notice",
      "edition": "2020-06",
      "filelink": "20278/sysfgm.osdxc.110.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psOSDXCPACKAGEV110Bde": {
    "spaceProperties": {
      "prodId": "product-osdxcpackage",
      "prod": "OSD/XC Paket",
      "lang": 0,
      "productPackage": true,
      "servicePack": false,
      "spaceType": "PRODUCT_PACKAGE"
    },
    "manuals": [{
      "title": "OSD/XC",
      "subtitle": "",
      "version": "V11.0B",
      "type": "Freigabemitteilung",
      "edition": "2020-06",
      "filelink": "20275/sysfgm.osdxc.110.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psOSDXCPACKAGEV100en": {
    "spaceProperties": {
      "prodId": "product-osdxcpackage",
      "prod": "OSD/XC Package",
      "lang": 1,
      "productPackage": true,
      "servicePack": false,
      "spaceType": "PRODUCT_PACKAGE"
    },
    "manuals": [{
      "title": "OSD/XC",
      "subtitle": "",
      "version": "V10.0",
      "type": "Release Notice",
      "edition": "2020-06",
      "filelink": "20279/sysfgm.osdxc.100.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psOSDXCPACKAGEV100de": {
    "spaceProperties": {
      "prodId": "product-osdxcpackage",
      "prod": "OSD/XC Paket",
      "lang": 0,
      "productPackage": true,
      "servicePack": false,
      "spaceType": "PRODUCT_PACKAGE"
    },
    "manuals": [{
      "title": "OSD/XC",
      "subtitle": "",
      "version": "V10.0",
      "type": "Freigabemitteilung",
      "edition": "2020-06",
      "filelink": "20274/sysfgm.osdxc.100.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psCONCEPTDESCRIPTIONSV110Ben": {
    "spaceProperties": {
      "prodId": "product-conceptdescriptions",
      "prod": "Concept Descriptions",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Files and Volumes Larger than 32 GB",
        "subtitle": "",
        "version": "V11.0",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13232/dv32.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Performance Handbook",
        "subtitle": "",
        "version": "V11.0B",
        "type": "User Guide",
        "edition": "2020-02",
        "filelink": "20237/bs2_perf.110b.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Unicode in BS2000/OSD",
        "subtitle": "",
        "version": "",
        "type": "Readme File",
        "edition": "2010-03",
        "filelink": "9287/sysrme.unicode.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "Unicode Introduction",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2007-03",
        "filelink": "3234/unicode.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCONCEPTDESCRIPTIONSV110Bde": {
    "spaceProperties": {
      "prodId": "product-conceptdescriptions",
      "prod": "Konzeptbeschreibungen",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Dateien und Volumes größer 32 GB",
        "subtitle": "",
        "version": "V11.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13231/dv32.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Performance-Handbuch",
        "subtitle": "",
        "version": "V11.0B",
        "type": "Benutzerhandbuch",
        "edition": "2020-02",
        "filelink": "20236/bs2_perf.110b.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Unicode in BS2000/OSD",
        "subtitle": "",
        "version": "",
        "type": "Readme Datei",
        "edition": "2010-03",
        "filelink": "9286/sysrme.unicode.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "Unicode Übersichtshandbuch",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2007-03",
        "filelink": "4456/unicode.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCONCEPTDESCRIPTIONSV110en": {
    "spaceProperties": {
      "prodId": "product-conceptdescriptions",
      "prod": "Concept Descriptions",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Files and Volumes Larger than 32 GB",
        "subtitle": "",
        "version": "V11.0",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13232/dv32.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Performance Handbook",
        "subtitle": "",
        "version": "V11.0",
        "type": "User Guide",
        "edition": "2018-10",
        "filelink": "13876/perform.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Unicode in BS2000/OSD",
        "subtitle": "",
        "version": "",
        "type": "Readme File",
        "edition": "2010-03",
        "filelink": "9287/sysrme.unicode.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "Unicode Introduction",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2007-03",
        "filelink": "3234/unicode.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCONCEPTDESCRIPTIONSV110de": {
    "spaceProperties": {
      "prodId": "product-conceptdescriptions",
      "prod": "Konzeptbeschreibungen",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Dateien und Volumes größer 32 GB",
        "subtitle": "",
        "version": "V11.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13231/dv32.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Performance Handbuch",
        "subtitle": "",
        "version": "V11.0",
        "type": "Benutzerhandbuch",
        "edition": "2018-10",
        "filelink": "13875/perform.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Unicode in BS2000/OSD",
        "subtitle": "",
        "version": "",
        "type": "Readme Datei",
        "edition": "2010-03",
        "filelink": "9286/sysrme.unicode.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "Unicode Übersichtshandbuch",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2007-03",
        "filelink": "4456/unicode.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCONCEPTDESCRIPTIONSV100en": {
    "spaceProperties": {
      "prodId": "product-conceptdescriptions",
      "prod": "Concept Descriptions",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Files and Volumes Larger than 32 GB",
        "subtitle": "",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2009-12",
        "filelink": "9118/dv32.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Performance Handbook",
        "subtitle": "",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2016-09",
        "filelink": "12836/perform.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Unicode in BS2000/OSD",
        "subtitle": "",
        "version": "",
        "type": "Readme File",
        "edition": "2010-03",
        "filelink": "9287/sysrme.unicode.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "Unicode Introduction",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2007-03",
        "filelink": "3234/unicode.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCONCEPTDESCRIPTIONSV100de": {
    "spaceProperties": {
      "prodId": "product-conceptdescriptions",
      "prod": "Konzeptbeschreibungen",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Dateien und Volumes größer 32 GB",
        "subtitle": "",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2009-12",
        "filelink": "9117/dv32.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Performance Handbuch",
        "subtitle": "",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-09",
        "filelink": "12789/perform.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Unicode in BS2000/OSD",
        "subtitle": "",
        "version": "",
        "type": "Readme Datei",
        "edition": "2010-03",
        "filelink": "9286/sysrme.unicode.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "Unicode Übersichtshandbuch",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2007-03",
        "filelink": "4456/unicode.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCONCEPTDESCRIPTIONSV90en": {
    "spaceProperties": {
      "prodId": "product-conceptdescriptions",
      "prod": "Concept Descriptions",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Files and Volumes Larger than 32 GB",
        "subtitle": "",
        "version": "V9.0",
        "type": "User Guide",
        "edition": "2009-12",
        "filelink": "9118/dv32.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Performance Handbook",
        "subtitle": "",
        "version": "V9.0",
        "type": "User Guide",
        "edition": "2013-03",
        "filelink": "11270/perform.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Unicode in BS2000/OSD",
        "subtitle": "",
        "version": "",
        "type": "Readme File",
        "edition": "2010-03",
        "filelink": "9287/sysrme.unicode.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "Unicode Introduction",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2007-03",
        "filelink": "3234/unicode.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCONCEPTDESCRIPTIONSV90de": {
    "spaceProperties": {
      "prodId": "product-conceptdescriptions",
      "prod": "Konzeptbeschreibungen",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Dateien und Volumes größer 32 GB",
        "subtitle": "",
        "version": "V9.0",
        "type": "Benutzerhandbuch",
        "edition": "2009-12",
        "filelink": "9117/dv32.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Performance Handbuch",
        "subtitle": "",
        "version": "V9.0",
        "type": "Benutzerhandbuch",
        "edition": "2013-03",
        "filelink": "11269/perform.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Unicode in BS2000/OSD",
        "subtitle": "",
        "version": "",
        "type": "Readme Datei",
        "edition": "2010-03",
        "filelink": "9286/sysrme.unicode.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "Unicode Übersichtshandbuch",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2007-03",
        "filelink": "4456/unicode.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psEDTV170en": {
    "spaceProperties": {
      "prodId": "product-edt",
      "prod": "EDT",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "EDT",
        "subtitle": "",
        "version": "V17.0",
        "type": "Release Notice",
        "edition": "2017-06",
        "filelink": "5804/sysfgm.edt.170.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "EDT",
        "subtitle": "",
        "version": "V17.0D",
        "type": "Readme File",
        "edition": "2017-06",
        "filelink": "13273/sysrme.edt.170.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Statements",
        "subtitle": "",
        "version": "V16.6B",
        "type": "User Guide",
        "edition": "2007-03",
        "filelink": "2795/edt.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Subroutine Interface",
        "subtitle": "",
        "version": "V16.6A",
        "type": "User Guide",
        "edition": "1996-08",
        "filelink": "1235/edt_ups.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Unicode Mode Statements",
        "subtitle": "",
        "version": "V17.0A",
        "type": "User Guide",
        "edition": "2007-12",
        "filelink": "2796/edt_um.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Unicode Mode Subroutine Interface",
        "subtitle": "",
        "version": "V17.0A",
        "type": "User Guide",
        "edition": "2007-12",
        "filelink": "2797/edt_um_ups.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psEDTV170de": {
    "spaceProperties": {
      "prodId": "product-edt",
      "prod": "EDT",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Anweisungen",
        "subtitle": "",
        "version": "V16.6B",
        "type": "Benutzerhandbuch",
        "edition": "2007-03",
        "filelink": "2083/edt.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "EDT",
        "subtitle": "",
        "version": "V17.0",
        "type": "Freigabemitteilung",
        "edition": "2017-06",
        "filelink": "4930/sysfgm.edt.170.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "EDT",
        "subtitle": "",
        "version": "V17.0D",
        "type": "Readme Datei",
        "edition": "2017-06",
        "filelink": "13272/sysrme.edt.170.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Unicode-Modus Anweisungen",
        "subtitle": "",
        "version": "V17.0A",
        "type": "Benutzerhandbuch",
        "edition": "2007-12",
        "filelink": "2084/edt_um.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Unicode-Modus Unterprogrammschnittstellen",
        "subtitle": "",
        "version": "V17.0A",
        "type": "Benutzerhandbuch",
        "edition": "2007-12",
        "filelink": "2085/edt_um_ups.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Unterprogrammschnittstellen",
        "subtitle": "",
        "version": "V16.6A",
        "type": "Benutzerhandbuch",
        "edition": "1996-08",
        "filelink": "301/edt_ups.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psFHSV83en": {
    "spaceProperties": {
      "prodId": "product-fhs",
      "prod": "FHS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Dialog Extension for TIAM and SDF-P",
        "subtitle": "",
        "version": "V8.1A",
        "type": "User Guide",
        "edition": "1994-12",
        "filelink": "1237/fhs_dm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS",
        "subtitle": "",
        "version": "V8.3",
        "type": "Release Notice",
        "edition": "2013-05",
        "filelink": "5823/sysfgm.fhs.083.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Format Handling System für openUTM, TIAM, DCAM",
        "subtitle": "",
        "version": "V8.3A",
        "type": "User Guide",
        "edition": "2006-10",
        "filelink": "2806/fhs.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psFHSV83de": {
    "spaceProperties": {
      "prodId": "product-fhs",
      "prod": "FHS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Dialogerweiterung für TIAM und SDF-P",
        "subtitle": "",
        "version": "V8.1A",
        "type": "Benutzerhandbuch",
        "edition": "1994-12",
        "filelink": "303/fhs_dm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS",
        "subtitle": "",
        "version": "V8.3",
        "type": "Freigabemitteilung",
        "edition": "2013-05",
        "filelink": "4949/sysfgm.fhs.083.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Formatierungssystem für openUTM, TIAM, DCAM",
        "subtitle": "",
        "version": "V8.3A",
        "type": "Benutzerhandbuch",
        "edition": "2006-10",
        "filelink": "2094/fhs.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psFMSV24en": {
    "spaceProperties": {
      "prodId": "product-fms",
      "prod": "FMS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "FMS",
      "subtitle": "",
      "version": "V2.4",
      "type": "Release Notice",
      "edition": "2009-05",
      "filelink": "5830/sysfgm.fms.024.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psFMSV24de": {
    "spaceProperties": {
      "prodId": "product-fms",
      "prod": "FMS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "FMS",
        "subtitle": "",
        "version": "V2.4",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "4956/sysfgm.fms.024.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FMS (BS2000)",
        "subtitle": "File Management System",
        "version": "V2.34",
        "type": "Benutzerhandbuch",
        "edition": "1985-01",
        "filelink": "8907/fms.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psIFGV83en": {
    "spaceProperties": {
      "prodId": "product-ifg",
      "prod": "IFG",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "IFG",
        "subtitle": "",
        "version": "V8.3",
        "type": "Release Notice",
        "edition": "2009-05",
        "filelink": "5854/sysfgm.ifg.083.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IFG",
        "subtitle": "",
        "version": "V8.3A",
        "type": "User Guide",
        "edition": "2006-10",
        "filelink": "2823/ifg.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psIFGV83de": {
    "spaceProperties": {
      "prodId": "product-ifg",
      "prod": "IFG",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "IFG",
        "subtitle": "",
        "version": "V8.3",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "4980/sysfgm.ifg.083.D.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IFG",
        "subtitle": "",
        "version": "V8.3A",
        "type": "Benutzerhandbuch",
        "edition": "2006-10",
        "filelink": "2117/ifg.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psLMSV35en": {
    "spaceProperties": {
      "prodId": "product-lms",
      "prod": "LMS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "LMS",
        "subtitle": "",
        "version": "V3.5B",
        "type": "Readme File",
        "edition": "2020-06",
        "filelink": "20253/sysrme.lms.035.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LMS",
        "subtitle": "",
        "version": "V3.5B",
        "type": "Release Notice",
        "edition": "2020-06",
        "filelink": "20252/sysfgm.lms.035.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LMS",
        "subtitle": "",
        "version": "V3.5",
        "type": "Release Notice",
        "edition": "2018-06",
        "filelink": "12133/sysfgm.lms.035.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LMS",
        "subtitle": "",
        "version": "V3.5",
        "type": "Readme File",
        "edition": "2018-06",
        "filelink": "12173/sysrme.lms.035.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LMS",
        "subtitle": "",
        "version": "V3.4B",
        "type": "User Guide",
        "edition": "2013-06",
        "filelink": "11319/lms.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LMS Subroutine Interface",
        "subtitle": "",
        "version": "V3.4B",
        "type": "User Guide",
        "edition": "2013-06",
        "filelink": "11321/lms_ups.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psLMSV35de": {
    "spaceProperties": {
      "prodId": "product-lms",
      "prod": "LMS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "LMS",
        "subtitle": "",
        "version": "V3.5B",
        "type": "Freigabemitteilung",
        "edition": "2020-06",
        "filelink": "20250/sysfgm.lms.035.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LMS",
        "subtitle": "",
        "version": "V3.5B",
        "type": "Readme Datei",
        "edition": "2020-06",
        "filelink": "20251/sysrme.lms.035.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LMS",
        "subtitle": "",
        "version": "V3.5",
        "type": "Freigabemitteilung",
        "edition": "2018-06",
        "filelink": "12132/sysfgm.lms.035.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LMS",
        "subtitle": "",
        "version": "V3.5",
        "type": "Readme Datei",
        "edition": "2018-06",
        "filelink": "12172/sysrme.lms.035.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LMS",
        "subtitle": "",
        "version": "V3.4B",
        "type": "Benutzerhandbuch",
        "edition": "2013-06",
        "filelink": "11318/lms.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LMS UP-Schnittstelle",
        "subtitle": "",
        "version": "V3.4B",
        "type": "Benutzerhandbuch",
        "edition": "2013-06",
        "filelink": "11320/lms_ups.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psPERCONV29en": {
    "spaceProperties": {
      "prodId": "product-percon",
      "prod": "PERCON",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "PERCON",
        "subtitle": "",
        "version": "V2.9",
        "type": "Release Notice",
        "edition": "2015-11",
        "filelink": "6008/sysfgm.percon.029.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PERCON",
        "subtitle": "",
        "version": "V2.9A",
        "type": "User Guide",
        "edition": "2007-01",
        "filelink": "8209/percon.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psPERCONV29de": {
    "spaceProperties": {
      "prodId": "product-percon",
      "prod": "PERCON",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "PERCON",
        "subtitle": "",
        "version": "V2.9",
        "type": "Freigabemitteilung",
        "edition": "2015-11",
        "filelink": "5134/sysfgm.percon.029.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PERCON",
        "subtitle": "",
        "version": "V2.9A",
        "type": "Benutzerhandbuch",
        "edition": "2007-01",
        "filelink": "8208/percon.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psRFAV200en": {
    "spaceProperties": {
      "prodId": "product-rfa",
      "prod": "RFA",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "RFA",
        "subtitle": "",
        "version": "V20.0",
        "type": "Release Notice",
        "edition": "2017-07",
        "filelink": "13413/sysfgm.rfa.200.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "RFA",
        "subtitle": "",
        "version": "V14.0A",
        "type": "User Guide",
        "edition": "2002-03",
        "filelink": "3123/rfa.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psRFAV200de": {
    "spaceProperties": {
      "prodId": "product-rfa",
      "prod": "RFA",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "RFA",
        "subtitle": "",
        "version": "V20.0",
        "type": "Freigabemitteilung",
        "edition": "2017-07",
        "filelink": "13412/sysfgm.rfa.200.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "RFA",
        "subtitle": "",
        "version": "V14.0A",
        "type": "Benutzerhandbuch",
        "edition": "2002-03",
        "filelink": "2418/rfa.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psRFAV190en": {
    "spaceProperties": {
      "prodId": "product-rfa",
      "prod": "RFA",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "RFA",
        "subtitle": "",
        "version": "V19.0",
        "type": "Release Notice",
        "edition": "2014-12",
        "filelink": "12141/sysfgm.rfa.190.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "RFA",
        "subtitle": "",
        "version": "V14.0A",
        "type": "User Guide",
        "edition": "2002-03",
        "filelink": "3123/rfa.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psRFAV190de": {
    "spaceProperties": {
      "prodId": "product-rfa",
      "prod": "RFA",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "RFA",
        "subtitle": "",
        "version": "V19.0",
        "type": "Freigabemitteilung",
        "edition": "2014-12",
        "filelink": "12140/sysfgm.rfa.190.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "RFA",
        "subtitle": "",
        "version": "V14.0A",
        "type": "Benutzerhandbuch",
        "edition": "2002-03",
        "filelink": "2418/rfa.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSORTV80en": {
    "spaceProperties": {
      "prodId": "product-sort",
      "prod": "SORT",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SORT",
        "subtitle": "",
        "version": "V8.0",
        "type": "Release Notice",
        "edition": "2014-11",
        "filelink": "11865/sysfgm.sort.080.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SORT",
        "subtitle": "",
        "version": "V8.0A",
        "type": "User Guide",
        "edition": "2014-11",
        "filelink": "11877/sort.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSORTV80de": {
    "spaceProperties": {
      "prodId": "product-sort",
      "prod": "SORT",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SORT",
        "subtitle": "",
        "version": "V8.0",
        "type": "Freigabemitteilung",
        "edition": "2014-11",
        "filelink": "11864/sysfgm.sort.080.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SORT",
        "subtitle": "",
        "version": "V8.0A",
        "type": "Benutzerhandbuch",
        "edition": "2014-11",
        "filelink": "11876/sort.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psTASKDATEV200Ben": {
    "spaceProperties": {
      "prodId": "product-taskdate",
      "prod": "TASKDATE",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "TASKDATE",
        "subtitle": "",
        "version": "V20.0B",
        "type": "Readme File",
        "edition": "2019-06",
        "filelink": "20051/sysrme.taskdate.200.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "TASKDATE",
        "subtitle": "",
        "version": "V20.0B",
        "type": "Release Notice",
        "edition": "2019-06",
        "filelink": "20052/sysfgm.taskdate.200.E.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psTASKDATEV200Bde": {
    "spaceProperties": {
      "prodId": "product-taskdate",
      "prod": "TASKDATE",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "TASKDATE",
        "subtitle": "",
        "version": "V20.0B",
        "type": "Freigabemitteilung",
        "edition": "2019-06",
        "filelink": "20037/sysfgm.taskdate.200.D.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "TASKDATE",
        "subtitle": "",
        "version": "V20.0B",
        "type": "Readme Datei",
        "edition": "2019-06",
        "filelink": "20038/sysrme.taskdate.200.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psTASKDATEV190en": {
    "spaceProperties": {
      "prodId": "product-taskdate",
      "prod": "TASKDATE",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "TASKDATE",
        "subtitle": "",
        "version": "V19.0",
        "type": "Release Notice",
        "edition": "2015-05",
        "filelink": "12203/sysrme.taskdate.190.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "TASKDATE",
        "subtitle": "",
        "version": "V19.0A",
        "type": "Readme File",
        "edition": "2015-05",
        "filelink": "12205/sysrme.taskdate.190.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psTASKDATEV190de": {
    "spaceProperties": {
      "prodId": "product-taskdate",
      "prod": "TASKDATE",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "TASKDATE",
        "subtitle": "",
        "version": "V19.0",
        "type": "Freigabemitteilung",
        "edition": "2015-05",
        "filelink": "12202/sysrme.taskdate.190.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "TASKDATE",
        "subtitle": "",
        "version": "V19.0A",
        "type": "Readme Datei",
        "edition": "2015-05",
        "filelink": "12204/sysrme.taskdate.190.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psTOMPRODUCTSV51en": {
    "spaceProperties": {
      "prodId": "product-tomproducts",
      "prod": "TOM Products",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "TomDoors (German)",
      "subtitle": "",
      "version": "V5.1",
      "type": "User Guide",
      "edition": "1996-09",
      "filelink": "1804/tom_dr_m.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psTOMPRODUCTSV51de": {
    "spaceProperties": {
      "prodId": "product-tomproducts",
      "prod": "TOM-Produkte",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "TomDoors",
      "subtitle": "",
      "version": "V5.1",
      "type": "Benutzerhandbuch",
      "edition": "1996-09",
      "filelink": "6716/tom_dr_m.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psTOMPRODUCTSV50en": {
    "spaceProperties": {
      "prodId": "product-tomproducts",
      "prod": "TOM Products",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "TOMDOORS-M",
      "subtitle": "",
      "version": "V5.0",
      "type": "Release Notice",
      "edition": "2009-05",
      "filelink": "6364/sysfgm.tomdoors-m.050.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psTOMPRODUCTSV50de": {
    "spaceProperties": {
      "prodId": "product-tomproducts",
      "prod": "TOM-Produkte",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "TOMDOORS-M",
      "subtitle": "",
      "version": "V5.0",
      "type": "Freigabemitteilung",
      "edition": "2009-05",
      "filelink": "5492/sysfgm.tomdoors-m.050.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psTOMPRODUCTSV32en": {
    "spaceProperties": {
      "prodId": "product-tomproducts",
      "prod": "TOM Products",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "TOM-DOC",
        "subtitle": "",
        "version": "V3.2",
        "type": "Release Notice",
        "edition": "2009-05",
        "filelink": "6361/sysfgm.tom-doc.032.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "TOM-DOC",
        "subtitle": "",
        "version": "V3.2",
        "type": "User Guide",
        "edition": "1995-04",
        "filelink": "1801/tom_doc.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psTOMPRODUCTSV32de": {
    "spaceProperties": {
      "prodId": "product-tomproducts",
      "prod": "TOM-Produkte",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "TOM-DOC",
        "subtitle": "",
        "version": "V3.2",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "5489/sysfgm.tom-doc.032.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "TOM-DOC",
        "subtitle": "",
        "version": "V3.2",
        "type": "Benutzerhandbuch",
        "edition": "1995-04",
        "filelink": "6714/tom_doc.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psTOMPRODUCTSV30en": {
    "spaceProperties": {
      "prodId": "product-tomproducts",
      "prod": "TOM Products",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "TOM-REF",
        "subtitle": "",
        "version": "V3.0",
        "type": "Release Notice",
        "edition": "2009-05",
        "filelink": "6366/sysfgm.tom-ref.030.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "TOM-REF",
        "subtitle": "",
        "version": "V3.0",
        "type": "Readme File",
        "edition": "1995-07",
        "filelink": "1799/tom_ref.rme",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "TOM-REF (German)",
        "subtitle": "",
        "version": "V3.0",
        "type": "User Guide",
        "edition": "1995-07",
        "filelink": "1803/tom_ref.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "TOM-TI 030",
        "subtitle": "",
        "version": "V3.0",
        "type": "Release Notice",
        "edition": "2009-05",
        "filelink": "8296/sysfgm.tom-ti.v3.0.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psTOMPRODUCTSV30de": {
    "spaceProperties": {
      "prodId": "product-tomproducts",
      "prod": "TOM-Produkte",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "TOM-REF",
        "subtitle": "",
        "version": "V3.0",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "5494/sysfgm.tom-ref.030.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "TOM-REF",
        "subtitle": "",
        "version": "V3.0",
        "type": "Benutzerhandbuch",
        "edition": "1995-07",
        "filelink": "6710/tom_ref.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "TOM-REF",
        "subtitle": "",
        "version": "V3.0",
        "type": "Readme Datei",
        "edition": "1995-07",
        "filelink": "6711/tom_ref.rme",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "TOM-TI 030",
        "subtitle": "",
        "version": "V3.0",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "8366/sysfgm.tom-ti.v3.0.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psAVASV85en": {
    "spaceProperties": {
      "prodId": "product-avas",
      "prod": "AVAS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "AVAS (BS2000), AVAS-SV-BS2 (BS2000)",
        "subtitle": "",
        "version": "V8.5",
        "type": "Release Notice",
        "edition": "2017-06",
        "filelink": "10102/sysfgm.avas.085.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "AVAS for the Administrator",
        "subtitle": "",
        "version": "V8.5A",
        "type": "User Guide",
        "edition": "2017-06",
        "filelink": "13269/avas_adm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "AVAS Functions and Tables",
        "subtitle": "",
        "version": "V8.5A",
        "type": "User Guide",
        "edition": "2017-06",
        "filelink": "13268/avas_fkt.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "AVAS Statements",
        "subtitle": "",
        "version": "V8.5A",
        "type": "User Guide",
        "edition": "2017-06",
        "filelink": "13267/avas_anw.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psAVASV85de": {
    "spaceProperties": {
      "prodId": "product-avas",
      "prod": "AVAS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "AVAS (BS2000), AVAS-SV-BS2 (BS2000)",
        "subtitle": "",
        "version": "V8.5",
        "type": "Freigabemitteilung",
        "edition": "2017-06",
        "filelink": "10101/sysfgm.avas.085.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "AVAS Anweisungen",
        "subtitle": "",
        "version": "V8.5A",
        "type": "Benutzerhandbuch",
        "edition": "2017-06",
        "filelink": "13264/avas_anw.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "AVAS Funktionen und Tabellen",
        "subtitle": "",
        "version": "V8.5A",
        "type": "Benutzerhandbuch",
        "edition": "2017-06",
        "filelink": "13265/avas_fkt.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "AVAS für den Administrator",
        "subtitle": "",
        "version": "V8.5A",
        "type": "Benutzerhandbuch",
        "edition": "2017-06",
        "filelink": "13266/avas_adm.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psJVV151en": {
    "spaceProperties": {
      "prodId": "product-jv",
      "prod": "JV",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "JV",
        "subtitle": "",
        "version": "V15.1",
        "type": "Release Notice",
        "edition": "2012-04",
        "filelink": "10861/sysfgm.jv.151.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "JV",
        "subtitle": "",
        "version": "V15.1A",
        "type": "Readme File",
        "edition": "2010-12",
        "filelink": "10835/sysrme.jv.151a.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "JV",
        "subtitle": "",
        "version": "V15.0",
        "type": "User Guide",
        "edition": "2010-12",
        "filelink": "9871/jv.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psJVV151de": {
    "spaceProperties": {
      "prodId": "product-jv",
      "prod": "JV",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "JV",
        "subtitle": "",
        "version": "V15.1",
        "type": "Freigabemitteilung",
        "edition": "2012-04",
        "filelink": "10860/sysfgm.jv.151.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "JV",
        "subtitle": "",
        "version": "V15.0",
        "type": "Benutzerhandbuch",
        "edition": "2010-12",
        "filelink": "9870/jv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "JV",
        "subtitle": "",
        "version": "V15.1A",
        "type": "Readme Datei",
        "edition": "2010-12",
        "filelink": "10834/sysrme.jv.151a.d.txt",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psSDFV48en": {
    "spaceProperties": {
      "prodId": "product-sdf",
      "prod": "SDF",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SDF",
        "subtitle": "",
        "version": "V4.8",
        "type": "Release Notice",
        "edition": "2017-07",
        "filelink": "13417/sysfgm.sdf.048.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF",
        "subtitle": "",
        "version": "V4.8A",
        "type": "Readme File",
        "edition": "2017-06",
        "filelink": "13441/sysrme.sdf.048.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF Dialog Interface",
        "subtitle": "",
        "version": "V4.7",
        "type": "User Guide",
        "edition": "2010-12",
        "filelink": "9858/sdf.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSDFV48de": {
    "spaceProperties": {
      "prodId": "product-sdf",
      "prod": "SDF",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SDF",
        "subtitle": "",
        "version": "V4.8",
        "type": "Freigabemitteilung",
        "edition": "2017-07",
        "filelink": "13416/sysfgm.sdf.048.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF",
        "subtitle": "",
        "version": "V4.8A",
        "type": "Readme Datei",
        "edition": "2017-06",
        "filelink": "13440/sysrme.sdf.048.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF Dialogschnittstelle",
        "subtitle": "",
        "version": "V4.7",
        "type": "Benutzerhandbuch",
        "edition": "2010-12",
        "filelink": "9857/sdf.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSDFV47en": {
    "spaceProperties": {
      "prodId": "product-sdf",
      "prod": "SDF",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SDF",
        "subtitle": "",
        "version": "V4.7",
        "type": "Release Notice",
        "edition": "2013-03",
        "filelink": "8723/sysfgm.sdf.047.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF",
        "subtitle": "",
        "version": "V4.7D",
        "type": "Readme File",
        "edition": "2012-11",
        "filelink": "8633/sysrme.sdf.047d.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF Dialog Interface",
        "subtitle": "",
        "version": "V4.7",
        "type": "User Guide",
        "edition": "2010-12",
        "filelink": "9858/sdf.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSDFV47de": {
    "spaceProperties": {
      "prodId": "product-sdf",
      "prod": "SDF",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SDF",
        "subtitle": "",
        "version": "V4.7",
        "type": "Freigabemitteilung",
        "edition": "2013-03",
        "filelink": "8722/sysfgm.sdf.047.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF",
        "subtitle": "",
        "version": "V4.7D",
        "type": "Readme Datei",
        "edition": "2012-11",
        "filelink": "8632/sysrme.sdf.047d.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF Dialogschnittstelle",
        "subtitle": "",
        "version": "V4.7",
        "type": "Benutzerhandbuch",
        "edition": "2010-12",
        "filelink": "9857/sdf.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSDFV46en": {
    "spaceProperties": {
      "prodId": "product-sdf",
      "prod": "SDF",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SDF",
        "subtitle": "",
        "version": "V4.6",
        "type": "Release Notice",
        "edition": "2005-11",
        "filelink": "6153/sysfgm.sdf.046.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF",
        "subtitle": "",
        "version": "V4.6A",
        "type": "Readme File",
        "edition": "2004-10",
        "filelink": "3132/sdf.rme",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "SDF Introductory Guide",
        "subtitle": "",
        "version": "V4.5A",
        "type": "User Guide",
        "edition": "2002-03",
        "filelink": "1570/sdf_einf.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF Management",
        "subtitle": "",
        "version": "V4.5A",
        "type": "User Guide",
        "edition": "2002-03",
        "filelink": "1571/sdf_vw.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF-CONV",
        "subtitle": "",
        "version": "V3.0",
        "type": "Release Notice",
        "edition": "1997-08",
        "filelink": "6169/sysfgm.sdf-conv.030.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF-CONV",
        "subtitle": "",
        "version": "V3.0B",
        "type": "Readme File",
        "edition": "1995-01",
        "filelink": "3133/sdf_conv.rme",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "SDF-CONV",
        "subtitle": "",
        "version": "V3.0A",
        "type": "User Guide",
        "edition": "1994-02",
        "filelink": "1264/sdf_conv.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSDFV46de": {
    "spaceProperties": {
      "prodId": "product-sdf",
      "prod": "SDF",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SDF",
        "subtitle": "",
        "version": "V4.6",
        "type": "Freigabemitteilung",
        "edition": "2005-11",
        "filelink": "5278/sysfgm.sdf.046.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF",
        "subtitle": "",
        "version": "V4.6A",
        "type": "Readme Datei",
        "edition": "2004-10",
        "filelink": "2427/sdf.rme",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "SDF Einführung",
        "subtitle": "",
        "version": "V4.5A",
        "type": "Benutzerhandbuch",
        "edition": "2002-03",
        "filelink": "615/sdf_einf.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF Verwaltung",
        "subtitle": "",
        "version": "V4.5A",
        "type": "Benutzerhandbuch",
        "edition": "2002-03",
        "filelink": "616/sdf_vw.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF-CONV",
        "subtitle": "",
        "version": "V3.0",
        "type": "Freigabemitteilung",
        "edition": "1997-08",
        "filelink": "5294/sysfgm.sdf-conv.030.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF-CONV",
        "subtitle": "",
        "version": "V3.0B",
        "type": "Readme Datei",
        "edition": "1995-01",
        "filelink": "2428/sdf_conv.rme",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "SDF-CONV",
        "subtitle": "",
        "version": "V3.0A",
        "type": "Benutzerhandbuch",
        "edition": "1994-02",
        "filelink": "333/sdf_conv.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSDFAV41en": {
    "spaceProperties": {
      "prodId": "product-sdfa",
      "prod": "SDF-A",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SDF-A",
        "subtitle": "",
        "version": "V4.1G",
        "type": "Readme File",
        "edition": "2011-12",
        "filelink": "10537/sysrme.sdf-a.041g.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "SDF-A",
        "subtitle": "",
        "version": "V4.1",
        "type": "Release Notice",
        "edition": "2011-11",
        "filelink": "6168/sysfgm.sdf-a.041.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF-A",
        "subtitle": "",
        "version": "V4.1E",
        "type": "User Guide",
        "edition": "2002-03",
        "filelink": "3134/sdf_a.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSDFAV41de": {
    "spaceProperties": {
      "prodId": "product-sdfa",
      "prod": "SDF-A",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SDF-A",
        "subtitle": "",
        "version": "V4.1G",
        "type": "Readme Datei",
        "edition": "2011-12",
        "filelink": "10536/sysrme.sdf-a.041g.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "SDF-A",
        "subtitle": "",
        "version": "V4.1",
        "type": "Freigabemitteilung",
        "edition": "2011-11",
        "filelink": "5293/sysfgm.sdf-a.041.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF-A",
        "subtitle": "",
        "version": "V4.1E",
        "type": "Benutzerhandbuch",
        "edition": "2002-03",
        "filelink": "2429/sdf_a.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSDFPV25en": {
    "spaceProperties": {
      "prodId": "product-sdfp",
      "prod": "SDF-P",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SDF-P",
        "subtitle": "",
        "version": "V2.5G",
        "type": "Release Notice",
        "edition": "2017-07",
        "filelink": "8725/sysfgm.sdf-p.025.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF-P",
        "subtitle": "",
        "version": "V2.5G",
        "type": "Readme File",
        "edition": "2017-06",
        "filelink": "8675/sysrme.sdf-p.025.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF-P",
        "subtitle": "",
        "version": "V2.4A",
        "type": "User Guide",
        "edition": "2007-05",
        "filelink": "3137/sdf_p.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF-P Ready Reference",
        "subtitle": "",
        "version": "V2.4A",
        "type": "Ready Reference",
        "edition": "2007-05",
        "filelink": "3138/sdf_p_tb.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSDFPV25de": {
    "spaceProperties": {
      "prodId": "product-sdfp",
      "prod": "SDF-P",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SDF-P",
        "subtitle": "",
        "version": "V2.5G",
        "type": "Freigabemitteilung",
        "edition": "2017-07",
        "filelink": "8724/sysfgm.sdf-p.025.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF-P",
        "subtitle": "",
        "version": "V2.5G",
        "type": "Readme Datei",
        "edition": "2017-06",
        "filelink": "8674/sysrme.sdf-p.025.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF-P",
        "subtitle": "",
        "version": "V2.4A",
        "type": "Benutzerhandbuch",
        "edition": "2007-05",
        "filelink": "2432/sdf_p.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SDF-P Taschenbuch",
        "subtitle": "",
        "version": "V2.4A",
        "type": "Taschenbuch",
        "edition": "2007-05",
        "filelink": "2433/sdf_p_tb.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psAPACHEV24en": {
    "spaceProperties": {
      "prodId": "product-apache",
      "prod": "Apache",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "APACHE",
        "subtitle": "",
        "version": "V2.4A",
        "type": "Readme File",
        "edition": "2019-11",
        "filelink": "20112/sysrme.apache.024.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "APACHE",
        "subtitle": "",
        "version": "V2.4A",
        "type": "Release Notice",
        "edition": "2019-11",
        "filelink": "20113/sysfgm.apache.024.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psAPACHEV24de": {
    "spaceProperties": {
      "prodId": "product-apache",
      "prod": "Apache",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "APACHE",
        "subtitle": "",
        "version": "V2.4A",
        "type": "Freigabemitteilung",
        "edition": "2019-11",
        "filelink": "20093/sysfgm.apache.024.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "APACHE",
        "subtitle": "",
        "version": "V2.4A",
        "type": "Readme Datei",
        "edition": "2019-11",
        "filelink": "20094/sysrme.apache.024.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psAPACHEV22en": {
    "spaceProperties": {
      "prodId": "product-apache",
      "prod": "Apache",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "APACHE",
        "subtitle": "",
        "version": "V2.2",
        "type": "Release Notice",
        "edition": "2018-05",
        "filelink": "11548/sysfgm.apache.022.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "APACHE",
        "subtitle": "",
        "version": "V2.2A",
        "type": "Readme File",
        "edition": "2018-05",
        "filelink": "3050/sysrme.apache.022.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psAPACHEV22de": {
    "spaceProperties": {
      "prodId": "product-apache",
      "prod": "Apache",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "APACHE",
        "subtitle": "",
        "version": "V2.2",
        "type": "Freigabemitteilung",
        "edition": "2018-05",
        "filelink": "11327/sysfgm.apache.022.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "APACHE",
        "subtitle": "",
        "version": "V2.2A",
        "type": "Readme Datei",
        "edition": "2018-05",
        "filelink": "2344/sysrme.apache.022.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psINTERNETSERVICESV34Ben": {
    "spaceProperties": {
      "prodId": "product-internetservices",
      "prod": "interNet Services",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "interNet Services",
        "subtitle": "",
        "version": "V3.4B",
        "type": "Release Notice",
        "edition": "2020-06",
        "filelink": "20258/sysfgm.inetserv.034.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "interNet Services",
        "subtitle": "",
        "version": "V3.4B",
        "type": "Readme File",
        "edition": "2018-06",
        "filelink": "13773/sysrme.inetserv.034.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "interNet Services Administrator",
        "subtitle": "",
        "version": "V3.4B",
        "type": "System Administrator Guide",
        "edition": "2017-06",
        "filelink": "13220/iserv_ad.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "interNet Services User Guide",
        "subtitle": "",
        "version": "V3.4B",
        "type": "User Guide",
        "edition": "2017-06",
        "filelink": "13222/iserv_bh.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psINTERNETSERVICESV34Bde": {
    "spaceProperties": {
      "prodId": "product-internetservices",
      "prod": "interNet Services",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "interNet Services",
        "subtitle": "",
        "version": "V3.4B",
        "type": "Freigabemitteilung",
        "edition": "2020-06",
        "filelink": "20259/sysfgm.inetserv.034.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "interNet Services",
        "subtitle": "",
        "version": "V3.4B",
        "type": "Readme Datei",
        "edition": "2018-06",
        "filelink": "13772/sysrme.inetserv.034.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "interNet Services Administrator",
        "subtitle": "",
        "version": "V3.4B",
        "type": "Systemverwalterhandbuch",
        "edition": "2017-06",
        "filelink": "13219/iserv_ad.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "interNet Services Benutzer",
        "subtitle": "",
        "version": "V3.4B",
        "type": "Benutzerhandbuch",
        "edition": "2017-06",
        "filelink": "13221/iserv_bh.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psINTERNETSERVICESV34en": {
    "spaceProperties": {
      "prodId": "product-internetservices",
      "prod": "interNet Services",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "interNet Services",
        "subtitle": "",
        "version": "V3.4A",
        "type": "Readme File",
        "edition": "2016-05",
        "filelink": "11695/sysrme.inetserv.034.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "interNet Services Administrator",
        "subtitle": "",
        "version": "V3.4A",
        "type": "System Administrator Guide",
        "edition": "2010-12",
        "filelink": "9875/iserv_ad.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "interNet Services User Guide",
        "subtitle": "",
        "version": "V3.4A",
        "type": "User Guide",
        "edition": "2010-12",
        "filelink": "9873/iserv_bh.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psINTERNETSERVICESV34de": {
    "spaceProperties": {
      "prodId": "product-internetservices",
      "prod": "interNet Services",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "interNet Services",
        "subtitle": "",
        "version": "V3.4A",
        "type": "Readme Datei",
        "edition": "2016-05",
        "filelink": "11694/sysrme.inetserv.034.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "interNet Services Administrator",
        "subtitle": "",
        "version": "V3.4A",
        "type": "Systemverwalterhandbuch",
        "edition": "2010-12",
        "filelink": "9874/iserv_ad.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "interNet Services Benutzer",
        "subtitle": "",
        "version": "V3.4A",
        "type": "Benutzerhandbuch",
        "edition": "2010-12",
        "filelink": "9872/iserv_bh.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psMT9750V90en": {
    "spaceProperties": {
      "prodId": "product-mt9750",
      "prod": "MT9750",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "MT9750",
        "subtitle": "",
        "version": "V9.0",
        "type": "Readme File",
        "edition": "2019-06",
        "filelink": "20086/sysrme.mt9750.090.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MT9750",
        "subtitle": "",
        "version": "V9.0",
        "type": "Release Notice",
        "edition": "2019-06",
        "filelink": "20082/sysfgm.mt9750.090.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MT9750",
        "subtitle": "Emulation of the DSS9750 family for connection to BS2000 systems",
        "version": "V9.0A",
        "type": "User Guide",
        "edition": "2019-11",
        "filelink": "20193/MT9750 V9.0A-en.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psMT9750V90de": {
    "spaceProperties": {
      "prodId": "product-mt9750",
      "prod": "MT9750",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "MT9750",
        "subtitle": "",
        "version": "V9.0",
        "type": "Freigabemitteilung",
        "edition": "2019-06",
        "filelink": "20081/sysfgm.mt9750.090.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MT9750",
        "subtitle": "",
        "version": "V9.0",
        "type": "Readme Datei",
        "edition": "2019-06",
        "filelink": "20085/sysrme.mt9750.090.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MT9750",
        "subtitle": "Emulation der DSS9750-Familie zum Anschluss an BS2000-Systeme",
        "version": "V9.0A",
        "type": "Benutzerhandbuch",
        "edition": "2019-11",
        "filelink": "20192/MT9750 V9.0A-de.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psMT9750V80en": {
    "spaceProperties": {
      "prodId": "product-mt9750",
      "prod": "MT9750",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "MT9750",
        "subtitle": "",
        "version": "V8.0",
        "type": "Release Notice",
        "edition": "2017-02",
        "filelink": "10471/sysfgm.mt9750.080.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MT9750",
        "subtitle": "Emulation of the DSS9750 family for connection to BS2000 systems",
        "version": "V8.0C",
        "type": "User Guide",
        "edition": "2018-08",
        "filelink": "20194/MT9750 V8.0C-en.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psMT9750V80de": {
    "spaceProperties": {
      "prodId": "product-mt9750",
      "prod": "MT9750",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "MT9750",
        "subtitle": "",
        "version": "V8.0",
        "type": "Freigabemitteilung",
        "edition": "2017-02",
        "filelink": "10470/sysfgm.mt9750.080.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MT9750",
        "subtitle": "Emulation der DSS9750-Familie zum Anschluss an BS2000-Systeme",
        "version": "V8.0C",
        "type": "Benutzerhandbuch",
        "edition": "2018-08",
        "filelink": "20195/MT9750 V8.0C-de.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psNFSV30en": {
    "spaceProperties": {
      "prodId": "product-nfs",
      "prod": "NFS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "NFS",
        "subtitle": "",
        "version": "V3.0",
        "type": "Release Notice",
        "edition": "2012-11",
        "filelink": "5952/sysfgm.nfs.030.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "NFS",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2001-02",
        "filelink": "1250/nfs.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psNFSV30de": {
    "spaceProperties": {
      "prodId": "product-nfs",
      "prod": "NFS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "NFS",
        "subtitle": "",
        "version": "V3.0",
        "type": "Freigabemitteilung",
        "edition": "2012-11",
        "filelink": "5078/sysfgm.nfs.030.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "NFS",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2001-02",
        "filelink": "318/nfs.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENNETSERVERV40en": {
    "spaceProperties": {
      "prodId": "product-opennetserver",
      "prod": "openNet Server",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "BCAM Volume 1/2  (one pdf file)",
        "subtitle": "",
        "version": "V24.0",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13244/bcam.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX",
        "subtitle": "",
        "version": "V1.1A",
        "type": "Readme File",
        "edition": "1996-02",
        "filelink": "3079/cmx.rme",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "CMX",
        "subtitle": "",
        "version": "V1.0",
        "type": "User Guide",
        "edition": "1992-09",
        "filelink": "1161/cmx.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DCAM COBOL",
        "subtitle": "",
        "version": "V13.3",
        "type": "User Guide",
        "edition": "2010-04",
        "filelink": "9497/dcam_cob.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DCAM Macros",
        "subtitle": "",
        "version": "V13.3",
        "type": "User Guide",
        "edition": "2010-04",
        "filelink": "9495/dcam_mak.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DCAM Program Interfaces",
        "subtitle": "",
        "version": "V13.3",
        "type": "User Guide",
        "edition": "2010-04",
        "filelink": "9499/dcam_ps.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IPSec",
        "subtitle": "Internet Security in BS2000/OSD",
        "version": "V1.4",
        "type": "User Guide",
        "edition": "2010-11",
        "filelink": "9787/ipsec.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IPv6 Conversion Guide Level 1",
        "subtitle": "",
        "version": "V4.0",
        "type": "User Guide",
        "edition": "2001-02",
        "filelink": "1287/ipv6_ums.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openNet Server",
        "subtitle": "",
        "version": "V4.0",
        "type": "Release Notice",
        "edition": "2017-07",
        "filelink": "13405/sysfgm.onetserv.040.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PRNGD",
        "subtitle": "",
        "version": "V1.1",
        "type": "Readme File",
        "edition": "2007-12",
        "filelink": "8647/sysrme.prngd.011a.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "SNMP Management openNet Server",
        "subtitle": "",
        "version": "V4.0",
        "type": "User Guide",
        "edition": "2001-02",
        "filelink": "1292/net_snmp.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SOCKETS",
        "subtitle": "",
        "version": "V2.7A",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12111/sock_bs2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VTSU",
        "subtitle": "",
        "version": "V11.0A",
        "type": "User Guide",
        "edition": "1994-04",
        "filelink": "1166/vtsu.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VTSU-B",
        "subtitle": "",
        "version": "V13.3",
        "type": "Readme File",
        "edition": "2007-12",
        "filelink": "8649/sysrme.vtsu-b.133a.e.txt",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psOPENNETSERVERV40de": {
    "spaceProperties": {
      "prodId": "product-opennetserver",
      "prod": "openNet Server",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "BCAM Band 1/2 (eine pdf-Datei)",
        "subtitle": "",
        "version": "V24.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13243/bcam.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX",
        "subtitle": "",
        "version": "V1.2A",
        "type": "Readme Datei",
        "edition": "1997-10",
        "filelink": "2373/cmx.rme",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "CMX",
        "subtitle": "",
        "version": "V1.0",
        "type": "Benutzerhandbuch",
        "edition": "1992-09",
        "filelink": "223/cmx.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DCAM COBOL",
        "subtitle": "",
        "version": "V13.3",
        "type": "Benutzerhandbuch",
        "edition": "2010-04",
        "filelink": "9496/dcam_cob.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DCAM Makros",
        "subtitle": "",
        "version": "V13.3",
        "type": "Benutzerhandbuch",
        "edition": "2010-04",
        "filelink": "9494/dcam_mak.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DCAM Programmschnittstellen",
        "subtitle": "",
        "version": "V13.3",
        "type": "Benutzerhandbuch",
        "edition": "2010-04",
        "filelink": "9498/dcam_ps.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IPSec",
        "subtitle": "Internet-Sicherheit im BS2000/OSD",
        "version": "V1.4",
        "type": "Benutzerhandbuch",
        "edition": "2010-11",
        "filelink": "9786/ipsec.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IPv6 Umstellhandbuch Stufe 1",
        "subtitle": "",
        "version": "V4.0",
        "type": "Benutzerhandbuch",
        "edition": "2001-02",
        "filelink": "359/ipv6_ums.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openNet Server",
        "subtitle": "",
        "version": "V4.0",
        "type": "Freigabemitteilung",
        "edition": "2017-07",
        "filelink": "13404/sysfgm.onetserv.040.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PRNGD",
        "subtitle": "",
        "version": "V1.1",
        "type": "Readme Datei",
        "edition": "2007-12",
        "filelink": "8646/sysrme.prngd.011a.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "SNMP Management openNet Server",
        "subtitle": "",
        "version": "V4.0",
        "type": "Benutzerhandbuch",
        "edition": "2001-02",
        "filelink": "364/net_snmp.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SOCKETS",
        "subtitle": "",
        "version": "V2.7A",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12110/sock_bs2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VTSU",
        "subtitle": "",
        "version": "V11.0A",
        "type": "Benutzerhandbuch",
        "edition": "1994-04",
        "filelink": "229/vtsu.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VTSU-B",
        "subtitle": "",
        "version": "V13.3",
        "type": "Readme Datei",
        "edition": "2007-12",
        "filelink": "8648/sysrme.vtsu-b.133a.d.txt",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psOPENNETSERVERV36en": {
    "spaceProperties": {
      "prodId": "product-opennetserver",
      "prod": "openNet Server",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "BCAM Volume 1/2  (one pdf file)",
        "subtitle": "",
        "version": "V23.0A",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12109/bcam.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX",
        "subtitle": "",
        "version": "V1.1A",
        "type": "Readme File",
        "edition": "1996-02",
        "filelink": "3079/cmx.rme",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "CMX",
        "subtitle": "",
        "version": "V1.0",
        "type": "User Guide",
        "edition": "1992-09",
        "filelink": "1161/cmx.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DCAM COBOL",
        "subtitle": "",
        "version": "V13.3",
        "type": "User Guide",
        "edition": "2010-04",
        "filelink": "9497/dcam_cob.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DCAM Macros",
        "subtitle": "",
        "version": "V13.3",
        "type": "User Guide",
        "edition": "2010-04",
        "filelink": "9495/dcam_mak.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DCAM Program Interfaces",
        "subtitle": "",
        "version": "V13.3",
        "type": "User Guide",
        "edition": "2010-04",
        "filelink": "9499/dcam_ps.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IPSec",
        "subtitle": "Internet Security in BS2000/OSD",
        "version": "V1.4",
        "type": "User Guide",
        "edition": "2010-11",
        "filelink": "9787/ipsec.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IPv6 Conversion Guide Level 1",
        "subtitle": "",
        "version": "V3.6",
        "type": "User Guide",
        "edition": "2001-02",
        "filelink": "1287/ipv6_ums.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openNet Server",
        "subtitle": "",
        "version": "V3.6",
        "type": "Release Notice",
        "edition": "2015-11",
        "filelink": "12137/sysfgm.onetserv.036.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PLUS",
        "subtitle": "",
        "version": "V9.1",
        "type": "Release Notice",
        "edition": "2009-05",
        "filelink": "6040/sysfgm.plus.091.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PRNGD",
        "subtitle": "",
        "version": "V1.1",
        "type": "Readme File",
        "edition": "2007-12",
        "filelink": "8647/sysrme.prngd.011a.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "SNMP Management openNet Server",
        "subtitle": "",
        "version": "V3.6",
        "type": "User Guide",
        "edition": "2001-02",
        "filelink": "1292/net_snmp.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SOCKETS",
        "subtitle": "",
        "version": "V2.7A",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12111/sock_bs2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VTSU",
        "subtitle": "",
        "version": "V11.0A",
        "type": "User Guide",
        "edition": "1994-04",
        "filelink": "1166/vtsu.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VTSU-B",
        "subtitle": "",
        "version": "V13.3",
        "type": "Release Notice",
        "edition": "2009-05",
        "filelink": "8715/sysfgm.vtsu-b.133.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VTSU-B",
        "subtitle": "",
        "version": "V13.3",
        "type": "Readme File",
        "edition": "2007-12",
        "filelink": "8649/sysrme.vtsu-b.133a.e.txt",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psOPENNETSERVERV36de": {
    "spaceProperties": {
      "prodId": "product-opennetserver",
      "prod": "openNet Server",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "BCAM Band 1/2 (eine pdf-Datei)",
        "subtitle": "",
        "version": "V23.0A",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12108/bcam.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX",
        "subtitle": "",
        "version": "V1.2A",
        "type": "Readme Datei",
        "edition": "1997-10",
        "filelink": "2373/cmx.rme",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "CMX",
        "subtitle": "",
        "version": "V1.0",
        "type": "Benutzerhandbuch",
        "edition": "1992-09",
        "filelink": "223/cmx.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DCAM COBOL",
        "subtitle": "",
        "version": "V13.3",
        "type": "Benutzerhandbuch",
        "edition": "2010-04",
        "filelink": "9496/dcam_cob.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DCAM Makros",
        "subtitle": "",
        "version": "V13.3",
        "type": "Benutzerhandbuch",
        "edition": "2010-04",
        "filelink": "9494/dcam_mak.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DCAM Programmschnittstellen",
        "subtitle": "",
        "version": "V13.3",
        "type": "Benutzerhandbuch",
        "edition": "2010-04",
        "filelink": "9498/dcam_ps.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IPSec",
        "subtitle": "Internet-Sicherheit im BS2000/OSD",
        "version": "V1.4",
        "type": "Benutzerhandbuch",
        "edition": "2010-11",
        "filelink": "9786/ipsec.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "IPv6 Umstellhandbuch Stufe 1",
        "subtitle": "",
        "version": "V3.6",
        "type": "Benutzerhandbuch",
        "edition": "2001-02",
        "filelink": "359/ipv6_ums.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openNet Server",
        "subtitle": "",
        "version": "V3.6",
        "type": "Freigabemitteilung",
        "edition": "2015-11",
        "filelink": "12136/sysfgm.onetserv.036.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PLUS",
        "subtitle": "",
        "version": "V9.1",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "5165/sysfgm.plus.091.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PRNGD",
        "subtitle": "",
        "version": "V1.1",
        "type": "Readme Datei",
        "edition": "2007-12",
        "filelink": "8646/sysrme.prngd.011a.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "SNMP Management openNet Server",
        "subtitle": "",
        "version": "V3.6",
        "type": "Benutzerhandbuch",
        "edition": "2001-02",
        "filelink": "364/net_snmp.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SOCKETS",
        "subtitle": "",
        "version": "V2.7A",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12110/sock_bs2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VTSU",
        "subtitle": "",
        "version": "V11.0A",
        "type": "Benutzerhandbuch",
        "edition": "1994-04",
        "filelink": "229/vtsu.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VTSU-B",
        "subtitle": "",
        "version": "V13.3",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "8714/sysfgm.vtsu-b.133.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VTSU-B",
        "subtitle": "",
        "version": "V13.3",
        "type": "Readme Datei",
        "edition": "2007-12",
        "filelink": "8648/sysrme.vtsu-b.133a.d.txt",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psOSISESSIONSERVICEV41en": {
    "spaceProperties": {
      "prodId": "product-osisessionservice",
      "prod": "OSI Session Service",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "OSS (BS2000/OSD)",
        "subtitle": "",
        "version": "V4.1",
        "type": "Release Notice",
        "edition": "2012-06",
        "filelink": "5989/sysfgm.oss.041.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "OSS (BS2000/OSD)",
        "subtitle": "",
        "version": "V4.1A",
        "type": "Readme File",
        "edition": "2007-01",
        "filelink": "3115/oss.rme",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "OSS (BS2000/OSD)",
        "subtitle": "",
        "version": "V3.0A",
        "type": "User Guide",
        "edition": "1993-03",
        "filelink": "2409/oss.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "OSS (Unix)",
        "subtitle": "",
        "version": "V3.0",
        "type": "User Guide",
        "edition": "1992-10",
        "filelink": "7440/ossx.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOSISESSIONSERVICEV41de": {
    "spaceProperties": {
      "prodId": "product-osisessionservice",
      "prod": "OSI Session Service",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "OSS (BS2000/OSD)",
        "subtitle": "",
        "version": "V4.1",
        "type": "Freigabemitteilung",
        "edition": "2012-06",
        "filelink": "5115/sysfgm.oss.041.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "OSS (BS2000/OSD)",
        "subtitle": "",
        "version": "V4.1A",
        "type": "Readme Datei",
        "edition": "2007-01",
        "filelink": "2410/oss.rme",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psTIAMV132en": {
    "spaceProperties": {
      "prodId": "product-tiam",
      "prod": "TIAM",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "TIAM",
        "subtitle": "",
        "version": "V13.2",
        "type": "Release Notice",
        "edition": "2009-05",
        "filelink": "8699/sysfgm.tiam.132.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "TIAM",
        "subtitle": "",
        "version": "V13.2",
        "type": "Readme File",
        "edition": "2007-12",
        "filelink": "8673/sysrme.tiam.132a.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "TIAM",
        "subtitle": "",
        "version": "V11.2",
        "type": "User Guide",
        "edition": "1995-07",
        "filelink": "1282/tiam.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psTIAMV132de": {
    "spaceProperties": {
      "prodId": "product-tiam",
      "prod": "TIAM",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "TIAM",
        "subtitle": "",
        "version": "V13.2",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "8698/sysfgm.tiam.132.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "TIAM",
        "subtitle": "",
        "version": "V13.2",
        "type": "Readme Datei",
        "edition": "2007-12",
        "filelink": "8672/sysrme.tiam.132a.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "TIAM",
        "subtitle": "",
        "version": "V11.2",
        "type": "Benutzerhandbuch",
        "edition": "1995-07",
        "filelink": "353/tiam.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psXHCSV40en": {
    "spaceProperties": {
      "prodId": "product-xhcs",
      "prod": "XHCS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "XHCS",
        "subtitle": "",
        "version": "V2.0A",
        "type": "User Guide",
        "edition": "2007-03",
        "filelink": "3085/xhcs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "XHCS-SYS",
        "subtitle": "",
        "version": "V2.2A",
        "type": "Readme File",
        "edition": "2012-04",
        "filelink": "10870/sysrme.xhcs-sys.022a.e.txt",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psXHCSV40de": {
    "spaceProperties": {
      "prodId": "product-xhcs",
      "prod": "XHCS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "XHCS",
        "subtitle": "",
        "version": "V2.0A",
        "type": "Benutzerhandbuch",
        "edition": "2007-03",
        "filelink": "2379/xhcs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "XHCS-SYS",
        "subtitle": "",
        "version": "V2.2A",
        "type": "Readme Datei",
        "edition": "2012-04",
        "filelink": "10869/sysrme.xhcs-sys.022a.d.txt",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psXHCSV36en": {
    "spaceProperties": {
      "prodId": "product-xhcs",
      "prod": "XHCS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "XHCS-SYS",
      "subtitle": "",
      "version": "V2.2A",
      "type": "Readme File",
      "edition": "2012-04",
      "filelink": "10870/sysrme.xhcs-sys.022a.e.txt",
      "mediatype": "fj-mediatype-text"
    }]
  },
  "psXHCSV36de": {
    "spaceProperties": {
      "prodId": "product-xhcs",
      "prod": "XHCS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "XHCS-SYS",
      "subtitle": "",
      "version": "V2.2A",
      "type": "Readme Datei",
      "edition": "2012-04",
      "filelink": "10869/sysrme.xhcs-sys.022a.d.txt",
      "mediatype": "fj-mediatype-text"
    }]
  },
  "psXHCSV35en": {
    "spaceProperties": {
      "prodId": "product-xhcs",
      "prod": "XHCS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "XHCS-SYS",
      "subtitle": "",
      "version": "V2.2A",
      "type": "Readme File",
      "edition": "2012-04",
      "filelink": "10870/sysrme.xhcs-sys.022a.e.txt",
      "mediatype": "fj-mediatype-text"
    }]
  },
  "psXHCSV35de": {
    "spaceProperties": {
      "prodId": "product-xhcs",
      "prod": "XHCS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "XHCS-SYS",
      "subtitle": "",
      "version": "V2.2A",
      "type": "Readme Datei",
      "edition": "2012-04",
      "filelink": "10869/sysrme.xhcs-sys.022a.d.txt",
      "mediatype": "fj-mediatype-text"
    }]
  },
  "psCOSMOSV200Ben": {
    "spaceProperties": {
      "prodId": "product-cosmos",
      "prod": "COSMOS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "COSMOS",
        "subtitle": "",
        "version": "V20.0B",
        "type": "Release Notice",
        "edition": "2019-06",
        "filelink": "20044/sysfgm.cosmos.200B.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COSMOS-TOOLS",
        "subtitle": "",
        "version": "V20.0",
        "type": "Release Notice",
        "edition": "2017-07",
        "filelink": "13389/sysfgm.cosmos-tools.200.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCOSMOSV200Bde": {
    "spaceProperties": {
      "prodId": "product-cosmos",
      "prod": "COSMOS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "COSMOS",
        "subtitle": "",
        "version": "V20.0B",
        "type": "Freigabemitteilung",
        "edition": "2019-06",
        "filelink": "20030/sysfgm.cosmos.200B.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COSMOS-TOOLS",
        "subtitle": "",
        "version": "V20.0",
        "type": "Freigabemitteilung",
        "edition": "2017-07",
        "filelink": "13387/sysfgm.cosmos-tools.200.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCOSMOSV200en": {
    "spaceProperties": {
      "prodId": "product-cosmos",
      "prod": "COSMOS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "COSMOS",
        "subtitle": "",
        "version": "V20.0",
        "type": "Release Notice",
        "edition": "2017-07",
        "filelink": "13388/sysfgm.cosmos.200.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COSMOS-TOOLS",
        "subtitle": "",
        "version": "V20.0",
        "type": "Release Notice",
        "edition": "2017-07",
        "filelink": "13389/sysfgm.cosmos-tools.200.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCOSMOSV200de": {
    "spaceProperties": {
      "prodId": "product-cosmos",
      "prod": "COSMOS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "COSMOS",
        "subtitle": "",
        "version": "V20.0",
        "type": "Freigabemitteilung",
        "edition": "2017-07",
        "filelink": "13386/sysfgm.cosmos.200.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COSMOS-TOOLS",
        "subtitle": "",
        "version": "V20.0",
        "type": "Freigabemitteilung",
        "edition": "2017-07",
        "filelink": "13387/sysfgm.cosmos-tools.200.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCOSMOSV190en": {
    "spaceProperties": {
      "prodId": "product-cosmos",
      "prod": "COSMOS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "COSMOS",
        "subtitle": "",
        "version": "V19.0",
        "type": "Release Notice",
        "edition": "2014-11",
        "filelink": "12117/sysfgm.cosmos.190.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COSMOS-TOOLS",
        "subtitle": "",
        "version": "V19.0",
        "type": "Release Notice",
        "edition": "2014-11",
        "filelink": "12119/sysfgm.cosmos-tools.190.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCOSMOSV190de": {
    "spaceProperties": {
      "prodId": "product-cosmos",
      "prod": "COSMOS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "COSMOS",
        "subtitle": "",
        "version": "V19.0",
        "type": "Freigabemitteilung",
        "edition": "2014-11",
        "filelink": "12116/sysfgm.cosmos.190.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COSMOS-TOOLS",
        "subtitle": "",
        "version": "V19.0",
        "type": "Freigabemitteilung",
        "edition": "2015-04",
        "filelink": "12118/sysfgm.cosmos-tools.190.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCOSMOSV180en": {
    "spaceProperties": {
      "prodId": "product-cosmos",
      "prod": "COSMOS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "COSMOS",
        "subtitle": "",
        "version": "V18.0",
        "type": "Release Notice",
        "edition": "2012-06",
        "filelink": "10853/sysfgm.cosmos.180.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COSMOS-TOOLS",
        "subtitle": "",
        "version": "V18.0",
        "type": "Release Notice",
        "edition": "2012-06",
        "filelink": "10852/sysfgm.cosmos-tools.180.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCOSMOSV180de": {
    "spaceProperties": {
      "prodId": "product-cosmos",
      "prod": "COSMOS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "COSMOS",
        "subtitle": "",
        "version": "V18.0",
        "type": "Freigabemitteilung",
        "edition": "2012-06",
        "filelink": "10850/sysfgm.cosmos.180.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COSMOS-TOOLS",
        "subtitle": "",
        "version": "V18.0",
        "type": "Freigabemitteilung",
        "edition": "2012-06",
        "filelink": "10851/sysfgm.cosmos-tools.180.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psDABV95en": {
    "spaceProperties": {
      "prodId": "product-dab",
      "prod": "DAB",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "DAB",
        "subtitle": "",
        "version": "V9.5",
        "type": "Release Notice",
        "edition": "2017-07",
        "filelink": "13395/sysfgm.dab.095.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Disk Access Buffer",
        "subtitle": "",
        "version": "V9.5",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13180/dab.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psDABV95de": {
    "spaceProperties": {
      "prodId": "product-dab",
      "prod": "DAB",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "DAB",
        "subtitle": "",
        "version": "V9.5",
        "type": "Freigabemitteilung",
        "edition": "2017-07",
        "filelink": "13394/sysfgm.dab.095.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Disk Access Buffer",
        "subtitle": "",
        "version": "V9.5",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13179/dab.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psDABV94en": {
    "spaceProperties": {
      "prodId": "product-dab",
      "prod": "DAB",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "DAB",
        "subtitle": "",
        "version": "V9.4",
        "type": "Release Notice",
        "edition": "2015-04",
        "filelink": "12125/sysfgm.dab.094.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Disk Access Buffer",
        "subtitle": "",
        "version": "V9.3",
        "type": "User Guide",
        "edition": "2012-06",
        "filelink": "10712/dab.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psDABV94de": {
    "spaceProperties": {
      "prodId": "product-dab",
      "prod": "DAB",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "DAB",
        "subtitle": "",
        "version": "V9.4",
        "type": "Freigabemitteilung",
        "edition": "2015-04",
        "filelink": "12124/sysfgm.dab.094.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Disk Access Buffer",
        "subtitle": "",
        "version": "V9.3",
        "type": "Benutzerhandbuch",
        "edition": "2012-06",
        "filelink": "10711/dab.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENSM2V110Ben": {
    "spaceProperties": {
      "prodId": "product-opensm2",
      "prod": "openSM2",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "openSM2",
        "subtitle": "Software Monitor",
        "version": "V11.0B",
        "type": "User Guide",
        "edition": "2019-06",
        "filelink": "20076/openSM2-en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SM2",
        "subtitle": "",
        "version": "V20.0B",
        "type": "Release Notice",
        "edition": "2019-06",
        "filelink": "20059/sysfgm.sm2.200.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SM2-TOOLS",
        "subtitle": "",
        "version": "V11.0B",
        "type": "Release Notice",
        "edition": "2020-07",
        "filelink": "20270/sysfgm.sm2-tools.110.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SM2-WEB",
        "subtitle": "",
        "version": "V11.0B",
        "type": "Release Notice",
        "edition": "2020-07",
        "filelink": "20271/sysfgm.sm2-web.110.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENSM2V110Bde": {
    "spaceProperties": {
      "prodId": "product-opensm2",
      "prod": "openSM2",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "openSM2",
        "subtitle": "Software Monitor",
        "version": "V11.0B",
        "type": "Benutzerhandbuch",
        "edition": "2019-06",
        "filelink": "20018/openSM2-de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SM2",
        "subtitle": "",
        "version": "V20.0B",
        "type": "Freigabemitteilung",
        "edition": "2019-06",
        "filelink": "20075/sysfgm.sm2.200B.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SM2-TOOLS",
        "subtitle": "",
        "version": "V11.0B",
        "type": "Freigabemitteilung",
        "edition": "2020-07",
        "filelink": "20268/sysfgm.sm2-tools.110.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SM2-WEB",
        "subtitle": "",
        "version": "V11.0B",
        "type": "Freigabemitteilung",
        "edition": "2020-07",
        "filelink": "20269/sysfgm.sm2-web.110.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENSM2V100en": {
    "spaceProperties": {
      "prodId": "product-opensm2",
      "prod": "openSM2",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "openSM2",
        "subtitle": "Software Monitor",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12101/sm2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SM2",
        "subtitle": "",
        "version": "V19.0",
        "type": "Release Notice",
        "edition": "2015-04",
        "filelink": "12147/sysfgm.sm2.190.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SM2-TOOLS",
        "subtitle": "",
        "version": "V10.0",
        "type": "Release Notice",
        "edition": "2016-04",
        "filelink": "12149/sysfgm.sm2-tools.100.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENSM2V100de": {
    "spaceProperties": {
      "prodId": "product-opensm2",
      "prod": "openSM2",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "openSM2",
        "subtitle": "Software Monitor",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12100/sm2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SM2",
        "subtitle": "",
        "version": "V19.0",
        "type": "Freigabemitteilung",
        "edition": "2015-04",
        "filelink": "12146/sysfgm.sm2.190.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SM2-TOOLS",
        "subtitle": "",
        "version": "V10.0",
        "type": "Freigabemitteilung",
        "edition": "2016-04",
        "filelink": "12148/sysfgm.sm2-tools.100.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENSM2V92en": {
    "spaceProperties": {
      "prodId": "product-opensm2",
      "prod": "openSM2",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "openSM2 for Solaris, Linux, Windows, VMware ESX Server",
      "subtitle": "",
      "version": "V9.2",
      "type": "Release Notice",
      "edition": "2012-05",
      "filelink": "10798/fgm.openSM2.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psOPENSM2V92de": {
    "spaceProperties": {
      "prodId": "product-opensm2",
      "prod": "openSM2",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "openSM2 for Solaris, Linux, Windows, VMware ESX Server",
      "subtitle": "",
      "version": "V9.2",
      "type": "Freigabemitteilung",
      "edition": "2012-05",
      "filelink": "10797/fgm.openSM2.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psPCSV32en": {
    "spaceProperties": {
      "prodId": "product-pcs",
      "prod": "PCS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "PCS",
      "subtitle": "",
      "version": "V3.2",
      "type": "Release Notice",
      "edition": "2017-07",
      "filelink": "13409/sysfgm.pcs.032.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psPCSV32de": {
    "spaceProperties": {
      "prodId": "product-pcs",
      "prod": "PCS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "PCS",
      "subtitle": "",
      "version": "V3.2",
      "type": "Freigabemitteilung",
      "edition": "2017-07",
      "filelink": "13408/sysfgm.pcs.032.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psPCSV31en": {
    "spaceProperties": {
      "prodId": "product-pcs",
      "prod": "PCS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "PCS",
        "subtitle": "",
        "version": "V3.1",
        "type": "Release Notice",
        "edition": "2014-11",
        "filelink": "12139/sysfgm.pcs.031.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PCS",
        "subtitle": "",
        "version": "V2.7A",
        "type": "User Guide",
        "edition": "2004-12",
        "filelink": "3116/pcs.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psPCSV31de": {
    "spaceProperties": {
      "prodId": "product-pcs",
      "prod": "PCS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "PCS",
        "subtitle": "",
        "version": "V3.1",
        "type": "Freigabemitteilung",
        "edition": "2014-11",
        "filelink": "12138/sysfgm.pcs.031.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PCS",
        "subtitle": "",
        "version": "V2.7A",
        "type": "Benutzerhandbuch",
        "edition": "2004-12",
        "filelink": "2411/pcs.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSCAV200en": {
    "spaceProperties": {
      "prodId": "product-sca",
      "prod": "SCA",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "SCA",
      "subtitle": "",
      "version": "V20.0",
      "type": "Release Notice",
      "edition": "2017-02",
      "filelink": "13415/sysfgm.sca.200.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psSCAV200de": {
    "spaceProperties": {
      "prodId": "product-sca",
      "prod": "SCA",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "SCA",
      "subtitle": "",
      "version": "V20.0",
      "type": "Freigabemitteilung",
      "edition": "2017-02",
      "filelink": "13414/sysfgm.sca.200.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psSCAV190en": {
    "spaceProperties": {
      "prodId": "product-sca",
      "prod": "SCA",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "SCA",
      "subtitle": "",
      "version": "V19.0",
      "type": "Release Notice",
      "edition": "2014-12",
      "filelink": "12157/sysfgm.sca.190.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psSCAV190de": {
    "spaceProperties": {
      "prodId": "product-sca",
      "prod": "SCA",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "SCA",
      "subtitle": "",
      "version": "V19.0",
      "type": "Freigabemitteilung",
      "edition": "2014-12",
      "filelink": "12156/sysfgm.sca.190.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psSM2PAV20en": {
    "spaceProperties": {
      "prodId": "product-sm2pa",
      "prod": "SM2-PA",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SM2-PA",
        "subtitle": "",
        "version": "V2.0",
        "type": "Release Notice",
        "edition": "2009-05",
        "filelink": "8733/sysfgm.sm2-pa.020.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SM2-PA",
        "subtitle": "",
        "version": "V2.0A",
        "type": "Readme File",
        "edition": "2000-06",
        "filelink": "3179/sm2_pa.rme",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "SM2-PA",
        "subtitle": "",
        "version": "V2.0",
        "type": "User Guide",
        "edition": "1993-11",
        "filelink": "1762/sm2_pa.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSM2PAV20de": {
    "spaceProperties": {
      "prodId": "product-sm2pa",
      "prod": "SM2-PA",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SM2-PA",
        "subtitle": "",
        "version": "V2.0",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "8732/sysfgm.sm2-pa.020.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SM2-PA",
        "subtitle": "",
        "version": "V2.0",
        "type": "Benutzerhandbuch",
        "edition": "2004-12",
        "filelink": "803/sm2_pa.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SM2-PA",
        "subtitle": "",
        "version": "V2.0A",
        "type": "Readme Datei",
        "edition": "2000-06",
        "filelink": "2475/sm2_pa.rme",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psBS2ZIPV12en": {
    "spaceProperties": {
      "prodId": "product-bs2zip",
      "prod": "BS2ZIP",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "BS2ZIP",
      "subtitle": "Zip Archiving in BS2000",
      "version": "V1.2G",
      "type": "User Guide",
      "edition": "2014-11",
      "filelink": "11875/bs2zip.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psBS2ZIPV12de": {
    "spaceProperties": {
      "prodId": "product-bs2zip",
      "prod": "BS2ZIP",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "BS2ZIP",
      "subtitle": "Zip Archivierung in BS2000",
      "version": "V1.2G",
      "type": "Benutzerhandbuch",
      "edition": "2014-11",
      "filelink": "11874/bs2zip.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psCONV2PDFV49en": {
    "spaceProperties": {
      "prodId": "product-conv2pdf",
      "prod": "CONV2PDF",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Spool&Print Macros for Converting to PDF",
        "subtitle": "CONV2PDF",
        "version": "V4.9A",
        "type": "Readme File",
        "edition": "2019-11",
        "filelink": "20179/sysrme.conv2pdf.010.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Spool&Print Macros for Converting to PDF",
        "subtitle": "CONV2PDF",
        "version": "V4.9A",
        "type": "User Guide",
        "edition": "2017-06",
        "filelink": "9959/conv2pdf.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCONV2PDFV49de": {
    "spaceProperties": {
      "prodId": "product-conv2pdf",
      "prod": "CONV2PDF",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SPOOL&Print Makros zur Konvertierung in PDF",
        "subtitle": "CONV2PDF",
        "version": "V4.9A",
        "type": "Readme Datei",
        "edition": "2019-11",
        "filelink": "20180/sysrme.conv2pdf.010.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPOOL&Print Makros zur Konvertierung in PDF",
        "subtitle": "CONV2PDF",
        "version": "V4.9A",
        "type": "Benutzerhandbuch",
        "edition": "2017-06",
        "filelink": "9929/conv2pdf.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psDPRINTV12en": {
    "spaceProperties": {
      "prodId": "product-dprint",
      "prod": "DPRINT",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Dprint",
        "subtitle": "",
        "version": "V1.1B",
        "type": "User Guide",
        "edition": "2005-05",
        "filelink": "2794/dprint.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DPRINT-SV",
        "subtitle": "",
        "version": "V1.2",
        "type": "Release Notice",
        "edition": "2012-06",
        "filelink": "8593/sysfgm.dprintsv.012.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DPRINTCL",
        "subtitle": "",
        "version": "V1.2",
        "type": "Release Notice",
        "edition": "2012-06",
        "filelink": "8591/sysfgm.dprintcl.012.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psDPRINTV12de": {
    "spaceProperties": {
      "prodId": "product-dprint",
      "prod": "DPRINT",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Dprint",
        "subtitle": "",
        "version": "V1.1B",
        "type": "Benutzerhandbuch",
        "edition": "2005-05",
        "filelink": "2082/dprint.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DPRINT-SV",
        "subtitle": "",
        "version": "V1.2",
        "type": "Freigabemitteilung",
        "edition": "2012-06",
        "filelink": "8592/sysfgm.dprintsv.012.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DPRINTCL",
        "subtitle": "",
        "version": "V1.2",
        "type": "Freigabemitteilung",
        "edition": "2012-06",
        "filelink": "8590/sysfgm.dprintcl.012.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psRSOV36en": {
    "spaceProperties": {
      "prodId": "product-rso",
      "prod": "RSO",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "RSO",
        "subtitle": "",
        "version": "V3.6",
        "type": "Release Notice",
        "edition": "2009-05",
        "filelink": "8709/sysfgm.rso.036a.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "RSO",
        "subtitle": "",
        "version": "V3.5",
        "type": "User Guide",
        "edition": "2008-11",
        "filelink": "3070/rso.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "RSOSERVE",
        "subtitle": "",
        "version": "V3.0A",
        "type": "User Guide",
        "edition": "1996-03",
        "filelink": "1613/rsoserve.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psRSOV36de": {
    "spaceProperties": {
      "prodId": "product-rso",
      "prod": "RSO",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "RSO",
        "subtitle": "",
        "version": "V3.6",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "8708/sysfgm.rso.036a.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "RSO",
        "subtitle": "",
        "version": "V3.5",
        "type": "Benutzerhandbuch",
        "edition": "2008-11",
        "filelink": "2364/rso.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "RSOSERVE",
        "subtitle": "",
        "version": "V3.0A",
        "type": "Benutzerhandbuch",
        "edition": "1996-03",
        "filelink": "658/rsoserve.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSPOOLV49en": {
    "spaceProperties": {
      "prodId": "product-spool",
      "prod": "SPOOL",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "PRM",
        "subtitle": "",
        "version": "V1.2A",
        "type": "User Guide",
        "edition": "2000-03",
        "filelink": "1273/prm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SNS User Guide",
        "subtitle": "",
        "version": "V1.0B",
        "type": "User Guide",
        "edition": "2004-10",
        "filelink": "2668/sns.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPCONV",
        "subtitle": "",
        "version": "V1.0A",
        "type": "User Guide",
        "edition": "1997-05",
        "filelink": "1275/spconv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPOOL",
        "subtitle": "",
        "version": "V4.9A",
        "type": "Release Notice",
        "edition": "2019-11",
        "filelink": "20149/sysfgm.spool.049.e.2019.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPOOL",
        "subtitle": "",
        "version": "V4.9A06",
        "type": "Readme File",
        "edition": "2019-06",
        "filelink": "20047/sysrme.spool.049.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPOOL User Guide",
        "subtitle": "",
        "version": "V4.6A",
        "type": "User Guide",
        "edition": "2005-05",
        "filelink": "2669/spool.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPOOL&Print Commands",
        "subtitle": "",
        "version": "V4.9A",
        "type": "User Guide",
        "edition": "2003-05",
        "filelink": "1579/s_p_kdo.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPOOL&Print Macros and Exits",
        "subtitle": "",
        "version": "V4.9A",
        "type": "User Guide",
        "edition": "2005-05",
        "filelink": "2671/spmakros.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPOOL&Print Messages",
        "subtitle": "",
        "version": "V4.9A",
        "type": "User Guide",
        "edition": "2001-03",
        "filelink": "1580/sp_meld.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPS/BS2000-APA",
        "subtitle": "(only in German)",
        "version": "V3.6",
        "type": "User Guide",
        "edition": "1999-06",
        "filelink": "13011/sps.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPSERVE",
        "subtitle": "",
        "version": "V2.9A",
        "type": "User Guide",
        "edition": "2006-10",
        "filelink": "2749/spserve.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSPOOLV49de": {
    "spaceProperties": {
      "prodId": "product-spool",
      "prod": "SPOOL",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "PRM",
        "subtitle": "",
        "version": "V1.2A",
        "type": "Benutzerhandbuch",
        "edition": "2000-03",
        "filelink": "344/prm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SNS BHB",
        "subtitle": "",
        "version": "V1.0B",
        "type": "Benutzerhandbuch",
        "edition": "2004-10",
        "filelink": "1943/sns.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPCONV",
        "subtitle": "",
        "version": "V1.0A",
        "type": "Benutzerhandbuch",
        "edition": "1997-05",
        "filelink": "346/spconv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPOOL",
        "subtitle": "",
        "version": "V4.9A",
        "type": "Freigabemitteilung",
        "edition": "2019-11",
        "filelink": "20148/sysfgm.spool.049.d.2019.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPOOL",
        "subtitle": "",
        "version": "V4.9A06",
        "type": "Readme Datei",
        "edition": "2019-06",
        "filelink": "20033/sysrme.spool.049.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPOOL BHB",
        "subtitle": "",
        "version": "V4.6A",
        "type": "Benutzerhandbuch",
        "edition": "2005-05",
        "filelink": "1944/spool.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPOOL&Print Makros und Exits",
        "subtitle": "",
        "version": "V4.9A",
        "type": "Benutzerhandbuch",
        "edition": "2005-05",
        "filelink": "1945/spmakros.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPOOL&Print Meldungen",
        "subtitle": "",
        "version": "V4.9A",
        "type": "Benutzerhandbuch",
        "edition": "2001-03",
        "filelink": "625/sp_meld.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPOOL&Print-Kommandos",
        "subtitle": "",
        "version": "V4.9A",
        "type": "Benutzerhandbuch",
        "edition": "2003-05",
        "filelink": "626/s_p_kdo.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPS/BS2000-APA",
        "subtitle": "",
        "version": "V3.8",
        "type": "Benutzerhandbuch",
        "edition": "2000-09",
        "filelink": "2487/sps.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPS/BS2000-APA",
        "subtitle": "",
        "version": "V3.6",
        "type": "Benutzerhandbuch",
        "edition": "1999-06",
        "filelink": "2489/sps.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPSERVE",
        "subtitle": "",
        "version": "V2.9A",
        "type": "Benutzerhandbuch",
        "edition": "2006-10",
        "filelink": "2024/spserve.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psAIDV34en": {
    "spaceProperties": {
      "prodId": "product-aid",
      "prod": "AID",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "AID",
        "subtitle": "",
        "version": "V3.4",
        "type": "Release Notice",
        "edition": "2018-06",
        "filelink": "8571/sysfgm.aid.034.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "AID",
        "subtitle": "",
        "version": "V3.4",
        "type": "Readme File",
        "edition": "2011-07",
        "filelink": "8641/sysrme.aid.034a.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "Core Manual",
        "subtitle": "",
        "version": "V3.4B",
        "type": "User Guide",
        "edition": "2016-06",
        "filelink": "12463/aid_bas.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Core Manual",
        "subtitle": "",
        "version": "V3.2A",
        "type": "User Guide",
        "edition": "2006-10",
        "filelink": "6645/aid_bas.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Debugging of ASSEMBH Programs",
        "subtitle": "",
        "version": "V3.4B",
        "type": "User Guide",
        "edition": "2016-06",
        "filelink": "12472/aid_ass.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Debugging of ASSEMBH Programs",
        "subtitle": "",
        "version": "V2.0A",
        "type": "User Guide",
        "edition": "1991-12",
        "filelink": "938/aid_ass.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Debugging of C/C++ Programs",
        "subtitle": "",
        "version": "V3.4B",
        "type": "User Guide",
        "edition": "2016-06",
        "filelink": "12473/aid_cpp.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Debugging of C/C++ Programs",
        "subtitle": "",
        "version": "V2.3B",
        "type": "User Guide",
        "edition": "1999-04",
        "filelink": "951/aid_cpp.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Debugging of COBOL Programs",
        "subtitle": "",
        "version": "V3.4B",
        "type": "User Guide",
        "edition": "2016-06",
        "filelink": "12474/aid_cob.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Debugging of COBOL Programs",
        "subtitle": "",
        "version": "V3.2A",
        "type": "User Guide",
        "edition": "2006-11",
        "filelink": "2589/aid_cob.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Debugging of FORTRAN Programs",
        "subtitle": "",
        "version": "V3.4B",
        "type": "User Guide",
        "edition": "2015-11",
        "filelink": "12475/aid_for.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Debugging of FORTRAN Programs",
        "subtitle": "",
        "version": "V2.0A",
        "type": "User Guide",
        "edition": "1991-09",
        "filelink": "939/aid_for.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Debugging on Machine Code Level",
        "subtitle": "",
        "version": "V3.4B",
        "type": "User Guide",
        "edition": "2016-06",
        "filelink": "12470/aid_mc.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Debugging on Machine Code Level",
        "subtitle": "",
        "version": "V2.1A",
        "type": "User Guide",
        "edition": "1995-03",
        "filelink": "944/aid_mc.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Debugging under POSIX",
        "subtitle": "",
        "version": "V3.4B",
        "type": "User Guide",
        "edition": "2015-11",
        "filelink": "12471/aid_pos.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Debugging under POSIX",
        "subtitle": "",
        "version": "V2.2",
        "type": "User Guide",
        "edition": "1996-12",
        "filelink": "10541/aid_pos.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psAIDV34de": {
    "spaceProperties": {
      "prodId": "product-aid",
      "prod": "AID",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "AID",
        "subtitle": "",
        "version": "V3.4",
        "type": "Freigabemitteilung",
        "edition": "2018-06",
        "filelink": "8570/sysfgm.aid.034.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "AID",
        "subtitle": "",
        "version": "V3.4",
        "type": "Readme Datei",
        "edition": "2011-07",
        "filelink": "8640/sysrme.aid.034a.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "Basishandbuch",
        "subtitle": "",
        "version": "V3.4B",
        "type": "Benutzerhandbuch",
        "edition": "2016-06",
        "filelink": "12462/aid_bas.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Basishandbuch",
        "subtitle": "",
        "version": "V3.2A",
        "type": "Benutzerhandbuch",
        "edition": "2006-10",
        "filelink": "1864/aid_bas.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Testen auf Maschinencode-Ebene",
        "subtitle": "",
        "version": "V3.4B",
        "type": "Benutzerhandbuch",
        "edition": "2018-06",
        "filelink": "12464/aid_mc.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Testen auf Maschinencode-Ebene",
        "subtitle": "",
        "version": "V2.1A",
        "type": "Benutzerhandbuch",
        "edition": "1995-04",
        "filelink": "9/aid_mc.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Testen unter POSIX",
        "subtitle": "",
        "version": "V3.4B",
        "type": "Benutzerhandbuch",
        "edition": "2015-11",
        "filelink": "12469/aid_pos.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Testen unter POSIX",
        "subtitle": "",
        "version": "V2.2",
        "type": "Benutzerhandbuch",
        "edition": "1996-12",
        "filelink": "10540/aid_pos.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Testen von ASSEMBH-Programmen",
        "subtitle": "",
        "version": "V3.4B",
        "type": "Benutzerhandbuch",
        "edition": "2018-06",
        "filelink": "12466/aid_ass.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Testen von ASSEMBH-Programmen",
        "subtitle": "",
        "version": "V2.0",
        "type": "Benutzerhandbuch",
        "edition": "1991-12",
        "filelink": "3/aid_ass.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Testen von C/C++-Programmen",
        "subtitle": "",
        "version": "V3.4B",
        "type": "Benutzerhandbuch",
        "edition": "2018-06",
        "filelink": "12468/aid_cpp.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Testen von C/C++-Programmen",
        "subtitle": "",
        "version": "V2.3B",
        "type": "Benutzerhandbuch",
        "edition": "1999-04",
        "filelink": "17/aid_cpp.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Testen von COBOL-Programmen",
        "subtitle": "",
        "version": "V3.4B",
        "type": "Benutzerhandbuch",
        "edition": "2018-06",
        "filelink": "12465/aid_cob.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Testen von COBOL-Programmen",
        "subtitle": "",
        "version": "V3.2A",
        "type": "Benutzerhandbuch",
        "edition": "2006-11",
        "filelink": "1865/aid_cob.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Testen von FORTRAN-Programmen",
        "subtitle": "",
        "version": "V3.4B",
        "type": "Benutzerhandbuch",
        "edition": "2018-06",
        "filelink": "12467/aid_for.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Testen von FORTRAN-Programmen",
        "subtitle": "",
        "version": "V2.0",
        "type": "Benutzerhandbuch",
        "edition": "1991-09",
        "filelink": "5/aid_for.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psASSEMBHV13en": {
    "spaceProperties": {
      "prodId": "product-assembh",
      "prod": "ASSEMBH",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ASSEMBH",
        "subtitle": "",
        "version": "V1.3",
        "type": "Release Notice",
        "edition": "2012-12",
        "filelink": "10843/sysfgm.assembh.013.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ASSEMBH",
        "subtitle": "",
        "version": "V1.3",
        "type": "Readme File",
        "edition": "2012-01",
        "filelink": "10888/sysrme.assembh.013a.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "ASSEMBH Reference Manual",
        "subtitle": "",
        "version": "V1.2",
        "type": "User Guide",
        "edition": "2010-06",
        "filelink": "957/assh_bs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ASSEMBH User Guide",
        "subtitle": "",
        "version": "V1.2",
        "type": "User Guide",
        "edition": "2010-06",
        "filelink": "958/assh_bhb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Assembler Instructions",
        "subtitle": "",
        "version": "V1.3",
        "type": "User Guide",
        "edition": "2016-10",
        "filelink": "959/assembl_e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ASSTRAN",
        "subtitle": "",
        "version": "V5.2B",
        "type": "Readme File",
        "edition": "2011-08",
        "filelink": "10829/sysrme.asstran.052b.e.txt",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psASSEMBHV13de": {
    "spaceProperties": {
      "prodId": "product-assembh",
      "prod": "ASSEMBH",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ASSEMBH",
        "subtitle": "",
        "version": "V1.3",
        "type": "Freigabemitteilung",
        "edition": "2012-12",
        "filelink": "10842/sysfgm.assembh.013.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ASSEMBH",
        "subtitle": "",
        "version": "V1.3",
        "type": "Readme Datei",
        "edition": "2012-01",
        "filelink": "10887/sysrme.assembh.013a.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "ASSEMBH Beschreibung",
        "subtitle": "",
        "version": "V1.2",
        "type": "Benutzerhandbuch",
        "edition": "2010-06",
        "filelink": "24/assh_bs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ASSEMBH BHB",
        "subtitle": "",
        "version": "V1.2",
        "type": "Benutzerhandbuch",
        "edition": "2010-06",
        "filelink": "23/assh_bhb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Assembler Befehle",
        "subtitle": "",
        "version": "V1.3",
        "type": "Benutzerhandbuch",
        "edition": "2010-07",
        "filelink": "25/assembl.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ASSTRAN",
        "subtitle": "",
        "version": "V5.2",
        "type": "Freigabemitteilung",
        "edition": "2012-06",
        "filelink": "10844/sysfgm.asstran.052.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ASSTRAN",
        "subtitle": "",
        "version": "V5.2B",
        "type": "Readme Datei",
        "edition": "2011-08",
        "filelink": "10828/sysrme.asstran.052b.d.txt",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psCOBOL85V23en": {
    "spaceProperties": {
      "prodId": "product-cobol85",
      "prod": "COBOL85",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "COBOL85 Reference Manual",
        "subtitle": "",
        "version": "V2.3",
        "type": "User Guide",
        "edition": "1998-05",
        "filelink": "1135/cb85_bs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COBOL85 User Guide",
        "subtitle": "",
        "version": "V2.3",
        "type": "User Guide",
        "edition": "2014-07",
        "filelink": "1136/cb85bhb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COBOL85-FGM",
        "subtitle": "",
        "version": "V2.3",
        "type": "Release Notice",
        "edition": "2012-06",
        "filelink": "5684/sysfgm.cobol85.023.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCOBOL85V23de": {
    "spaceProperties": {
      "prodId": "product-cobol85",
      "prod": "COBOL85",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "COBOL85 Beschreibung",
        "subtitle": "",
        "version": "V2.3",
        "type": "Benutzerhandbuch",
        "edition": "1998-04",
        "filelink": "199/cb85_bs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COBOL85 BHB",
        "subtitle": "",
        "version": "V2.3",
        "type": "Benutzerhandbuch",
        "edition": "2014-07",
        "filelink": "198/cb85bhb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COBOL85-FGM",
        "subtitle": "",
        "version": "V2.3",
        "type": "Freigabemitteilung",
        "edition": "2012-06",
        "filelink": "4810/sysfgm.cobol85.023.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCOBOL2000V16en": {
    "spaceProperties": {
      "prodId": "product-cobol2000",
      "prod": "COBOL2000",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "COBOL2000",
        "subtitle": "",
        "version": "V1.6",
        "type": "Release Notice",
        "edition": "2018-06",
        "filelink": "13769/sysfgm.cobol2000-gem.016.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COBOL2000",
        "subtitle": "COBOL Compiler",
        "version": "V1.6A",
        "type": "Reference Manual",
        "edition": "2018-06",
        "filelink": "13781/cob2bs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COBOL2000",
        "subtitle": "COBOL Compiler",
        "version": "V1.6A",
        "type": "User Guide",
        "edition": "2018-06",
        "filelink": "13779/cob2bhb.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCOBOL2000V16de": {
    "spaceProperties": {
      "prodId": "product-cobol2000",
      "prod": "COBOL2000",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "COBOL2000",
        "subtitle": "",
        "version": "V1.6",
        "type": "Freigabemitteilung",
        "edition": "2018-06",
        "filelink": "13768/sysfgm.cobol2000-gem.016.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COBOL2000",
        "subtitle": "COBOL-Compiler",
        "version": "V1.6A",
        "type": "Benutzerhandbuch",
        "edition": "2018-06",
        "filelink": "13778/cob2bhb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COBOL2000",
        "subtitle": "COBOL-Compiler",
        "version": "V1.6A",
        "type": "Sprachbeschreibung",
        "edition": "2018-06",
        "filelink": "13780/cob2bs.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCOBOL2000V15en": {
    "spaceProperties": {
      "prodId": "product-cobol2000",
      "prod": "COBOL2000",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "COBOL2000",
        "subtitle": "",
        "version": "V1.5",
        "type": "Release Notice",
        "edition": "2017-06",
        "filelink": "8575/sysfgm.cobol2000-gem.015.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COBOL2000",
        "subtitle": "",
        "version": "V1.5",
        "type": "Readme File",
        "edition": "2017-06",
        "filelink": "12810/sysrme.cobol2000.015.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COBOL2000",
        "subtitle": "COBOL Compiler",
        "version": "V1.5A",
        "type": "User Guide",
        "edition": "2014-03",
        "filelink": "8510/cob2bhb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COBOL2000",
        "subtitle": "COBOL Compiler",
        "version": "V1.5A",
        "type": "Reference Manual",
        "edition": "2009-04",
        "filelink": "8511/cob2bs.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCOBOL2000V15de": {
    "spaceProperties": {
      "prodId": "product-cobol2000",
      "prod": "COBOL2000",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "COBOL2000",
        "subtitle": "",
        "version": "V1.5",
        "type": "Freigabemitteilung",
        "edition": "2017-06",
        "filelink": "8574/sysfgm.cobol2000-gem.015.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COBOL2000",
        "subtitle": "",
        "version": "V1.5",
        "type": "Readme Datei",
        "edition": "2017-06",
        "filelink": "12809/sysrme.cobol2000.015.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COBOL2000",
        "subtitle": "COBOL-Compiler",
        "version": "V1.5A",
        "type": "Benutzerhandbuch",
        "edition": "2014-03",
        "filelink": "8494/cob2bhb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "COBOL2000",
        "subtitle": "COBOL-Compiler",
        "version": "V1.5A",
        "type": "Sprachbeschreibung",
        "edition": "2009-04",
        "filelink": "8495/cob2bs.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCOLUMBUS85V11en": {
    "spaceProperties": {
      "prodId": "product-columbus85",
      "prod": "COLUMBUS85",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "COL85",
      "subtitle": "",
      "version": "V1.1",
      "type": "Release Notice",
      "edition": "2012-06",
      "filelink": "10849/sysfgm.col85.011.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psCOLUMBUS85V11de": {
    "spaceProperties": {
      "prodId": "product-columbus85",
      "prod": "COLUMBUS85",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "COL85",
      "subtitle": "",
      "version": "V1.1",
      "type": "Freigabemitteilung",
      "edition": "2012-06",
      "filelink": "10848/sysfgm.col85.011.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psCCV40en": {
    "spaceProperties": {
      "prodId": "product-cc++",
      "prod": "C/C++",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "C Library Functions for POSIX Applications",
        "subtitle": "CRTE V10.1A00/V11.1A00",
        "version": "V4.0A",
        "type": "Reference Manual",
        "edition": "2020-06",
        "filelink": "20282/CPP_poslib_40_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C++ Library Functions",
        "subtitle": "",
        "version": "V4.0A",
        "type": "User Guide",
        "edition": "2020-06",
        "filelink": "20281/CPP_cpplib_40_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C/C++ Compiler",
        "subtitle": "",
        "version": "V4.0A",
        "type": "User Guide",
        "edition": "2020-06",
        "filelink": "20284/CPP_bhb_40_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C/C++ POSIX Commands",
        "subtitle": "",
        "version": "V4.0A",
        "type": "User Guide",
        "edition": "2020-06",
        "filelink": "20283/CPP_poscmd_40_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CPP",
        "subtitle": "",
        "version": "V4.0",
        "type": "Release Notice",
        "edition": "2019-11",
        "filelink": "20118/sysfgm.cpp.040.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCCV40de": {
    "spaceProperties": {
      "prodId": "product-cc++",
      "prod": "C/C++",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "C++-Bibliotheksfunktionen",
        "subtitle": "",
        "version": "V4.0A",
        "type": "Benutzerhandbuch",
        "edition": "2020-06",
        "filelink": "20143/CPP_cpplib_40.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C-Bibliotheksfunktionen",
        "subtitle": "CRTE V10.1A00/V11.1A00",
        "version": "V4.0A",
        "type": "Referenzhandbuch",
        "edition": "2019-12",
        "filelink": "20144/CPP_clib_40.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C-Bibliotheksfunktionen für POSIX-Anwendungen",
        "subtitle": "CRTE V10.1A00/V11.1A00",
        "version": "V4.0A",
        "type": "Referenzhandbuch",
        "edition": "2019-12",
        "filelink": "20145/CPP_poslib_40.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C/C++ POSIX-Kommandos",
        "subtitle": "",
        "version": "V4.0A",
        "type": "Benutzerhandbuch",
        "edition": "2020-06",
        "filelink": "20146/CPP_poscmd_40.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C/C++-Compiler",
        "subtitle": "",
        "version": "V4.0A",
        "type": "Benutzerhandbuch",
        "edition": "2020-06",
        "filelink": "20147/CPP_bhb_40.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CPP",
        "subtitle": "",
        "version": "V4.0",
        "type": "Freigabemitteilung",
        "edition": "2019-11",
        "filelink": "20098/sysfgm.cpp.040.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCCV32en": {
    "spaceProperties": {
      "prodId": "product-cc++",
      "prod": "C/C++",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "C Library Functions",
        "subtitle": "",
        "version": "V3.1B",
        "type": "Reference Manual",
        "edition": "2014-11",
        "filelink": "11879/c_bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C Library Functions",
        "subtitle": "",
        "version": "V3.1A",
        "type": "Reference Manual",
        "edition": "2012-06",
        "filelink": "10825/c_bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C Library Functions",
        "subtitle": "",
        "version": "V2.6A",
        "type": "Reference Manual",
        "edition": "2003-01",
        "filelink": "1121/c_bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C Library Functions",
        "subtitle": "CRTE V10.0B00/V11.0B00",
        "version": "V3.2D",
        "type": "Reference Manual",
        "edition": "2018-06",
        "filelink": "12538/c-bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C Library Functions for POSIX Applications",
        "subtitle": "",
        "version": "V2.5",
        "type": "User Guide",
        "edition": "2001-08",
        "filelink": "1119/c_plib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C Library Functions for POSIX Applications",
        "subtitle": "CRTE V10.0B00/V11.0B00",
        "version": "V3.2D",
        "type": "Reference Manual",
        "edition": "2018-06",
        "filelink": "12536/c-plib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C++ Library Functions",
        "subtitle": "",
        "version": "V2.1",
        "type": "User Guide",
        "edition": "1993-08",
        "filelink": "1111/cpp_bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C/C++ POSIX Commands",
        "subtitle": "",
        "version": "V3.2D",
        "type": "User Guide",
        "edition": "2011-12",
        "filelink": "10462/cpp_pcmd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C/C++ POSIX Commands",
        "subtitle": "",
        "version": "V3.2A",
        "type": "User Guide",
        "edition": "2007-05",
        "filelink": "2770/cpp_pcmd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C/C++ User Guide",
        "subtitle": "",
        "version": "V3.2D",
        "type": "User Guide",
        "edition": "2011-12",
        "filelink": "10461/cpp_bhb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C/C++ User Guide",
        "subtitle": "",
        "version": "V3.2A",
        "type": "User Guide",
        "edition": "2007-05",
        "filelink": "2771/cpp_bhb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CPP",
        "subtitle": "",
        "version": "V3.2",
        "type": "Release Notice",
        "edition": "2018-06",
        "filelink": "5694/sysfgm.cpp.032.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CPP-RS",
        "subtitle": "",
        "version": "V3.2",
        "type": "Release Notice",
        "edition": "2018-06",
        "filelink": "5699/sysfgm.cpp-rs.032.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Loading shared objects in POSIX",
        "subtitle": "",
        "version": "V3.2D",
        "type": "User Guide",
        "edition": "2005-03",
        "filelink": "4571/dynlnk.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Rogue Wave Standard C++ Library",
        "subtitle": "",
        "version": "V1.2",
        "type": "User Guide",
        "edition": "1996-07",
        "filelink": "175/rwslib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Rogue Wave Tools.h++ Class Ref.",
        "subtitle": "",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "1996-03",
        "filelink": "176/rwtcr.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Rogue Wave Tools.h++ User's Guide",
        "subtitle": "",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "1996-03",
        "filelink": "177/rwtug.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCCV32de": {
    "spaceProperties": {
      "prodId": "product-cc++",
      "prod": "C/C++",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "C++-Bibliotheksfunktionen",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1993-08",
        "filelink": "170/cpp_bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C-Bibliotheksfunktionen",
        "subtitle": "",
        "version": "V3.1B",
        "type": "Referenzhandbuch",
        "edition": "2014-11",
        "filelink": "11878/c_bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C-Bibliotheksfunktionen",
        "subtitle": "",
        "version": "V3.1A",
        "type": "Referenzhandbuch",
        "edition": "2012-06",
        "filelink": "10824/c_bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C-Bibliotheksfunktionen",
        "subtitle": "",
        "version": "V2.6A",
        "type": "Referenzhandbuch",
        "edition": "2003-01",
        "filelink": "184/c_bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C-Bibliotheksfunktionen",
        "subtitle": "CRTE V10.0B00/V11.0B00",
        "version": "V3.2D",
        "type": "Referenzhandbuch",
        "edition": "2018-06",
        "filelink": "12537/c-bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C-Bibliotheksfunktionen für POSIX-Anwendungen",
        "subtitle": "",
        "version": "V2.5A",
        "type": "Benutzerhandbuch",
        "edition": "2001-08",
        "filelink": "182/c_plib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C-Bibliotheksfunktionen für POSIX-Anwendungen",
        "subtitle": "CRTE V10.0B00/V11.0B00",
        "version": "V3.2D",
        "type": "Referenzhandbuch",
        "edition": "2018-06",
        "filelink": "12535/c-plib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C/C++ BHB",
        "subtitle": "",
        "version": "V3.2D",
        "type": "Benutzerhandbuch",
        "edition": "2011-12",
        "filelink": "10459/cpp_bhb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C/C++ BHB",
        "subtitle": "",
        "version": "V3.2A",
        "type": "Benutzerhandbuch",
        "edition": "2007-05",
        "filelink": "2056/cpp_bhb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C/C++ POSIX-Kommandos",
        "subtitle": "",
        "version": "V3.2D",
        "type": "Benutzerhandbuch",
        "edition": "2011-12",
        "filelink": "10460/cpp_pcmd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C/C++ POSIX-Kommandos",
        "subtitle": "",
        "version": "V3.2A",
        "type": "Benutzerhandbuch",
        "edition": "2007-05",
        "filelink": "2057/cpp_pcmd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CPP",
        "subtitle": "",
        "version": "V3.2",
        "type": "Freigabemitteilung",
        "edition": "2018-06",
        "filelink": "4820/sysfgm.cpp.032.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CPP-RS",
        "subtitle": "",
        "version": "V3.2",
        "type": "Freigabemitteilung",
        "edition": "2018-06",
        "filelink": "4825/sysfgm.cpp-rs.032.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Laden von Shared Objects in POSIX",
        "subtitle": "",
        "version": "V3.2D",
        "type": "Benutzerhandbuch",
        "edition": "2005-03",
        "filelink": "4570/dynlnk.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCRTEV111en": {
    "spaceProperties": {
      "prodId": "product-crte",
      "prod": "CRTE",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "C Library Functions for POSIX Applications",
        "subtitle": "CRTE V10.1A00/V11.1A00",
        "version": "V4.0A",
        "type": "Reference Manual",
        "edition": "2020-06",
        "filelink": "20282/CPP_poslib_40_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE",
        "subtitle": "",
        "version": "V11.1",
        "type": "Release Notice",
        "edition": "2020-07",
        "filelink": "20262/sysfgm.crte.111.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE",
        "subtitle": "",
        "version": "V11.1",
        "type": "User Guide",
        "edition": "2019-12",
        "filelink": "20134/CRTE_111_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE-BAS",
        "subtitle": "",
        "version": "V11.1",
        "type": "Release Notice",
        "edition": "2020-07",
        "filelink": "20263/sysfgm.crte-bas.111.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCRTEV111de": {
    "spaceProperties": {
      "prodId": "product-crte",
      "prod": "CRTE",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "C++-Bibliotheksfunktionen",
        "subtitle": "",
        "version": "V4.0A",
        "type": "Benutzerhandbuch",
        "edition": "2020-06",
        "filelink": "20143/CPP_cpplib_40.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C-Bibliotheksfunktionen",
        "subtitle": "CRTE V10.1A00/V11.1A00",
        "version": "V4.0A",
        "type": "Referenzhandbuch",
        "edition": "2019-12",
        "filelink": "20144/CPP_clib_40.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C-Bibliotheksfunktionen für POSIX-Anwendungen",
        "subtitle": "CRTE V10.1A00/V11.1A00",
        "version": "V4.0A",
        "type": "Referenzhandbuch",
        "edition": "2019-12",
        "filelink": "20145/CPP_poslib_40.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE",
        "subtitle": "",
        "version": "V11.1",
        "type": "Freigabemitteilung",
        "edition": "2020-07",
        "filelink": "20260/sysfgm.crte.111.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE",
        "subtitle": "",
        "version": "V11.1",
        "type": "Benutzerhandbuch",
        "edition": "2019-12",
        "filelink": "20131/CRTE_111_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE-BAS",
        "subtitle": "",
        "version": "V11.1",
        "type": "Freigabemitteilung",
        "edition": "2020-07",
        "filelink": "20261/sysfgm.crte-bas.111.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCRTEV110en": {
    "spaceProperties": {
      "prodId": "product-crte",
      "prod": "CRTE",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "C Library Functions",
        "subtitle": "CRTE V10.0B00/V11.0B00",
        "version": "V11.0B",
        "type": "Reference Manual",
        "edition": "2018-06",
        "filelink": "12538/c-bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C Library Functions for POSIX Applications",
        "subtitle": "CRTE V10.0B00/V11.0B00",
        "version": "V11.0B",
        "type": "Reference Manual",
        "edition": "2018-06",
        "filelink": "12536/c-plib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C++ Library Functions",
        "subtitle": "",
        "version": "V2.1",
        "type": "User Guide",
        "edition": "1993-08",
        "filelink": "1111/cpp_bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE",
        "subtitle": "",
        "version": "V11.0",
        "type": "Release Notice",
        "edition": "2018-06",
        "filelink": "13391/sysfgm.crte.110.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE",
        "subtitle": "",
        "version": "V11.0",
        "type": "User Guide",
        "edition": "2018-06",
        "filelink": "13238/crte.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE-BAS",
        "subtitle": "",
        "version": "V11.0",
        "type": "Release Notice",
        "edition": "2018-06",
        "filelink": "13393/sysfgm.crte-bas.110.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCRTEV110de": {
    "spaceProperties": {
      "prodId": "product-crte",
      "prod": "CRTE",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "C++-Bibliotheksfunktionen",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1993-08",
        "filelink": "170/cpp_bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C-Bibliotheksfunktionen",
        "subtitle": "CRTE V10.0B00/V11.0B00",
        "version": "V11.0B",
        "type": "Referenzhandbuch",
        "edition": "2018-06",
        "filelink": "12537/c-bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C-Bibliotheksfunktionen für POSIX-Anwendungen",
        "subtitle": "CRTE V10.0B00/V11.0B00",
        "version": "V11.0B",
        "type": "Referenzhandbuch",
        "edition": "2018-06",
        "filelink": "12535/c-plib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE",
        "subtitle": "",
        "version": "V11.0",
        "type": "Freigabemitteilung",
        "edition": "2018-06",
        "filelink": "13390/sysfgm.crte.110.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE",
        "subtitle": "",
        "version": "V11.0",
        "type": "Benutzerhandbuch",
        "edition": "2018-06",
        "filelink": "13237/crte.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE-BAS",
        "subtitle": "",
        "version": "V11.0",
        "type": "Freigabemitteilung",
        "edition": "2018-06",
        "filelink": "13392/sysfgm.crte-bas.110.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCRTEV101en": {
    "spaceProperties": {
      "prodId": "product-crte",
      "prod": "CRTE",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "C Library Functions for POSIX Applications",
        "subtitle": "CRTE V10.1A00/V11.1A00",
        "version": "V4.0A",
        "type": "Reference Manual",
        "edition": "2020-06",
        "filelink": "20282/CPP_poslib_40_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE",
        "subtitle": "",
        "version": "V10.1",
        "type": "Release Notice",
        "edition": "2020-07",
        "filelink": "20264/sysfgm.crte.101.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE",
        "subtitle": "",
        "version": "V10.1",
        "type": "User Guide",
        "edition": "2019-12",
        "filelink": "20133/CRTE_101_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE-BAS",
        "subtitle": "",
        "version": "V10.1",
        "type": "Release Notice",
        "edition": "2020-07",
        "filelink": "20265/sysfgm.crte-bas.101.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCRTEV101de": {
    "spaceProperties": {
      "prodId": "product-crte",
      "prod": "CRTE",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "C++-Bibliotheksfunktionen",
        "subtitle": "",
        "version": "V4.0A",
        "type": "Benutzerhandbuch",
        "edition": "2020-06",
        "filelink": "20143/CPP_cpplib_40.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C-Bibliotheksfunktionen",
        "subtitle": "CRTE V10.1A00/V11.1A00",
        "version": "V4.0A",
        "type": "Referenzhandbuch",
        "edition": "2019-12",
        "filelink": "20144/CPP_clib_40.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C-Bibliotheksfunktionen für POSIX-Anwendungen",
        "subtitle": "CRTE V10.1A00/V11.1A00",
        "version": "V4.0A",
        "type": "Referenzhandbuch",
        "edition": "2019-12",
        "filelink": "20145/CPP_poslib_40.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE",
        "subtitle": "",
        "version": "V10.1",
        "type": "Freigabemitteilung",
        "edition": "2020-07",
        "filelink": "20266/sysfgm.crte.101.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE",
        "subtitle": "",
        "version": "V10.1",
        "type": "Benutzerhandbuch",
        "edition": "2019-12",
        "filelink": "20132/CRTE_101_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE-BAS",
        "subtitle": "",
        "version": "V10.1",
        "type": "Freigabemitteilung",
        "edition": "2020-07",
        "filelink": "20267/sysfgm.crte-bas.101.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCRTEV100en": {
    "spaceProperties": {
      "prodId": "product-crte",
      "prod": "CRTE",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "C Library Functions",
        "subtitle": "CRTE V10.0B00/V11.0B00",
        "version": "V10.0B",
        "type": "Reference Manual",
        "edition": "2018-06",
        "filelink": "12538/c-bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C Library Functions for POSIX Applications",
        "subtitle": "CRTE V10.0B00/V11.0B00",
        "version": "V10.0B",
        "type": "Reference Manual",
        "edition": "2018-06",
        "filelink": "12536/c-plib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C++ Library Functions",
        "subtitle": "",
        "version": "V2.1",
        "type": "User Guide",
        "edition": "1993-08",
        "filelink": "1111/cpp_bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE",
        "subtitle": "",
        "version": "V10.0",
        "type": "Release Notice",
        "edition": "2018-06",
        "filelink": "12121/sysfgm.crte.100.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE",
        "subtitle": "",
        "version": "V10.0B",
        "type": "User Guide",
        "edition": "2018-06",
        "filelink": "12087/crte.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE-BAS",
        "subtitle": "",
        "version": "V10.0",
        "type": "Release Notice",
        "edition": "2018-06",
        "filelink": "12123/sysfgm.crte-bas.100.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCRTEV100de": {
    "spaceProperties": {
      "prodId": "product-crte",
      "prod": "CRTE",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "C++-Bibliotheksfunktionen",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1993-08",
        "filelink": "170/cpp_bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C-Bibliotheksfunktionen",
        "subtitle": "CRTE V10.0B00/V11.0B00",
        "version": "V10.0B",
        "type": "Referenzhandbuch",
        "edition": "2018-06",
        "filelink": "12537/c-bib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "C-Bibliotheksfunktionen für POSIX-Anwendungen",
        "subtitle": "CRTE V10.0B00/V11.0B00",
        "version": "V10.0B",
        "type": "Referenzhandbuch",
        "edition": "2018-06",
        "filelink": "12535/c-plib.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE",
        "subtitle": "",
        "version": "V10.0",
        "type": "Freigabemitteilung",
        "edition": "2018-06",
        "filelink": "12120/sysfgm.crte.100.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE",
        "subtitle": "",
        "version": "V10.0B",
        "type": "Benutzerhandbuch",
        "edition": "2018-06",
        "filelink": "12086/crte.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CRTE-BAS",
        "subtitle": "",
        "version": "V10.0",
        "type": "Freigabemitteilung",
        "edition": "2018-06",
        "filelink": "12122/sysfgm.crte-bas.100.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCRTEV19en": {
    "spaceProperties": {
      "prodId": "product-crte",
      "prod": "CRTE",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "CRTE-BAS",
      "subtitle": "",
      "version": "V1.9",
      "type": "Release Notice",
      "edition": "2017-06",
      "filelink": "10857/sysfgm.crte-bas.019.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psCRTEV19de": {
    "spaceProperties": {
      "prodId": "product-crte",
      "prod": "CRTE",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "CRTE-BAS",
      "subtitle": "",
      "version": "V1.9",
      "type": "Freigabemitteilung",
      "edition": "2017-06",
      "filelink": "10856/sysfgm.crte-bas.019.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psFOR1FORTRANV22en": {
    "spaceProperties": {
      "prodId": "product-for1fortran",
      "prod": "FOR1 (Fortran)",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "FOR1 (BS2000)",
        "subtitle": "Fortran Compiler",
        "version": "V2.2A",
        "type": "User Guide",
        "edition": "1992-01",
        "filelink": "8991/for1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FOR1-LZS",
        "subtitle": "",
        "version": "V2.2",
        "type": "Release Notice",
        "edition": "2010-11",
        "filelink": "5831/sysfgm.for1-lzs.022.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psFOR1FORTRANV22de": {
    "spaceProperties": {
      "prodId": "product-for1fortran",
      "prod": "FOR1 (Fortran)",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "FOR1 (BS2000)",
        "subtitle": "Fortran-Compiler",
        "version": "V2.2A",
        "type": "Benutzerhandbuch",
        "edition": "1992-01",
        "filelink": "8990/for1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FOR1-LZS",
        "subtitle": "",
        "version": "V2.2",
        "type": "Freigabemitteilung",
        "edition": "2010-11",
        "filelink": "4957/sysfgm.for1-lzs.022.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psJENVJAVAV90en": {
    "spaceProperties": {
      "prodId": "product-jenvjava",
      "prod": "JENV (Java)",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "JENV",
        "subtitle": "",
        "version": "V9.0",
        "type": "Release Notice",
        "edition": "2018-06",
        "filelink": "13771/sysfgm.jenv.090.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "JENV",
        "subtitle": "",
        "version": "V9.0",
        "type": "User Guide",
        "edition": "2018-06",
        "filelink": "13783/jenv.V90.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psJENVJAVAV90de": {
    "spaceProperties": {
      "prodId": "product-jenvjava",
      "prod": "JENV (Java)",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "JENV",
        "subtitle": "",
        "version": "V9.0",
        "type": "Freigabemitteilung",
        "edition": "2018-12",
        "filelink": "13923/sysfgm.jenv.090.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "JENV",
        "subtitle": "",
        "version": "V9.0",
        "type": "Benutzerhandbuch",
        "edition": "2018-06",
        "filelink": "13782/jenv.V90.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psJENVJAVAV81en": {
    "spaceProperties": {
      "prodId": "product-jenvjava",
      "prod": "JENV (Java)",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "JENV",
        "subtitle": "",
        "version": "V8.1B",
        "type": "Release Notice",
        "edition": "2019-11",
        "filelink": "20111/sysfgm.jenv.081.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "JENV",
        "subtitle": "",
        "version": "V8.1",
        "type": "User Guide",
        "edition": "2017-03",
        "filelink": "12978/jenv.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psJENVJAVAV81de": {
    "spaceProperties": {
      "prodId": "product-jenvjava",
      "prod": "JENV (Java)",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "JENV",
        "subtitle": "",
        "version": "V8.1B",
        "type": "Freigabemitteilung",
        "edition": "2019-11",
        "filelink": "20110/sysfgm.jenv.081.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "JENV",
        "subtitle": "",
        "version": "V8.1",
        "type": "Benutzerhandbuch",
        "edition": "2017-03",
        "filelink": "12977/jenv.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psPASCALV22en": {
    "spaceProperties": {
      "prodId": "product-pascal",
      "prod": "Pascal",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "PAS-XT-LZS",
        "subtitle": "",
        "version": "V2.2",
        "type": "Release Notice",
        "edition": "2011-02",
        "filelink": "5990/sysfgm.pascal-xt.022.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PASCAL-XT Referece",
        "subtitle": "",
        "version": "V2.2",
        "type": "Reference Manual",
        "edition": "",
        "filelink": "12740/PAS-XT_Reference.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PASCAL-XT User Guide",
        "subtitle": "",
        "version": "V2.2",
        "type": "User Guide",
        "edition": "",
        "filelink": "12741/PAS_XT_UG.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PASCAL-XT-LZS",
        "subtitle": "",
        "version": "V2.2",
        "type": "Release Notice",
        "edition": "2011-02",
        "filelink": "5991/sysfgm.pascal-xt.022.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psPASCALV22de": {
    "spaceProperties": {
      "prodId": "product-pascal",
      "prod": "Pascal",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "PAS-XT-LZS",
        "subtitle": "",
        "version": "V2.2",
        "type": "Freigabemitteilung",
        "edition": "2011-02",
        "filelink": "5116/sysfgm.pascal-xt.022.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PASCAL-XT Beschreibung",
        "subtitle": "",
        "version": "V2.2",
        "type": "Referenzhandbuch",
        "edition": "",
        "filelink": "12738/PAS-XT_Beschreibung.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PASCAL-XT BHB",
        "subtitle": "",
        "version": "V2.2",
        "type": "Benutzerhandbuch",
        "edition": "",
        "filelink": "12739/PAS-XT_BHB.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PASCAL-XT-LZS",
        "subtitle": "",
        "version": "V2.2",
        "type": "Freigabemitteilung",
        "edition": "2011-02",
        "filelink": "5117/sysfgm.pascal-xt.022.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psPERLV524en": {
    "spaceProperties": {
      "prodId": "product-perl",
      "prod": "PERL",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "PERL",
      "subtitle": "",
      "version": "V52.4",
      "type": "Readme File",
      "edition": "2019-11",
      "filelink": "20124/sysrme.perl.524.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psPERLV524de": {
    "spaceProperties": {
      "prodId": "product-perl",
      "prod": "PERL",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "PERL",
      "subtitle": "",
      "version": "V52.4",
      "type": "Readme Datei",
      "edition": "2019-11",
      "filelink": "20104/sysrme.perl.524.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psPERLV58en": {
    "spaceProperties": {
      "prodId": "product-perl",
      "prod": "PERL",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "PERL",
      "subtitle": "",
      "version": "V5.8",
      "type": "Readme File",
      "edition": "2017-05",
      "filelink": "8679/sysrme.perl.058.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psPERLV58de": {
    "spaceProperties": {
      "prodId": "product-perl",
      "prod": "PERL",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "PERL",
      "subtitle": "",
      "version": "V5.8",
      "type": "Readme Datei",
      "edition": "2017-05",
      "filelink": "8678/sysrme.perl.058.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psPERLV13en": {
    "spaceProperties": {
      "prodId": "product-perl",
      "prod": "PERL",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "PERL",
      "subtitle": "",
      "version": "V1.0",
      "type": "Release Notice",
      "edition": "2002-04",
      "filelink": "6011/sysfgm.perl.010.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psPERLV13de": {
    "spaceProperties": {
      "prodId": "product-perl",
      "prod": "PERL",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "PERL",
      "subtitle": "",
      "version": "V1.0",
      "type": "Freigabemitteilung",
      "edition": "2002-04",
      "filelink": "5137/sysfgm.perl.010.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psPERLV10en": {
    "spaceProperties": {
      "prodId": "product-perl",
      "prod": "PERL",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "PERL",
      "subtitle": "",
      "version": "V1.0",
      "type": "Release Notice",
      "edition": "2002-04",
      "filelink": "6011/sysfgm.perl.010.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psPERLV10de": {
    "spaceProperties": {
      "prodId": "product-perl",
      "prod": "PERL",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "PERL",
      "subtitle": "",
      "version": "V1.0",
      "type": "Freigabemitteilung",
      "edition": "2002-04",
      "filelink": "5137/sysfgm.perl.010.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psPL1V42en": {
    "spaceProperties": {
      "prodId": "product-pl1",
      "prod": "PL/1",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "PLI",
        "subtitle": "",
        "version": "V4.2A",
        "type": "Readme File",
        "edition": "2007-01",
        "filelink": "1654/pli1.rme",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "PLI",
        "subtitle": "",
        "version": "V4.1A",
        "type": "User Guide",
        "edition": "1991-05",
        "filelink": "8962/pl1_bhb_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PLI1-LZS",
        "subtitle": "",
        "version": "V4.2",
        "type": "Release Notice",
        "edition": "2009-05",
        "filelink": "6039/sysfgm.pli1.042.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psPL1V42de": {
    "spaceProperties": {
      "prodId": "product-pl1",
      "prod": "PL/1",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "PLI",
        "subtitle": "",
        "version": "V4.2A",
        "type": "Readme Datei",
        "edition": "2007-01",
        "filelink": "701/pli1.rme",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "PLI",
        "subtitle": "",
        "version": "V4.1A",
        "type": "Benutzerhandbuch",
        "edition": "1991-05",
        "filelink": "8961/pl1_bhb_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PLI1-LZS",
        "subtitle": "",
        "version": "V4.2",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "5164/sysfgm.pli1.042.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCRYPTV20en": {
    "spaceProperties": {
      "prodId": "product-crypt",
      "prod": "CRYPT",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "CRYPT",
      "subtitle": "",
      "version": "V2.0",
      "type": "User Guide",
      "edition": "2017-07",
      "filelink": "13262/cryptobox.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psCRYPTV20de": {
    "spaceProperties": {
      "prodId": "product-crypt",
      "prod": "CRYPT",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "CRYPT",
      "subtitle": "",
      "version": "V2.0",
      "type": "Benutzerhandbuch",
      "edition": "2017-07",
      "filelink": "13261/cryptobox.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psIPSECV14en": {
    "spaceProperties": {
      "prodId": "product-ipsec",
      "prod": "IPSec",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "IPSec",
      "subtitle": "Internet Security in BS2000/OSD",
      "version": "V1.4",
      "type": "User Guide",
      "edition": "2010-11",
      "filelink": "9787/ipsec.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psIPSECV14de": {
    "spaceProperties": {
      "prodId": "product-ipsec",
      "prod": "IPSec",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "IPSec",
      "subtitle": "Internet-Sicherheit im BS2000/OSD",
      "version": "V1.4",
      "type": "Benutzerhandbuch",
      "edition": "2010-11",
      "filelink": "9786/ipsec.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psSECOSV55en": {
    "spaceProperties": {
      "prodId": "product-secos",
      "prod": "SECOS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SECOS",
        "subtitle": "",
        "version": "V5.5",
        "type": "Release Notice",
        "edition": "2020-06",
        "filelink": "20257/sysfgm.secos.055.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SECOS - Access Control",
        "subtitle": "",
        "version": "V5.5",
        "type": "User Guide",
        "edition": "2018-03",
        "filelink": "13740/secos_1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SECOS - Audit",
        "subtitle": "",
        "version": "V5.5",
        "type": "User Guide",
        "edition": "2018-03",
        "filelink": "13742/secos_2.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSECOSV55de": {
    "spaceProperties": {
      "prodId": "product-secos",
      "prod": "SECOS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SECOS",
        "subtitle": "",
        "version": "V5.5",
        "type": "Freigabemitteilung",
        "edition": "2020-06",
        "filelink": "20256/sysfgm.secos.055.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SECOS - Beweissicherung",
        "subtitle": "",
        "version": "V5.5",
        "type": "Benutzerhandbuch",
        "edition": "2018-03",
        "filelink": "13741/secos_2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SECOS - Zugangs- und Zugriffskontrolle",
        "subtitle": "",
        "version": "V5.5",
        "type": "Benutzerhandbuch",
        "edition": "2018-03",
        "filelink": "13739/secos_1.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSECOSV54en": {
    "spaceProperties": {
      "prodId": "product-secos",
      "prod": "SECOS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SECOS",
        "subtitle": "",
        "version": "V5.4",
        "type": "Release Notice",
        "edition": "2012-12",
        "filelink": "11155/sysfgm.secos.054.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SECOS",
        "subtitle": "",
        "version": "V5.4",
        "type": "Readme File",
        "edition": "2012-12",
        "filelink": "11153/sysrme.secos.054.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SECOS - Access Control",
        "subtitle": "",
        "version": "V5.4",
        "type": "User Guide",
        "edition": "2010-07",
        "filelink": "9487/secos_1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SECOS - Audit",
        "subtitle": "",
        "version": "V5.4",
        "type": "User Guide",
        "edition": "2010-07",
        "filelink": "9489/secos_2.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSECOSV54de": {
    "spaceProperties": {
      "prodId": "product-secos",
      "prod": "SECOS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SECOS",
        "subtitle": "",
        "version": "V5.4",
        "type": "Freigabemitteilung",
        "edition": "2012-12",
        "filelink": "11154/sysfgm.secos.054.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SECOS",
        "subtitle": "",
        "version": "V5.4",
        "type": "Readme Datei",
        "edition": "2012-12",
        "filelink": "11152/sysrme.secos.054.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SECOS - Beweissicherung",
        "subtitle": "",
        "version": "V5.4",
        "type": "Benutzerhandbuch",
        "edition": "2010-07",
        "filelink": "9488/secos_2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SECOS - Zugangs- und Zugriffskontrolle",
        "subtitle": "",
        "version": "V5.4",
        "type": "Benutzerhandbuch",
        "edition": "2010-07",
        "filelink": "9486/secos_1.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psARCHIVEV120en": {
    "spaceProperties": {
      "prodId": "product-archive",
      "prod": "ARCHIVE",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "ARCHIVE",
      "subtitle": "",
      "version": "V12.0",
      "type": "User Guide",
      "edition": "2019-11",
      "filelink": "20184/ARCHIVE V12.0 Manual-en.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psARCHIVEV120de": {
    "spaceProperties": {
      "prodId": "product-archive",
      "prod": "ARCHIVE",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "ARCHIVE",
      "subtitle": "",
      "version": "V12.0",
      "type": "Benutzerhandbuch",
      "edition": "2019-11",
      "filelink": "20185/ARCHIVE V12.0 Manual-de.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psARCHIVEV110en": {
    "spaceProperties": {
      "prodId": "product-archive",
      "prod": "ARCHIVE",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V11.0",
        "type": "Release Notice",
        "edition": "2019-06",
        "filelink": "20049/SYSFGM.ARCHIVE.110.E.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V11.0",
        "type": "Readme File",
        "edition": "2017-07",
        "filelink": "13431/sysrme.archive.110.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V9.0A",
        "type": "User Guide",
        "edition": "2010-09",
        "filelink": "8149/archive.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psARCHIVEV110de": {
    "spaceProperties": {
      "prodId": "product-archive",
      "prod": "ARCHIVE",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V11.0",
        "type": "Freigabemitteilung",
        "edition": "2019-06",
        "filelink": "20035/SYSFGM.ARCHIVE.110.D.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V11.0",
        "type": "Readme Datei",
        "edition": "2017-07",
        "filelink": "13430/sysrme.archive.110.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V9.0A",
        "type": "Benutzerhandbuch",
        "edition": "2010-09",
        "filelink": "8148/archive.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psARCHIVEV100en": {
    "spaceProperties": {
      "prodId": "product-archive",
      "prod": "ARCHIVE",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V10.0A",
        "type": "Readme File",
        "edition": "2017-06",
        "filelink": "12207/sysrme.archive.100.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V10.0",
        "type": "Release Notice",
        "edition": "2015-11",
        "filelink": "12115/sysfgm.archive.100.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V9.0A",
        "type": "User Guide",
        "edition": "2010-09",
        "filelink": "8149/archive.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psARCHIVEV100de": {
    "spaceProperties": {
      "prodId": "product-archive",
      "prod": "ARCHIVE",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V10.0A",
        "type": "Readme Datei",
        "edition": "2017-06",
        "filelink": "12206/sysrme.archive.100.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V10.0",
        "type": "Freigabemitteilung",
        "edition": "2015-11",
        "filelink": "12114/sysfgm.archive.100.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V9.0A",
        "type": "Benutzerhandbuch",
        "edition": "2010-09",
        "filelink": "8148/archive.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psDRVV32en": {
    "spaceProperties": {
      "prodId": "product-drv",
      "prod": "DRV",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "DRV",
        "subtitle": "",
        "version": "V3.2",
        "type": "User Guide",
        "edition": "2010-09",
        "filelink": "8651/drv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DRV",
        "subtitle": "",
        "version": "V3.2",
        "type": "Release Notice",
        "edition": "2009-05",
        "filelink": "8595/sysfgm.drv.032.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psDRVV32de": {
    "spaceProperties": {
      "prodId": "product-drv",
      "prod": "DRV",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "DRV",
        "subtitle": "",
        "version": "V3.2",
        "type": "Benutzerhandbuch",
        "edition": "2010-09",
        "filelink": "8650/drv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DRV",
        "subtitle": "",
        "version": "V3.2",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "8594/sysfgm.drv.032.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psFDDRLV200en": {
    "spaceProperties": {
      "prodId": "product-fddrl",
      "prod": "FDDRL",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "FDDRL",
        "subtitle": "",
        "version": "V20.0",
        "type": "Release Notice",
        "edition": "2017-06",
        "filelink": "13397/sysfgm.fddrl.200.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FDDRL",
        "subtitle": "",
        "version": "V20.0",
        "type": "User Guide",
        "edition": "2017-06",
        "filelink": "13224/fddrl.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psFDDRLV200de": {
    "spaceProperties": {
      "prodId": "product-fddrl",
      "prod": "FDDRL",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "FDDRL",
        "subtitle": "",
        "version": "V20.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13223/fddrl.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FDDRL",
        "subtitle": "",
        "version": "V20.0",
        "type": "Freigabemitteilung",
        "edition": "2017-06",
        "filelink": "13396/sysfgm.fddrl.200.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psFDDRLV190en": {
    "spaceProperties": {
      "prodId": "product-fddrl",
      "prod": "FDDRL",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "FDDRL",
        "subtitle": "",
        "version": "V19.0",
        "type": "Release Notice",
        "edition": "2015-04",
        "filelink": "12127/sysfgm.fddrl.190.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FDDRL",
        "subtitle": "",
        "version": "V19.0",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12089/fddrl.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psFDDRLV190de": {
    "spaceProperties": {
      "prodId": "product-fddrl",
      "prod": "FDDRL",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "FDDRL",
        "subtitle": "",
        "version": "V19.0",
        "type": "Freigabemitteilung",
        "edition": "2015-04",
        "filelink": "12126/sysfgm.fddrl.190.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FDDRL",
        "subtitle": "",
        "version": "V19.0",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12088/fddrl.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psHSMSV120en": {
    "spaceProperties": {
      "prodId": "product-hsms",
      "prod": "HSMS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V12.0",
        "type": "User Guide",
        "edition": "2019-11",
        "filelink": "20184/ARCHIVE V12.0 Manual-en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS",
        "subtitle": "",
        "version": "V12.0A",
        "type": "Release Notice",
        "edition": "2020-06",
        "filelink": "20254/SYSFGM.HSMS.120.E.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS Volume 1: Functions, Management and Installation",
        "subtitle": "",
        "version": "V12.0A",
        "type": "User Guide",
        "edition": "2020-06",
        "filelink": "20302/HSMS V12.0 Functions-en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS Volume 2: Statements",
        "subtitle": "",
        "version": "V12.0A",
        "type": "User Guide",
        "edition": "2020-06",
        "filelink": "20303/HSMS V12.0 Statements-en.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psHSMSV120de": {
    "spaceProperties": {
      "prodId": "product-hsms",
      "prod": "HSMS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V12.0",
        "type": "Benutzerhandbuch",
        "edition": "2019-11",
        "filelink": "20185/ARCHIVE V12.0 Manual-de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS",
        "subtitle": "",
        "version": "V12.0A",
        "type": "Freigabemitteilung",
        "edition": "2020-06",
        "filelink": "20255/SYSFGM.HSMS.120.D.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS Band 1: Funktionen, Verwaltung und Installation",
        "subtitle": "",
        "version": "V12.0A",
        "type": "Benutzerhandbuch",
        "edition": "2020-06",
        "filelink": "20300/HSMS V12.0 Funktionen-de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS Band 2: Anweisungen",
        "subtitle": "",
        "version": "V12.0A",
        "type": "Benutzerhandbuch",
        "edition": "2020-06",
        "filelink": "20301/HSMS V12.0 Anweisungen-de.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psHSMSV110en": {
    "spaceProperties": {
      "prodId": "product-hsms",
      "prod": "HSMS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V11.0",
        "type": "Release Notice",
        "edition": "2019-06",
        "filelink": "20049/SYSFGM.ARCHIVE.110.E.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V11.0",
        "type": "Readme File",
        "edition": "2017-07",
        "filelink": "13431/sysrme.archive.110.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V9.0A",
        "type": "User Guide",
        "edition": "2010-09",
        "filelink": "8149/archive.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS",
        "subtitle": "",
        "version": "V11.0A",
        "type": "Release Notice",
        "edition": "2019-06",
        "filelink": "20050/SYSFGM.HSMS.110.E.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS Functions",
        "subtitle": "",
        "version": "V11.0",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13242/hsms1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS Statements",
        "subtitle": "",
        "version": "V11.0",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13240/hsms2.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psHSMSV110de": {
    "spaceProperties": {
      "prodId": "product-hsms",
      "prod": "HSMS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V11.0",
        "type": "Freigabemitteilung",
        "edition": "2019-06",
        "filelink": "20035/SYSFGM.ARCHIVE.110.D.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V11.0",
        "type": "Readme Datei",
        "edition": "2017-07",
        "filelink": "13430/sysrme.archive.110.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V9.0A",
        "type": "Benutzerhandbuch",
        "edition": "2010-09",
        "filelink": "8148/archive.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS",
        "subtitle": "",
        "version": "V11.0A",
        "type": "Freigabemitteilung",
        "edition": "2019-06",
        "filelink": "20036/SYSFGM.HSMS.110.D.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS Anweisungen",
        "subtitle": "",
        "version": "V11.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13239/hsms2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS Funktionen",
        "subtitle": "",
        "version": "V11.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13241/hsms1.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psHSMSV100en": {
    "spaceProperties": {
      "prodId": "product-hsms",
      "prod": "HSMS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V10.0A",
        "type": "Readme File",
        "edition": "2017-06",
        "filelink": "12207/sysrme.archive.100.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V10.0",
        "type": "Release Notice",
        "edition": "2015-11",
        "filelink": "12115/sysfgm.archive.100.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V9.0A",
        "type": "User Guide",
        "edition": "2010-09",
        "filelink": "8149/archive.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS",
        "subtitle": "",
        "version": "V10.0",
        "type": "Readme File",
        "edition": "2017-06",
        "filelink": "12816/sysrme.hsms.100.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS",
        "subtitle": "",
        "version": "V10.0",
        "type": "Release Notice",
        "edition": "2015-11",
        "filelink": "12131/sysfgm.hsms.100.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS Functions",
        "subtitle": "",
        "version": "V10.0A",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12095/hsms1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS Statements",
        "subtitle": "",
        "version": "V10.0A",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12093/hsms2.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psHSMSV100de": {
    "spaceProperties": {
      "prodId": "product-hsms",
      "prod": "HSMS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V10.0A",
        "type": "Readme Datei",
        "edition": "2017-06",
        "filelink": "12206/sysrme.archive.100.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V10.0",
        "type": "Freigabemitteilung",
        "edition": "2015-11",
        "filelink": "12114/sysfgm.archive.100.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ARCHIVE",
        "subtitle": "",
        "version": "V9.0A",
        "type": "Benutzerhandbuch",
        "edition": "2010-09",
        "filelink": "8148/archive.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS",
        "subtitle": "",
        "version": "V10.0",
        "type": "Readme Datei",
        "edition": "2017-06",
        "filelink": "12815/sysrme.hsms.100.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS",
        "subtitle": "",
        "version": "V10.0",
        "type": "Freigabemitteilung",
        "edition": "2015-11",
        "filelink": "12130/sysfgm.hsms.100.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS Anweisungen",
        "subtitle": "",
        "version": "V10.0A",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12092/hsms2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HSMS Funktionen",
        "subtitle": "",
        "version": "V10.0A",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12094/hsms1.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psMARENV125en": {
    "spaceProperties": {
      "prodId": "product-maren",
      "prod": "MAREN",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "MAREN",
        "subtitle": "",
        "version": "V12.5",
        "type": "Release Notice",
        "edition": "2017-06",
        "filelink": "13401/sysfgm.maren.125.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MAREN Tape Management in BS2000",
        "subtitle": "Basics and MAREN Application",
        "version": "V12.5",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13378/maren_1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MAREN Tape Management in BS2000",
        "subtitle": "MAREN Administration",
        "version": "V12.5",
        "type": "System Administrator Guide",
        "edition": "2017-07",
        "filelink": "13379/maren_2.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psMARENV125de": {
    "spaceProperties": {
      "prodId": "product-maren",
      "prod": "MAREN",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "MAREN",
        "subtitle": "",
        "version": "V12.5",
        "type": "Freigabemitteilung",
        "edition": "2017-06",
        "filelink": "13400/sysfgm.maren.125.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MAREN Bandverwaltung in BS2000",
        "subtitle": "Grundlagen und MAREN-Anwendung",
        "version": "V12.5",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13186/maren_1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MAREN Bandverwaltung in BS2000",
        "subtitle": "MAREN-Administration",
        "version": "V12.5",
        "type": "Systemverwalterhandbuch",
        "edition": "2017-07",
        "filelink": "13185/maren_2.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psMARENV120en": {
    "spaceProperties": {
      "prodId": "product-maren",
      "prod": "MAREN",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "MAREN",
        "subtitle": "",
        "version": "V12.0B",
        "type": "Readme File",
        "edition": "2017-03",
        "filelink": "11869/sysrme.maren.120.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MAREN",
        "subtitle": "",
        "version": "V12.0",
        "type": "Release Notice",
        "edition": "2013-10",
        "filelink": "11552/sysfgm.maren.120.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MAREN",
        "subtitle": "",
        "version": "V12.0",
        "type": "Release Notice",
        "edition": "2009-05",
        "filelink": "8689/sysfgm.maren.120.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MAREN Volume 1: Basics of MTC Management",
        "subtitle": "",
        "version": "V12.0B",
        "type": "User Guide",
        "edition": "2013-11",
        "filelink": "11529/maren_1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MAREN Volume 1: Basics of MTC Management",
        "subtitle": "",
        "version": "V12.0A",
        "type": "User Guide",
        "edition": "2009-05",
        "filelink": "8615/maren_1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MAREN Volume 2: User Interfaces",
        "subtitle": "",
        "version": "V12.0B",
        "type": "User Guide",
        "edition": "2013-11",
        "filelink": "11531/maren_2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MAREN Volume 2: User Interfaces",
        "subtitle": "",
        "version": "V12.0A",
        "type": "User Guide",
        "edition": "2009-05",
        "filelink": "8617/maren_2.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psMARENV120de": {
    "spaceProperties": {
      "prodId": "product-maren",
      "prod": "MAREN",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "MAREN",
        "subtitle": "",
        "version": "V12.0B",
        "type": "Readme Datei",
        "edition": "2017-03",
        "filelink": "11868/sysrme.maren.120.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MAREN",
        "subtitle": "",
        "version": "V12.0",
        "type": "Freigabemitteilung",
        "edition": "2013-10",
        "filelink": "11551/sysfgm.maren.120.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MAREN",
        "subtitle": "",
        "version": "V12.0",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "8688/sysfgm.maren.120.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MAREN Band 1: Grundlagen der MBK-Verwaltung",
        "subtitle": "",
        "version": "V12.0B",
        "type": "Benutzerhandbuch",
        "edition": "2013-11",
        "filelink": "11528/maren_1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MAREN Band 1: Grundlagen der MBK-Verwaltung",
        "subtitle": "",
        "version": "V12.0A",
        "type": "Benutzerhandbuch",
        "edition": "2009-05",
        "filelink": "8614/maren_1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MAREN Band 2: Benutzerschnittstellen",
        "subtitle": "",
        "version": "V12.0B",
        "type": "Benutzerhandbuch",
        "edition": "2013-11",
        "filelink": "11530/maren_2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "MAREN Band 2: Benutzerschnittstellen",
        "subtitle": "",
        "version": "V12.0A",
        "type": "Benutzerhandbuch",
        "edition": "2009-05",
        "filelink": "8616/maren_2.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psROBARV76en": {
    "spaceProperties": {
      "prodId": "product-robar",
      "prod": "ROBAR",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ROBAR",
        "subtitle": "",
        "version": "V7.5",
        "type": "User Guide",
        "edition": "2016-12",
        "filelink": "12955/robar.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ROBAR-CL",
        "subtitle": "",
        "version": "V7.6A",
        "type": "Release Notice",
        "edition": "2019-11",
        "filelink": "20126/sysfgm.robar-cl.076.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ROBAR-SV",
        "subtitle": "",
        "version": "V7.6A",
        "type": "Release Notice",
        "edition": "2020-01",
        "filelink": "20197/sysfgm.robar-sv.076.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psROBARV76de": {
    "spaceProperties": {
      "prodId": "product-robar",
      "prod": "ROBAR",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ROBAR",
        "subtitle": "",
        "version": "V7.5",
        "type": "Benutzerhandbuch",
        "edition": "2016-12",
        "filelink": "12954/robar.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ROBAR-CL",
        "subtitle": "",
        "version": "V7.6A",
        "type": "Freigabemitteilung",
        "edition": "2019-11",
        "filelink": "20105/sysfgm.robar-cl.076.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ROBAR-SV",
        "subtitle": "",
        "version": "V7.6A",
        "type": "Freigabemitteilung",
        "edition": "2020-01",
        "filelink": "20196/sysfgm.robar-sv.076.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psROBARV75en": {
    "spaceProperties": {
      "prodId": "product-robar",
      "prod": "ROBAR",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ROBAR",
        "subtitle": "",
        "version": "V7.5",
        "type": "User Guide",
        "edition": "2016-12",
        "filelink": "12955/robar.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ROBAR-CL",
        "subtitle": "",
        "version": "V7.5",
        "type": "Release Notice",
        "edition": "2018-05",
        "filelink": "12983/sysfgm.robar-cl.075.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ROBAR-SV",
        "subtitle": "",
        "version": "V7.5B",
        "type": "Release Notice",
        "edition": "2019-04",
        "filelink": "12985/sysfgm.robar-sv.075.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psROBARV75de": {
    "spaceProperties": {
      "prodId": "product-robar",
      "prod": "ROBAR",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ROBAR",
        "subtitle": "",
        "version": "V7.5",
        "type": "Benutzerhandbuch",
        "edition": "2016-12",
        "filelink": "12954/robar.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ROBAR-CL",
        "subtitle": "",
        "version": "V7.5",
        "type": "Freigabemitteilung",
        "edition": "2018-05",
        "filelink": "12982/sysfgm.robar-cl.075.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ROBAR-SV",
        "subtitle": "",
        "version": "V7.5B",
        "type": "Freigabemitteilung",
        "edition": "2019-04",
        "filelink": "12984/sysfgm.robar-sv.075.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psROBARV70en": {
    "spaceProperties": {
      "prodId": "product-robar",
      "prod": "ROBAR",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ROBAR",
        "subtitle": "",
        "version": "V7.0A",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12103/robar.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ROBAR-CL",
        "subtitle": "",
        "version": "V7.0",
        "type": "Release Notice",
        "edition": "2018-05",
        "filelink": "12152/sysfgm.robar-cl.070.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ROBAR-CL",
        "subtitle": "",
        "version": "V7.0A",
        "type": "Readme File",
        "edition": "2016-04",
        "filelink": "12545/sysrme.robar-cl.070.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ROBAR-SV",
        "subtitle": "",
        "version": "V7.0",
        "type": "Release Notice",
        "edition": "2016-10",
        "filelink": "12153/sysfgm.robar-sv.070.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psROBARV70de": {
    "spaceProperties": {
      "prodId": "product-robar",
      "prod": "ROBAR",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ROBAR",
        "subtitle": "",
        "version": "V7.0A",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12102/robar.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ROBAR-CL",
        "subtitle": "",
        "version": "V7.0",
        "type": "Freigabemitteilung",
        "edition": "2018-05",
        "filelink": "12151/sysfgm.robar-cl.070.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ROBAR-CL",
        "subtitle": "",
        "version": "V7.0A",
        "type": "Readme Datei",
        "edition": "2016-04",
        "filelink": "12544/sysrme.robar-cl.070.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ROBAR-SV",
        "subtitle": "",
        "version": "V7.0",
        "type": "Freigabemitteilung",
        "edition": "2016-10",
        "filelink": "12150/sysfgm.robar-sv.070.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSHCOSDV140en": {
    "spaceProperties": {
      "prodId": "product-shcosd",
      "prod": "SHC-OSD",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SHC-OSD",
        "subtitle": "",
        "version": "V14.0A",
        "type": "Release Notice",
        "edition": "2020-04",
        "filelink": "20229/SYSFGM.SHC-OSD.140.E.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SHC-OSD",
        "subtitle": "Storage Management for BS2000",
        "version": "V14.0A",
        "type": "User Guide",
        "edition": "2020-04",
        "filelink": "20228/SHC-OSD_Manual_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (StorMan)",
        "subtitle": "",
        "version": "V9.0.0",
        "type": "Release Notice",
        "edition": "2020-04",
        "filelink": "20232/StorManReleaseNotice_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (StorMan)",
        "subtitle": "Provisioning and managing virtualized storage resources",
        "version": "V9.0.0",
        "type": "User Guide",
        "edition": "2020-04",
        "filelink": "20233/STORMAN_Manual_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSHCOSDV140de": {
    "spaceProperties": {
      "prodId": "product-shcosd",
      "prod": "SHC-OSD",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SHC-OSD",
        "subtitle": "",
        "version": "V14.0A",
        "type": "Freigabemitteilung",
        "edition": "2020-04",
        "filelink": "20226/SYSFGM.SHC-OSD.140.D.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SHC-OSD",
        "subtitle": "Storage Management für BS2000",
        "version": "V14.0A",
        "type": "Benutzerhandbuch",
        "edition": "2020-04",
        "filelink": "20227/SHC-OSD_Manual_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (StorMan)",
        "subtitle": "",
        "version": "V9.0.0",
        "type": "Freigabemitteilung",
        "edition": "2020-04",
        "filelink": "20230/StorManReleaseNotice_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (StorMan)",
        "subtitle": "Bereitstellung und Verwaltung von virtualisierten Speicherressourcen",
        "version": "V9.0.0",
        "type": "Benutzerhandbuch",
        "edition": "2020-04",
        "filelink": "20231/STORMAN_Manual_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSHCOSDV130en": {
    "spaceProperties": {
      "prodId": "product-shcosd",
      "prod": "SHC-OSD",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SHC-OSD",
        "subtitle": "",
        "version": "V13.0C",
        "type": "Readme File",
        "edition": "2019-01",
        "filelink": "13953/sysrme..shc-osd.130.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SHC-OSD",
        "subtitle": "",
        "version": "V13.0C",
        "type": "Release Notice",
        "edition": "2019-01",
        "filelink": "13642/sysfgm.shc-osd.130.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SHC-OSD",
        "subtitle": "Storage Management for BS2000",
        "version": "V13.0",
        "type": "User Guide",
        "edition": "2018-04",
        "filelink": "13614/shc-osd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager  (StorMan)",
        "subtitle": "Provisioning and managing virtualized storage resources",
        "version": "V8.0.1",
        "type": "User Guide",
        "edition": "2018-04",
        "filelink": "13632/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (StorMan)",
        "subtitle": "",
        "version": "V8.0",
        "type": "Release Notice",
        "edition": "2019-01",
        "filelink": "13644/sysfgm.storman.080.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSHCOSDV130de": {
    "spaceProperties": {
      "prodId": "product-shcosd",
      "prod": "SHC-OSD",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SHC-OSD",
        "subtitle": "",
        "version": "V13.0C",
        "type": "Freigabemitteilung",
        "edition": "2019-01",
        "filelink": "13641/sysfgm.shc-osd.130.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SHC-OSD",
        "subtitle": "",
        "version": "V13.0C",
        "type": "Readme Datei",
        "edition": "2019-01",
        "filelink": "13952/sysrme..shc-osd.130.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SHC-OSD",
        "subtitle": "Storage Management für BS2000",
        "version": "V13.0",
        "type": "Benutzerhandbuch",
        "edition": "2018-04",
        "filelink": "13613/shc-osd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager  (StorMan)",
        "subtitle": "Bereitstellung und Verwaltung von virtualisierten Speicherressourcen",
        "version": "V8.0.1",
        "type": "Benutzerhandbuch",
        "edition": "2018-04",
        "filelink": "13631/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (StorMan)",
        "subtitle": "",
        "version": "V8.0",
        "type": "Freigabemitteilung",
        "edition": "2019-01",
        "filelink": "13643/sysfgm.storman.080.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSHCOSDV120en": {
    "spaceProperties": {
      "prodId": "product-shcosd",
      "prod": "SHC-OSD",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SHC-OSD",
        "subtitle": "",
        "version": "V12.0",
        "type": "Release Notice",
        "edition": "2017-10",
        "filelink": "12842/sysfgm.shc-osd.120.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SHC-OSD",
        "subtitle": "Storage Management for BS2000",
        "version": "V12.0",
        "type": "User Guide",
        "edition": "2016-06",
        "filelink": "12737/shc-osd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager  (StorMan)",
        "subtitle": "Provisioning and managing virtualized storage resources",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "2016-06",
        "filelink": "12804/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (StorMan)",
        "subtitle": "",
        "version": "V7.0",
        "type": "Release Notice",
        "edition": "2016-11",
        "filelink": "12843/sysfgm.storman.070.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSHCOSDV120de": {
    "spaceProperties": {
      "prodId": "product-shcosd",
      "prod": "SHC-OSD",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SHC-OSD",
        "subtitle": "",
        "version": "V12.0",
        "type": "Freigabemitteilung",
        "edition": "2017-10",
        "filelink": "12841/sysfgm.shc-osd.120.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SHC-OSD",
        "subtitle": "Storage Management für BS2000",
        "version": "V12.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-06",
        "filelink": "12735/shc-osd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager  (StorMan)",
        "subtitle": "Bereitstellung und Verwaltung von virtualisierten Speicherressourcen",
        "version": "V7.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-06",
        "filelink": "12835/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSPACEOPTV80en": {
    "spaceProperties": {
      "prodId": "product-spaceopt",
      "prod": "SPACEOPT",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SPACEOPT",
        "subtitle": "",
        "version": "V8.0",
        "type": "Release Notice",
        "edition": "2017-07",
        "filelink": "13423/sysfgm.spaceopt.080.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPACEOPT",
        "subtitle": "",
        "version": "V7.0A",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12091/spaceopt.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSPACEOPTV80de": {
    "spaceProperties": {
      "prodId": "product-spaceopt",
      "prod": "SPACEOPT",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SPACEOPT",
        "subtitle": "",
        "version": "V8.0",
        "type": "Freigabemitteilung",
        "edition": "2017-07",
        "filelink": "13422/sysfgm.spaceopt.080.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPACEOPT",
        "subtitle": "",
        "version": "V7.0A",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12090/spaceopt.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSPACEOPTV70en": {
    "spaceProperties": {
      "prodId": "product-spaceopt",
      "prod": "SPACEOPT",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SPACEOPT",
        "subtitle": "",
        "version": "V7.0",
        "type": "Release Notice",
        "edition": "2015-04",
        "filelink": "12145/sysfgm.spaceopt.070.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPACEOPT",
        "subtitle": "",
        "version": "V7.0A",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12091/spaceopt.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSPACEOPTV70de": {
    "spaceProperties": {
      "prodId": "product-spaceopt",
      "prod": "SPACEOPT",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SPACEOPT",
        "subtitle": "",
        "version": "V7.0",
        "type": "Freigabemitteilung",
        "edition": "2015-04",
        "filelink": "12144/sysfgm.spaceopt.070.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SPACEOPT",
        "subtitle": "",
        "version": "V7.0A",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12090/spaceopt.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psHIPLEXMSCFV110en": {
    "spaceProperties": {
      "prodId": "product-hiplexmscf",
      "prod": "HIPLEX-MSCF",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "HILPLEX MSCF",
        "subtitle": "",
        "version": "V6.0",
        "type": "User Guide",
        "edition": "2010-11",
        "filelink": "9842/mscf.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HIPLEX MSCF",
        "subtitle": "",
        "version": "V11.0",
        "type": "Release Notice",
        "edition": "2017-02",
        "filelink": "13403/sysfgm.mscf.200.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HIPLEX MSCF",
        "subtitle": "",
        "version": "V11.0",
        "type": "Readme File",
        "edition": "2016-10",
        "filelink": "13433/sysrme.mscf.200.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psHIPLEXMSCFV110de": {
    "spaceProperties": {
      "prodId": "product-hiplexmscf",
      "prod": "HIPLEX-MSCF",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "HILPLEX MSCF",
        "subtitle": "",
        "version": "V6.0",
        "type": "Benutzerhandbuch",
        "edition": "2010-11",
        "filelink": "9841/mscf.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HIPLEX MSCF",
        "subtitle": "",
        "version": "V11.0",
        "type": "Freigabemitteilung",
        "edition": "2017-02",
        "filelink": "13402/sysfgm.mscf.200.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HIPLEX MSCF",
        "subtitle": "",
        "version": "V11.0",
        "type": "Readme Datei",
        "edition": "2016-10",
        "filelink": "13432/sysrme.mscf.200.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psHIPLEXMSCFV80en": {
    "spaceProperties": {
      "prodId": "product-hiplexmscf",
      "prod": "HIPLEX-MSCF",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "HILPLEX MSCF",
        "subtitle": "",
        "version": "V6.0",
        "type": "User Guide",
        "edition": "2010-11",
        "filelink": "9842/mscf.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HIPLEX MSCF",
        "subtitle": "",
        "version": "V8.0",
        "type": "Release Notice",
        "edition": "2014-12",
        "filelink": "12135/sysfgm.mscf.190.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HIPLEX MSCF",
        "subtitle": "",
        "version": "V8.0",
        "type": "Readme File",
        "edition": "2013-11",
        "filelink": "12175/sysrme.mscf.190.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psHIPLEXMSCFV80de": {
    "spaceProperties": {
      "prodId": "product-hiplexmscf",
      "prod": "HIPLEX-MSCF",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "HILPLEX MSCF",
        "subtitle": "",
        "version": "V6.0",
        "type": "Benutzerhandbuch",
        "edition": "2010-11",
        "filelink": "9841/mscf.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HIPLEX MSCF",
        "subtitle": "",
        "version": "V8.0",
        "type": "Freigabemitteilung",
        "edition": "2014-12",
        "filelink": "12134/sysfgm.mscf.190.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "HIPLEX MSCF",
        "subtitle": "",
        "version": "V8.0",
        "type": "Readme Datei",
        "edition": "2013-11",
        "filelink": "12174/sysrme.mscf.190.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOMNISV85en": {
    "spaceProperties": {
      "prodId": "product-omnis",
      "prod": "OMNIS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "OMNIS",
        "subtitle": "",
        "version": "V8.5",
        "type": "Release Notice",
        "edition": "2011-01",
        "filelink": "9602/sysfgm.omnis.085.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "OMNIS/-MENU Administration",
        "subtitle": "",
        "version": "V8.5",
        "type": "System Administrator Guide",
        "edition": "2015-04",
        "filelink": "12097/omnis_ad.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "OMNIS/-MENU Functions",
        "subtitle": "",
        "version": "V8.5",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12099/omnis_fk.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOMNISV85de": {
    "spaceProperties": {
      "prodId": "product-omnis",
      "prod": "OMNIS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "OMNIS",
        "subtitle": "",
        "version": "V8.5",
        "type": "Freigabemitteilung",
        "edition": "2011-01",
        "filelink": "9601/sysfgm.omnis.085.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "OMNIS/-MENU Administration",
        "subtitle": "",
        "version": "V8.5",
        "type": "Systemverwalterhandbuch",
        "edition": "2015-04",
        "filelink": "12096/omnis_ad.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "OMNIS/-MENU Funktionen",
        "subtitle": "",
        "version": "V8.5",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12098/omnis_fk.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOMNISMENUV35en": {
    "spaceProperties": {
      "prodId": "product-omnismenu",
      "prod": "OMNIS-MENU",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "OMNIS-MENU",
        "subtitle": "",
        "version": "V3.5",
        "type": "Release Notice",
        "edition": "2011-01",
        "filelink": "9603/sysfgm.omnis-menu.035.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "OMNIS/-MENU Administration",
        "subtitle": "",
        "version": "V8.5",
        "type": "System Administrator Guide",
        "edition": "2015-04",
        "filelink": "12097/omnis_ad.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "OMNIS/-MENU Functions",
        "subtitle": "",
        "version": "V8.5",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12099/omnis_fk.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOMNISMENUV35de": {
    "spaceProperties": {
      "prodId": "product-omnismenu",
      "prod": "OMNIS-MENU",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "OMNIS-MENU",
        "subtitle": "",
        "version": "V3.5",
        "type": "Freigabemitteilung",
        "edition": "2011-01",
        "filelink": "9604/sysfgm.omnis-menu.035.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "OMNIS/-MENU Administration",
        "subtitle": "",
        "version": "V8.5",
        "type": "Systemverwalterhandbuch",
        "edition": "2015-04",
        "filelink": "12096/omnis_ad.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "OMNIS/-MENU Funktionen",
        "subtitle": "",
        "version": "V8.5",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12098/omnis_fk.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psPROPXTV13en": {
    "spaceProperties": {
      "prodId": "product-propxt",
      "prod": "PROP-XT",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "PROP-XT",
        "subtitle": "",
        "version": "V1.3",
        "type": "Release Notice",
        "edition": "2009-05",
        "filelink": "8705/sysfgm.prop-xt.013.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PROP-XT",
        "subtitle": "",
        "version": "V1.1A",
        "type": "User Guide",
        "edition": "1995-07",
        "filelink": "1657/prop_xt.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psPROPXTV13de": {
    "spaceProperties": {
      "prodId": "product-propxt",
      "prod": "PROP-XT",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "PROP-XT",
        "subtitle": "",
        "version": "V1.3",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "8704/sysfgm.prop-xt.013.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PROP-XT",
        "subtitle": "",
        "version": "V1.1A",
        "type": "Benutzerhandbuch",
        "edition": "1995-07",
        "filelink": "704/prop_xt.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSBABS2V62en": {
    "spaceProperties": {
      "prodId": "product-sbabs2",
      "prod": "SBA-BS2",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SBA-BS2",
        "subtitle": "",
        "version": "V6.2",
        "type": "Release Notice",
        "edition": "2009-05",
        "filelink": "8717/sysfgm.sba-bs2.062.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SBA-BS2",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Readme File",
        "edition": "2009-04",
        "filelink": "8677/sysrme.sba-bs2.062a.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "SNMP Management",
        "subtitle": "",
        "version": "V6.0A",
        "type": "User Guide",
        "edition": "2002-07",
        "filelink": "3182/snmp.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SNMP Management",
        "subtitle": "",
        "version": "V5.0",
        "type": "User Guide",
        "edition": "2000-07",
        "filelink": "1270/snmp.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSBABS2V62de": {
    "spaceProperties": {
      "prodId": "product-sbabs2",
      "prod": "SBA-BS2",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SBA-BS2",
        "subtitle": "",
        "version": "V6.2",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "8716/sysfgm.sba-bs2.062.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SBA-BS2",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Readme Datei",
        "edition": "2009-04",
        "filelink": "8676/sysrme.sba-bs2.062a.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "SNMP Management",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Benutzerhandbuch",
        "edition": "2002-07",
        "filelink": "4455/snmp.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SNMP Management",
        "subtitle": "",
        "version": "V5.0",
        "type": "Benutzerhandbuch",
        "edition": "2000-07",
        "filelink": "340/snmp.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSNMPAGENTSV11en": {
    "spaceProperties": {
      "prodId": "product-snmpagents",
      "prod": "SNMP-AGENTS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SNMP Agents",
        "subtitle": "",
        "version": "V1.1",
        "type": "Release Notice",
        "edition": "2020-07",
        "filelink": "20245/sysfgm.snmp-agents.011.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SNMP Management (NET-SNMP) for BS2000",
        "subtitle": "",
        "version": "V1.1",
        "type": "User Guide",
        "edition": "2020-06",
        "filelink": "20243/SNMP_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSNMPAGENTSV11de": {
    "spaceProperties": {
      "prodId": "product-snmpagents",
      "prod": "SNMP-AGENTS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SNMP Agents",
        "subtitle": "",
        "version": "V1.1",
        "type": "Freigabemitteilung",
        "edition": "2020-07",
        "filelink": "20244/sysfgm.snmp-agents.011.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SNMP Management (NET-SNMP) für BS2000",
        "subtitle": "",
        "version": "V1.1",
        "type": "Benutzerhandbuch",
        "edition": "2020-06",
        "filelink": "20242/SNMP_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSNMPAGENTSV10en": {
    "spaceProperties": {
      "prodId": "product-snmpagents",
      "prod": "SNMP-AGENTS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SNMP Agents",
        "subtitle": "",
        "version": "V1.0",
        "type": "Release Notice",
        "edition": "2019-01",
        "filelink": "13940/sysfgm.snmp-agents.010.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SNMP Management (NET-SNMP) for BS2000",
        "subtitle": "",
        "version": "V1.0",
        "type": "User Guide",
        "edition": "2019-01",
        "filelink": "13943/snmps.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSNMPAGENTSV10de": {
    "spaceProperties": {
      "prodId": "product-snmpagents",
      "prod": "SNMP-AGENTS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SNMP Agents",
        "subtitle": "",
        "version": "V1.0",
        "type": "Freigabemitteilung",
        "edition": "2019-01",
        "filelink": "13939/sysfgm.snmp-agents.010.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SNMP Management (NET-SNMP) für BS2000",
        "subtitle": "",
        "version": "V1.0",
        "type": "Benutzerhandbuch",
        "edition": "2019-01",
        "filelink": "13942/snmps.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSSASM2BS2V50en": {
    "spaceProperties": {
      "prodId": "product-ssasm2bs2",
      "prod": "SSA-SM2-BS2",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "SSA-SM2-BS2",
      "subtitle": "",
      "version": "V5.0",
      "type": "Release Notice",
      "edition": "2018-01",
      "filelink": "6325/sysfgm.ssa-sm2-bs2.050.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psSSASM2BS2V50de": {
    "spaceProperties": {
      "prodId": "product-ssasm2bs2",
      "prod": "SSA-SM2-BS2",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "SSA-SM2-BS2",
      "subtitle": "",
      "version": "V5.0",
      "type": "Freigabemitteilung",
      "edition": "2018-01",
      "filelink": "5452/sysfgm.ssa-sm2-bs2.050.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psSSAOUTMBS2V50en": {
    "spaceProperties": {
      "prodId": "product-ssaoutmbs2",
      "prod": "SSA-OUTM-BS2",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SSA-OUTM-BS2",
        "subtitle": "",
        "version": "V5.0",
        "type": "Release Notice",
        "edition": "2009-05",
        "filelink": "6322/sysfgm.ssa-outm-bs2.050.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SSA-OUTM-BS2",
        "subtitle": "",
        "version": "V5.0A",
        "type": "Readme File",
        "edition": "2001-11",
        "filelink": "3181/ssa_outm.rme",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psSSAOUTMBS2V50de": {
    "spaceProperties": {
      "prodId": "product-ssaoutmbs2",
      "prod": "SSA-OUTM-BS2",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "SSA-OUTM-BS2",
        "subtitle": "",
        "version": "V5.0",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "5449/sysfgm.ssa-outm-bs2.050.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SSA-OUTM-BS2",
        "subtitle": "",
        "version": "V5.0A",
        "type": "Readme Datei",
        "edition": "2001-11",
        "filelink": "4454/ssa_outm.rme",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psSSCBS2V60en": {
    "spaceProperties": {
      "prodId": "product-sscbs2",
      "prod": "SSC-BS2",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "SSC-BS2",
      "subtitle": "",
      "version": "V6.0",
      "type": "Release Notice",
      "edition": "2009-05",
      "filelink": "6326/sysfgm.ssc-bs2.060.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psSSCBS2V60de": {
    "spaceProperties": {
      "prodId": "product-sscbs2",
      "prod": "SSC-BS2",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "SSC-BS2",
      "subtitle": "",
      "version": "V6.0",
      "type": "Freigabemitteilung",
      "edition": "2009-05",
      "filelink": "5453/sysfgm.ssc-bs2.060.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psVM2000V115en": {
    "spaceProperties": {
      "prodId": "product-vm2000",
      "prod": "VM2000",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "VM2000",
        "subtitle": "",
        "version": "V11.5",
        "type": "User Guide",
        "edition": "2017-10",
        "filelink": "13184/vm2000.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VM2000-MON",
        "subtitle": "",
        "version": "V11.5",
        "type": "Release Notice",
        "edition": "2020-06",
        "filelink": "20248/SYSFGM.VM2000-MON.115.E.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psVM2000V115de": {
    "spaceProperties": {
      "prodId": "product-vm2000",
      "prod": "VM2000",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "VM2000",
        "subtitle": "",
        "version": "V11.5",
        "type": "Benutzerhandbuch",
        "edition": "2017-10",
        "filelink": "13183/vm2000.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VM2000-MON",
        "subtitle": "",
        "version": "V11.5",
        "type": "Freigabemitteilung",
        "edition": "2020-06",
        "filelink": "20249/SYSFGM.VM2000-MON.115.D.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psVM2000V110en": {
    "spaceProperties": {
      "prodId": "product-vm2000",
      "prod": "VM2000",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "VM2000",
        "subtitle": "",
        "version": "V11.0",
        "type": "User Guide",
        "edition": "2015-06",
        "filelink": "12298/vm2000.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VM2000-MON",
        "subtitle": "",
        "version": "V11.0",
        "type": "Release Notice",
        "edition": "2019-10",
        "filelink": "20128/SYSFGM.VM2000-MON.110.E.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psVM2000V110de": {
    "spaceProperties": {
      "prodId": "product-vm2000",
      "prod": "VM2000",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "VM2000",
        "subtitle": "",
        "version": "V11.0",
        "type": "Benutzerhandbuch",
        "edition": "2015-06",
        "filelink": "12245/vm2000.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VM2000-MON",
        "subtitle": "",
        "version": "V11.0",
        "type": "Freigabemitteilung",
        "edition": "2019-10",
        "filelink": "20107/SYSFGM.VM2000-MON.110.D.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psVM2000V100en": {
    "spaceProperties": {
      "prodId": "product-vm2000",
      "prod": "VM2000",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "VM2000",
        "subtitle": "",
        "version": "V10.0",
        "type": "User Guide",
        "edition": "2012-09",
        "filelink": "10724/vm2000.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VM2000-MON",
        "subtitle": "",
        "version": "V10.0",
        "type": "Release Notice",
        "edition": "2017-06",
        "filelink": "11013/sysfgm.vm2000-mon.100.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psVM2000V100de": {
    "spaceProperties": {
      "prodId": "product-vm2000",
      "prod": "VM2000",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "VM2000",
        "subtitle": "",
        "version": "V10.0",
        "type": "Benutzerhandbuch",
        "edition": "2012-09",
        "filelink": "10723/vm2000.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VM2000-MON",
        "subtitle": "",
        "version": "V10.0",
        "type": "Freigabemitteilung",
        "edition": "2017-06",
        "filelink": "11012/sysfgm.vm2000-mon.100.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCISV120en": {
    "spaceProperties": {
      "prodId": "product-cis",
      "prod": "CIS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "CIS (German)",
        "subtitle": "",
        "version": "V12.0",
        "type": "Readme File",
        "edition": "2020-04",
        "filelink": "20294/CIS_Readme-Datei.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CIS - Diagnosehilfe (German)",
        "subtitle": "",
        "version": "V12.0",
        "type": "User Guide",
        "edition": "2020-04",
        "filelink": "20299/CIS_Manual5_Diagnosehilfe.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CIS - Dienstprogramme (German)",
        "subtitle": "",
        "version": "V12.0",
        "type": "User Guide",
        "edition": "2020-04",
        "filelink": "20296/CIS_Manual2_Dienstprogramme.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CIS - Einführung (German)",
        "subtitle": "",
        "version": "V12.0",
        "type": "User Guide",
        "edition": "2020-04",
        "filelink": "20295/CIS_Manual1_Einfuehrung.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CIS - Kommandos (German)",
        "subtitle": "",
        "version": "V12.0",
        "type": "User Guide",
        "edition": "2020-04",
        "filelink": "20297/CIS_Manual3_Kommandos.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CIS - Schnittstellen (German)",
        "subtitle": "",
        "version": "V12.0",
        "type": "User Guide",
        "edition": "2020-04",
        "filelink": "20298/CIS_Manual4_Schnittstellen.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psCISV120de": {
    "spaceProperties": {
      "prodId": "product-cis",
      "prod": "CIS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "CIS",
        "subtitle": "",
        "version": "V12.0",
        "type": "Readme Datei",
        "edition": "2020-04",
        "filelink": "20294/CIS_Readme-Datei.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CIS - Diagnosehilfe",
        "subtitle": "",
        "version": "V12.0",
        "type": "Benutzerhandbuch",
        "edition": "2020-04",
        "filelink": "20299/CIS_Manual5_Diagnosehilfe.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CIS - Dienstprogramme",
        "subtitle": "",
        "version": "V12.0",
        "type": "Benutzerhandbuch",
        "edition": "2020-04",
        "filelink": "20296/CIS_Manual2_Dienstprogramme.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CIS - Einführung",
        "subtitle": "",
        "version": "V12.0",
        "type": "Benutzerhandbuch",
        "edition": "2020-04",
        "filelink": "20295/CIS_Manual1_Einfuehrung.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CIS - Kommandos",
        "subtitle": "",
        "version": "V12.0",
        "type": "Benutzerhandbuch",
        "edition": "2020-04",
        "filelink": "20297/CIS_Manual3_Kommandos.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CIS - Schnittstellen",
        "subtitle": "",
        "version": "V12.0",
        "type": "Benutzerhandbuch",
        "edition": "2020-04",
        "filelink": "20298/CIS_Manual4_Schnittstellen.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psDRIVECOMPV31en": {
    "spaceProperties": {
      "prodId": "product-drivecomp",
      "prod": "DRIVE-COMP",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "DRIVE-COMP-DOC",
        "subtitle": "",
        "version": "V3.1",
        "type": "Release Notice",
        "edition": "2012-04",
        "filelink": "5778/sysfgm.drive-comp-doc.031.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DRIVE/WINDOWS-COMP",
        "subtitle": "",
        "version": "V3.1B",
        "type": "Readme File",
        "edition": "",
        "filelink": "2786/sysrme.drive-comp-doc.031a.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "DRIVE/WINDOWS-COMP",
        "subtitle": "",
        "version": "V2.1B",
        "type": "Readme File",
        "edition": "",
        "filelink": "2785/drv_comp.rme",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psDRIVECOMPV31de": {
    "spaceProperties": {
      "prodId": "product-drivecomp",
      "prod": "DRIVE-COMP",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "DRIVE-COMP-DOC",
        "subtitle": "",
        "version": "V3.1",
        "type": "Freigabemitteilung",
        "edition": "2012-04",
        "filelink": "4904/sysfgm.drive-comp-doc.031.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DRIVE/WIN Compiler",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1996-06",
        "filelink": "250/drv_comp.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DRIVE/WINDOWS-COMP",
        "subtitle": "",
        "version": "V3.1B",
        "type": "Readme Datei",
        "edition": "",
        "filelink": "2074/sysrme.drive-comp-doc.031a.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "DRIVE/WINDOWS-COMP",
        "subtitle": "",
        "version": "V2.1B",
        "type": "Readme Datei",
        "edition": "",
        "filelink": "2073/drv_comp.rme",
        "mediatype": "fj-mediatype-text"
      }
    ]
  },
  "psDRIVECOMPV21en": {
    "spaceProperties": {
      "prodId": "product-drivecomp",
      "prod": "DRIVE-COMP",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "DRIVE-COMP",
        "subtitle": "",
        "version": "V2.1B",
        "type": "Readme File",
        "edition": "",
        "filelink": "1189/drv_comp.rme",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "DRIVE-COMP-DOC",
        "subtitle": "",
        "version": "V2.1",
        "type": "Release Notice",
        "edition": "2000-07",
        "filelink": "5777/sysfgm.drive-comp-doc.021.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psDRIVECOMPV21de": {
    "spaceProperties": {
      "prodId": "product-drivecomp",
      "prod": "DRIVE-COMP",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "DRIVE-COMP",
        "subtitle": "",
        "version": "V2.1B",
        "type": "Readme Datei",
        "edition": "",
        "filelink": "251/drv_comp.rme",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "DRIVE-COMP-DOC",
        "subtitle": "",
        "version": "V2.1",
        "type": "Freigabemitteilung",
        "edition": "2000-07",
        "filelink": "4903/sysfgm.drive-comp-doc.021.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DRIVE/WIN Compiler",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1996-06",
        "filelink": "250/drv_comp.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psDRIVEWINDOWSV31en": {
    "spaceProperties": {
      "prodId": "product-drivewindows",
      "prod": "DRIVE/Windows",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Directory of DRIVE SQL Statements for SESAM/SQL 2",
        "subtitle": "",
        "version": "V2.1",
        "type": "User Guide",
        "edition": "1996-02",
        "filelink": "1198/drv_ses2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Directory of DRIVE SQL Statements for UDS",
        "subtitle": "",
        "version": "V1.1",
        "type": "User Guide",
        "edition": "1993-12",
        "filelink": "1195/drv_uds.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Directory of DRIVE Statements",
        "subtitle": "",
        "version": "V2.1",
        "type": "User Guide",
        "edition": "1996-02",
        "filelink": "1199/drv_lex.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DRIVE",
        "subtitle": "",
        "version": "V3.1",
        "type": "Release Notice",
        "edition": "2012-04",
        "filelink": "5776/sysfgm.drive.031.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DRIVE",
        "subtitle": "",
        "version": "V3.1A",
        "type": "Readme File",
        "edition": "",
        "filelink": "2788/sysrme.drive.031a.e.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "Supplement",
        "subtitle": "",
        "version": "V2.2",
        "type": "User Guide",
        "edition": "2000-01",
        "filelink": "2787/drive_22.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psDRIVEWINDOWSV31de": {
    "spaceProperties": {
      "prodId": "product-drivewindows",
      "prod": "DRIVE/Windows",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "DRIVE",
        "subtitle": "",
        "version": "V3.1",
        "type": "Freigabemitteilung",
        "edition": "2012-04",
        "filelink": "4902/sysfgm.drive.031.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DRIVE",
        "subtitle": "",
        "version": "V3.1A",
        "type": "Readme Datei",
        "edition": "",
        "filelink": "2076/sysrme.drive.031a.d.txt",
        "mediatype": "fj-mediatype-text"
      },
      {
        "title": "Ergänzungsband",
        "subtitle": "",
        "version": "V2.2A",
        "type": "Benutzerhandbuch",
        "edition": "2000-01",
        "filelink": "2075/drive_22.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Lexikon der DRIVE-Anweisungen",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1996-02",
        "filelink": "254/drv_lex.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Lexikon der DRIVE-SQL-Anweisungen für ISO/SQL",
        "subtitle": "",
        "version": "V1.1",
        "type": "Benutzerhandbuch",
        "edition": "1993-12",
        "filelink": "6582/drv_iso.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Lexikon der DRIVE-SQL-Anweisungen für SESAM/SQL 2",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1996-02",
        "filelink": "257/drv_ses2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Lexikon der DRIVE-SQL-Anweisungen für UDS",
        "subtitle": "",
        "version": "V1.1",
        "type": "Benutzerhandbuch",
        "edition": "1993-12",
        "filelink": "6581/drv_uds.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Programmiersprache",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1996-02",
        "filelink": "255/drv_prog.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Programmiersystem",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1996-02",
        "filelink": "256/drv_psys.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psDRIVEWINDOWSV22en": {
    "spaceProperties": {
      "prodId": "product-drivewindows",
      "prod": "DRIVE/Windows",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Directory of DRIVE SQL Statements for SESAM/SQL 2",
        "subtitle": "",
        "version": "V2.1",
        "type": "User Guide",
        "edition": "1996-02",
        "filelink": "1198/drv_ses2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Directory of DRIVE SQL Statements for UDS",
        "subtitle": "",
        "version": "V1.1",
        "type": "User Guide",
        "edition": "1993-12",
        "filelink": "1195/drv_uds.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Directory of DRIVE Statements",
        "subtitle": "",
        "version": "V2.1",
        "type": "User Guide",
        "edition": "1996-02",
        "filelink": "1199/drv_lex.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Supplement",
        "subtitle": "",
        "version": "V2.2",
        "type": "User Guide",
        "edition": "2000-01",
        "filelink": "2787/drive_22.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psDRIVEWINDOWSV22de": {
    "spaceProperties": {
      "prodId": "product-drivewindows",
      "prod": "DRIVE/Windows",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Ergänzungsband",
        "subtitle": "",
        "version": "V2.2A",
        "type": "Benutzerhandbuch",
        "edition": "2000-01",
        "filelink": "2075/drive_22.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Lexikon der DRIVE-Anweisungen",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1996-02",
        "filelink": "254/drv_lex.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Lexikon der DRIVE-SQL-Anweisungen für ISO/SQL",
        "subtitle": "",
        "version": "V1.1",
        "type": "Benutzerhandbuch",
        "edition": "1993-12",
        "filelink": "6582/drv_iso.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Lexikon der DRIVE-SQL-Anweisungen für SESAM/SQL 2",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1996-02",
        "filelink": "257/drv_ses2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Lexikon der DRIVE-SQL-Anweisungen für UDS",
        "subtitle": "",
        "version": "V1.1",
        "type": "Benutzerhandbuch",
        "edition": "1993-12",
        "filelink": "6581/drv_uds.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Programmiersprache",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1996-02",
        "filelink": "255/drv_prog.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Programmiersystem",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1996-02",
        "filelink": "256/drv_psys.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psDRIVEWINDOWSV21en": {
    "spaceProperties": {
      "prodId": "product-drivewindows",
      "prod": "DRIVE/Windows",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Directory of DRIVE SQL Statements for SESAM/SQL 2",
        "subtitle": "",
        "version": "V2.1",
        "type": "User Guide",
        "edition": "1996-02",
        "filelink": "1198/drv_ses2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Directory of DRIVE SQL Statements for UDS",
        "subtitle": "",
        "version": "V1.1",
        "type": "User Guide",
        "edition": "1993-12",
        "filelink": "1195/drv_uds.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Directory of DRIVE Statements",
        "subtitle": "",
        "version": "V2.1",
        "type": "User Guide",
        "edition": "1996-02",
        "filelink": "1199/drv_lex.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DRIVE",
        "subtitle": "",
        "version": "V2.1",
        "type": "Release Notice",
        "edition": "2000-07",
        "filelink": "5775/sysfgm.drive.021.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psDRIVEWINDOWSV21de": {
    "spaceProperties": {
      "prodId": "product-drivewindows",
      "prod": "DRIVE/Windows",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "DRIVE",
        "subtitle": "",
        "version": "V2.1",
        "type": "Freigabemitteilung",
        "edition": "2000-07",
        "filelink": "4901/sysfgm.drive.021.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Lexikon der DRIVE-Anweisungen",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1996-02",
        "filelink": "254/drv_lex.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Lexikon der DRIVE-SQL-Anweisungen für ISO/SQL",
        "subtitle": "",
        "version": "V1.1",
        "type": "Benutzerhandbuch",
        "edition": "1993-12",
        "filelink": "6582/drv_iso.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Lexikon der DRIVE-SQL-Anweisungen für SESAM/SQL 2",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1996-02",
        "filelink": "257/drv_ses2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Lexikon der DRIVE-SQL-Anweisungen für UDS",
        "subtitle": "",
        "version": "V1.1",
        "type": "Benutzerhandbuch",
        "edition": "1993-12",
        "filelink": "6581/drv_uds.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Programmiersprache",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1996-02",
        "filelink": "255/drv_prog.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Programmiersystem",
        "subtitle": "",
        "version": "V2.1",
        "type": "Benutzerhandbuch",
        "edition": "1996-02",
        "filelink": "256/drv_psys.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psLEASYV62en": {
    "spaceProperties": {
      "prodId": "product-leasy",
      "prod": "LEASY",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "LEASY",
        "subtitle": "",
        "version": "V6.2",
        "type": "Release Notice",
        "edition": "2018-01",
        "filelink": "5918/sysfgm.leasy.062.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LEASY",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Readme File",
        "edition": "2018-01",
        "filelink": "8191/sysrme.leasy.062.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LEASY Program Interface",
        "subtitle": "",
        "version": "V6.2A",
        "type": "User Guide",
        "edition": "2007-03",
        "filelink": "2830/leasy_ps.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LEASY Ready Reference",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Ready Reference",
        "edition": "2007-03",
        "filelink": "2831/leasy_tb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LEASY Utility Routines",
        "subtitle": "",
        "version": "V6.2A",
        "type": "User Guide",
        "edition": "2007-03",
        "filelink": "2832/leasy_dp.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psLEASYV62de": {
    "spaceProperties": {
      "prodId": "product-leasy",
      "prod": "LEASY",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "LEASY",
        "subtitle": "",
        "version": "V6.2",
        "type": "Freigabemitteilung",
        "edition": "2018-01",
        "filelink": "5044/sysfgm.leasy.062.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LEASY",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Readme Datei",
        "edition": "2018-01",
        "filelink": "8190/sysrme.leasy.062.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LEASY Dienstprogramme",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Benutzerhandbuch",
        "edition": "2007-03",
        "filelink": "2123/leasy_dp.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LEASY Programm-Schnittstelle",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Benutzerhandbuch",
        "edition": "2007-03",
        "filelink": "2124/leasy_ps.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "LEASY Taschenbuch",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Taschenbuch",
        "edition": "2007-03",
        "filelink": "2125/leasy_tb.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psORACLEV122en": {
    "spaceProperties": {
      "prodId": "product-oracle",
      "prod": "Oracle",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Database Installation and Administration Guide for Fujitsu BS2000",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2019-01",
        "filelink": "20077/oracle-database-installation-and-administration-guide-fujitsu-bs2000.pdf",
        "mediatype": ""
      },
      {
        "title": "Database Release Notes for Fujitsu BS2000",
        "subtitle": "",
        "version": "",
        "type": "Release Notice",
        "edition": "2019-01",
        "filelink": "20078/oracle-database-release-notes-fujitsu-bs2000.pdf",
        "mediatype": ""
      }
    ]
  },
  "psORACLEV122de": {
    "spaceProperties": {
      "prodId": "product-oracle",
      "prod": "Oracle",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Database Installation and Administration Guide for Fujitsu BS2000",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2019-01",
        "filelink": "20077/oracle-database-installation-and-administration-guide-fujitsu-bs2000.pdf",
        "mediatype": ""
      },
      {
        "title": "Database Release Notes for Fujitsu BS2000",
        "subtitle": "",
        "version": "",
        "type": "Release Notice",
        "edition": "2019-01",
        "filelink": "20078/oracle-database-release-notes-fujitsu-bs2000.pdf",
        "mediatype": ""
      }
    ]
  },
  "psORACLEV121en": {
    "spaceProperties": {
      "prodId": "product-oracle",
      "prod": "Oracle",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Database Installation and Administration Guide for Fujitsu BS2000",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2017-01",
        "filelink": "12981/E67706-02.pdf",
        "mediatype": ""
      },
      {
        "title": "Database Release Notes for Fujitsu BS2000",
        "subtitle": "",
        "version": "",
        "type": "Release Notice",
        "edition": "2017-01",
        "filelink": "12986/E74140-02.pdf",
        "mediatype": ""
      }
    ]
  },
  "psORACLEV121de": {
    "spaceProperties": {
      "prodId": "product-oracle",
      "prod": "Oracle",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Database Installation and Administration Guide for Fujitsu BS2000",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2017-01",
        "filelink": "12981/E67706-02.pdf",
        "mediatype": ""
      },
      {
        "title": "Database Release Notes for Fujitsu BS2000",
        "subtitle": "",
        "version": "",
        "type": "Release Notice",
        "edition": "2017-01",
        "filelink": "12986/E74140-02.pdf",
        "mediatype": ""
      }
    ]
  },
  "psORACLEV112en": {
    "spaceProperties": {
      "prodId": "product-oracle",
      "prod": "Oracle",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Database Installation and Administration Guide for Fujitsu BS2000",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2015-07",
        "filelink": "11160/utm_prg.pdf",
        "mediatype": ""
      },
      {
        "title": "Database User's Guide for Fujitsu BS2000",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2015-07",
        "filelink": "11159/utm_gen.pdf",
        "mediatype": ""
      }
    ]
  },
  "psORACLEV112de": {
    "spaceProperties": {
      "prodId": "product-oracle",
      "prod": "Oracle",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Database Installation and Administration Guide for Fujitsu BS2000",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2015-07",
        "filelink": "20004/e27508.pdf",
        "mediatype": ""
      },
      {
        "title": "Database User's Guide for Fujitsu BS2000",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2015-07",
        "filelink": "20005/e27507.pdf",
        "mediatype": ""
      }
    ]
  },
  "psSESAMSQLV91en": {
    "spaceProperties": {
      "prodId": "product-sesamsql",
      "prod": "SESAM/SQL",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ESQL-COBOL",
        "subtitle": "",
        "version": "V3.0",
        "type": "Release Notice",
        "edition": "2013-12",
        "filelink": "5810/sysfgm.esql-cobol.030.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ESQL-COBOL",
        "subtitle": "",
        "version": "V3.0D",
        "type": "Readme File",
        "edition": "2013-12",
        "filelink": "4659/sysrme.esql-cobol.030.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ESQL-COBOL for SESAM/SQL Server",
        "subtitle": "",
        "version": "V3.0A",
        "type": "User Guide",
        "edition": "2006-11",
        "filelink": "2798/esql_cb2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM-DBAccess",
        "subtitle": "",
        "version": "V9.1",
        "type": "Administration and Installation Guide",
        "edition": "2018-10",
        "filelink": "13874/jdbc.V9.1.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM-SQL",
        "subtitle": "",
        "version": "V9.1",
        "type": "Release Notice",
        "edition": "2018-09",
        "filelink": "13829/sysfgm.sesam-sql.091.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL CALL DML",
        "subtitle": "",
        "version": "V3.0",
        "type": "User Guide",
        "edition": "2000-01",
        "filelink": "1731/ses_dml.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Core Manual",
        "subtitle": "",
        "version": "V9.1",
        "type": "User Guide",
        "edition": "2018-10",
        "filelink": "13871/ses_bas.V9.1.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Database Operation",
        "subtitle": "",
        "version": "V9.1",
        "type": "User Guide",
        "edition": "2019-06",
        "filelink": "20067/SESDBO.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Messages",
        "subtitle": "",
        "version": "V9.0",
        "type": "User Guide",
        "edition": "2016-10",
        "filelink": "12928/ses_msg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Performance",
        "subtitle": "",
        "version": "V9.0",
        "type": "User Guide",
        "edition": "2016-10",
        "filelink": "12930/ses_per.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL SQL Reference Manual Part 1",
        "subtitle": "",
        "version": "V9.1",
        "type": "User Guide",
        "edition": "2019-06",
        "filelink": "20068/SESREF1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL SQL Reference Manual Part 2",
        "subtitle": "",
        "version": "V9.0",
        "type": "User Guide",
        "edition": "2016-10",
        "filelink": "12924/ses_bs2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Utility Monitor",
        "subtitle": "",
        "version": "V9.0",
        "type": "User Guide",
        "edition": "2016-10",
        "filelink": "12926/ses_uti.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESDBA",
        "subtitle": "",
        "version": "V9.1",
        "type": "Release Notice",
        "edition": "2018-09",
        "filelink": "13831/sysfgm.sesdba.091.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA Access for SESAM/SQL",
        "subtitle": "",
        "version": "V9.0",
        "type": "Readme File",
        "edition": "2016-10",
        "filelink": "12936/wt-readme.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSESAMSQLV91de": {
    "spaceProperties": {
      "prodId": "product-sesamsql",
      "prod": "SESAM/SQL",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ESQL-COBOL",
        "subtitle": "",
        "version": "V3.0",
        "type": "Freigabemitteilung",
        "edition": "2013-12",
        "filelink": "4936/sysfgm.esql-cobol.030.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ESQL-COBOL",
        "subtitle": "",
        "version": "V3.0D",
        "type": "Readme Datei",
        "edition": "2013-12",
        "filelink": "4658/sysrme.esql-cobol.030.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ESQL-COBOL für SESAM/SQL-Server",
        "subtitle": "",
        "version": "V3.0A",
        "type": "Benutzerhandbuch",
        "edition": "2006-11",
        "filelink": "2086/esql_cb2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM-DBAccess",
        "subtitle": "",
        "version": "V9.1",
        "type": "Administrations- und Installationshandbuch",
        "edition": "2018-10",
        "filelink": "13827/jdbc.V9.1.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM-SQL",
        "subtitle": "",
        "version": "V9.1",
        "type": "Freigabemitteilung",
        "edition": "2018-09",
        "filelink": "13828/sysfgm.sesam-sql.091.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Basishandbuch",
        "subtitle": "",
        "version": "V9.1",
        "type": "Benutzerhandbuch",
        "edition": "2018-10",
        "filelink": "13824/ses_bas.V9.1.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL CALL DML",
        "subtitle": "",
        "version": "V3.0",
        "type": "Benutzerhandbuch",
        "edition": "1999-11",
        "filelink": "782/ses_dml.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Datenbankbetrieb",
        "subtitle": "",
        "version": "V9.1",
        "type": "Benutzerhandbuch",
        "edition": "2019-06",
        "filelink": "20065/SESDBB.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Meldungen",
        "subtitle": "",
        "version": "V9.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-10",
        "filelink": "12927/ses_msg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Performance",
        "subtitle": "",
        "version": "V9.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-10",
        "filelink": "12929/ses_perf.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL SQL-Sprachbeschreibung Teil 1",
        "subtitle": "",
        "version": "V9.1",
        "type": "Benutzerhandbuch",
        "edition": "2019-06",
        "filelink": "20066/SESSBT1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL SQL-Sprachbeschreibung Teil 2",
        "subtitle": "",
        "version": "V9.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-10",
        "filelink": "12923/ses_bs2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Utility-Monitor",
        "subtitle": "",
        "version": "V9.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-10",
        "filelink": "12925/ses_uti.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESDBA",
        "subtitle": "",
        "version": "V9.1",
        "type": "Freigabemitteilung",
        "edition": "2018-09",
        "filelink": "13830/sysfgm.sesdba.091.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA-Zugang für SESAM/SQL",
        "subtitle": "",
        "version": "V9.0",
        "type": "Readme Datei",
        "edition": "2016-10",
        "filelink": "12935/wt-readme.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSESAMSQLV90en": {
    "spaceProperties": {
      "prodId": "product-sesamsql",
      "prod": "SESAM/SQL",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ESQL-COBOL",
        "subtitle": "",
        "version": "V3.0",
        "type": "Release Notice",
        "edition": "2013-12",
        "filelink": "5810/sysfgm.esql-cobol.030.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ESQL-COBOL",
        "subtitle": "",
        "version": "V3.0D",
        "type": "Readme File",
        "edition": "2013-12",
        "filelink": "4659/sysrme.esql-cobol.030.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ESQL-COBOL for SESAM/SQL Server",
        "subtitle": "",
        "version": "V3.0A",
        "type": "User Guide",
        "edition": "2006-11",
        "filelink": "2798/esql_cb2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM-DBAccess",
        "subtitle": "",
        "version": "V9.0",
        "type": "Administration and Installation Guide",
        "edition": "2016-10",
        "filelink": "12932/jdbc.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM-SQL",
        "subtitle": "",
        "version": "V9.0",
        "type": "Release Notice",
        "edition": "2016-10",
        "filelink": "12951/sysfgm.sesam-sql.090.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL CALL DML",
        "subtitle": "",
        "version": "V3.0",
        "type": "User Guide",
        "edition": "2000-01",
        "filelink": "1731/ses_dml.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Core Manual",
        "subtitle": "",
        "version": "V9.0",
        "type": "User Guide",
        "edition": "2016-10",
        "filelink": "12918/ses_bas.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Database Operation",
        "subtitle": "",
        "version": "V9.0",
        "type": "User Guide",
        "edition": "2016-10",
        "filelink": "12920/ses_dbb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Messages",
        "subtitle": "",
        "version": "V9.0",
        "type": "User Guide",
        "edition": "2016-10",
        "filelink": "12928/ses_msg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Performance",
        "subtitle": "",
        "version": "V9.0",
        "type": "User Guide",
        "edition": "2016-10",
        "filelink": "12930/ses_per.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL SQL Reference Manual Part 1",
        "subtitle": "",
        "version": "V9.0",
        "type": "User Guide",
        "edition": "2016-10",
        "filelink": "12922/ses_bs1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL SQL Reference Manual Part 2",
        "subtitle": "",
        "version": "V9.0",
        "type": "User Guide",
        "edition": "2016-10",
        "filelink": "12924/ses_bs2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Utility Monitor",
        "subtitle": "",
        "version": "V9.0",
        "type": "User Guide",
        "edition": "2016-10",
        "filelink": "12926/ses_uti.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESDBA",
        "subtitle": "",
        "version": "V9.0",
        "type": "Release Notice",
        "edition": "2016-10",
        "filelink": "12953/sysfgm.sesdba.090.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA Access for SESAM/SQL",
        "subtitle": "",
        "version": "V9.0",
        "type": "Readme File",
        "edition": "2016-10",
        "filelink": "12936/wt-readme.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSESAMSQLV90de": {
    "spaceProperties": {
      "prodId": "product-sesamsql",
      "prod": "SESAM/SQL",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ESQL-COBOL",
        "subtitle": "",
        "version": "V3.0",
        "type": "Freigabemitteilung",
        "edition": "2013-12",
        "filelink": "4936/sysfgm.esql-cobol.030.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ESQL-COBOL",
        "subtitle": "",
        "version": "V3.0D",
        "type": "Readme Datei",
        "edition": "2013-12",
        "filelink": "4658/sysrme.esql-cobol.030.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "ESQL-COBOL für SESAM/SQL-Server",
        "subtitle": "",
        "version": "V3.0A",
        "type": "Benutzerhandbuch",
        "edition": "2006-11",
        "filelink": "2086/esql_cb2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM-DBAccess",
        "subtitle": "",
        "version": "V9.0",
        "type": "Administrations- und Installationshandbuch",
        "edition": "2016-10",
        "filelink": "12931/jdbc.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM-SQL",
        "subtitle": "",
        "version": "V9.0",
        "type": "Freigabemitteilung",
        "edition": "2016-10",
        "filelink": "12950/sysfgm.sesam-sql.090.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Basishandbuch",
        "subtitle": "",
        "version": "V9.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-10",
        "filelink": "12917/ses_bas.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL CALL DML",
        "subtitle": "",
        "version": "V3.0",
        "type": "Benutzerhandbuch",
        "edition": "1999-11",
        "filelink": "782/ses_dml.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Datenbankbetrieb",
        "subtitle": "",
        "version": "V9.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-10",
        "filelink": "12919/ses_dbb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Meldungen",
        "subtitle": "",
        "version": "V9.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-10",
        "filelink": "12927/ses_msg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Performance",
        "subtitle": "",
        "version": "V9.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-10",
        "filelink": "12929/ses_perf.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL SQL-Sprachbeschreibung Teil 1",
        "subtitle": "",
        "version": "V9.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-10",
        "filelink": "12921/ses_bs1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL SQL-Sprachbeschreibung Teil 2",
        "subtitle": "",
        "version": "V9.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-10",
        "filelink": "12923/ses_bs2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESAM/SQL Utility-Monitor",
        "subtitle": "",
        "version": "V9.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-10",
        "filelink": "12925/ses_uti.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SESDBA",
        "subtitle": "",
        "version": "V9.0",
        "type": "Freigabemitteilung",
        "edition": "2016-10",
        "filelink": "12952/sysfgm.sesdba.090.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA-Zugang für SESAM/SQL",
        "subtitle": "",
        "version": "V9.0",
        "type": "Readme Datei",
        "edition": "2016-10",
        "filelink": "12935/wt-readme.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psUDSIQSV40en": {
    "spaceProperties": {
      "prodId": "product-udsiqs",
      "prod": "UDS-IQS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "IQS",
        "subtitle": "",
        "version": "V4.0",
        "type": "Release Notice",
        "edition": "2013-05",
        "filelink": "5881/sysfgm.iqs.040.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS-IQS",
        "subtitle": "",
        "version": "V4.0A",
        "type": "Readme File",
        "edition": "2013-05",
        "filelink": "3203/sysrme.iqs.040a50.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psUDSIQSV40de": {
    "spaceProperties": {
      "prodId": "product-udsiqs",
      "prod": "UDS-IQS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "IQS",
        "subtitle": "",
        "version": "V4.0",
        "type": "Freigabemitteilung",
        "edition": "2013-05",
        "filelink": "5007/sysfgm.iqs.040.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS IQS",
        "subtitle": "",
        "version": "V3.1D",
        "type": "Benutzerhandbuch",
        "edition": "1986-09",
        "filelink": "860/uds_iqs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS-IQS",
        "subtitle": "",
        "version": "V4.0A",
        "type": "Readme Datei",
        "edition": "2013-05",
        "filelink": "2502/sysrme.iqs.040a50.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psUDSSQLV29en": {
    "spaceProperties": {
      "prodId": "product-udssql",
      "prod": "UDS/SQL",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "UDS/SQL",
        "subtitle": "",
        "version": "V2.9B",
        "type": "Release Notice",
        "edition": "2019-06",
        "filelink": "20053/sysfgm.uds-sql.029.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Application Programming",
        "subtitle": "",
        "version": "V2.9A",
        "type": "User Guide",
        "edition": "2017-09",
        "filelink": "13483/uds_anw.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Creation and Restructuring",
        "subtitle": "",
        "version": "V2.9B",
        "type": "User Guide",
        "edition": "2019-06",
        "filelink": "20072/UDSen-Creation and Restructuring.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Creation and Restructuring",
        "subtitle": "",
        "version": "V2.9A",
        "type": "User Guide",
        "edition": "2017-09",
        "filelink": "13491/uds_auu.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Database Operation",
        "subtitle": "",
        "version": "V2.9B",
        "type": "User Guide",
        "edition": "2019-06",
        "filelink": "20073/UDSen-Database operation.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Database Operation",
        "subtitle": "",
        "version": "V2.9A",
        "type": "User Guide",
        "edition": "2017-09",
        "filelink": "13485/uds_dbb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Design & Definition",
        "subtitle": "",
        "version": "V2.9A",
        "type": "User Guide",
        "edition": "2017-09",
        "filelink": "13486/uds_eud.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Messages",
        "subtitle": "",
        "version": "V2.9B",
        "type": "User Guide",
        "edition": "2019-06",
        "filelink": "20074/UDSen-Messages.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Ready Reference",
        "subtitle": "",
        "version": "V2.9A",
        "type": "User Guide",
        "edition": "2017-09",
        "filelink": "13490/uds_tab.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Recovery, Information and Reorganization",
        "subtitle": "",
        "version": "V2.9A",
        "type": "User Guide",
        "edition": "2017-09",
        "filelink": "13488/uds_sir.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psUDSSQLV29de": {
    "spaceProperties": {
      "prodId": "product-udssql",
      "prod": "UDS/SQL",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "UDS/SQL",
        "subtitle": "",
        "version": "V2.9B",
        "type": "Freigabemitteilung",
        "edition": "2019-06",
        "filelink": "20039/sysfgm.uds-sql.029.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Anwendungen programmieren",
        "subtitle": "",
        "version": "V2.9A",
        "type": "Benutzerhandbuch",
        "edition": "2017-09",
        "filelink": "13477/uds_anw.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Aufbauen und Umstrukturieren",
        "subtitle": "",
        "version": "V2.9B",
        "type": "Benutzerhandbuch",
        "edition": "2019-06",
        "filelink": "20069/UDSde-AufbauenUmstrukturieren.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Aufbauen und Umstrukturieren",
        "subtitle": "",
        "version": "V2.9A",
        "type": "Benutzerhandbuch",
        "edition": "2017-09",
        "filelink": "13478/uds_auu.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Datenbankbetrieb",
        "subtitle": "",
        "version": "V2.9B",
        "type": "Benutzerhandbuch",
        "edition": "2019-06",
        "filelink": "20070/UDSde-Datenbankbetrieb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Datenbankbetrieb",
        "subtitle": "",
        "version": "V2.9A",
        "type": "Benutzerhandbuch",
        "edition": "2017-09",
        "filelink": "13479/uds_dbb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Entwerfen und Definieren",
        "subtitle": "",
        "version": "V2.9A",
        "type": "Benutzerhandbuch",
        "edition": "2017-09",
        "filelink": "13480/uds_eud.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Meldungen",
        "subtitle": "",
        "version": "V2.9B",
        "type": "Benutzerhandbuch",
        "edition": "2019-06",
        "filelink": "20071/UDSde-Meldungen.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Sichern, Informieren und Reorganisieren",
        "subtitle": "",
        "version": "V2.9A",
        "type": "Benutzerhandbuch",
        "edition": "2017-09",
        "filelink": "13482/uds_sir.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Taschenbuch",
        "subtitle": "",
        "version": "V2.9A",
        "type": "Benutzerhandbuch",
        "edition": "2017-09",
        "filelink": "13489/uds_tab.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psUDSSQLV28en": {
    "spaceProperties": {
      "prodId": "product-udssql",
      "prod": "UDS/SQL",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ODBC-DEMO-UDS",
        "subtitle": "",
        "version": "V3.7",
        "type": "Release Notice",
        "edition": "2009-05",
        "filelink": "5963/sysfgm.odbc-demo-uds.037.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS-SQL",
        "subtitle": "",
        "version": "V2.8",
        "type": "Release Notice",
        "edition": "2016-04",
        "filelink": "12726/sysfgm.uds-sql.028.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Application Programming",
        "subtitle": "",
        "version": "V2.8A",
        "type": "User Guide",
        "edition": "2016-03",
        "filelink": "12682/uds_anw.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Creation & Restructuring",
        "subtitle": "",
        "version": "V2.8A",
        "type": "User Guide",
        "edition": "2016-03",
        "filelink": "12683/uds_auu.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Database Operation",
        "subtitle": "",
        "version": "V2.8A",
        "type": "User Guide",
        "edition": "2016-03",
        "filelink": "12684/uds_dbb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Design & Definition",
        "subtitle": "",
        "version": "V2.8A",
        "type": "User Guide",
        "edition": "2016-03",
        "filelink": "12685/uds_eud.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Messages",
        "subtitle": "",
        "version": "V2.8A",
        "type": "User Guide",
        "edition": "2016-03",
        "filelink": "12686/uds_msg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Ready Reference",
        "subtitle": "",
        "version": "V2.8A",
        "type": "Ready Reference",
        "edition": "2016-03",
        "filelink": "12688/uds_tab.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Recovery, Information and Reorganization",
        "subtitle": "",
        "version": "V2.8A",
        "type": "User Guide",
        "edition": "2016-03",
        "filelink": "12687/uds_sir.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psUDSSQLV28de": {
    "spaceProperties": {
      "prodId": "product-udssql",
      "prod": "UDS/SQL",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "ODBC-DEMO-UDS",
        "subtitle": "",
        "version": "V3.7",
        "type": "Freigabemitteilung",
        "edition": "2009-05",
        "filelink": "5089/sysfgm.odbc-demo-uds.037.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS-SQL",
        "subtitle": "",
        "version": "V2.8",
        "type": "Freigabemitteilung",
        "edition": "2016-04",
        "filelink": "12725/sysfgm.uds-sql.028.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Anwendungen programmieren",
        "subtitle": "",
        "version": "V2.8A",
        "type": "Benutzerhandbuch",
        "edition": "2016-03",
        "filelink": "12675/uds_anw.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Aufbauen und Umstrukturieren",
        "subtitle": "",
        "version": "V2.8A",
        "type": "Benutzerhandbuch",
        "edition": "2016-03",
        "filelink": "12676/uds_auu.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Datenbankbetrieb",
        "subtitle": "",
        "version": "V2.8A",
        "type": "Benutzerhandbuch",
        "edition": "2016-03",
        "filelink": "12677/uds_dbb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Entwerfen und Definieren",
        "subtitle": "",
        "version": "V2.8A",
        "type": "Benutzerhandbuch",
        "edition": "2016-03",
        "filelink": "12678/uds_eud.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Meldungen",
        "subtitle": "",
        "version": "V2.8A",
        "type": "Benutzerhandbuch",
        "edition": "2016-03",
        "filelink": "12679/uds_msg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Sichern, Informieren und Reorganisieren",
        "subtitle": "",
        "version": "V2.8A",
        "type": "Benutzerhandbuch",
        "edition": "2016-03",
        "filelink": "12680/uds_sir.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UDS/SQL Taschenbuch",
        "subtitle": "",
        "version": "V2.8A",
        "type": "Taschenbuch",
        "edition": "2016-03",
        "filelink": "12681/uds_tab.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psBEANCONNECTV65en": {
    "spaceProperties": {
      "prodId": "product-beanconnect",
      "prod": "BeanConnect",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "BeanConnect User Guide",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2018-09",
        "filelink": "13821/bcv65_bhb_e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Release Notice BeanConnect",
        "subtitle": "",
        "version": "V6.5",
        "type": "Release Notice",
        "edition": "2018-09",
        "filelink": "13823/fgm.BeanConnect.065e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psBEANCONNECTV65de": {
    "spaceProperties": {
      "prodId": "product-beanconnect",
      "prod": "BeanConnect",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "BeanConnect Benutzerhandbuch",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2018-09",
        "filelink": "13820/bcv65_bhb_d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Freigabemitteilung BeanConnect",
        "subtitle": "",
        "version": "V6.5",
        "type": "Freigabemitteilung",
        "edition": "2018-09",
        "filelink": "13822/fgm.BeanConnect.065d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psBEANCONNECTV30en": {
    "spaceProperties": {
      "prodId": "product-beanconnect",
      "prod": "BeanConnect",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "BeanConnect User Guide",
        "subtitle": "",
        "version": "V3.0B",
        "type": "User Guide",
        "edition": "2015-08",
        "filelink": "12435/bcv30b_bhb_e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "BeanConnect User Guide",
        "subtitle": "",
        "version": "V3.0A",
        "type": "User Guide",
        "edition": "2013-08",
        "filelink": "11444/bcv30_bhb_e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Release Notice BeanConnect",
        "subtitle": "",
        "version": "V3.0B",
        "type": "Release Notice",
        "edition": "2015-10",
        "filelink": "12437/fgm.BeanConnect.030b.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Release Notice BeanConnect",
        "subtitle": "",
        "version": "V3.0A",
        "type": "Release Notice",
        "edition": "2013-09",
        "filelink": "11450/fgm.BeanConnect.030.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Release Notice openUTM-JConnect",
        "subtitle": "",
        "version": "V3.0B",
        "type": "Release Notice",
        "edition": "2015-10",
        "filelink": "12439/fgm.JConnect.030b.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Release Notice openUTM-JConnect",
        "subtitle": "",
        "version": "V3.0A",
        "type": "Release Notice",
        "edition": "2013-09",
        "filelink": "11452/fgm.JConnect.030.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psBEANCONNECTV30de": {
    "spaceProperties": {
      "prodId": "product-beanconnect",
      "prod": "BeanConnect",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "BeanConnect Benutzerhandbuch",
        "subtitle": "",
        "version": "V3.0B",
        "type": "Benutzerhandbuch",
        "edition": "2015-08",
        "filelink": "12434/bcv30b_bhb_d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "BeanConnect Benutzerhandbuch",
        "subtitle": "",
        "version": "V3.0A",
        "type": "Benutzerhandbuch",
        "edition": "2013-08",
        "filelink": "11443/bcv30_bhb_d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Freigabemitteilung BeanConnect",
        "subtitle": "",
        "version": "V3.0B",
        "type": "Freigabemitteilung",
        "edition": "2015-10",
        "filelink": "12436/fgm.BeanConnect.030b.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Freigabemitteilung BeanConnect",
        "subtitle": "",
        "version": "V3.0A",
        "type": "Freigabemitteilung",
        "edition": "2013-09",
        "filelink": "11449/fgm.BeanConnect.030.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Freigabemitteilung openUTM-JConnect",
        "subtitle": "",
        "version": "V3.0B",
        "type": "Freigabemitteilung",
        "edition": "2015-10",
        "filelink": "12438/fgm.JConnect.030b.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Freigabemitteilung openUTM-JConnect",
        "subtitle": "",
        "version": "V3.0A",
        "type": "Freigabemitteilung",
        "edition": "2013-09",
        "filelink": "11451/fgm.JConnect.030.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENFTV121en": {
    "spaceProperties": {
      "prodId": "product-openft",
      "prod": "openFT",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "C and Java Program Interface (Unix Systems and Windows Systems)",
        "subtitle": "",
        "version": "V12.1",
        "type": "Programmer Reference Guide",
        "edition": "2017-07",
        "filelink": "13103/ftuw_prg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Command Interface (BS2000)",
        "subtitle": "",
        "version": "V12.1",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13099/ftbs2_cmd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Command Interface (Unix Systems and Windows Systems)",
        "subtitle": "",
        "version": "V12.1",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13109/ftuw_cmd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Command Interface (z/OS)",
        "subtitle": "",
        "version": "V12.1",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13117/ftzos_cmd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Concepts and Functions",
        "subtitle": "",
        "version": "V12.1",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13133/ft_kon.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Installation and Operation (BS2000)",
        "subtitle": "",
        "version": "V12.1",
        "type": "System Administrator Guide",
        "edition": "2017-07",
        "filelink": "13097/ftbs2_inst.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Installation and Operation (Unix Systems and Windows Systems)",
        "subtitle": "",
        "version": "V12.1",
        "type": "System Administrator Guide",
        "edition": "2017-07",
        "filelink": "13105/ftuw_inst.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Installation and Operation (z/OS)",
        "subtitle": "",
        "version": "V12.1",
        "type": "System Administrator Guide",
        "edition": "2017-07",
        "filelink": "13115/ftzos_inst.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (BS2000)",
        "subtitle": "",
        "version": "V12.1B10",
        "type": "Release Notice",
        "edition": "2019-06",
        "filelink": "20054/sysfgm.openft-gem.121.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (BS2000)",
        "subtitle": "",
        "version": "V12.1B00",
        "type": "Release Notice",
        "edition": "2018-05",
        "filelink": "13445/sysfgm.openft-gem.121.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (Unix Systems)",
        "subtitle": "",
        "version": "V12.1B10",
        "type": "Release Notice",
        "edition": "2019-06",
        "filelink": "20055/sysfgm.openft-ux.12.1b10.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (Unix Systems)",
        "subtitle": "",
        "version": "V12.1",
        "type": "Release Notice",
        "edition": "2018-05",
        "filelink": "13455/sysfgm.openft-ux.12.1b00.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (Windows)",
        "subtitle": "",
        "version": "V12.1B10",
        "type": "Release Notice",
        "edition": "2019-06",
        "filelink": "20056/sysfgm.openft-win.12.1b10.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (Windows)",
        "subtitle": "",
        "version": "V12.1",
        "type": "Release Notice",
        "edition": "2018-05",
        "filelink": "13453/sysfgm.openft-win.12.1b00.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (z/OS)",
        "subtitle": "",
        "version": "V12.1B10",
        "type": "Release Notice",
        "edition": "2019-06",
        "filelink": "20057/sysfgm.openft-zos.121b10.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (z/OS)",
        "subtitle": "",
        "version": "V12.1B00",
        "type": "Release Notice",
        "edition": "2018-05",
        "filelink": "13458/sysfgm.openft-zos.121b.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT-Script (Unix Systems and Windows Systems)",
        "subtitle": "",
        "version": "V12.1",
        "type": "User Guide",
        "edition": "2017-07",
        "filelink": "13113/ftscript.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Program Interfaces (BS2000)",
        "subtitle": "",
        "version": "V12.1",
        "type": "Programmer Reference Guide",
        "edition": "2017-07",
        "filelink": "13101/ftbs2_prg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Readme",
        "subtitle": "",
        "version": "V12.1B",
        "type": "Readme File",
        "edition": "2018-05",
        "filelink": "13761/Readme.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENFTV121de": {
    "spaceProperties": {
      "prodId": "product-openft",
      "prod": "openFT",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "C- und Java-Programmschnittstelle (Unix-/Windows-Systeme)",
        "subtitle": "",
        "version": "V12.1",
        "type": "Programmierhandbuch",
        "edition": "2017-07",
        "filelink": "13102/ftuw_prg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Installation und Betrieb  (Unix-/Windows-Systeme)",
        "subtitle": "",
        "version": "V12.1",
        "type": "Systemverwalterhandbuch",
        "edition": "2017-07",
        "filelink": "13104/ftuw_inst.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Installation und Betrieb (BS2000)",
        "subtitle": "",
        "version": "V12.1",
        "type": "Systemverwalterhandbuch",
        "edition": "2017-07",
        "filelink": "13096/ftbs2_inst.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Installation und Betrieb (z/OS)",
        "subtitle": "",
        "version": "V12.1",
        "type": "Systemverwalterhandbuch",
        "edition": "2017-07",
        "filelink": "13114/ftzos_inst.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Kommandoschnittstelle (BS2000)",
        "subtitle": "",
        "version": "V12.1",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13098/ftbs2_cmd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Kommandoschnittstelle (Unix-/Windows-Systeme)",
        "subtitle": "",
        "version": "V12.1",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13108/ftuw_cmd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Kommandoschnittstelle (z/OS)",
        "subtitle": "",
        "version": "V12.1",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13116/ftzos_cmd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Konzepte und Funktionen",
        "subtitle": "",
        "version": "V12.1",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13132/ft_kon.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (BS2000)",
        "subtitle": "",
        "version": "V12.1B10",
        "type": "Freigabemitteilung",
        "edition": "2019-06",
        "filelink": "20040/sysfgm.openft-gem.121.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (BS2000)",
        "subtitle": "",
        "version": "V12.1B00",
        "type": "Freigabemitteilung",
        "edition": "2018-05",
        "filelink": "13444/sysfgm.openft-gem.121.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (Unix Systeme)",
        "subtitle": "",
        "version": "V12.1B10",
        "type": "Freigabemitteilung",
        "edition": "2019-06",
        "filelink": "20041/sysfgm.openft-ux.12.1b10.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (Unix Systeme)",
        "subtitle": "",
        "version": "V12.1",
        "type": "Freigabemitteilung",
        "edition": "2018-05",
        "filelink": "13454/sysfgm.openft-ux.12.1b00.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (Windows)",
        "subtitle": "",
        "version": "V12.1B10",
        "type": "Freigabemitteilung",
        "edition": "2019-06",
        "filelink": "20042/sysfgm.openft-win.12.1b10.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (Windows)",
        "subtitle": "",
        "version": "V12.1",
        "type": "Freigabemitteilung",
        "edition": "2018-05",
        "filelink": "13451/sysfgm.openft-win.12.1b00.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (z/OS)",
        "subtitle": "",
        "version": "V12.1B10",
        "type": "Freigabemitteilung",
        "edition": "2019-06",
        "filelink": "20043/sysfgm.openft-zos.121b10.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (z/OS)",
        "subtitle": "",
        "version": "V12.1B00",
        "type": "Freigabemitteilung",
        "edition": "2018-05",
        "filelink": "13456/sysfgm.openft-zos.121b.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT-Script (Unix-/Windows-Systeme)",
        "subtitle": "",
        "version": "V12.1",
        "type": "Benutzerhandbuch",
        "edition": "2017-07",
        "filelink": "13112/ftscript.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Programmschnittstellen (BS2000)",
        "subtitle": "",
        "version": "V12.1",
        "type": "Programmierhandbuch",
        "edition": "2017-07",
        "filelink": "13100/ftbs2_prg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Readme",
        "subtitle": "",
        "version": "V12.1B",
        "type": "Readme Datei",
        "edition": "2018-05",
        "filelink": "13760/Readme.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENFTV120en": {
    "spaceProperties": {
      "prodId": "product-openft",
      "prod": "openFT",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "C Program Interface (Unix Systems and Windows Systems)",
        "subtitle": "",
        "version": "V12.0",
        "type": "Programmer Reference Guide",
        "edition": "2012-09",
        "filelink": "10973/ftuw_prg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Installation and Administration (BS2000)",
        "subtitle": "",
        "version": "V12.0",
        "type": "System Administrator Guide",
        "edition": "2012-09",
        "filelink": "10975/ftbs2_ad.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Installation and Administration (Unix-Systems)",
        "subtitle": "",
        "version": "V12.0",
        "type": "System Administrator Guide",
        "edition": "2012-09",
        "filelink": "11039/ftuni_sv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Installation and Administration (Windows Systems)",
        "subtitle": "",
        "version": "V12.0",
        "type": "System Administrator Guide",
        "edition": "2012-09",
        "filelink": "10983/ftwin_sv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Installation and Administration (z/OS)",
        "subtitle": "",
        "version": "V12.0",
        "type": "System Administrator Guide",
        "edition": "2012-09",
        "filelink": "10991/ftmsp_ad.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Managed  File Transfer in the Open World (BS2000)",
        "subtitle": "",
        "version": "V12.0",
        "type": "User Guide",
        "edition": "2012-09",
        "filelink": "10977/ftbs2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Managed  File Transfer in the Open World (Unix Systems)",
        "subtitle": "",
        "version": "V12.0",
        "type": "User Guide",
        "edition": "2012-09",
        "filelink": "10985/ftuni_bh.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Managed  File Transfer in the Open World (Windows Systems)",
        "subtitle": "",
        "version": "V12.0",
        "type": "User Guide",
        "edition": "2012-09",
        "filelink": "10987/ftwin_bh.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Managed  File Transfer in the Open World (z/OS)",
        "subtitle": "",
        "version": "V12.0",
        "type": "User Guide",
        "edition": "2012-09",
        "filelink": "10993/ftmsp_bh.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT",
        "subtitle": "",
        "version": "V12.0C",
        "type": "Readme File",
        "edition": "2015-07",
        "filelink": "12290/Readme_V12.0C_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (BS2000)",
        "subtitle": "",
        "version": "V12.0C",
        "type": "Release Notice",
        "edition": "2016-06",
        "filelink": "10999/sysfgm.openft-gem.120.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (z/OS)",
        "subtitle": "",
        "version": "V12.0C",
        "type": "Release Notice",
        "edition": "2015-07",
        "filelink": "11001/sysfgm.openft-zos.120.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT for Unix Systems",
        "subtitle": "",
        "version": "V12.0C",
        "type": "Release Notice",
        "edition": "2016-08",
        "filelink": "11003/fgm.openFT-Unix-V.12.0C00.en.pdf.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT for Windows Systems",
        "subtitle": "",
        "version": "V12.0C",
        "type": "Release Notice",
        "edition": "2015-07",
        "filelink": "11005/fgm.openFT-Win-V12.0C00.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT-Script (Unix Systems and Windows Systems)",
        "subtitle": "",
        "version": "V12.0",
        "type": "User Guide",
        "edition": "2012-09",
        "filelink": "10989/ftscript.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Program Interfaces",
        "subtitle": "",
        "version": "V12.0A",
        "type": "Programmer Reference Guide",
        "edition": "2012-09",
        "filelink": "10979/ftbs2_pg.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENFTV120de": {
    "spaceProperties": {
      "prodId": "product-openft",
      "prod": "openFT",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "C-Programmschnittstelle (Unix-/Windows-Systeme)",
        "subtitle": "",
        "version": "V12.0",
        "type": "Programmierhandbuch",
        "edition": "2012-09",
        "filelink": "10972/ftuw_prg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Installation und Administration (BS2000)",
        "subtitle": "",
        "version": "V12.0",
        "type": "Systemverwalterhandbuch",
        "edition": "2012-09",
        "filelink": "10974/ftbs2_ad.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Installation und Administration (Unix-Systeme)",
        "subtitle": "",
        "version": "V12.0",
        "type": "Systemverwalterhandbuch",
        "edition": "2012-09",
        "filelink": "10980/ftuni_sv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Installation und Administration (Windows-Systeme)",
        "subtitle": "",
        "version": "V12.0",
        "type": "Systemverwalterhandbuch",
        "edition": "2012-09",
        "filelink": "10982/ftwin_sv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Installation und Administration (z/OS)",
        "subtitle": "",
        "version": "V12.0",
        "type": "Systemverwalterhandbuch",
        "edition": "2012-09",
        "filelink": "10990/ftmsp_ad.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Managed File Transfer in der offenen Welt (BS2000)",
        "subtitle": "",
        "version": "V12.0",
        "type": "Benutzerhandbuch",
        "edition": "2012-09",
        "filelink": "10976/ftbs2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Managed File Transfer in der offenen Welt (Unix-Systeme)",
        "subtitle": "",
        "version": "V12.0",
        "type": "Benutzerhandbuch",
        "edition": "2012-09",
        "filelink": "10984/ftuni_bh.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Managed File Transfer in der offenen Welt (Windows-Systeme)",
        "subtitle": "",
        "version": "V12.0",
        "type": "Benutzerhandbuch",
        "edition": "2012-09",
        "filelink": "10986/ftwin_bh.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Managed File Transfer in der offenen Welt (z/OS)",
        "subtitle": "",
        "version": "V12.0",
        "type": "Benutzerhandbuch",
        "edition": "2012-09",
        "filelink": "10992/ftmsp_bh.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT",
        "subtitle": "",
        "version": "V12.0C",
        "type": "Readme Datei",
        "edition": "2015-07",
        "filelink": "12289/Readme_V12.0C_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (BS2000)",
        "subtitle": "",
        "version": "V12.0C",
        "type": "Freigabemitteilung",
        "edition": "2016-06",
        "filelink": "10998/sysfgm.openft-gem.120.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT (z/OS)",
        "subtitle": "",
        "version": "V12.0C",
        "type": "Freigabemitteilung",
        "edition": "2015-07",
        "filelink": "11000/sysfgm.openft-zos.120.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT für Unix-Systeme",
        "subtitle": "",
        "version": "V12.0C",
        "type": "Freigabemitteilung",
        "edition": "2016-08",
        "filelink": "11002/fgm.openFT-Unix-V.12.0C00.de.pdf.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT für Windows-Systeme",
        "subtitle": "",
        "version": "V12.0C",
        "type": "Freigabemitteilung",
        "edition": "2015-07",
        "filelink": "11004/fgm.openFT-Win-V12.0C00.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openFT-Script (Unix-/Windows-Systeme)",
        "subtitle": "",
        "version": "V12.0",
        "type": "Benutzerhandbuch",
        "edition": "2012-09",
        "filelink": "10988/ftscript.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Programmschnittstellen",
        "subtitle": "",
        "version": "V12.0A",
        "type": "Programmierhandbuch",
        "edition": "2012-09",
        "filelink": "10978/ftbs2_pg.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENUTMV70en": {
    "spaceProperties": {
      "prodId": "product-openutm",
      "prod": "openUTM",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Administering Applications",
        "subtitle": "",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "2019-11",
        "filelink": "20170/utm_adm.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Client-Server Communication with openUTM for the UPIC Carrier System",
        "subtitle": "",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "2019-11",
        "filelink": "20171/utm_upic.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Concepts and Functions",
        "subtitle": "",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "2019-11",
        "filelink": "20172/utm_kon.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Creating Applications with X/Open Interfaces",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2017-12",
        "filelink": "13600/utm_xop.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Distributed Transaction Processing between openUTM and CICS, IMS and LU6.2 Applications",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2008-07",
        "filelink": "6904/utm_lu62-6.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS",
        "subtitle": "Format Handling System für openUTM, TIAM, DCAM",
        "version": "V8.3A",
        "type": "User Guide",
        "edition": "2006-10",
        "filelink": "2806/fhs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS-DOORS",
        "subtitle": "Graphical interface for BS2000/OSD applications",
        "version": "V3.1",
        "type": "User Guide",
        "edition": "1997-03",
        "filelink": "1323/fhs_dor1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Generating Applications",
        "subtitle": "",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "2019-11",
        "filelink": "20173/utm_gen.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Messages, Debugging and Diagnostics on BS2000 Systems",
        "subtitle": "",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "2019-11",
        "filelink": "20174/utm_dia.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Messages, Debugging and Diagnostics on Unix, Linux and Windows Systems",
        "subtitle": "",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "2019-11",
        "filelink": "20175/utmx_dia.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM (BS2000)",
        "subtitle": "",
        "version": "V7.0",
        "type": "Release Notice",
        "edition": "2019-11",
        "filelink": "20151/sysfgm.utm.070.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM Enterprise Edition",
        "subtitle": "(Linux / Windows systems)",
        "version": "V7.0",
        "type": "Release Notice",
        "edition": "2019-11",
        "filelink": "20129/fgm.utm.070.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WebAdmin",
        "subtitle": "",
        "version": "V7.0",
        "type": "Release Notice",
        "edition": "2019-11",
        "filelink": "20152/fgm.webadmin.070.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WebAdmin",
        "subtitle": "Web Administering for openUTM",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "2019-11",
        "filelink": "20139/WebAdmin.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WinAdmin",
        "subtitle": "",
        "version": "V7.0",
        "type": "Release Notice",
        "edition": "2019-11",
        "filelink": "20153/fgm.winadmin.070.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WinAdmin",
        "subtitle": "Graphic Administration Interface for openUTM",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "2019-11",
        "filelink": "20140/WinAdmin.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (BS2000, Linux /Windows Systems) - Carrier System UPIC",
        "subtitle": "",
        "version": "V7.0",
        "type": "Release Notice",
        "edition": "2019-11",
        "filelink": "20154/fgm.utm-client.070.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (Unix, Linux and Windows systems), Carrier System OpenCPIC",
        "subtitle": "",
        "version": "V4.0A",
        "type": "Release Notice",
        "edition": "2017-02",
        "filelink": "13039/fgm.openCPIC.040A50.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client V4.0 for the OpenCPIC Carrier System",
        "subtitle": "Client Server Communication with openUTM",
        "version": "V4.0",
        "type": "User Guide",
        "edition": "2017-02",
        "filelink": "13037/opencpic_e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-LU62 V5.1A41 (Unix/Linux/Windows Systems)",
        "subtitle": "",
        "version": "V5.1A41",
        "type": "Release Notice",
        "edition": "2010-05",
        "filelink": "8255/fgm.openutm-lu62.051a41.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Programming Applications with KDCS for Assembler (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "1998-11",
        "filelink": "13692/utm_ass.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Programming Applications with KDCS for COBOL, C and C++",
        "subtitle": "",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "2019-11",
        "filelink": "20176/utm_prg.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Supplement for FORTRAN (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "1997-02",
        "filelink": "13694/utm_for.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Supplement for Pascal-XT (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "1997-02",
        "filelink": "13696/utm_pas.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Supplement for PL/I (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "1997-02",
        "filelink": "13695/utm_pl1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Using UTM Applications on BS2000 Systems",
        "subtitle": "",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "2019-11",
        "filelink": "20177/utm_betr.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Using UTM Applications on Unix, Linux and Windows Systems",
        "subtitle": "",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "2019-11",
        "filelink": "20178/utmx_betr.en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UTM\u2010XML V3.0A50 (BS2000, Unix /Linux /Windows Systems, z/OS)",
        "subtitle": "",
        "version": "V3.0",
        "type": "Release Notice / ReadMe ",
        "edition": "2013-11",
        "filelink": "7544/fgm.utm-xml.030.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WIN-DOORS",
        "subtitle": "",
        "version": "V3.1",
        "type": "User Guide",
        "edition": "1997-03",
        "filelink": "1853/win_dor.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "XML for openUTM",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2013-11",
        "filelink": "6475/utm-xml.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENUTMV70de": {
    "spaceProperties": {
      "prodId": "product-openutm",
      "prod": "openUTM",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Anwendungen administrieren",
        "subtitle": "",
        "version": "V7.0",
        "type": "Benutzerhandbuch",
        "edition": "2019-11",
        "filelink": "20160/utm_adm.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen erstellen mit X/Open-Schnittstellen",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2017-12",
        "filelink": "13587/utm_xop.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen generieren",
        "subtitle": "",
        "version": "V7.0",
        "type": "Benutzerhandbuch",
        "edition": "2019-11",
        "filelink": "20161/utm_gen.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für Assembler (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "1998-11",
        "filelink": "13677/utm_ass.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für COBOL, C und C++",
        "subtitle": "",
        "version": "V7.0",
        "type": "Benutzerhandbuch",
        "edition": "2019-11",
        "filelink": "20162/utm_prg.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für FORTRAN (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "1997-02",
        "filelink": "13679/utm_for.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für Pascal-XT (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "1997-02",
        "filelink": "13681/utm_pas.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für PL/I (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "1997-02",
        "filelink": "13680/utm_pl1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Client-Server-Kommunikation mit openUTM für Trägersystem UPIC",
        "subtitle": "",
        "version": "V7.0",
        "type": "Benutzerhandbuch",
        "edition": "2019-11",
        "filelink": "20163/utm_upic.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Einsatz von UTM-Anwendungen auf BS2000-Systemen",
        "subtitle": "",
        "version": "V7.0",
        "type": "Benutzerhandbuch",
        "edition": "2019-11",
        "filelink": "20164/utm_betr.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Einsatz von UTM-Anwendungen auf Unix-, Linux- und Windows-Systemen",
        "subtitle": "",
        "version": "V7.0",
        "type": "Benutzerhandbuch",
        "edition": "2019-11",
        "filelink": "20165/utmx_betr.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS",
        "subtitle": "Formatierungssystem für openUTM, TIAM, DCAM",
        "version": "V8.3A",
        "type": "Benutzerhandbuch",
        "edition": "2006-10",
        "filelink": "2094/fhs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS-DOORS",
        "subtitle": "Grafische Oberfläche für BS2000/OSD-Anwendungen",
        "version": "V3.1",
        "type": "Benutzerhandbuch",
        "edition": "1997-04",
        "filelink": "395/fhs_dor1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Konzepte und Funktionen",
        "subtitle": "",
        "version": "V7.0",
        "type": "Benutzerhandbuch",
        "edition": "2019-11",
        "filelink": "20166/utm_kon.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Meldungen, Test und Diagnose auf BS2000-Systemen",
        "subtitle": "",
        "version": "V7.0",
        "type": "Benutzerhandbuch",
        "edition": "2019-11",
        "filelink": "20167/utm_dia.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Meldungen, Test und Diagnose auf Unix-, Linux- und Windows-Systemen",
        "subtitle": "",
        "version": "V7.0",
        "type": "Benutzerhandbuch",
        "edition": "2019-11",
        "filelink": "20168/utmx_dia.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM (BS2000)",
        "subtitle": "",
        "version": "V7.0",
        "type": "Freigabemitteilung",
        "edition": "2019-11",
        "filelink": "20155/sysfgm.utm.070.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM Enterprise Edition",
        "subtitle": "(Linux- und Windows-Systeme)",
        "version": "V7.0",
        "type": "Freigabemitteilung",
        "edition": "2019-11",
        "filelink": "20156/Liesmich.UTM.070.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WebAdmin",
        "subtitle": "",
        "version": "V7.0",
        "type": "Freigabemitteilung",
        "edition": "2019-11",
        "filelink": "20157/fgm.webadmin.070.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WebAdmin",
        "subtitle": "Web-Administrationsanwendung für openUTM",
        "version": "V7.0",
        "type": "Benutzerhandbuch",
        "edition": "2019-11",
        "filelink": "20169/WebAdmin.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WinAdmin",
        "subtitle": "",
        "version": "V7.0",
        "type": "Freigabemitteilung",
        "edition": "2019-11",
        "filelink": "20158/fgm.winadmin.070.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WinAdmin",
        "subtitle": "Grafische Administrationsoberfläche für openUTM",
        "version": "V7.0",
        "type": "Benutzerhandbuch",
        "edition": "2019-11",
        "filelink": "20142/WinAdmin.de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (BS2000, Linux-/Windows-Systeme) - Trägersystem UPIC",
        "subtitle": "",
        "version": "V7.0",
        "type": "Freigabemitteilung",
        "edition": "2019-11",
        "filelink": "20159/fgm.utm-client.070.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (Unix-, Linux- und Windows-Systeme), Trägersystem OpenCPIC",
        "subtitle": "",
        "version": "V4.0A",
        "type": "Freigabemitteilung",
        "edition": "2017-02",
        "filelink": "13038/fgm.openCPIC.040A50.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client V4.0 für Trägersystem OpenCPIC",
        "subtitle": "Client-Server-Kommunikation mit openUTM",
        "version": "V4.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-02",
        "filelink": "13036/opencpic_d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-LU62 V5.1A41 (Unix-/Linux-/Windows-Systeme)",
        "subtitle": "",
        "version": "V5.1A41",
        "type": "Freigabemitteilung",
        "edition": "2010-05",
        "filelink": "8254/fgm.openutm-lu62.051a41.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UTM\u2010XML V3.0A50 (BS2000, Unix-/Linux-/Windows\u2010Systeme, z/OS)",
        "subtitle": "",
        "version": "V3.0",
        "type": "Freigabemitteilung / ReadMe ",
        "edition": "2013-11",
        "filelink": "7543/fgm.utm-xml.030.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Verteilte Transaktionsverarbeitung zwischen openUTM- und CICS-, IMS- und LU6.2-Anwendungen",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2008-07",
        "filelink": "6903/utm_lu62-6.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WIN-DOORS",
        "subtitle": "",
        "version": "V3.1",
        "type": "Benutzerhandbuch",
        "edition": "1997-04",
        "filelink": "922/win_dor.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "XML für openUTM",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2013-11",
        "filelink": "6474/utm-xml.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENUTMV65en": {
    "spaceProperties": {
      "prodId": "product-openutm",
      "prod": "openUTM",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Administering Applications",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2017-12",
        "filelink": "13599/utm_adm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Client-Server Communication with openUTM for the UPIC Carrier System",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2017-12",
        "filelink": "13610/utm_upic.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Concepts and Functions",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2017-12",
        "filelink": "13645/utm_kon.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Creating Applications with X/Open Interfaces",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2017-12",
        "filelink": "13600/utm_xop.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Distributed Transaction Processing between openUTM and CICS, IMS and LU6.2 Applications",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2008-07",
        "filelink": "6904/utm_lu62-6.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS",
        "subtitle": "Format Handling System für openUTM, TIAM, DCAM",
        "version": "V8.3A",
        "type": "User Guide",
        "edition": "2006-10",
        "filelink": "2806/fhs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS-DOORS",
        "subtitle": "Graphical interface for BS2000/OSD applications",
        "version": "V3.1",
        "type": "User Guide",
        "edition": "1997-03",
        "filelink": "1323/fhs_dor1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Generating Applications",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2017-12",
        "filelink": "13606/utm_gen.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Messages, Debugging and Diagnostics on BS2000 Systems",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2017-12",
        "filelink": "13602/utm_dia.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Messages, Debugging and Diagnostics on Unix, Linux and Windows Systems",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2017-12",
        "filelink": "13603/utmx_dia.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM (BS2000), openUTM-CRYPT (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "Release Notice",
        "edition": "2018-04",
        "filelink": "13746/sysfgm.utm.065.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM Enterprise Edition, openUTM-CRYPT Enterprise Edition",
        "subtitle": "(Unix / Linux / Windows systems)",
        "version": "V6.5A",
        "type": "Release Notice",
        "edition": "2018-04",
        "filelink": "13607/fgm.utm.065.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WebAdmin",
        "subtitle": "",
        "version": "V6.5",
        "type": "Release Notice",
        "edition": "2017-12",
        "filelink": "13640/fgm.webadmin.065.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WebAdmin",
        "subtitle": "Graphic Administration Interface for openUTM",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2017-11",
        "filelink": "13638/WebAdmin.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WinAdmin",
        "subtitle": "",
        "version": "V6.5",
        "type": "Release Notice",
        "edition": "2017-12",
        "filelink": "13636/fgm.winadmin.065.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WinAdmin",
        "subtitle": "Graphic Administration Interface for openUTM",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2017-11",
        "filelink": "13634/WinAdmin.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (BS2000, Unix /Linux /Windows Systems) \u2013 Carrier System UPIC",
        "subtitle": "",
        "version": "V6.5",
        "type": "Release Notice",
        "edition": "2020-01",
        "filelink": "20223/fgm.utm-client.065.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (BS2000, Unix /Linux /Windows Systems) \u2013 Carrier System UPIC",
        "subtitle": "",
        "version": "V6.5",
        "type": "Release Notice",
        "edition": "2018-04",
        "filelink": "13748/fgm.utm-client.065.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (Unix, Linux and Windows systems), Carrier System OpenCPIC",
        "subtitle": "",
        "version": "V4.0A",
        "type": "Release Notice",
        "edition": "2017-02",
        "filelink": "13039/fgm.openCPIC.040A50.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client V4.0 for the OpenCPIC Carrier System",
        "subtitle": "Client Server Communication with openUTM",
        "version": "V4.0",
        "type": "User Guide",
        "edition": "2017-02",
        "filelink": "13037/opencpic_e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-LU62 V5.1A41 (Unix/Linux/Windows Systems)",
        "subtitle": "",
        "version": "V5.1A41",
        "type": "Release Notice",
        "edition": "2010-05",
        "filelink": "8255/fgm.openutm-lu62.051a41.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Programming Applications with KDCS for Assembler (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "1998-11",
        "filelink": "13692/utm_ass.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Programming Applications with KDCS for COBOL, C and C++",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2017-12",
        "filelink": "13601/utm_prg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Supplement for FORTRAN (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "1997-02",
        "filelink": "13694/utm_for.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Supplement for Pascal-XT (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "1997-02",
        "filelink": "13696/utm_pas.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Supplement for PL/I (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "1997-02",
        "filelink": "13695/utm_pl1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Using UTM Applications on BS2000 Systems",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2017-12",
        "filelink": "13604/utm_betr.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Using UTM Applications on Unix, Linux and Windows Systems",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2017-12",
        "filelink": "13605/utmx_betr.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UTM\u2010XML V3.0A50 (BS2000, Unix /Linux /Windows Systems, z/OS)",
        "subtitle": "",
        "version": "V3.0",
        "type": "Release Notice / ReadMe ",
        "edition": "2013-11",
        "filelink": "7544/fgm.utm-xml.030.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WIN-DOORS",
        "subtitle": "",
        "version": "V3.1",
        "type": "User Guide",
        "edition": "1997-03",
        "filelink": "1853/win_dor.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "XML for openUTM",
        "subtitle": "",
        "version": "V6.5",
        "type": "User Guide",
        "edition": "2013-11",
        "filelink": "6475/utm-xml.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENUTMV65de": {
    "spaceProperties": {
      "prodId": "product-openutm",
      "prod": "openUTM",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Anwendungen administrieren",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2017-12",
        "filelink": "13586/utm_adm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen erstellen mit X/Open-Schnittstellen",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2017-12",
        "filelink": "13587/utm_xop.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen generieren",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2017-12",
        "filelink": "13588/utm_gen.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für Assembler (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "1998-11",
        "filelink": "13677/utm_ass.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für COBOL, C und C++",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2017-12",
        "filelink": "13589/utm_prg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für FORTRAN (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "1997-02",
        "filelink": "13679/utm_for.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für Pascal-XT (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "1997-02",
        "filelink": "13681/utm_pas.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für PL/I (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "1997-02",
        "filelink": "13680/utm_pl1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Client-Server-Kommunikation mit openUTM für Trägersystem UPIC",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2017-12",
        "filelink": "13608/utm_upic.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Einsatz von UTM-Anwendungen auf BS2000-Systemen",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2017-12",
        "filelink": "13590/utm_betr.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Einsatz von UTM-Anwendungen auf Unix-, Linux- und Windows-Systemen",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2017-12",
        "filelink": "13591/utmx_betr.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS",
        "subtitle": "Formatierungssystem für openUTM, TIAM, DCAM",
        "version": "V8.3A",
        "type": "Benutzerhandbuch",
        "edition": "2006-10",
        "filelink": "2094/fhs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS-DOORS",
        "subtitle": "Grafische Oberfläche für BS2000/OSD-Anwendungen",
        "version": "V3.1",
        "type": "Benutzerhandbuch",
        "edition": "1997-04",
        "filelink": "395/fhs_dor1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Konzepte und Funktionen",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2017-12",
        "filelink": "13592/utm_kon.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Meldungen, Test und Diagnose auf BS2000-Systemen",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2017-12",
        "filelink": "13593/utm_dia.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Meldungen, Test und Diagnose auf Unix-, Linux- und Windows-Systemen",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2017-12",
        "filelink": "13594/utmx_dia.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM (BS2000), openUTM-CRYPT (BS2000)",
        "subtitle": "",
        "version": "V6.5",
        "type": "Freigabemitteilung",
        "edition": "2018-04",
        "filelink": "13745/sysfgm.utm.065.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM Enterprise Edition, openUTM-CRYPT Enterprise Edition",
        "subtitle": "(Unix-, Linux- und Windows-Systeme)",
        "version": "V6.5A",
        "type": "Freigabemitteilung",
        "edition": "2018-04",
        "filelink": "13596/fgm.utm.065.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WebAdmin",
        "subtitle": "",
        "version": "V6.5",
        "type": "Freigabemitteilung",
        "edition": "2017-12",
        "filelink": "13639/fgm.webadmin.065.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WebAdmin",
        "subtitle": "Grafische Administrationsoberfläche für openUTM",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2017-11",
        "filelink": "13637/WebAdmin.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WinAdmin",
        "subtitle": "",
        "version": "V6.5",
        "type": "Freigabemitteilung",
        "edition": "2017-12",
        "filelink": "13635/fgm.winadmin.065.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WinAdmin",
        "subtitle": "Grafische Administrationsoberfläche für openUTM",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2017-11",
        "filelink": "13633/WinAdmin.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (BS2000, Unix-/Linux-/Windows-Systeme) \u2013 Trägersystem UPIC",
        "subtitle": "",
        "version": "V6.5",
        "type": "Freigabemitteilung",
        "edition": "2020-01",
        "filelink": "20222/fgm.utm-client.065.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (BS2000, Unix-/Linux-/Windows-Systeme) \u2013 Trägersystem UPIC",
        "subtitle": "",
        "version": "V6.5",
        "type": "Freigabemitteilung",
        "edition": "2018-04",
        "filelink": "13747/fgm.utm-client.065.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (Unix-, Linux- und Windows-Systeme), Trägersystem OpenCPIC",
        "subtitle": "",
        "version": "V4.0A",
        "type": "Freigabemitteilung",
        "edition": "2017-02",
        "filelink": "13038/fgm.openCPIC.040A50.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client V4.0 für Trägersystem OpenCPIC",
        "subtitle": "Client-Server-Kommunikation mit openUTM",
        "version": "V4.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-02",
        "filelink": "13036/opencpic_d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-LU62 V5.1A41 (Unix-/Linux-/Windows-Systeme)",
        "subtitle": "",
        "version": "V5.1A41",
        "type": "Freigabemitteilung",
        "edition": "2010-05",
        "filelink": "8254/fgm.openutm-lu62.051a41.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UTM\u2010XML V3.0A50 (BS2000, Unix-/Linux-/Windows\u2010Systeme, z/OS)",
        "subtitle": "",
        "version": "V3.0",
        "type": "Freigabemitteilung / ReadMe ",
        "edition": "2013-11",
        "filelink": "7543/fgm.utm-xml.030.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Verteilte Transaktionsverarbeitung zwischen openUTM- und CICS-, IMS- und LU6.2-Anwendungen",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2008-07",
        "filelink": "6903/utm_lu62-6.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WIN-DOORS",
        "subtitle": "",
        "version": "V3.1",
        "type": "Benutzerhandbuch",
        "edition": "1997-04",
        "filelink": "922/win_dor.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "XML für openUTM",
        "subtitle": "",
        "version": "V6.5",
        "type": "Benutzerhandbuch",
        "edition": "2013-11",
        "filelink": "6474/utm-xml.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENUTMV64en": {
    "spaceProperties": {
      "prodId": "product-openutm",
      "prod": "openUTM",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Administering Applications",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "2016-07",
        "filelink": "12866/utm_adm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Client-Server Communication with openUTM for the UPIC Carrier System",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "2016-07",
        "filelink": "12867/utm_upic.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Concepts and Functions",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "2016-07",
        "filelink": "12868/utm_kon.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Creating Applications with X/Open Interfaces",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "2016-07",
        "filelink": "12869/utm_xop.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Distributed Transaction Processing between openUTM and CICS, IMS and LU6.2 Applications",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "2008-07",
        "filelink": "6904/utm_lu62-6.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS",
        "subtitle": "Format Handling System für openUTM, TIAM, DCAM",
        "version": "V8.3A",
        "type": "User Guide",
        "edition": "2006-10",
        "filelink": "2806/fhs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS-DOORS",
        "subtitle": "Graphical interface for BS2000/OSD applications",
        "version": "V3.1",
        "type": "User Guide",
        "edition": "1997-03",
        "filelink": "1323/fhs_dor1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Generating Applications",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "2016-07",
        "filelink": "12870/utm_gen.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Master Index",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "2016-07",
        "filelink": "12892/utm_index.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Messages, Debugging and Diagnostics on BS2000 Systems",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "2016-07",
        "filelink": "12872/utm_dia.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Messages, Debugging and Diagnostics on Unix, Linux and Windows Systems",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "2016-07",
        "filelink": "12877/utmx_dia.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM ( (Unix / Linux / Windows systems)",
        "subtitle": "",
        "version": "V6.4",
        "type": "Release Notice",
        "edition": "2016-07",
        "filelink": "12888/fgm.utm.064.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM (BS2000), openUTM-CRYPT (BS2000)",
        "subtitle": "",
        "version": "V6.4",
        "type": "Release Notice",
        "edition": "2018-05",
        "filelink": "12895/sysfgm.utm.064.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WebAdmin",
        "subtitle": "",
        "version": "V6.4",
        "type": "Release Notice",
        "edition": "2016-07",
        "filelink": "12886/fgm.webadmin.064.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WebAdmin",
        "subtitle": "Graphic Administration Interface for openUTM",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "2016-06",
        "filelink": "12884/WebAdmin.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WinAdmin",
        "subtitle": "",
        "version": "V6.4",
        "type": "Release Notice",
        "edition": "2016-07",
        "filelink": "12882/fgm.winadmin.064.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WinAdmin",
        "subtitle": "Graphic Administration Interface for openUTM",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "2016-07",
        "filelink": "12880/WinAdmin.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (BS2000, Unix /Linux /Windows Systems) \u2013 Carrier System UPIC",
        "subtitle": "",
        "version": "V6.4",
        "type": "Release Notice",
        "edition": "2016-07",
        "filelink": "12890/sysfgm.utm-client.064.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (Unix, Linux and Windows systems), Carrier System OpenCPIC",
        "subtitle": "",
        "version": "V4.0A",
        "type": "Release Notice",
        "edition": "2017-02",
        "filelink": "13039/fgm.openCPIC.040A50.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client V4.0 for the OpenCPIC Carrier System",
        "subtitle": "Client Server Communication with openUTM",
        "version": "V4.0",
        "type": "User Guide",
        "edition": "2017-02",
        "filelink": "13037/opencpic_e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-LU62 V5.1A41 (Unix/Linux/Windows Systems)",
        "subtitle": "",
        "version": "V5.1A41",
        "type": "Release Notice",
        "edition": "2010-05",
        "filelink": "8255/fgm.openutm-lu62.051a41.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Programming Applications with KDCS for Assembler (BS2000)",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "1998-11",
        "filelink": "13692/utm_ass.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Programming Applications with KDCS for COBOL, C and C++",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "2016-07",
        "filelink": "12873/utm_prg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Supplement for FORTRAN (BS2000)",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "1997-02",
        "filelink": "13694/utm_for.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Supplement for Pascal-XT (BS2000)",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "1997-02",
        "filelink": "13696/utm_pas.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Supplement for PL/I (BS2000)",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "1997-02",
        "filelink": "13695/utm_pl1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Using openUTM Applications on BS2000 Systems",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "2016-07",
        "filelink": "12871/utm_betr.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Using openUTM Applications on Unix, Linux and Windows Systems",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "2016-07",
        "filelink": "12876/utmx_betr.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UTM\u2010XML V3.0A50 (BS2000, Unix /Linux /Windows Systems, z/OS)",
        "subtitle": "",
        "version": "V3.0",
        "type": "Release Notice / ReadMe ",
        "edition": "2013-11",
        "filelink": "7544/fgm.utm-xml.030.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WIN-DOORS",
        "subtitle": "",
        "version": "V3.1",
        "type": "User Guide",
        "edition": "1997-03",
        "filelink": "1853/win_dor.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "XML for openUTM",
        "subtitle": "",
        "version": "V6.4",
        "type": "User Guide",
        "edition": "2013-11",
        "filelink": "6475/utm-xml.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENUTMV64de": {
    "spaceProperties": {
      "prodId": "product-openutm",
      "prod": "openUTM",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Anwendungen administrieren",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "2016-07",
        "filelink": "12858/utm_adm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen erstellen mit X/Open-Schnittstellen",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "2016-07",
        "filelink": "12859/utm_xop.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen generieren",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "2016-07",
        "filelink": "12860/utm_gen.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für Assembler (BS2000)",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "1998-11",
        "filelink": "13677/utm_ass.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für COBOL, C und C++",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "2016-07",
        "filelink": "12861/utm_prg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für FORTRAN (BS2000)",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "1997-02",
        "filelink": "13679/utm_for.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für Pascal-XT (BS2000)",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "1997-02",
        "filelink": "13681/utm_pas.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für PL/I (BS2000)",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "1997-02",
        "filelink": "13680/utm_pl1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Client-Server-Kommunikation mit openUTM  für Trägersystem UPIC",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "2016-07",
        "filelink": "12865/utm_upic.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Einsatz von openUTM-Anwendungen auf BS2000-Systemen",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "2016-07",
        "filelink": "12863/utm_betr.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Einsatz von openUTM-Anwendungen auf Unix-, Linux- und Windows-Systemen",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "2016-07",
        "filelink": "12874/utmx_betr.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS",
        "subtitle": "Formatierungssystem für openUTM, TIAM, DCAM",
        "version": "V8.3A",
        "type": "Benutzerhandbuch",
        "edition": "2006-10",
        "filelink": "2094/fhs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS-DOORS",
        "subtitle": "Grafische Oberfläche für BS2000/OSD-Anwendungen",
        "version": "V3.1",
        "type": "Benutzerhandbuch",
        "edition": "1997-04",
        "filelink": "395/fhs_dor1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Konzepte und Funktionen",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "2016-07",
        "filelink": "12862/utm_kon.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Masterindex",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "2016-07",
        "filelink": "12891/utm_index.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Meldungen, Test und Diagnose auf BS2000-Systemen",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "2016-07",
        "filelink": "12864/utm_dia.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Meldungen, Test und Diagnose auf Unix-, Linux- und Windows-Systemen",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "2016-07",
        "filelink": "12875/utmx_dia.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM (BS2000), openUTM-CRYPT (BS2000)",
        "subtitle": "",
        "version": "V6.4",
        "type": "Freigabemitteilung",
        "edition": "2018-05",
        "filelink": "12894/sysfgm.utm.064.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM (Unix-/Linux-/Windows-Systeme)",
        "subtitle": "",
        "version": "V6.4",
        "type": "Freigabemitteilung",
        "edition": "2016-07",
        "filelink": "12887/fgm.utm.064.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WebAdmin",
        "subtitle": "",
        "version": "V6.4",
        "type": "Freigabemitteilung",
        "edition": "2016-07",
        "filelink": "12885/fgm.webadmin.064.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WebAdmin",
        "subtitle": "Grafische Administrationsoberfläche für openUTM",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "2016-06",
        "filelink": "12883/WebAdmin.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WinAdmin",
        "subtitle": "",
        "version": "V6.4",
        "type": "Freigabemitteilung",
        "edition": "2016-07",
        "filelink": "12881/fgm.winadmin.064.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WinAdmin",
        "subtitle": "Grafische Administrationsoberfläche für openUTM",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "2016-06",
        "filelink": "12879/WinAdmin.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (BS2000, Unix-/Linux-/Windows-Systeme) \u2013 Trägersystem UPIC",
        "subtitle": "",
        "version": "V6.4",
        "type": "Freigabemitteilung",
        "edition": "2016-07",
        "filelink": "12889/sysfgm.utm-client.064.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (Unix-, Linux- und Windows-Systeme), Trägersystem OpenCPIC",
        "subtitle": "",
        "version": "V4.0A",
        "type": "Freigabemitteilung",
        "edition": "2017-02",
        "filelink": "13038/fgm.openCPIC.040A50.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client V4.0 für Trägersystem OpenCPIC",
        "subtitle": "Client-Server-Kommunikation mit openUTM",
        "version": "V4.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-02",
        "filelink": "13036/opencpic_d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-LU62 V5.1A41 (Unix-/Linux-/Windows-Systeme)",
        "subtitle": "",
        "version": "V5.1A41",
        "type": "Freigabemitteilung",
        "edition": "2010-05",
        "filelink": "8254/fgm.openutm-lu62.051a41.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UTM\u2010XML V3.0A50 (BS2000, Unix-/Linux-/Windows\u2010Systeme, z/OS)",
        "subtitle": "",
        "version": "V3.0",
        "type": "Freigabemitteilung / ReadMe ",
        "edition": "2013-11",
        "filelink": "7543/fgm.utm-xml.030.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Verteilte Transaktionsverarbeitung zwischen openUTM- und CICS-, IMS- und LU6.2-Anwendungen",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "2008-07",
        "filelink": "6903/utm_lu62-6.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WIN-DOORS",
        "subtitle": "",
        "version": "V3.1",
        "type": "Benutzerhandbuch",
        "edition": "1997-04",
        "filelink": "922/win_dor.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "XML für openUTM",
        "subtitle": "",
        "version": "V6.4",
        "type": "Benutzerhandbuch",
        "edition": "2013-11",
        "filelink": "6474/utm-xml.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENUTMV63en": {
    "spaceProperties": {
      "prodId": "product-openutm",
      "prod": "openUTM",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Administering Applications",
        "subtitle": "",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "2015-01",
        "filelink": "11941/utm_adm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Client-Server Communication with openUTM for the UPIC Carrier System",
        "subtitle": "",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "2015-01",
        "filelink": "11947/utm_upic.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Concepts and Functions",
        "subtitle": "",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "2015-01",
        "filelink": "11951/utm_kon.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Creating Applications with X/Open Interfaces",
        "subtitle": "",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "2015-01",
        "filelink": "11999/utm_xop.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Distributed Transaction Processing between openUTM and CICS, IMS and LU6.2 Applications",
        "subtitle": "",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "2008-07",
        "filelink": "6904/utm_lu62-6.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS",
        "subtitle": "Format Handling System für openUTM, TIAM, DCAM",
        "version": "V8.3A",
        "type": "User Guide",
        "edition": "2006-10",
        "filelink": "2806/fhs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS-DOORS",
        "subtitle": "Graphical interface for BS2000/OSD applications",
        "version": "V3.1",
        "type": "User Guide",
        "edition": "1997-03",
        "filelink": "1323/fhs_dor1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Generating Applications",
        "subtitle": "",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "2015-01",
        "filelink": "11943/utm_gen.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Master Index",
        "subtitle": "",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "2015-01",
        "filelink": "11967/utm_index.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Messages, Debugging and Diagnostics in BS2000 Systems",
        "subtitle": "",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "2015-05",
        "filelink": "11953/utm_dia.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Messages, Debugging and Diagnostics in Unix Systems and Windows Systems",
        "subtitle": "",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "2015-05",
        "filelink": "11982/utmx_dia.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM ( (Unix / Linux / Windows systems)",
        "subtitle": "",
        "version": "V6.3",
        "type": "Release Notice",
        "edition": "2015-01",
        "filelink": "11984/fgm.utm.063.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM (BS2000), openUTM-CRYPT (BS2000)",
        "subtitle": "",
        "version": "V6.3",
        "type": "Release Notice",
        "edition": "2018-05",
        "filelink": "11976/sysfgm.utm.063.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WebAdmin",
        "subtitle": "",
        "version": "V6.3",
        "type": "Release Notice / ReadMe ",
        "edition": "2015-05",
        "filelink": "12219/fgm.webadmin.063.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WebAdmin",
        "subtitle": "Web user interface for administering openUTM",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "2015-05",
        "filelink": "12217/WebAdmin.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WinAdmin",
        "subtitle": "",
        "version": "V6.3",
        "type": "Release Notice",
        "edition": "2015-01",
        "filelink": "11986/fgm.winadmin.063.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WinAdmin",
        "subtitle": "Graphic Administration Interface for openUTM",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "2015-01",
        "filelink": "11965/WinAdmin.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (BS2000, Unix /Linux /Windows Systems) \u2013 Carrier System UPIC",
        "subtitle": "",
        "version": "V6.3",
        "type": "Release Notice",
        "edition": "2015-01",
        "filelink": "11961/fgm.utm-client.063.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (Unix, Linux and Windows systems), Carrier System OpenCPIC",
        "subtitle": "",
        "version": "V4.0A",
        "type": "Release Notice",
        "edition": "2017-02",
        "filelink": "13039/fgm.openCPIC.040A50.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client for carrier System UPIC",
        "subtitle": "",
        "version": "V6.3",
        "type": "Release Notice",
        "edition": "2015-01",
        "filelink": "11978/sysfgm.utm-client.063.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client V4.0 for the OpenCPIC Carrier System",
        "subtitle": "Client Server Communication with openUTM",
        "version": "V4.0",
        "type": "User Guide",
        "edition": "2017-02",
        "filelink": "13037/opencpic_e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-LU62 V5.1A41 (Unix/Linux/Windows Systems)",
        "subtitle": "",
        "version": "V5.1A41",
        "type": "Release Notice",
        "edition": "2010-05",
        "filelink": "8255/fgm.openutm-lu62.051a41.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Programming Applications with KDCS for Assembler (BS2000)",
        "subtitle": "",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "1998-11",
        "filelink": "13692/utm_ass.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Programming Applications with KDCS for COBOL, C and C++",
        "subtitle": "",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "2015-01",
        "filelink": "11945/utm_prg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Supplement for FORTRAN (BS2000)",
        "subtitle": "",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "1997-02",
        "filelink": "13694/utm_for.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Supplement for Pascal-XT (BS2000)",
        "subtitle": "",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "1997-02",
        "filelink": "13696/utm_pas.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Supplement for PL/I (BS2000)",
        "subtitle": "",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "1997-02",
        "filelink": "13695/utm_pl1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Using openUTM Applications under BS2000 Systems",
        "subtitle": "",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "2015-01",
        "filelink": "11949/utm_betr.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Using openUTM Applications under Unix Systems and Windows Systems",
        "subtitle": "",
        "version": "V6.3",
        "type": "User Guide",
        "edition": "2015-01",
        "filelink": "11980/utmx_betr.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UTM\u2010XML V3.0A50 (BS2000, Unix /Linux /Windows Systems, z/OS)",
        "subtitle": "",
        "version": "V3.0",
        "type": "Release Notice / ReadMe ",
        "edition": "2013-11",
        "filelink": "7544/fgm.utm-xml.030.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WIN-DOORS",
        "subtitle": "",
        "version": "V3.1",
        "type": "User Guide",
        "edition": "1997-03",
        "filelink": "1853/win_dor.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "XML for openUTM",
        "subtitle": "",
        "version": "V3.0",
        "type": "User Guide",
        "edition": "2013-11",
        "filelink": "6475/utm-xml.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psOPENUTMV63de": {
    "spaceProperties": {
      "prodId": "product-openutm",
      "prod": "openUTM",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Anwendungen administrieren",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "2015-01",
        "filelink": "11940/utm_adm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen erstellen mit X/Open-Schnittstellen",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "2015-01",
        "filelink": "11998/utm_xop.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen generieren",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "2015-01",
        "filelink": "11942/utm_gen.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für Assembler (BS2000)",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "1998-11",
        "filelink": "13677/utm_ass.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für COBOL, C und C++",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "2015-01",
        "filelink": "11944/utm_prg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für FORTRAN (BS2000)",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "1997-02",
        "filelink": "13679/utm_for.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für Pascal-XT (BS2000)",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "1997-02",
        "filelink": "13681/utm_pas.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anwendungen programmieren mit KDCS für PL/I (BS2000)",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "1997-02",
        "filelink": "13680/utm_pl1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Client-Server-Kommunikation mit openUTM  für Trägersystem UPIC",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "2015-01",
        "filelink": "11946/utm_upic.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Einsatz von openUTM-Anwendungen unter BS2000-Systemen",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "2015-01",
        "filelink": "11948/utm_betr.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Einsatz von openUTM-Anwendungen unter Unix- und Windows-Systemen",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "2015-01",
        "filelink": "11979/utmx_betr.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS",
        "subtitle": "Formatierungssystem für openUTM, TIAM, DCAM",
        "version": "V8.3A",
        "type": "Benutzerhandbuch",
        "edition": "2006-10",
        "filelink": "2094/fhs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "FHS-DOORS",
        "subtitle": "Grafische Oberfläche für BS2000/OSD-Anwendungen",
        "version": "V3.1",
        "type": "Benutzerhandbuch",
        "edition": "1997-04",
        "filelink": "395/fhs_dor1.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Konzepte und Funktionen",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "2015-01",
        "filelink": "11950/utm_kon.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Masterindex",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "2015-01",
        "filelink": "11966/utm_index.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Meldungen, Test und Diagnose in BS2000-Systemen",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "2015-01",
        "filelink": "11952/utm_dia.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Meldungen, Test und Diagnose in Unix- und Windows-Systemen",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "2015-01",
        "filelink": "11981/utmx_dia.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM (BS2000), openUTM-CRYPT (BS2000)",
        "subtitle": "",
        "version": "V6.3",
        "type": "Freigabemitteilung",
        "edition": "2018-05",
        "filelink": "11975/sysfgm.utm.063.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM (Unix-/Linux-/Windows-Systeme)",
        "subtitle": "",
        "version": "V6.3",
        "type": "Freigabemitteilung",
        "edition": "2015-01",
        "filelink": "11983/fgm.utm.063.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WebAdmin",
        "subtitle": "",
        "version": "V6.3",
        "type": "Freigabemitteilung",
        "edition": "2015-05",
        "filelink": "12218/fgm.webadmin.063.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WebAdmin",
        "subtitle": "Web-Oberfläche zur Administration von openUTM",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "2015-05",
        "filelink": "12216/WebAdmin.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WinAdmin",
        "subtitle": "",
        "version": "V6.3",
        "type": "Freigabemitteilung",
        "edition": "2015-01",
        "filelink": "11985/fgm.winadmin.063.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM WinAdmin",
        "subtitle": "Grafische Administrationsoberfläche für openUTM",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "2015-01",
        "filelink": "11964/WinAdmin.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (BS2000, Unix-/Linux-/Windows-Systeme) \u2013 Trägersystem UPIC",
        "subtitle": "",
        "version": "V6.3",
        "type": "Freigabemitteilung",
        "edition": "2015-01",
        "filelink": "11960/fgm.utm-client.063.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client (Unix-, Linux- und Windows-Systeme), Trägersystem OpenCPIC",
        "subtitle": "",
        "version": "V4.0A",
        "type": "Freigabemitteilung",
        "edition": "2017-02",
        "filelink": "13038/fgm.openCPIC.040A50.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client für Trägersystem UPIC",
        "subtitle": "",
        "version": "V6.3",
        "type": "Freigabemitteilung",
        "edition": "2015-01",
        "filelink": "11977/sysfgm.utm-client.063.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-Client V4.0 für Trägersystem OpenCPIC",
        "subtitle": "Client-Server-Kommunikation mit openUTM",
        "version": "V4.0",
        "type": "Benutzerhandbuch",
        "edition": "2017-02",
        "filelink": "13036/opencpic_d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "openUTM-LU62 V5.1A41 (Unix-/Linux-/Windows-Systeme)",
        "subtitle": "",
        "version": "V5.1A41",
        "type": "Freigabemitteilung",
        "edition": "2010-05",
        "filelink": "8254/fgm.openutm-lu62.051a41.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "UTM\u2010XML V3.0A50 (BS2000, Unix-/Linux-/Windows\u2010Systeme, z/OS)",
        "subtitle": "",
        "version": "V3.0",
        "type": "Freigabemitteilung / ReadMe ",
        "edition": "2013-11",
        "filelink": "7543/fgm.utm-xml.030.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Verteilte Transaktionsverarbeitung zwischen openUTM- und CICS-, IMS- und LU6.2-Anwendungen",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "2008-07",
        "filelink": "6903/utm_lu62-6.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WIN-DOORS",
        "subtitle": "",
        "version": "V3.1",
        "type": "Benutzerhandbuch",
        "edition": "1997-04",
        "filelink": "922/win_dor.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "XML für openUTM",
        "subtitle": "",
        "version": "V6.3",
        "type": "Benutzerhandbuch",
        "edition": "2013-11",
        "filelink": "6474/utm-xml.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psPCMXUNIXBASEDOSV60en": {
    "spaceProperties": {
      "prodId": "product-pcmxunixbasedos",
      "prod": "PCMX (Unix based OS)",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "CMX (Solaris) Operation and Administration",
        "subtitle": "",
        "version": "V6.0B",
        "type": "User Guide",
        "edition": "2005-06",
        "filelink": "7707/o41103e4.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX (Solaris) Operation and Administration",
        "subtitle": "",
        "version": "V6.0A",
        "type": "User Guide",
        "edition": "2003-06",
        "filelink": "7706/o41103e3.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX (Unix) Manual Changes",
        "subtitle": "",
        "version": "V6.0",
        "type": "Manual Changes",
        "edition": "2018-12",
        "filelink": "7714/pcmx-manual_changes_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX Programming Applications",
        "subtitle": "",
        "version": "V6.0",
        "type": "User Guide",
        "edition": "2003-06",
        "filelink": "7708/o41136e3.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX TCP/IP via WAN/ISDN",
        "subtitle": "",
        "version": "V6.0",
        "type": "User Guide",
        "edition": "2001-12",
        "filelink": "7709/o41106e2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX/CCP ISDN Communication",
        "subtitle": "",
        "version": "V6.0",
        "type": "User Guide",
        "edition": "2003-06",
        "filelink": "7711/o41105e3.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX/CCP WAN Communication",
        "subtitle": "",
        "version": "V6.0",
        "type": "User Guide",
        "edition": "2003-06",
        "filelink": "7710/o41104e3.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Configuration with KOGS Macros",
        "subtitle": "",
        "version": "",
        "type": "User Guide",
        "edition": "2000-01",
        "filelink": "7791/kogs_e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PCMX",
        "subtitle": "",
        "version": "V6.0B",
        "type": "Release Notice",
        "edition": "2012-06",
        "filelink": "13819/fgm.pcmx-pure-60b00.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PCMX (AIX)",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Release Notice",
        "edition": "2009-06",
        "filelink": "7725/fgm.pcmx-aix-60a60.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PCMX (HPUX)",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Release Notice",
        "edition": "2009-06",
        "filelink": "7726/fgm.pcmx-hpux-60a60.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PCMX (LINUX-EMT64)",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Release Notice",
        "edition": "2009-06",
        "filelink": "7727/fgm.pcmx-linux-emt64-60a70.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PCMX (LINUX-IA32)",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Release Notice",
        "edition": "2009-06",
        "filelink": "7728/fgm.pcmx-linux-ia32-60a70.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PCMX (LINUX-IA64)",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Release Notice",
        "edition": "2009-06",
        "filelink": "7729/fgm.pcmx-linux-ia64-60a70.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SMAWpcmx (Solaris-IA32)",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Release Notice",
        "edition": "2009-06",
        "filelink": "7732/fgm.pcmx-solaris-ia32-60a60.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SMAWpcmx (SOLARIS-sparc)",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Release Notice",
        "edition": "2009-06",
        "filelink": "7724/fgm.pcmx-solaris-sparc-60a60.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "XTI X/Open Transport Interface",
        "subtitle": "",
        "version": "V6.0",
        "type": "User Guide",
        "edition": "2001-12",
        "filelink": "7705/o20225e3.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psPCMXUNIXBASEDOSV60de": {
    "spaceProperties": {
      "prodId": "product-pcmxunixbasedos",
      "prod": "PCMX (Unix basiertes OS)",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "CMX (Solaris) Betrieb und Administration",
        "subtitle": "",
        "version": "V6.0B",
        "type": "Betrieb und Administration",
        "edition": "2005-06",
        "filelink": "7699/o41103d4.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX (Solaris) Betrieb und Administration",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Betrieb und Administration",
        "edition": "2003-06",
        "filelink": "7697/o41103d3.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX (Unix) Betrieb und Administration",
        "subtitle": "",
        "version": "V6.0",
        "type": "Benutzerhandbuch",
        "edition": "2003-06",
        "filelink": "7712/o20871d2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX (Unix) Manual Changes",
        "subtitle": "(Änderungen zum Handbuch Betrieb und Administration)",
        "version": "V6.0",
        "type": "Änderungen zum Handbuch",
        "edition": "2018-12",
        "filelink": "7713/pcmx-manual_changes_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX TCP/IP über WAN/ISDN",
        "subtitle": "",
        "version": "V6.0",
        "type": "Benutzerhandbuch",
        "edition": "2001-12",
        "filelink": "7704/o41106d2.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX-Anwendungen programmieren",
        "subtitle": "",
        "version": "V6.0",
        "type": "Benutzerhandbuch",
        "edition": "2003-06",
        "filelink": "7698/o41136d3.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX/CCP ISDN-Kommunikation",
        "subtitle": "",
        "version": "V6.0",
        "type": "Benutzerhandbuch",
        "edition": "2003-06",
        "filelink": "7703/o41105d3.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX/CCP Transport Gateway CS-GATE",
        "subtitle": "",
        "version": "V6.0B",
        "type": "Benutzerhandbuch",
        "edition": "2005-06",
        "filelink": "7701/csgate60bd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX/CCP Transport Gateway CS-GATE",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Benutzerhandbuch",
        "edition": "2003-06",
        "filelink": "7700/csgate60ad.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "CMX/CCP WAN-Kommunikation",
        "subtitle": "",
        "version": "V6.0",
        "type": "Benutzerhandbuch",
        "edition": "2003-06",
        "filelink": "7702/o41104d3.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Konfigurieren mit KOGS-Makros",
        "subtitle": "",
        "version": "",
        "type": "Benutzerhandbuch",
        "edition": "2000-01",
        "filelink": "7790/kogs_d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PCMX",
        "subtitle": "",
        "version": "V6.0B",
        "type": "Freigabemitteilung",
        "edition": "2012-06",
        "filelink": "13818/fgm.pcmx-pure-60b00.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PCMX (AIX)",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Freigabemitteilung",
        "edition": "2009-06",
        "filelink": "7715/fgm.pcmx-aix-60a60.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PCMX (HPUX)",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Freigabemitteilung",
        "edition": "2009-06",
        "filelink": "7716/fgm.pcmx-hpux-60a60.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PCMX (LINUX-EMT64)",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Freigabemitteilung",
        "edition": "2009-06",
        "filelink": "7717/fgm.pcmx-linux-emt64-60a70.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PCMX (LINUX-IA32)",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Freigabemitteilung",
        "edition": "2009-06",
        "filelink": "7718/fgm.pcmx-linux-ia32-60a70.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "PCMX (LINUX-IA64)",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Freigabemitteilung",
        "edition": "2009-06",
        "filelink": "7719/fgm.pcmx-linux-ia64-60a70.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SMAWpcmx (Solaris-IA32)",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Freigabemitteilung",
        "edition": "2009-06",
        "filelink": "7722/fgm.pcmx-solaris-ia32-60a60.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SMAWpcmx (SOLARIS-sparc)",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Freigabemitteilung",
        "edition": "2009-06",
        "filelink": "7723/fgm.pcmx-solaris-sparc-60a60.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psWEBTRANSACTIONSV75en": {
    "spaceProperties": {
      "prodId": "product-webtransactions",
      "prod": "WebTransactions",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Access to Dynamic Web Contents",
        "subtitle": "",
        "version": "V7.5",
        "type": "User Guide",
        "edition": "2010-08",
        "filelink": "9581/webta_hp.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Client-APIs for WebTransactions",
        "subtitle": "",
        "version": "V7.5",
        "type": "User Guide",
        "edition": "2010-08",
        "filelink": "9593/wta_cl.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Concepts and Functions",
        "subtitle": "",
        "version": "V7.5",
        "type": "User Guide",
        "edition": "2010-08",
        "filelink": "9579/webta_kf.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Connection to MVS Applications",
        "subtitle": "",
        "version": "V7.5",
        "type": "User Guide",
        "edition": "2010-08",
        "filelink": "9589/wta_mvs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Connection to openUTM Applications via UPIC",
        "subtitle": "",
        "version": "V7.5",
        "type": "User Guide",
        "edition": "2010-08",
        "filelink": "9591/wta_utm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Connection to OSD Applications",
        "subtitle": "",
        "version": "V7.5",
        "type": "User Guide",
        "edition": "2010-08",
        "filelink": "9583/webta_osd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Template Language",
        "subtitle": "",
        "version": "V7.5",
        "type": "Reference Manual",
        "edition": "2010-08",
        "filelink": "9585/webta_ts.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Web-Frontend for Web Services",
        "subtitle": "",
        "version": "V7.5",
        "type": "User Guide",
        "edition": "2010-08",
        "filelink": "9587/wta_seas.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA for MVS (Unix systems)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Release Notice",
        "edition": "2020-05",
        "filelink": "20305/fgm.webta-mvs-unix.075.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA for MVS (Windows)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Release Notice",
        "edition": "2020-05",
        "filelink": "20307/fgm.webta-mvs-windows.075.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA for openUTM (Unix systems)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Release Notice",
        "edition": "2020-05",
        "filelink": "20313/fgm.webta-utm-unix.075.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA for openUTM (Windows)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Release Notice",
        "edition": "2020-05",
        "filelink": "20315/fgm.webta-utm-windows.075.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA for OSD (Unix systems)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Release Notice",
        "edition": "2020-05",
        "filelink": "20309/fgm.webta-osd-unix.075.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA for OSD (Windows)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Release Notice",
        "edition": "2020-05",
        "filelink": "20311/fgm.webta-osd-windows.075.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA openUTM (BS2000)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Release Notice",
        "edition": "2020-05",
        "filelink": "20321/sysfgm.webta-utm-bs2000.075.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA OSD (BS2000)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Release Notice",
        "edition": "2020-05",
        "filelink": "20319/sysfgm.webta-osd-bs2000.075.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTransactions WebLab (Windows)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Release Notice",
        "edition": "2020-05",
        "filelink": "20317/fgm.wlab-windows.075.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTransactions-OSD",
        "subtitle": "",
        "version": "V7.5",
        "type": "Release Notice",
        "edition": "2014-12",
        "filelink": "9608/sysfgm.webta-osd-bs2000.075.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTransactions-UTM",
        "subtitle": "",
        "version": "V7.5",
        "type": "Release Notice",
        "edition": "2014-12",
        "filelink": "9609/sysfgm.webta-utm-bs2000.075.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psWEBTRANSACTIONSV75de": {
    "spaceProperties": {
      "prodId": "product-webtransactions",
      "prod": "WebTransactions",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Anschluss an MVS-Anwendungen",
        "subtitle": "",
        "version": "V7.5",
        "type": "Benutzerhandbuch",
        "edition": "2010-08",
        "filelink": "9588/wta_mvs.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anschluss an openUTM-Anwendungen über UPIC",
        "subtitle": "",
        "version": "V7.5",
        "type": "Benutzerhandbuch",
        "edition": "2010-08",
        "filelink": "9590/wta_utm.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Anschluss an OSD-Anwendungen",
        "subtitle": "",
        "version": "V7.5",
        "type": "Benutzerhandbuch",
        "edition": "2010-08",
        "filelink": "9582/webta_osd.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Client-APIs für WebTransactions",
        "subtitle": "",
        "version": "V7.5",
        "type": "Benutzerhandbuch",
        "edition": "2010-08",
        "filelink": "9592/wta_cl.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Konzepte und Funktionen",
        "subtitle": "",
        "version": "V7.5",
        "type": "Benutzerhandbuch",
        "edition": "2010-08",
        "filelink": "9578/webta_kf.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Template-Sprache",
        "subtitle": "",
        "version": "V7.5",
        "type": "Referenzhandbuch",
        "edition": "2010-08",
        "filelink": "9584/webta_ts.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Web-Frontend für Web-Services",
        "subtitle": "",
        "version": "V7.5",
        "type": "Benutzerhandbuch",
        "edition": "2010-08",
        "filelink": "9586/wta_seas.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA for MVS (Unix-Systeme)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Freigabemitteilung",
        "edition": "2020-05",
        "filelink": "20304/fgm.webta-mvs-unix.075.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA for MVS (Windows)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Freigabemitteilung",
        "edition": "2020-05",
        "filelink": "20306/fgm.webta-mvs-windows.075.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA for openUTM (Unix-Systeme)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Freigabemitteilung",
        "edition": "2020-05",
        "filelink": "20312/fgm.webta-utm-unix.075.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA for openUTM (Windows)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Freigabemitteilung",
        "edition": "2020-05",
        "filelink": "20314/fgm.webta-utm-windows.075.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA for OSD (Unix-Systeme)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Freigabemitteilung",
        "edition": "2020-05",
        "filelink": "20308/fgm.webta-osd-unix.075.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA for OSD (Windows)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Freigabemitteilung",
        "edition": "2020-05",
        "filelink": "20310/fgm.webta-osd-windows.075.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA openUTM (BS2000)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Freigabemitteilung",
        "edition": "2020-05",
        "filelink": "20320/sysfgm.webta-utm-bs2000.075.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTA OSD (BS2000)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Freigabemitteilung",
        "edition": "2020-05",
        "filelink": "20318/sysfgm.webta-osd-bs2000.075.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTransactions WebLab (Windows)",
        "subtitle": "",
        "version": "V7.5C",
        "type": "Freigabemitteilung",
        "edition": "2020-05",
        "filelink": "20316/fgm.wlab-windows.075.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTransactions-OSD",
        "subtitle": "",
        "version": "V7.5",
        "type": "Freigabemitteilung",
        "edition": "2014-12",
        "filelink": "9607/sysfgm.webta-osd-bs2000.075.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "WebTransactions-UTM",
        "subtitle": "",
        "version": "V7.5",
        "type": "Freigabemitteilung",
        "edition": "2014-12",
        "filelink": "9610/sysfgm.webta-utm-bs2000.075.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Zugriff auf dynamische Web-Inhalte",
        "subtitle": "",
        "version": "V7.5",
        "type": "Benutzerhandbuch",
        "edition": "2010-08",
        "filelink": "9580/webta_hp.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSESERIESINFRASTRUCTUREV63en": {
    "spaceProperties": {
      "prodId": "product-seseriesinfrastructure",
      "prod": "SE Infrastructure",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Release Notice HNC (HNC)",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Release Notice",
        "edition": "2020-01",
        "filelink": "20202/sysfgm.HNC.063.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager  (Add-on StorMan)",
        "subtitle": "",
        "version": "V8.0.1",
        "type": "User Guide",
        "edition": "2018-04",
        "filelink": "13632/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Release Notice M2000 (MU)",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Release Notice",
        "edition": "2020-01",
        "filelink": "20203/sysfgm.M2000.063.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Release Notice X2000 (SU x86)",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Release Notice",
        "edition": "2020-01",
        "filelink": "20205/sysfgm.X2000.063.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE Series Administration and Operation",
        "subtitle": "",
        "version": "V6.3A",
        "type": "User Guide",
        "edition": "2019-12",
        "filelink": "20215/se-server_buv_063_201912_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (Add-on StorMan)",
        "subtitle": "",
        "version": "V8.0",
        "type": "Release Notice",
        "edition": "2019-01",
        "filelink": "20109/sysfgm.storman.080.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE Series Quick Guide",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Quick Guide",
        "edition": "2019-12",
        "filelink": "20218/se-server_ka_063_201912_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE Series Security Manual",
        "subtitle": "",
        "version": "V6.3A",
        "type": "User Guide",
        "edition": "2019-10",
        "filelink": "20219/se-server_shb_063_201912_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE Series Cluster Solutions for SE Server",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Whitepaper",
        "edition": "2019-12",
        "filelink": "20217/se-server_cls_063_201912_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE Series Basic Operating Manual",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Operating Manual",
        "edition": "2019-12",
        "filelink": "20216/se-server_ba_basis_201912_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE Series Server Unit /390",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Operating Manual",
        "edition": "2019-12",
        "filelink": "20220/se-server_ba_su390_201912_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE Series Server Unit x86",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Operating Manual",
        "edition": "2019-12",
        "filelink": "20221/se-server_ba_sux86_201912_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE Series Additive Components",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Operating Manual",
        "edition": "2019-12",
        "filelink": "20214/se-server_ba_addon_201912_en.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Release Notice SE Net Unit eXtension V1.0 (Add-on NUX)",
        "subtitle": "",
        "version": "V1.0",
        "type": "Release Notice",
        "edition": "2019-12",
        "filelink": "20204/sysfgm.nux.010.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSESERIESINFRASTRUCTUREV63de": {
    "spaceProperties": {
      "prodId": "product-seseriesinfrastructure",
      "prod": "SE-Infrastruktur",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Freigabemitteilung HNC (HNC)",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Freigabemitteilung",
        "edition": "2020-01",
        "filelink": "20198/sysfgm.HNC.063.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager  (Add-on StorMan)",
        "subtitle": "",
        "version": "V8.0.1",
        "type": "Benutzerhandbuch",
        "edition": "2018-04",
        "filelink": "13631/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Freigabemitteilung M2000 (MU)",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Freigabemitteilung",
        "edition": "2020-01",
        "filelink": "20199/sysfgm.M2000.063.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Freigabemitteilung X2000 (SU x86)",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Freigabemitteilung",
        "edition": "2020-01",
        "filelink": "20200/sysfgm.X2000.063.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE Serie Bedienen und Verwalten",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Benutzerhandbuch",
        "edition": "2019-12",
        "filelink": "20208/se-server_buv_063_201912_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (Add-on StorMan)",
        "subtitle": "",
        "version": "V8.0",
        "type": "Freigabemitteilung",
        "edition": "2019-01",
        "filelink": "20092/sysfgm.storman.080.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE Serie Kurzanleitung",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Kurzanleitung",
        "edition": "2019-12",
        "filelink": "20210/se-server_ka_063_201912_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE Serie Sicherheitshandbuch",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Benutzerhandbuch",
        "edition": "2019-12",
        "filelink": "20212/se-server_shb_063_201912_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE Serie Cluster-Lösungen für SE Server",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Whitepaper",
        "edition": "2019-12",
        "filelink": "20209/se-server_cls_063_201912_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE Serie Basis-Betriebsanleitung",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Betriebsanleitung",
        "edition": "2019-12",
        "filelink": "20207/se-server_ba_basis_201912_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE Serie Server Unit /390",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Betriebsanleitung",
        "edition": "2019-12",
        "filelink": "20211/se-server_ba_su390_201912_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE Serie Server Unit x86",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Betriebsanleitung",
        "edition": "2019-12",
        "filelink": "20206/se-server_ba_sux86_201912_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE Serie Additive Komponenten",
        "subtitle": "",
        "version": "V6.3A",
        "type": "Betriebsanleitung",
        "edition": "2019-12",
        "filelink": "20213/se-server_ba_addon_201912_de.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Freigabemitteilung SE Net Unit eXtension (Add-on NUX)",
        "subtitle": "",
        "version": "V1.0",
        "type": "Freigabemitteilung",
        "edition": "2019-12",
        "filelink": "20201/sysfgm.nux.010.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSESERIESINFRASTRUCTUREV62en": {
    "spaceProperties": {
      "prodId": "product-seseriesinfrastructure",
      "prod": "SE Infrastructure",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Release Notice HNC (HNC)",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Release Notice",
        "edition": "2018-04",
        "filelink": "13726/sysfgm.hnc.062sp1.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Release Notice M2000 (MU)",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Release Notice",
        "edition": "2018-04",
        "filelink": "13723/sysfgm.m2000.062sp1.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Administration and Operation",
        "subtitle": "",
        "version": "V6.2A",
        "type": "User Guide",
        "edition": "2018-03",
        "filelink": "13737/se-server_buv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Basic Operating Manual",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Operating Manual",
        "edition": "2017-04",
        "filelink": "13125/se-server_basis_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager  (Add-on StorMan)",
        "subtitle": "",
        "version": "V8.0.1",
        "type": "User Guide",
        "edition": "2018-04",
        "filelink": "13632/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Quick Guide",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Quick Guide",
        "edition": "2017-10",
        "filelink": "13526/se-server_qg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 Server Unit /390",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Operating Manual",
        "edition": "2017-04",
        "filelink": "13127/se-server_su390_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (Add-on StorMan)",
        "subtitle": "",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "2016-06",
        "filelink": "12804/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Release Notice X2000 (SU x86)",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Release Notice",
        "edition": "2018-04",
        "filelink": "13724/sysfgm.x2000.062sp1.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Security Manual",
        "subtitle": "",
        "version": "V6.2A",
        "type": "User Guide",
        "edition": "2018-02",
        "filelink": "13719/se-server_shb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Server Unit x86",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Operating Manual",
        "edition": "2017-04",
        "filelink": "13129/se-server_sux86_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (Add-on StorMan)",
        "subtitle": "",
        "version": "V6.0",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12107/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Additive Components",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Operating Manual",
        "edition": "2018-03",
        "filelink": "13735/se-server_addon_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Cluster Solutions for SE Server",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Whitepaper",
        "edition": "2017-09",
        "filelink": "20007/Cluster Solutions for SE Server - Whitepaper.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (Add-on StorMan)",
        "subtitle": "",
        "version": "V8.0",
        "type": "Release Notice",
        "edition": "2019-01",
        "filelink": "20109/sysfgm.storman.080.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSESERIESINFRASTRUCTUREV62de": {
    "spaceProperties": {
      "prodId": "product-seseriesinfrastructure",
      "prod": "SE-Infrastruktur",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Freigabemitteilung HNC (HNC)",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Freigabemitteilung",
        "edition": "2018-04",
        "filelink": "13725/sysfgm.hnc.062sp1.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Freigabemitteilung M2000 (MU)",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Freigabemitteilung",
        "edition": "2018-04",
        "filelink": "13023/sysfgm.m2000.062sp1.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Basis-Betriebsanleitung",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Betriebsanleitung",
        "edition": "2017-04",
        "filelink": "13124/se-server_basis_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Bedienen und Verwalten",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Benutzerhandbuch",
        "edition": "2018-03",
        "filelink": "13736/se-server_buv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager  (Add-on StorMan)",
        "subtitle": "",
        "version": "V8.0.1",
        "type": "Benutzerhandbuch",
        "edition": "2018-04",
        "filelink": "13631/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Kurzanleitung",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Kurzanleitung",
        "edition": "2017-10",
        "filelink": "13525/se-server_qg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 Server Unit /390",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Betriebsanleitung",
        "edition": "2017-04",
        "filelink": "13126/se-server_su390_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager  (Add-on StorMan)",
        "subtitle": "",
        "version": "V7.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-06",
        "filelink": "12835/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Freigabemitteilung X2000 (SU x86)",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Freigabemitteilung",
        "edition": "2018-04",
        "filelink": "13024/sysfgm.x2000.062sp1.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Server Unit x86",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Betriebsanleitung",
        "edition": "2017-04",
        "filelink": "13128/se-server_sux86_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Sicherheitshandbuch",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Benutzerhandbuch",
        "edition": "2018-02",
        "filelink": "13718/se-server_shb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (Add-on StorMan)",
        "subtitle": "",
        "version": "V6.0",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12179/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Additive Komponenten",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Betriebsanleitung",
        "edition": "2018-03",
        "filelink": "13734/se-server_addon_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Cluster-Lösungen für SE Server",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Whitepaper",
        "edition": "2017-09",
        "filelink": "20006/Cluster-Lösungen für SE Server - Whitepaper.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (Add-on StorMan)",
        "subtitle": "",
        "version": "V8.0",
        "type": "Freigabemitteilung",
        "edition": "2019-01",
        "filelink": "20092/sysfgm.storman.080.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSESERIESINFRASTRUCTUREV61en": {
    "spaceProperties": {
      "prodId": "product-seseriesinfrastructure",
      "prod": "SE Infrastructure",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Release Notice HNC (HNC)",
        "subtitle": "",
        "version": "V6.1",
        "type": "Release Notice",
        "edition": "2016-05",
        "filelink": "12569/sysfgm.hnc.061.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Release Notice M2000 (MU)",
        "subtitle": "",
        "version": "V6.1",
        "type": "Release Notice",
        "edition": "2016-05",
        "filelink": "12565/sysfgm.M2000.061_A0106.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Administration and Operation",
        "subtitle": "",
        "version": "V6.1",
        "type": "User Guide",
        "edition": "2015-11",
        "filelink": "12440/se-server_buv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Basic Operating Manual",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Operating Manual",
        "edition": "2017-04",
        "filelink": "13125/se-server_basis_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager  (Add-on StorMan)",
        "subtitle": "",
        "version": "V8.0.1",
        "type": "User Guide",
        "edition": "2018-04",
        "filelink": "13632/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Quick Guide",
        "subtitle": "",
        "version": "V6.1",
        "type": "Quick Guide",
        "edition": "2015-09",
        "filelink": "12309/se-server_qg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 Server Unit /390",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Operating Manual",
        "edition": "2017-04",
        "filelink": "13127/se-server_su390_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (Add-on StorMan)",
        "subtitle": "",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "2016-06",
        "filelink": "12804/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Release Notice X2000 (SU x86)",
        "subtitle": "",
        "version": "V6.1",
        "type": "Release Notice",
        "edition": "2016-05",
        "filelink": "12567/sysfgm.X2000.061.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Security Manual",
        "subtitle": "",
        "version": "V6.0A",
        "type": "User Guide",
        "edition": "2015-06",
        "filelink": "12257/se-server_shb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Server Unit x86",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Operating Manual",
        "edition": "2017-04",
        "filelink": "13129/se-server_sux86_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (Add-on StorMan)",
        "subtitle": "",
        "version": "V6.0",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12107/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Additive Components",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Operating Manual",
        "edition": "2018-03",
        "filelink": "13735/se-server_addon_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSESERIESINFRASTRUCTUREV61de": {
    "spaceProperties": {
      "prodId": "product-seseriesinfrastructure",
      "prod": "SE-Infrastruktur",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Freigabemitteilung HNC (HNC)",
        "subtitle": "",
        "version": "V6.1",
        "type": "Freigabemitteilung",
        "edition": "2016-05",
        "filelink": "12568/sysfgm.hnc.061.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Freigabemitteilung M2000 (MU)",
        "subtitle": "",
        "version": "V6.1",
        "type": "Freigabemitteilung",
        "edition": "2016-05",
        "filelink": "12564/sysfgm.M2000.061_A0106.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Basis-Betriebsanleitung",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Betriebsanleitung",
        "edition": "2017-04",
        "filelink": "13124/se-server_basis_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Bedienen und Verwalten",
        "subtitle": "",
        "version": "V6.1",
        "type": "Benutzerhandbuch",
        "edition": "2015-11",
        "filelink": "12432/se-server_buv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager  (Add-on StorMan)",
        "subtitle": "",
        "version": "V8.0.1",
        "type": "Benutzerhandbuch",
        "edition": "2018-04",
        "filelink": "13631/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Kurzanleitung",
        "subtitle": "",
        "version": "V6.1",
        "type": "Kurzanleitung",
        "edition": "2015-09",
        "filelink": "12308/se-server_qg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 Server Unit /390",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Betriebsanleitung",
        "edition": "2017-04",
        "filelink": "13126/se-server_su390_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager  (Add-on StorMan)",
        "subtitle": "",
        "version": "V7.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-06",
        "filelink": "12835/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Freigabemitteilung X2000 (SU x86)",
        "subtitle": "",
        "version": "V6.1",
        "type": "Freigabemitteilung",
        "edition": "2016-05",
        "filelink": "12566/sysfgm.X2000.061.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Server Unit x86",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Betriebsanleitung",
        "edition": "2017-04",
        "filelink": "13128/se-server_sux86_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Sicherheitshandbuch",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Benutzerhandbuch",
        "edition": "2015-06",
        "filelink": "12256/se-server_shb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (Add-on StorMan)",
        "subtitle": "",
        "version": "V6.0",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12179/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Additive Komponenten",
        "subtitle": "",
        "version": "V6.2A",
        "type": "Betriebsanleitung",
        "edition": "2018-03",
        "filelink": "13734/se-server_addon_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (Add-on StorMan)",
        "subtitle": "",
        "version": "V8.0",
        "type": "Freigabemitteilung",
        "edition": "2019-01",
        "filelink": "20092/sysfgm.storman.080.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSESERIESINFRASTRUCTUREV60en": {
    "spaceProperties": {
      "prodId": "product-seseriesinfrastructure",
      "prod": "SE Infrastructure",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Release Notice HNC (HNC)",
        "subtitle": "",
        "version": "V6.0",
        "type": "Release Notice",
        "edition": "2015-06",
        "filelink": "12297/sysfgm.hnc.060.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Release Notice M2000 (MU)",
        "subtitle": "",
        "version": "V6.0",
        "type": "Release Notice",
        "edition": "2015-06",
        "filelink": "12294/sysfgm.M2000.060.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Administration and Operation",
        "subtitle": "",
        "version": "V6.0",
        "type": "User Guide",
        "edition": "2015-06",
        "filelink": "12247/se-server_buv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Basic Operating Manual",
        "subtitle": "",
        "version": "V6.0",
        "type": "Operating Manual",
        "edition": "2015-06",
        "filelink": "12249/se-server_basis_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager  (Add-on StorMan)",
        "subtitle": "",
        "version": "V8.0.1",
        "type": "User Guide",
        "edition": "2018-04",
        "filelink": "13632/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Quick Guide",
        "subtitle": "",
        "version": "V6.1",
        "type": "Quick Guide",
        "edition": "2015-09",
        "filelink": "12309/se-server_qg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 Server Unit /390",
        "subtitle": "",
        "version": "V6.0",
        "type": "Operating Manual",
        "edition": "2015-06",
        "filelink": "12251/se-server_su390_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (Add-on StorMan)",
        "subtitle": "",
        "version": "V7.0",
        "type": "User Guide",
        "edition": "2016-06",
        "filelink": "12804/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Release Notice X2000 (SU x86)",
        "subtitle": "",
        "version": "V6.0",
        "type": "Release Notice",
        "edition": "2015-06",
        "filelink": "12292/sysfgm.X2000.060.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Security Manual",
        "subtitle": "",
        "version": "V6.0A",
        "type": "User Guide",
        "edition": "2015-06",
        "filelink": "12257/se-server_shb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Server Unit x86",
        "subtitle": "",
        "version": "V6.0",
        "type": "Operating Manual",
        "edition": "2015-06",
        "filelink": "12253/se-server_sux86_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (Add-on StorMan)",
        "subtitle": "",
        "version": "V6.0",
        "type": "User Guide",
        "edition": "2015-04",
        "filelink": "12107/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Additive Components",
        "subtitle": "",
        "version": "V6.0",
        "type": "Operating Manual",
        "edition": "2015-11",
        "filelink": "12443/se-server_addon_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psSESERIESINFRASTRUCTUREV60de": {
    "spaceProperties": {
      "prodId": "product-seseriesinfrastructure",
      "prod": "SE-Infrastruktur",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "Freigabemitteilung HNC (HNC)",
        "subtitle": "",
        "version": "V6.0",
        "type": "Freigabemitteilung",
        "edition": "2015-06",
        "filelink": "12296/sysfgm.hnc.060.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Freigabemitteilung M2000 (MU)",
        "subtitle": "",
        "version": "V6.0",
        "type": "Freigabemitteilung",
        "edition": "2015-06",
        "filelink": "12293/sysfgm.M2000.060.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Basis-Betriebsanleitung",
        "subtitle": "",
        "version": "V6.0",
        "type": "Betriebsanleitung",
        "edition": "2015-06",
        "filelink": "12248/se-server_basis_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Bedienen und Verwalten",
        "subtitle": "",
        "version": "V6.0",
        "type": "Benutzerhandbuch",
        "edition": "2015-06",
        "filelink": "12246/se-server_buv.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager  (Add-on StorMan)",
        "subtitle": "",
        "version": "V8.0.1",
        "type": "Benutzerhandbuch",
        "edition": "2018-04",
        "filelink": "13631/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Kurzanleitung",
        "subtitle": "",
        "version": "V6.1",
        "type": "Kurzanleitung",
        "edition": "2015-09",
        "filelink": "12308/se-server_qg.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 Server Unit /390",
        "subtitle": "",
        "version": "V6.0",
        "type": "Betriebsanleitung",
        "edition": "2015-06",
        "filelink": "12250/se-server_su390_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager  (Add-on StorMan)",
        "subtitle": "",
        "version": "V7.0",
        "type": "Benutzerhandbuch",
        "edition": "2016-06",
        "filelink": "12835/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Freigabemitteilung X2000 (SU x86)",
        "subtitle": "",
        "version": "V6.0",
        "type": "Freigabemitteilung",
        "edition": "2015-06",
        "filelink": "12291/sysfgm.X2000.060.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Server Unit x86",
        "subtitle": "",
        "version": "V6.0",
        "type": "Betriebsanleitung",
        "edition": "2015-06",
        "filelink": "12252/se-server_sux86_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Sicherheitshandbuch",
        "subtitle": "",
        "version": "V6.0A",
        "type": "Benutzerhandbuch",
        "edition": "2015-06",
        "filelink": "12256/se-server_shb.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (Add-on StorMan)",
        "subtitle": "",
        "version": "V6.0",
        "type": "Benutzerhandbuch",
        "edition": "2015-04",
        "filelink": "12179/storman.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "SE700 / SE500 / SE300 Additive Komponenten",
        "subtitle": "",
        "version": "V6.0",
        "type": "Betriebsanleitung",
        "edition": "2015-11",
        "filelink": "12433/se-server_addon_ba.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "Storage Manager (Add-on StorMan)",
        "subtitle": "",
        "version": "V8.0",
        "type": "Freigabemitteilung",
        "edition": "2019-01",
        "filelink": "20092/sysfgm.storman.080.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psONLINESTORAGEFUJITSUETERNUSen": {
    "spaceProperties": {
      "prodId": "product-onlinestoragefujitsueternus",
      "prod": "Online Storage FUJITSU ETERNUS",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "AF650 S2",
        "subtitle": "",
        "version": "",
        "type": "Release Notice",
        "edition": "2018-04",
        "filelink": "13538/sysfgm.ete_af650s2.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "AF650 S3",
        "subtitle": "",
        "version": "",
        "type": "Release Notice",
        "edition": "2020-04",
        "filelink": "20240/SYSFGM ETE AF650 S3 E 2020-04.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DX500 S3 / DX600 S3",
        "subtitle": "",
        "version": "",
        "type": "Release Notice",
        "edition": "2017-10",
        "filelink": "13754/syfgm.ete_dx500-dx600s3.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DX500 S4 / DX600 S4",
        "subtitle": "",
        "version": "",
        "type": "Release Notice",
        "edition": "2018-04",
        "filelink": "12749/sysfgm.ete_dx500-dx600s4.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DX500 S5 / DX600 S5",
        "subtitle": "",
        "version": "",
        "type": "Release Notice",
        "edition": "2020-04",
        "filelink": "20241/SYSFGM ETE DX500-DX600 S5 E 2020-04.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DX8700 S2",
        "subtitle": "",
        "version": "",
        "type": "Release Notice",
        "edition": "2012-08",
        "filelink": "12747/sysfgm.dx8700s2.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DX8700 S3",
        "subtitle": "",
        "version": "",
        "type": "Release Notice",
        "edition": "2017-10",
        "filelink": "12751/syfgm.ete_dx8700s3.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psONLINESTORAGEFUJITSUETERNUSde": {
    "spaceProperties": {
      "prodId": "product-onlinestoragefujitsueternus",
      "prod": "Online Storage FUJITSU ETERNUS",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "AF650 S2",
        "subtitle": "",
        "version": "",
        "type": "Freigabemitteilung",
        "edition": "2018-04",
        "filelink": "13537/sysfgm.ete_af650s2.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "AF650 S3",
        "subtitle": "",
        "version": "",
        "type": "Freigabemitteilung",
        "edition": "2020-04",
        "filelink": "20238/SYSFGM ETE AF650 S3 D 2020-04.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DX500 S3 / DX600 S3",
        "subtitle": "",
        "version": "",
        "type": "Freigabemitteilung",
        "edition": "2017-10",
        "filelink": "13753/syfgm.ete_dx500-dx600s3.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DX500 S4 / DX600 S4",
        "subtitle": "",
        "version": "",
        "type": "Freigabemitteilung",
        "edition": "2018-04",
        "filelink": "12748/sysfgm.ete_dx500-dx600s4.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DX500 S5 / DX600 S5",
        "subtitle": "",
        "version": "",
        "type": "Freigabemitteilung",
        "edition": "2020-04",
        "filelink": "20239/SYSFGM ETE DX500-DX600 S5 D 2020-04.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DX8700 S2",
        "subtitle": "",
        "version": "",
        "type": "Freigabemitteilung",
        "edition": "2012-08",
        "filelink": "12607/sysfgm.dx8700s2.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "DX8700 S3",
        "subtitle": "",
        "version": "",
        "type": "Freigabemitteilung",
        "edition": "2017-10",
        "filelink": "12750/syfgm.ete_dx8700s3.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psONLINESTORAGEEMCVMAXen": {
    "spaceProperties": {
      "prodId": "product-onlinestorageemcvmax",
      "prod": "Online Storage EMC VMAX",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "VMAX20K / VMAX40K",
        "subtitle": "",
        "version": "",
        "type": "Release Notice",
        "edition": "2016-04",
        "filelink": "12755/sysfgm.vmax20k-vmax40k.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VMAX3 / VMAX All Flash",
        "subtitle": "",
        "version": "",
        "type": "Release Notice",
        "edition": "2018-03",
        "filelink": "12609/sysfgm.vmax3-vmaxall_flash.e.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psONLINESTORAGEEMCVMAXde": {
    "spaceProperties": {
      "prodId": "product-onlinestorageemcvmax",
      "prod": "Online Storage EMC VMAX",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [
      {
        "title": "VMAX20K / VMAX40K",
        "subtitle": "",
        "version": "",
        "type": "Freigabemitteilung",
        "edition": "2016-04",
        "filelink": "12754/sysfgm.vmax20k-vmax40k.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      },
      {
        "title": "VMAX3 / VMAX All Flash",
        "subtitle": "",
        "version": "",
        "type": "Freigabemitteilung",
        "edition": "2018-03",
        "filelink": "12608/sysfgm.vmax3-vmaxall_flash.d.pdf",
        "mediatype": "fj-mediatype-pdf"
      }
    ]
  },
  "psFCSWITCHen": {
    "spaceProperties": {
      "prodId": "product-fcswitch",
      "prod": "FC-Switch",
      "lang": 1,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "Supportmatrix",
      "subtitle": "FC-Switch",
      "version": "",
      "type": "Release Notice",
      "edition": "2020-02",
      "filelink": "20225/SYSFGM.FC-SWITCH-SUPPORT.E.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "psFCSWITCHde": {
    "spaceProperties": {
      "prodId": "product-fcswitch",
      "prod": "FC-Switch",
      "lang": 0,
      "productPackage": false,
      "servicePack": false,
      "spaceType": "PRODUCT"
    },
    "manuals": [{
      "title": "Supportmatrix",
      "subtitle": "FC-Switch",
      "version": "",
      "type": "Freigabemitteilung",
      "edition": "2020-02",
      "filelink": "20224/SYSFGM.FC-SWITCH-SUPPORT.D.pdf",
      "mediatype": "fj-mediatype-pdf"
    }]
  },
  "spSERVICEPACK201en": {
    "spaceProperties": {
      "servicePackId": "sp-servicepack201",
      "servicePackName": "Service Pack 20.1",
      "lang": 1,
      "productPackage": false,
      "servicePack": true,
      "spaceType": "SERVICE_PACK"
    },
    "releaseNotice": {
      "title": "Service Pack 20.1",
      "subtitle": "",
      "version": "",
      "type": "Release Notice",
      "edition": "2020-07",
      "filelink": "20246/sysfgm.sp.201.pdf.e.pdf",
      "mediatype": "fj-mediatype-pdf"
    }
  },
  "spSERVICEPACK201de": {
    "spaceProperties": {
      "servicePackId": "sp-servicepack201",
      "servicePackName": "Service Pack 20.1",
      "lang": 0,
      "productPackage": false,
      "servicePack": true,
      "spaceType": "SERVICE_PACK"
    },
    "releaseNotice": {
      "title": "Service Pack 20.1",
      "subtitle": "",
      "version": "",
      "type": "Freigabemitteilung",
      "edition": "2020-07",
      "filelink": "20247/sysfgm.sp.201.pdf.d.pdf",
      "mediatype": "fj-mediatype-pdf"
    }
  }
}`;
